import { Option } from 'payload';

interface GoogleFont {
  family: string;
  files: Record<string, string>;
  [key: string]: unknown;
}

// TODO: extract from Google Fonts API
const GOOGLE_FONTS: Array<GoogleFont> = [
  {
    family: 'Roboto',
    files: {
      '100': 'https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgWxKKTM1K9nz.woff2',
      '300': 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5vBh05IsDqlA.woff2',
      '500': 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9vBh05IsDqlA.woff2',
      '700': 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvBh05IsDqlA.woff2',
      '900': 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtvBh05IsDqlA.woff2',
      regular: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me4GZLCzYlKw.woff2',
    },
  },
  {
    family: 'Open Sans',
    files: {
      '300': 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4iY1M2xLER.woff2',
      '500': 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjr0C4iY1M2xLER.woff2',
      '600': 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4iY1M2xLER.woff2',
      '700': 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4iY1M2xLER.woff2',
      '800': 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgshZ1y4iY1M2xLER.woff2',
      regular: 'https://fonts.gstatic.com/s/opensans/v40/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4iY1M2xLER.woff2',
    },
  },
  {
    family: 'Montserrat',
    files: {
      '100': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Uw7Y3tcoqK5.woff2',
      '200': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr6Ew7Y3tcoqK5.woff2',
      '300': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCs16Ew7Y3tcoqK5.woff2',
      '500': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew7Y3tcoqK5.woff2',
      '600': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCu170w7Y3tcoqK5.woff2',
      '700': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w7Y3tcoqK5.woff2',
      '800': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr70w7Y3tcoqK5.woff2',
      '900': 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvC70w7Y3tcoqK5.woff2',
      regular: 'https://fonts.gstatic.com/s/montserrat/v26/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew7Y3tcoqK5.woff2',
    },
  },
  {
    family: 'Poppins',
    files: {
      '100': 'https://fonts.gstatic.com/s/poppins/v21/pxiGyp8kv8JHgFVrLPTecnFBGPaTSQ.woff2',
      '200': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLFj_V15vFP-KUEg.woff2',
      '300': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLDz8V15vFP-KUEg.woff2',
      '500': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLGT9V15vFP-KUEg.woff2',
      '600': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLEj6V15vFP-KUEg.woff2',
      '700': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLCz7V15vFP-KUEg.woff2',
      '800': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLDD4V15vFP-KUEg.woff2',
      '900': 'https://fonts.gstatic.com/s/poppins/v21/pxiByp8kv8JHgFVrLBT5V15vFP-KUEg.woff2',
      regular: 'https://fonts.gstatic.com/s/poppins/v21/pxiEyp8kv8JHgFVrFJXUc1NECPY.woff2',
    },
  },
  {
    family: 'Lato',
    files: {
      '100': 'https://fonts.gstatic.com/s/lato/v24/S6u8w4BMUTPHh30wXiWrFCbw7A.woff2',
      '300': 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh7USewqFGC_p9dw.woff2',
      '700': 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVewqFGC_p9dw.woff2',
      '900': 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50XewqFGC_p9dw.woff2',
      regular: 'https://fonts.gstatic.com/s/lato/v24/S6uyw4BMUTPHvxw6XweuBCY.woff2',
    },
  },
  {
    family: 'Noto Sans JP',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEi757Y0rw-oME.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFJEj757Y0rw-oME.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFE8j757Y0rw-oME.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFCMj757Y0rw-oME.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFM8k757Y0rw-oME.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFPYk757Y0rw-oME.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFJEk757Y0rw-oME.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFLgk757Y0rw-oME.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEj757Y0rw-oME.woff2',
    },
  },
  {
    family: 'Inter',
    files: {
      '100': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyeMZ1rib2Bg-4.woff2',
      '200': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyfMZ1rib2Bg-4.woff2',
      '300': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuOKfMZ1rib2Bg-4.woff2',
      '500': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuI6fMZ1rib2Bg-4.woff2',
      '600': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuGKYMZ1rib2Bg-4.woff2',
      '700': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuFuYMZ1rib2Bg-4.woff2',
      '800': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyYMZ1rib2Bg-4.woff2',
      '900': 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuBWYMZ1rib2Bg-4.woff2',
      regular: 'https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfMZ1rib2Bg-4.woff2',
    },
  },
  {
    family: 'Material Icons',
    files: {
      regular: 'https://fonts.gstatic.com/s/materialicons/v141/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhI8tIHh.woff2',
    },
  },
  {
    family: 'Roboto Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyWyo_BM731BKMSK.woff2',
      '200': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyUyovBM731BKMSK.woff2',
      '300': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyXsovBM731BKMSK.woff2',
      '500': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyWAovBM731BKMSK.woff2',
      '600': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyVspfBM731BKMSK.woff2',
      '700': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyVVpfBM731BKMSK.woff2',
      '800': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyUypfBM731BKMSK.woff2',
      '900': 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyUbpfBM731BKMSK.woff2',
      regular: 'https://fonts.gstatic.com/s/robotocondensed/v27/ieVo2ZhZI2eCN5jzbjEETS9weq8-_d6T_POl0fRJeyWyovBM731BKMSK.woff2',
    },
  },
  {
    family: 'Oswald',
    files: {
      '200': 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs13FvgURoZAaRliE.woff2',
      '300': 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs169vgURoZAaRliE.woff2',
      '500': 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvgURoZAaRliE.woff2',
      '600': 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs1y9ogURoZAaRliE.woff2',
      '700': 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs1xZogURoZAaRliE.woff2',
      regular: 'https://fonts.gstatic.com/s/oswald/v53/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgURoZAaRliE.woff2',
    },
  },
  {
    family: 'Roboto Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vuPRu-5Ip2sSQ.woff2',
      '200': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_XvqPRu-5Ip2sSQ.woff2',
      '300': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_gPqPRu-5Ip2sSQ.woff2',
      '500': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7PqPRu-5Ip2sSQ.woff2',
      '600': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_AP2PRu-5Ip2sSQ.woff2',
      '700': 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_Of2PRu-5Ip2sSQ.woff2',
      regular: 'https://fonts.gstatic.com/s/robotomono/v23/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vqPRu-5Ip2sSQ.woff2',
    },
  },
  {
    family: 'Noto Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyD9At9Y41P6zHtY.woff2',
      '200': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyB9A99Y41P6zHtY.woff2',
      '300': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyCjA99Y41P6zHtY.woff2',
      '500': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyDPA99Y41P6zHtY.woff2',
      '600': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAjBN9Y41P6zHtY.woff2',
      '700': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyAaBN9Y41P6zHtY.woff2',
      '800': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyB9BN9Y41P6zHtY.woff2',
      '900': 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyBUBN9Y41P6zHtY.woff2',
      regular: 'https://fonts.gstatic.com/s/notosans/v36/o-0mIpQlx3QUlC5A4PNB6Ryti20_6n1iPHjcz6L1SoM-jCpoiyD9A99Y41P6zHtY.woff2',
    },
  },
  {
    family: 'Raleway',
    files: {
      '100': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvao4CKNLA3JC9c.woff2',
      '200': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtaooCKNLA3JC9c.woff2',
      '300': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVuEooCKNLA3JC9c.woff2',
      '500': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvoooCKNLA3JC9c.woff2',
      '600': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVsEpYCKNLA3JC9c.woff2',
      '700': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVs9pYCKNLA3JC9c.woff2',
      '800': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtapYCKNLA3JC9c.woff2',
      '900': 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtzpYCKNLA3JC9c.woff2',
      regular: 'https://fonts.gstatic.com/s/raleway/v29/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCKNLA3JC9c.woff2',
    },
  },
  {
    family: 'Ubuntu',
    files: {
      '300': 'https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoC1CzTsmaMH4V_gg.woff2',
      '500': 'https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCjC3TsmaMH4V_gg.woff2',
      '700': 'https://fonts.gstatic.com/s/ubuntu/v20/4iCv6KVjbNBYlgoCxCvTsmaMH4V_gg.woff2',
      regular: 'https://fonts.gstatic.com/s/ubuntu/v20/4iCs6KVjbNBYlgo6fQT3v02QFg.woff2',
    },
  },
  {
    family: 'Rubik',
    files: {
      '300': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-WYi1VU80V4bVkA.woff2',
      '500': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYi1VU80V4bVkA.woff2',
      '600': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-2Y-1VU80V4bVkA.woff2',
      '700': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-1VU80V4bVkA.woff2',
      '800': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-h4-1VU80V4bVkA.woff2',
      '900': 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-ro-1VU80V4bVkA.woff2',
      regular: 'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4i1VU80V4bVkA.woff2',
    },
  },
  {
    family: 'Nunito Sans',
    files: {
      '200':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GVilnsV8kA_Ykqw.woff2',
      '300':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GiClnsV8kA_Ykqw.woff2',
      '500':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G5ClnsV8kA_Ykqw.woff2',
      '600':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GCC5nsV8kA_Ykqw.woff2',
      '700':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GMS5nsV8kA_Ykqw.woff2',
      '800':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GVi5nsV8kA_Ykqw.woff2',
      '900':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4Gfy5nsV8kA_Ykqw.woff2',
      regular:
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G1ilnsV8kA_Ykqw.woff2',
    },
  },
  {
    family: 'Merriweather',
    files: {
      '300': 'https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l521wRpWs37pvjxPA.woff2',
      '700': 'https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52xwNpWs37pvjxPA.woff2',
      '900': 'https://fonts.gstatic.com/s/merriweather/v30/u-4n0qyriQwlOrhSvowK_l52_wFpWs37pvjxPA.woff2',
      regular: 'https://fonts.gstatic.com/s/merriweather/v30/u-440qyriQwlOrhSvowK_l5OfixNV-bnrw.woff2',
    },
  },
  {
    family: 'Playfair Display',
    files: {
      '500': 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKd3vUDVZNLo_U2r.woff2',
      '600': 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKebukDVZNLo_U2r.woff2',
      '700': 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKeiukDVZNLo_U2r.woff2',
      '800': 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfFukDVZNLo_U2r.woff2',
      '900': 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfsukDVZNLo_U2r.woff2',
      regular: 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDVZNLo_U2r.woff2',
    },
  },
  {
    family: 'Roboto Slab',
    files: {
      '100': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojIWWbW5iddG-1A.woff2',
      '200': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDISWbW5iddG-1A.woff2',
      '300': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjo0oSWbW5iddG-1A.woff2',
      '500': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjovoSWbW5iddG-1A.woff2',
      '600': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoUoOWbW5iddG-1A.woff2',
      '700': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoa4OWbW5iddG-1A.woff2',
      '800': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDIOWbW5iddG-1A.woff2',
      '900': 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoJYOWbW5iddG-1A.woff2',
      regular: 'https://fonts.gstatic.com/s/robotoslab/v34/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISWbW5iddG-1A.woff2',
    },
  },
  {
    family: 'Noto Sans KR',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuozeLHq8H4hfeE.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzmoyeLHq8H4hfeE.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzrQyeLHq8H4hfeE.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzztgyeLHq8H4hfeE.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzjQ1eLHq8H4hfeE.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzg01eLHq8H4hfeE.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzmo1eLHq8H4hfeE.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzkM1eLHq8H4hfeE.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuoyeLHq8H4hfeE.woff2',
    },
  },
  {
    family: 'Nunito',
    files: {
      '200': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDDshRTY9jo7eTWk.woff2',
      '300': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDOUhRTY9jo7eTWk.woff2',
      '500': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhRTY9jo7eTWk.woff2',
      '600': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDGUmRTY9jo7eTWk.woff2',
      '700': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDFwmRTY9jo7eTWk.woff2',
      '800': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDDsmRTY9jo7eTWk.woff2',
      '900': 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDBImRTY9jo7eTWk.woff2',
      regular: 'https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTY9jo7eTWk.woff2',
    },
  },
  {
    family: 'PT Sans',
    files: {
      '700': 'https://fonts.gstatic.com/s/ptsans/v17/jizfRExUiTo99u79B_mh4OynLD0Z4zM.woff2',
      regular: 'https://fonts.gstatic.com/s/ptsans/v17/jizaRExUiTo99u79P0COxOGMMDQ.woff2',
    },
  },
  {
    family: 'Work Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nWNi0Dp6_cOyA.woff2',
      '200': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nXNi0Dp6_cOyA.woff2',
      '300': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32KxfXNi0Dp6_cOyA.woff2',
      '500': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K3vXNi0Dp6_cOyA.woff2',
      '600': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K5fQNi0Dp6_cOyA.woff2',
      '700': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K67QNi0Dp6_cOyA.woff2',
      '800': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nQNi0Dp6_cOyA.woff2',
      '900': 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K-DQNi0Dp6_cOyA.woff2',
      regular: 'https://fonts.gstatic.com/s/worksans/v19/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNi0Dp6_cOyA.woff2',
    },
  },
  {
    family: 'Mulish',
    files: {
      '200': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexRNRwaWlGrw-PTY.woff2',
      '300': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexc1RwaWlGrw-PTY.woff2',
      '500': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexaFRwaWlGrw-PTY.woff2',
      '600': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexU1WwaWlGrw-PTY.woff2',
      '700': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexXRWwaWlGrw-PTY.woff2',
      '800': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexRNWwaWlGrw-PTY.woff2',
      '900': 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexTpWwaWlGrw-PTY.woff2',
      regular: 'https://fonts.gstatic.com/s/mulish/v13/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNRwaWlGrw-PTY.woff2',
    },
  },
  {
    family: 'Kanit',
    files: {
      '100': 'https://fonts.gstatic.com/s/kanit/v15/nKKX-Go6G5tXcr72GwCKcaxALFs.woff2',
      '200': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr5aOiWlX6BJNUJy.woff2',
      '300': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4-OSWlX6BJNUJy.woff2',
      '500': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr5mOCWlX6BJNUJy.woff2',
      '600': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr5KPyWlX6BJNUJy.woff2',
      '700': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4uPiWlX6BJNUJy.woff2',
      '800': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4yPSWlX6BJNUJy.woff2',
      '900': 'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4WPCWlX6BJNUJy.woff2',
      regular: 'https://fonts.gstatic.com/s/kanit/v15/nKKZ-Go6G5tXcoaXEQGodLxA.woff2',
    },
  },
  {
    family: 'Noto Sans TC',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz76Cz_C9Otma3uNQ.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7yCy_C9Otma3uNQ.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7_6y_C9Otma3uNQ.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz75Ky_C9Otma3uNQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7361_C9Otma3uNQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz70e1_C9Otma3uNQ.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7yC1_C9Otma3uNQ.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7wm1_C9Otma3uNQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz76Cy_C9Otma3uNQ.woff2',
    },
  },
  {
    family: 'Barlow',
    files: {
      '100': 'https://fonts.gstatic.com/s/barlow/v12/7cHrv4kjgoGqM7E3b8s5yn4hnCci.woff2',
      '200': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3w-oc5VAtlT47dw.woff2',
      '300': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3p-kc5VAtlT47dw.woff2',
      '500': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3_-gc5VAtlT47dw.woff2',
      '600': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E30-8c5VAtlT47dw.woff2',
      '700': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3t-4c5VAtlT47dw.woff2',
      '800': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3q-0c5VAtlT47dw.woff2',
      '900': 'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3j-wc5VAtlT47dw.woff2',
      regular: 'https://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7EPDsE46HsxnA.woff2',
    },
  },
  {
    family: 'Fira Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/firasans/v17/va9C4kDNxMZdWfMOD5Vn9IjLazP3dUTP.woff2',
      '200': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnWKnuRB37fF3Wlg.woff2',
      '300': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnPKruRB37fF3Wlg.woff2',
      '500': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnZKvuRB37fF3Wlg.woff2',
      '600': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnSKzuRB37fF3Wlg.woff2',
      '700': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnLK3uRB37fF3Wlg.woff2',
      '800': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnMK7uRB37fF3Wlg.woff2',
      '900': 'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnFK_uRB37fF3Wlg.woff2',
      regular: 'https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VflYLKSTbndQ.woff2',
    },
  },
  {
    family: 'Lora',
    files: {
      '500': 'https://fonts.gstatic.com/s/lora/v35/0QI6MX1D_JOuGQbT0gvTJPa787wsuyJDmKxemMeZ.woff2',
      '600': 'https://fonts.gstatic.com/s/lora/v35/0QI6MX1D_JOuGQbT0gvTJPa787zAvCJDmKxemMeZ.woff2',
      '700': 'https://fonts.gstatic.com/s/lora/v35/0QI6MX1D_JOuGQbT0gvTJPa787z5vCJDmKxemMeZ.woff2',
      regular: 'https://fonts.gstatic.com/s/lora/v35/0QI6MX1D_JOuGQbT0gvTJPa787weuyJDmKxemMeZ.woff2',
    },
  },
  {
    family: 'DM Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAop1hS2f3ZGMZpg.woff2',
      '200': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAIpxhS2f3ZGMZpg.woff2',
      '300': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwA_JxhS2f3ZGMZpg.woff2',
      '500': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAkJxhS2f3ZGMZpg.woff2',
      '600': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAfJthS2f3ZGMZpg.woff2',
      '700': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwARZthS2f3ZGMZpg.woff2',
      '800': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAIpthS2f3ZGMZpg.woff2',
      '900': 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAC5thS2f3ZGMZpg.woff2',
      regular: 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAopxhS2f3ZGMZpg.woff2',
    },
  },
  {
    family: 'Quicksand',
    files: {
      '300': 'https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkKEo18S0wx40QDw.woff2',
      '500': 'https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkM0o18S0wx40QDw.woff2',
      '600': 'https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkCEv18S0wx40QDw.woff2',
      '700': 'https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv18S0wx40QDw.woff2',
      regular: 'https://fonts.gstatic.com/s/quicksand/v31/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18S0wx40QDw.woff2',
    },
  },
  {
    family: 'Titillium Web',
    files: {
      '200': 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPDcZTIAOhVxoMyOr9n_E7ffAzHKIl5YrSYqWM.woff2',
      '300': 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPDcZTIAOhVxoMyOr9n_E7ffGjEKIl5YrSYqWM.woff2',
      '600': 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPDcZTIAOhVxoMyOr9n_E7ffBzCKIl5YrSYqWM.woff2',
      '700': 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPDcZTIAOhVxoMyOr9n_E7ffHjDKIl5YrSYqWM.woff2',
      '900': 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPDcZTIAOhVxoMyOr9n_E7ffEDBKIl5YrSYqWM.woff2',
      regular: 'https://fonts.gstatic.com/s/titilliumweb/v17/NaPecZTIAOhVxoMyOr9n_E7fRMHsDIRSfr0.woff2',
    },
  },
  {
    family: 'Nanum Gothic',
    files: {
      '700': 'https://fonts.gstatic.com/s/nanumgothic/v23/PN_oRfi-oW3hYwmKDpxS7F_LQv37y1En14YEUQ.woff2',
      '800': 'https://fonts.gstatic.com/s/nanumgothic/v23/PN_oRfi-oW3hYwmKDpxS7F_LXv77y1En14YEUQ.woff2',
      regular: 'https://fonts.gstatic.com/s/nanumgothic/v23/PN_3Rfi-oW3hYwmKDpxS7F_z-9Lfxno73g.woff2',
    },
  },
  {
    family: 'IBM Plex Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX-KVElMYYaJe8bpLHnCwDKjbLeFaxIedbzDw.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX9KVElMYYaJe8bpLHnCwDKjR7_MINmdd_qFmo.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX9KVElMYYaJe8bpLHnCwDKjXr8MINmdd_qFmo.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX9KVElMYYaJe8bpLHnCwDKjSL9MINmdd_qFmo.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX9KVElMYYaJe8bpLHnCwDKjQ76MINmdd_qFmo.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYX9KVElMYYaJe8bpLHnCwDKjWr7MINmdd_qFmo.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsans/v19/zYXgKVElMYYaJe8bpLHnCwDKtdPUFI5NadY.woff2',
    },
  },
  {
    family: 'Heebo',
    files: {
      '100': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiS2cd0Onz02SXQ.woff2',
      '200': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSycd0Onz02SXQ.woff2',
      '300': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1E1yycd0Onz02SXQ.woff2',
      '500': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1Euyycd0Onz02SXQ.woff2',
      '600': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EVyucd0Onz02SXQ.woff2',
      '700': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1Ebiucd0Onz02SXQ.woff2',
      '800': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSucd0Onz02SXQ.woff2',
      '900': 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EICucd0Onz02SXQ.woff2',
      regular: 'https://fonts.gstatic.com/s/heebo/v26/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSycd0Onz02SXQ.woff2',
    },
  },
  {
    family: 'Manrope',
    files: {
      '200': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk59FO_A87jxeN7B.woff2',
      '300': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk6jFO_A87jxeN7B.woff2',
      '500': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk7PFO_A87jxeN7B.woff2',
      '600': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4jE-_A87jxeN7B.woff2',
      '700': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4aE-_A87jxeN7B.woff2',
      '800': 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk59E-_A87jxeN7B.woff2',
      regular: 'https://fonts.gstatic.com/s/manrope/v15/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FO_A87jxeN7B.woff2',
    },
  },
  {
    family: 'PT Serif',
    files: {
      '700': 'https://fonts.gstatic.com/s/ptserif/v18/EJRSQgYoZZY2vCFuvAnt65qQXSr3pNNB.woff2',
      regular: 'https://fonts.gstatic.com/s/ptserif/v18/EJRVQgYoZZY2vCFuvDFUxL6ddjb-.woff2',
    },
  },
  {
    family: 'Inconsolata',
    files: {
      '200': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU8aR_8lleY2co.woff2',
      '300': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp9s8aR_8lleY2co.woff2',
      '500': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp7c8aR_8lleY2co.woff2',
      '600': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp1s7aR_8lleY2co.woff2',
      '700': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp2I7aR_8lleY2co.woff2',
      '800': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU7aR_8lleY2co.woff2',
      '900': 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lppyw7aR_8lleY2co.woff2',
      regular: 'https://fonts.gstatic.com/s/inconsolata/v32/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8aR_8lleY2co.woff2',
    },
  },
  {
    family: 'Material Symbols Outlined',
    files: {
      '100':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHeejbd5zrTgt.woff2',
      '200':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDAvHOejbd5zrTgt.woff2',
      '300':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDDxHOejbd5zrTgt.woff2',
      '500':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCdHOejbd5zrTgt.woff2',
      '600':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDBxG-ejbd5zrTgt.woff2',
      '700':
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDBIG-ejbd5zrTgt.woff2',
      regular:
        'https://fonts.gstatic.com/s/materialsymbolsoutlined/v170/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHOejbd5zrTgt.woff2',
    },
  },
  {
    family: 'Material Icons Outlined',
    files: {
      regular: 'https://fonts.gstatic.com/s/materialiconsoutlined/v109/gok-H7zzDkdnRel8-DQ6KAXJ69wP1tGnf4ZGhUcel5GuI2Ze.woff2',
    },
  },
  {
    family: 'Libre Franklin',
    files: {
      '100': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsSUAtrIb-JH1g.woff2',
      '200': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsWUAtrIb-JH1g.woff2',
      '300': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhcMWUAtrIb-JH1g.woff2',
      '500': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhHMWUAtrIb-JH1g.woff2',
      '600': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduh8MKUAtrIb-JH1g.woff2',
      '700': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhycKUAtrIb-JH1g.woff2',
      '800': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsKUAtrIb-JH1g.woff2',
      '900': 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhh8KUAtrIb-JH1g.woff2',
      regular: 'https://fonts.gstatic.com/s/librefranklin/v14/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWUAtrIb-JH1g.woff2',
    },
  },
  {
    family: 'Mukta',
    files: {
      '200': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbEOjFmf-2HW7ZB_.woff2',
      '300': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbFqj1mf-2HW7ZB_.woff2',
      '500': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbEyjlmf-2HW7ZB_.woff2',
      '600': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbEeiVmf-2HW7ZB_.woff2',
      '700': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbF6iFmf-2HW7ZB_.woff2',
      '800': 'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbFmi1mf-2HW7ZB_.woff2',
      regular: 'https://fonts.gstatic.com/s/mukta/v14/iJWKBXyXfDDVXYnDp32S0H3f.woff2',
    },
  },
  {
    family: 'Hind Siliguri',
    files: {
      '300': 'https://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRDf44uQfKiGvxts.woff2',
      '500': 'https://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRG_54uQfKiGvxts.woff2',
      '600': 'https://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoREP-4uQfKiGvxts.woff2',
      '700': 'https://fonts.gstatic.com/s/hindsiliguri/v12/ijwOs5juQtsyLLR5jN4cxBEoRCf_4uQfKiGvxts.woff2',
      regular: 'https://fonts.gstatic.com/s/hindsiliguri/v12/ijwTs5juQtsyLLR5jN4cxBEofJ7Qxuk0Nig.woff2',
    },
  },
  {
    family: 'Karla',
    files: {
      '200': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJqqEUNLR7fHGw.woff2',
      '300': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDppqqEUNLR7fHGw.woff2',
      '500': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDypqqEUNLR7fHGw.woff2',
      '600': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDJp2qEUNLR7fHGw.woff2',
      '700': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDH52qEUNLR7fHGw.woff2',
      '800': 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJ2qEUNLR7fHGw.woff2',
      regular: 'https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqEUNLR7fHGw.woff2',
    },
  },
  {
    family: 'Noto Serif',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFGjxc0Lhq_Szw.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZKFCjxc0Lhq_Szw.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZ9lCjxc0Lhq_Szw.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZmlCjxc0Lhq_Szw.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZdlejxc0Lhq_Szw.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZT1ejxc0Lhq_Szw.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZKFejxc0Lhq_Szw.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZAVejxc0Lhq_Szw.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserif/v23/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFCjxc0Lhq_Szw.woff2',
    },
  },
  {
    family: 'Bebas Neue',
    files: {
      regular: 'https://fonts.gstatic.com/s/bebasneue/v14/JTUSjIg69CK48gW7PXooxWtrygbi49c.woff2',
    },
  },
  {
    family: 'Arimo',
    files: {
      '500': 'https://fonts.gstatic.com/s/arimo/v29/P5sfzZCDf9_T_3cV7NCUECyoxNk338xsAhDAVQI4aA.woff2',
      '600': 'https://fonts.gstatic.com/s/arimo/v29/P5sfzZCDf9_T_3cV7NCUECyoxNk3M8tsAhDAVQI4aA.woff2',
      '700': 'https://fonts.gstatic.com/s/arimo/v29/P5sfzZCDf9_T_3cV7NCUECyoxNk3CstsAhDAVQI4aA.woff2',
      regular: 'https://fonts.gstatic.com/s/arimo/v29/P5sfzZCDf9_T_3cV7NCUECyoxNk37cxsAhDAVQI4aA.woff2',
    },
  },
  {
    family: 'Dosis',
    files: {
      '200': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7MV2RkFTq4EPw.woff2',
      '300': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJabMV2RkFTq4EPw.woff2',
      '500': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJBbMV2RkFTq4EPw.woff2',
      '600': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ6bQV2RkFTq4EPw.woff2',
      '700': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ0LQV2RkFTq4EPw.woff2',
      '800': 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7QV2RkFTq4EPw.woff2',
      regular: 'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7MV2RkFTq4EPw.woff2',
    },
  },
  {
    family: 'Cabin',
    files: {
      '500': 'https://fonts.gstatic.com/s/cabin/v27/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkW-EL7Svxm7rE_s.woff2',
      '600': 'https://fonts.gstatic.com/s/cabin/v27/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkYODL7Svxm7rE_s.woff2',
      '700': 'https://fonts.gstatic.com/s/cabin/v27/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkbqDL7Svxm7rE_s.woff2',
      regular: 'https://fonts.gstatic.com/s/cabin/v27/u-4X0qWljRw-PfU81xCKCpdpbgZJl6XFpfEd7eA9BIxxkV2EL7Svxm7rE_s.woff2',
    },
  },
  {
    family: 'Bitter',
    files: {
      '100': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbeCLrEXFh2reU.woff2',
      '200': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbfCLrEXFh2reU.woff2',
      '300': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8ajfCLrEXFh2reU.woff2',
      '500': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8cTfCLrEXFh2reU.woff2',
      '600': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8SjYCLrEXFh2reU.woff2',
      '700': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8RHYCLrEXFh2reU.woff2',
      '800': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbYCLrEXFh2reU.woff2',
      '900': 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8V_YCLrEXFh2reU.woff2',
      regular: 'https://fonts.gstatic.com/s/bitter/v33/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCLrEXFh2reU.woff2',
    },
  },
  {
    family: 'Barlow Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxxL3I-JCGChYJ8VI-L6OO_au7B43LT2lvytKgbaw.woff2',
      '200': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B497y_3TcuKECcrs.woff2',
      '300': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47rx_3TcuKECcrs.woff2',
      '500': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lw_3TcuKECcrs.woff2',
      '600': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873_3TcuKECcrs.woff2',
      '700': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2_3TcuKECcrs.woff2',
      '800': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1_3TcuKECcrs.woff2',
      '900': 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B45L0_3TcuKECcrs.woff2',
      regular: 'https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B2xPZ23n3pKg.woff2',
    },
  },
  {
    family: 'Noto Color Emoji',
    files: {
      regular: 'https://fonts.gstatic.com/s/notocoloremoji/v30/Yq6P-KqIXTD0t4D9z1ESnKM3-HpFabts79iz64w.woff2',
    },
  },
  {
    family: 'Abel',
    files: {
      regular: 'https://fonts.gstatic.com/s/abel/v18/MwQ5bhbm2POE6V1LPJp6qGI.woff2',
    },
  },
  {
    family: 'Archivo',
    files: {
      '100': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDJp9R1oJ0vyVQ.woff2',
      '200': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTtDNp9R1oJ0vyVQ.woff2',
      '300': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTajNp9R1oJ0vyVQ.woff2',
      '500': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTBjNp9R1oJ0vyVQ.woff2',
      '600': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT6jRp9R1oJ0vyVQ.woff2',
      '700': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT0zRp9R1oJ0vyVQ.woff2',
      '800': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTtDRp9R1oJ0vyVQ.woff2',
      '900': 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTnTRp9R1oJ0vyVQ.woff2',
      regular: 'https://fonts.gstatic.com/s/archivo/v19/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDNp9R1oJ0vyVQ.woff2',
    },
  },
  {
    family: 'Source Code Pro',
    files: {
      '200': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DEyQhMthTXUcdJg.woff2',
      '300': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DJKQhMthTXUcdJg.woff2',
      '500': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DP6QhMthTXUcdJg.woff2',
      '600': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DBKXhMthTXUcdJg.woff2',
      '700': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DCuXhMthTXUcdJg.woff2',
      '800': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DEyXhMthTXUcdJg.woff2',
      '900': 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DGWXhMthTXUcdJg.woff2',
      regular: 'https://fonts.gstatic.com/s/sourcecodepro/v23/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQhMthTXUcdJg.woff2',
    },
  },
  {
    family: 'Jost',
    files: {
      '100': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7myjJAVDPokMmuHL.woff2',
      '200': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mwjJQVDPokMmuHL.woff2',
      '300': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mz9JQVDPokMmuHL.woff2',
      '500': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7myRJQVDPokMmuHL.woff2',
      '600': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mx9IgVDPokMmuHL.woff2',
      '700': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mxEIgVDPokMmuHL.woff2',
      '800': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mwjIgVDPokMmuHL.woff2',
      '900': 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7mwKIgVDPokMmuHL.woff2',
      regular: 'https://fonts.gstatic.com/s/jost/v15/92zPtBhPNqw79Ij1E865zBUv7myjJQVDPokMmuHL.woff2',
    },
  },
  {
    family: 'Josefin Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjRXMRrLgTsQV0.woff2',
      '200': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_LjQXMRrLgTsQV0.woff2',
      '300': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_GbQXMRrLgTsQV0.woff2',
      '500': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ArQXMRrLgTsQV0.woff2',
      '600': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_ObXXMRrLgTsQV0.woff2',
      '700': 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_N_XXMRrLgTsQV0.woff2',
      regular: 'https://fonts.gstatic.com/s/josefinsans/v32/Qw3PZQNVED7rKGKxtqIqX5E-AVSJrOCfjY46_DjQXMRrLgTsQV0.woff2',
    },
  },
  {
    family: 'Hind Madurai',
    files: {
      '300': 'https://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfXaUnfMsoMJ0b_g.woff2',
      '500': 'https://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfBaQnfMsoMJ0b_g.woff2',
      '600': 'https://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfKaMnfMsoMJ0b_g.woff2',
      '700': 'https://fonts.gstatic.com/s/hindmadurai/v11/f0Xu0e2p98ZvDXdZQIOcpqjfTaInfMsoMJ0b_g.woff2',
      regular: 'https://fonts.gstatic.com/s/hindmadurai/v11/f0Xx0e2p98ZvDXdZQIOcpqjn9I0DceA0OQ.woff2',
    },
  },
  {
    family: 'Dancing Script',
    files: {
      '500': 'https://fonts.gstatic.com/s/dancingscript/v25/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BAyoHSOB9ptDqpw.woff2',
      '600': 'https://fonts.gstatic.com/s/dancingscript/v25/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B7y0HSOB9ptDqpw.woff2',
      '700': 'https://fonts.gstatic.com/s/dancingscript/v25/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7B1i0HSOB9ptDqpw.woff2',
      regular: 'https://fonts.gstatic.com/s/dancingscript/v25/If2cXTr6YS-zF4S-kcSWSVi_sxjsohD9F50Ruu7BMSoHSOB9ptDqpw.woff2',
    },
  },
  {
    family: 'Libre Baskerville',
    files: {
      '700': 'https://fonts.gstatic.com/s/librebaskerville/v14/kmKiZrc3Hgbbcjq75U4uslyuy4kn0qviTjY1I8Gcw6Oi.woff2',
      regular: 'https://fonts.gstatic.com/s/librebaskerville/v14/kmKnZrc3Hgbbcjq75U4uslyuy4kn0pNbYRI4CN2V.woff2',
    },
  },
  {
    family: 'Anton',
    files: {
      regular: 'https://fonts.gstatic.com/s/anton/v25/1Ptgg87LROyAm0Kx8i4gS7lu.woff2',
    },
  },
  {
    family: 'Material Symbols Rounded',
    files: {
      '100':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rIekXxeJKJBjAa8.woff2',
      '200':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rAelXxeJKJBjAa8.woff2',
      '300':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rNmlXxeJKJBjAa8.woff2',
      '500':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rLWlXxeJKJBjAa8.woff2',
      '600':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rFmiXxeJKJBjAa8.woff2',
      '700':
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rGCiXxeJKJBjAa8.woff2',
      regular:
        'https://fonts.gstatic.com/s/materialsymbolsrounded/v168/syl0-zNym6YjUruM-QrEh7-nyTnjDwKNJ_190FjpZIvDmUSVOK7BDB_Qb9vUSzq3wzLK-P0J-V_Zs-QtQth3-jOcbTCVpeRL2w5rwZu2rIelXxeJKJBjAa8.woff2',
    },
  },
  {
    family: 'EB Garamond',
    files: {
      '500': 'https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-2fRUBoV-e6yHgQ.woff2',
      '600': 'https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-NfNUBoV-e6yHgQ.woff2',
      '700': 'https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-DPNUBoV-e6yHgQ.woff2',
      '800': 'https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-a_NUBoV-e6yHgQ.woff2',
      regular: 'https://fonts.gstatic.com/s/ebgaramond/v27/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RUBoV-e6yHgQ.woff2',
    },
  },
  {
    family: 'Cairo',
    files: {
      '200': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA-W1HoLQ-HmkA.woff2',
      '300': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hL4-W1HoLQ-HmkA.woff2',
      '500': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hNI-W1HoLQ-HmkA.woff2',
      '600': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hD45W1HoLQ-HmkA.woff2',
      '700': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hAc5W1HoLQ-HmkA.woff2',
      '800': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA5W1HoLQ-HmkA.woff2',
      '900': 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hEk5W1HoLQ-HmkA.woff2',
      regular: 'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hOA-W1HoLQ-HmkA.woff2',
    },
  },
  {
    family: 'Oxygen',
    files: {
      '300': 'https://fonts.gstatic.com/s/oxygen/v15/2sDcZG1Wl4LcnbuCJW8Dam-4C7wFZQ.woff2',
      '700': 'https://fonts.gstatic.com/s/oxygen/v15/2sDcZG1Wl4LcnbuCNWgDam-4C7wFZQ.woff2',
      regular: 'https://fonts.gstatic.com/s/oxygen/v15/2sDfZG1Wl4Lcnbu6jEcnZ0SkAg.woff2',
    },
  },
  {
    family: 'Noto Sans SC',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_EnYlNbPzS5HE.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG1_FnYlNbPzS5HE.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG4HFnYlNbPzS5HE.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG-3FnYlNbPzS5HE.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaGwHCnYlNbPzS5HE.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaGzjCnYlNbPzS5HE.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG1_CnYlNbPzS5HE.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG3bCnYlNbPzS5HE.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_FnYlNbPzS5HE.woff2',
    },
  },
  {
    family: 'PT Sans Narrow',
    files: {
      '700': 'https://fonts.gstatic.com/s/ptsansnarrow/v18/BngSUXNadjH0qYEzV7ab-oWlsbg95DiHUfzgRd-3.woff2',
      regular: 'https://fonts.gstatic.com/s/ptsansnarrow/v18/BngRUXNadjH0qYEzV7ab-oWlsYCEyxyKeuDp.woff2',
    },
  },
  {
    family: 'Hind',
    files: {
      '300': 'https://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfMJaIR6YjDpf5Vw.woff2',
      '500': 'https://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfJpbIR6YjDpf5Vw.woff2',
      '600': 'https://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfLZcIR6YjDpf5Vw.woff2',
      '700': 'https://fonts.gstatic.com/s/hind/v16/5aU19_a8oxmIfNJdIR6YjDpf5Vw.woff2',
      regular: 'https://fonts.gstatic.com/s/hind/v16/5aU69_a8oxmIRGtyBROzkDM.woff2',
    },
  },
  {
    family: 'Noto Serif JP',
    files: {
      '200': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZBaPRksfU8fEwb0.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZHKMRksfU8fEwb0.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZCqNRksfU8fEwb0.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZAaKRksfU8fEwb0.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZGKLRksfU8fEwb0.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifjp/v21/xn77YHs72GKoTvER4Gn3b5eMZFqJRksfU8fEwb0.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifjp/v21/xn7mYHs72GKoTvER4Gn3b5eMXNukYkY0T84.woff2',
    },
  },
  {
    family: 'Outfit',
    files: {
      '100': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC0C4S-EiAou6Y.woff2',
      '200': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bC1C4S-EiAou6Y.woff2',
      '300': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4W61C4S-EiAou6Y.woff2',
      '500': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4QK1C4S-EiAou6Y.woff2',
      '600': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yC4S-EiAou6Y.woff2',
      '700': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4deyC4S-EiAou6Y.woff2',
      '800': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bCyC4S-EiAou6Y.woff2',
      '900': 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4ZmyC4S-EiAou6Y.woff2',
      regular: 'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4S-EiAou6Y.woff2',
    },
  },
  {
    family: 'Material Icons Round',
    files: {
      regular: 'https://fonts.gstatic.com/s/materialiconsround/v108/LDItaoyNOAY6Uewc665JcIzCKsKc_M9flwmPq_fTTvg-.woff2',
    },
  },
  {
    family: 'Teko',
    files: {
      '300': 'https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN9JG7S33TKEvkCF.woff2',
      '500': 'https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN8lG7S33TKEvkCF.woff2',
      '600': 'https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN_JHLS33TKEvkCF.woff2',
      '700': 'https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN_wHLS33TKEvkCF.woff2',
      regular: 'https://fonts.gstatic.com/s/teko/v20/LYjYdG7kmE0gV69VVPPdFl06VN8XG7S33TKEvkCF.woff2',
    },
  },
  {
    family: 'Noto Sans HK',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qHB_-oCTiYjNvVA.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qPB--oCTiYjNvVA.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qC5--oCTiYjNvVA.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qEJ--oCTiYjNvVA.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qK55-oCTiYjNvVA.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qJd5-oCTiYjNvVA.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qPB5-oCTiYjNvVA.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qNl5-oCTiYjNvVA.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qHB--oCTiYjNvVA.woff2',
    },
  },
  {
    family: 'Pacifico',
    files: {
      regular: 'https://fonts.gstatic.com/s/pacifico/v22/FwZY7-Qmy14u9lezJ96F4sijpFu_.woff2',
    },
  },
  {
    family: 'Crimson Text',
    files: {
      '600': 'https://fonts.gstatic.com/s/crimsontext/v19/wlppgwHKFkZgtmSR3NB0oRJXsCx2DtlR1LFffg.woff2',
      '700': 'https://fonts.gstatic.com/s/crimsontext/v19/wlppgwHKFkZgtmSR3NB0oRJX1C12DtlR1LFffg.woff2',
      regular: 'https://fonts.gstatic.com/s/crimsontext/v19/wlp2gwHKFkZgtmSR3NB0oRJvbQJSA_JN3Q.woff2',
    },
  },
  {
    family: 'Nanum Gothic Coding',
    files: {
      '700': 'https://fonts.gstatic.com/s/nanumgothiccoding/v21/8QIYdjzHisX_8vv59_xMxtPFW4IXROws8xgecsB88t5V9r4.woff2',
      regular: 'https://fonts.gstatic.com/s/nanumgothiccoding/v21/8QIVdjzHisX_8vv59_xMxtPFW4IXROwsy6ExVs1X7tc.woff2',
    },
  },
  {
    family: 'Public Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpi5xg0pX189fg.woff2',
      '200': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymulpm5xg0pX189fg.woff2',
      '300': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuSJm5xg0pX189fg.woff2',
      '500': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuJJm5xg0pX189fg.woff2',
      '600': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuyJ65xg0pX189fg.woff2',
      '700': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymu8Z65xg0pX189fg.woff2',
      '800': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymulp65xg0pX189fg.woff2',
      '900': 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuv565xg0pX189fg.woff2',
      regular: 'https://fonts.gstatic.com/s/publicsans/v15/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpm5xg0pX189fg.woff2',
    },
  },
  {
    family: 'Comfortaa',
    files: {
      '300': 'https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4TbMPrEVIT9c2c8.woff2',
      '500': 'https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4VrMPrEVIT9c2c8.woff2',
      '600': 'https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4bbLPrEVIT9c2c8.woff2',
      '700': 'https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4Y_LPrEVIT9c2c8.woff2',
      regular: 'https://fonts.gstatic.com/s/comfortaa/v45/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrEVIT9c2c8.woff2',
    },
  },
  {
    family: 'Lobster',
    files: {
      regular: 'https://fonts.gstatic.com/s/lobster/v30/neILzCirqoswsqX9_oCsMqEzSJQ.woff2',
    },
  },
  {
    family: 'Exo 2',
    files: {
      '100': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvOcO9q-rpvLpQ.woff2',
      '200': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvKcO9q-rpvLpQ.woff2',
      '300': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8j4PKcO9q-rpvLpQ.woff2',
      '500': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jjPKcO9q-rpvLpQ.woff2',
      '600': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jYPWcO9q-rpvLpQ.woff2',
      '700': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jWfWcO9q-rpvLpQ.woff2',
      '800': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvWcO9q-rpvLpQ.woff2',
      '900': 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jF_WcO9q-rpvLpQ.woff2',
      regular: 'https://fonts.gstatic.com/s/exo2/v21/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKcO9q-rpvLpQ.woff2',
    },
  },
  {
    family: 'Space Grotesk',
    files: {
      '300': 'https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj62UUsmNsFjTDJK.woff2',
      '500': 'https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj7aUUsmNsFjTDJK.woff2',
      '600': 'https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj42VksmNsFjTDJK.woff2',
      '700': 'https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj4PVksmNsFjTDJK.woff2',
      regular: 'https://fonts.gstatic.com/s/spacegrotesk/v16/V8mQoQDjQSkFtoMM3T6r8E7mF71Q-gOoraIAEj7oUUsmNsFjTDJK.woff2',
    },
  },
  {
    family: 'Assistant',
    files: {
      '200': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZnEGSf3qGuvM4.woff2',
      '300': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtrhnEGSf3qGuvM4.woff2',
      '500': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQttRnEGSf3qGuvM4.woff2',
      '600': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtjhgEGSf3qGuvM4.woff2',
      '700': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtgFgEGSf3qGuvM4.woff2',
      '800': 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtmZgEGSf3qGuvM4.woff2',
      regular: 'https://fonts.gstatic.com/s/assistant/v19/2sDPZGJYnIjSi6H75xkZZE1I0yCmYzzQtuZnEGSf3qGuvM4.woff2',
    },
  },
  {
    family: 'Prompt',
    files: {
      '100': 'https://fonts.gstatic.com/s/prompt/v10/-W_9XJnvUD7dzB2CA9odREcjeo0k.woff2',
      '200': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cr_s4a2kvc5Q9dw.woff2',
      '300': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cy_g4a2kvc5Q9dw.woff2',
      '500': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Ck_k4a2kvc5Q9dw.woff2',
      '600': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cv_44a2kvc5Q9dw.woff2',
      '700': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2C2_84a2kvc5Q9dw.woff2',
      '800': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cx_w4a2kvc5Q9dw.woff2',
      '900': 'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2C4_04a2kvc5Q9dw.woff2',
      regular: 'https://fonts.gstatic.com/s/prompt/v10/-W__XJnvUD7dzB26YtAcZkIzeg.woff2',
    },
  },
  {
    family: 'Fjalla One',
    files: {
      regular: 'https://fonts.gstatic.com/s/fjallaone/v15/Yq6R-LCAWCX3-6Ky7FAFnONwkxgtUb8.woff2',
    },
  },
  {
    family: 'Signika Negative',
    files: {
      '300': 'https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAr5S73pt9hiuEq8.woff2',
      '500': 'https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAqVS73pt9hiuEq8.woff2',
      '600': 'https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAp5TL3pt9hiuEq8.woff2',
      '700': 'https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RApATL3pt9hiuEq8.woff2',
      regular: 'https://fonts.gstatic.com/s/signikanegative/v21/E21x_cfngu7HiRpPX3ZpNE4kY5zKSPmJXkF0VDD2RAqnS73pt9hiuEq8.woff2',
    },
  },
  {
    family: 'Varela Round',
    files: {
      regular: 'https://fonts.gstatic.com/s/varelaround/v20/w8gdH283Tvk__Lua32TysjIvpcGOD9gxZw.woff2',
    },
  },
  {
    family: 'Figtree',
    files: {
      '300': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_chQF5bwkEU4HTy.woff2',
      '500': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_dNQF5bwkEU4HTy.woff2',
      '600': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_ehR15bwkEU4HTy.woff2',
      '700': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_eYR15bwkEU4HTy.woff2',
      '800': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_f_R15bwkEU4HTy.woff2',
      '900': 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_fWR15bwkEU4HTy.woff2',
      regular: 'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_d_QF5bwkEU4HTy.woff2',
    },
  },
  {
    family: 'M PLUS Rounded 1c',
    files: {
      '100': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGCAYIAV6gnpUpoWwNkYvrugw9RuM3ixL4g6-av1x0.woff2',
      '300': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0q5psPxeqmzgRK.woff2',
      '500': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM1y55sPxeqmzgRK.woff2',
      '700': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM064ZsPxeqmzgRK.woff2',
      '800': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0m4psPxeqmzgRK.woff2',
      '900': 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGBAYIAV6gnpUpoWwNkYvrugw9RuM0C45sPxeqmzgRK.woff2',
      regular: 'https://fonts.gstatic.com/s/mplusrounded1c/v15/VdGEAYIAV6gnpUpoWwNkYvrugw9RuPWDzr8C7vav.woff2',
    },
  },
  {
    family: 'Overpass',
    files: {
      '100': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PLrPJCLtce-og.woff2',
      '200': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPPrPJCLtce-og.woff2',
      '300': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6ovPrPJCLtce-og.woff2',
      '500': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6zvPrPJCLtce-og.woff2',
      '600': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6IvTrPJCLtce-og.woff2',
      '700': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6G_TrPJCLtce-og.woff2',
      '800': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPTrPJCLtce-og.woff2',
      '900': 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6VfTrPJCLtce-og.woff2',
      regular: 'https://fonts.gstatic.com/s/overpass/v13/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPrPJCLtce-og.woff2',
    },
  },
  {
    family: 'Chakra Petch',
    files: {
      '300': 'https://fonts.gstatic.com/s/chakrapetch/v11/cIflMapbsEk7TDLdtEz1BwkeNIhFRZXE3AY00g.woff2',
      '500': 'https://fonts.gstatic.com/s/chakrapetch/v11/cIflMapbsEk7TDLdtEz1BwkebIlFRZXE3AY00g.woff2',
      '600': 'https://fonts.gstatic.com/s/chakrapetch/v11/cIflMapbsEk7TDLdtEz1BwkeQI5FRZXE3AY00g.woff2',
      '700': 'https://fonts.gstatic.com/s/chakrapetch/v11/cIflMapbsEk7TDLdtEz1BwkeJI9FRZXE3AY00g.woff2',
      regular: 'https://fonts.gstatic.com/s/chakrapetch/v11/cIf6MapbsEk7TDLdtEz1BwkmnaBhSL7Y1Q.woff2',
    },
  },
  {
    family: 'Red Hat Display',
    files: {
      '300': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbjKWck05-Xecg3w.woff2',
      '500': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbl6Wck05-Xecg3w.woff2',
      '600': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbrKRck05-Xecg3w.woff2',
      '700': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRck05-Xecg3w.woff2',
      '800': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbuyRck05-Xecg3w.woff2',
      '900': 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbsWRck05-Xecg3w.woff2',
      regular: 'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWck05-Xecg3w.woff2',
    },
  },
  {
    family: 'Arvo',
    files: {
      '700': 'https://fonts.gstatic.com/s/arvo/v22/tDbM2oWUg0MKoZw1yLHA8vL7lAE.woff2',
      regular: 'https://fonts.gstatic.com/s/arvo/v22/tDbD2oWUg0MKmSUa7Lzr7vs.woff2',
    },
  },
  {
    family: 'Rajdhani',
    files: {
      '300': 'https://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pasEcOpc-bGkqIw.woff2',
      '500': 'https://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pb0EMOpc-bGkqIw.woff2',
      '600': 'https://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pbYF8Opc-bGkqIw.woff2',
      '700': 'https://fonts.gstatic.com/s/rajdhani/v15/LDI2apCSOBg7S-QT7pa8FsOpc-bGkqIw.woff2',
      regular: 'https://fonts.gstatic.com/s/rajdhani/v15/LDIxapCSOBg7S-QT7q4FOeekWPrP.woff2',
    },
  },
  {
    family: 'Material Icons Sharp',
    files: {
      regular: 'https://fonts.gstatic.com/s/materialiconssharp/v109/oPWQ_lt5nv4pWNJpghLP75WiFR4kLh3kvmvRImEyc0vd.woff2',
    },
  },
  {
    family: 'Maven Pro',
    files: {
      '500': 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Rf25nWpozp5GvU.woff2',
      '600': 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8fvx5nWpozp5GvU.woff2',
      '700': 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8cLx5nWpozp5GvU.woff2',
      '800': 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8aXx5nWpozp5GvU.woff2',
      '900': 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Yzx5nWpozp5GvU.woff2',
      regular: 'https://fonts.gstatic.com/s/mavenpro/v33/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX25nWpozp5GvU.woff2',
    },
  },
  {
    family: 'Source Sans 3',
    files: {
      '200': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kw461EI_io6npfB.woff2',
      '300': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kzm61EI_io6npfB.woff2',
      '500': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8KyK61EI_io6npfB.woff2',
      '600': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxm7FEI_io6npfB.woff2',
      '700': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxf7FEI_io6npfB.woff2',
      '800': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kw47FEI_io6npfB.woff2',
      '900': 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8KwR7FEI_io6npfB.woff2',
      regular: 'https://fonts.gstatic.com/s/sourcesans3/v15/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Ky461EI_io6npfB.woff2',
    },
  },
  {
    family: 'Caveat',
    files: {
      '500': 'https://fonts.gstatic.com/s/caveat/v18/WnznHAc5bAfYB2QRah7pcpNvOx-pjcB9SIejYBxPigs.woff2',
      '600': 'https://fonts.gstatic.com/s/caveat/v18/WnznHAc5bAfYB2QRah7pcpNvOx-pjSx6SIejYBxPigs.woff2',
      '700': 'https://fonts.gstatic.com/s/caveat/v18/WnznHAc5bAfYB2QRah7pcpNvOx-pjRV6SIejYBxPigs.woff2',
      regular: 'https://fonts.gstatic.com/s/caveat/v18/WnznHAc5bAfYB2QRah7pcpNvOx-pjfJ9SIejYBxPigs.woff2',
    },
  },
  {
    family: 'IBM Plex Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6pfjptAgt5VM-kVkqdyU8n3kwq131hj-sNFQ.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6qfjptAgt5VM-kVkqdyU8n3uAL8lJPg-IUDNg.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6qfjptAgt5VM-kVkqdyU8n3oQI8lJPg-IUDNg.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6qfjptAgt5VM-kVkqdyU8n3twJ8lJPg-IUDNg.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6qfjptAgt5VM-kVkqdyU8n3vAO8lJPg-IUDNg.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F6qfjptAgt5VM-kVkqdyU8n3pQP8lJPg-IUDNg.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexmono/v19/-F63fjptAgt5VM-kVkqdyU8n5i0g1l9kn-s.woff2',
    },
  },
  {
    family: 'Play',
    files: {
      '700': 'https://fonts.gstatic.com/s/play/v19/6ae84K2oVqwItm4TOpI423nTJTM.woff2',
      regular: 'https://fonts.gstatic.com/s/play/v19/6aez4K2oVqwIjtc8Hp8Tx3A.woff2',
    },
  },
  {
    family: 'Slabo 27px',
    files: {
      regular: 'https://fonts.gstatic.com/s/slabo27px/v14/mFT0WbgBwKPR_Z4hGN2qsx0J1EJ7i90.woff2',
    },
  },
  {
    family: 'Zilla Slab',
    files: {
      '300': 'https://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYpEY2HGjWlhzbaw.woff2',
      '500': 'https://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYskZ2HGjWlhzbaw.woff2',
      '600': 'https://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYuUe2HGjWlhzbaw.woff2',
      '700': 'https://fonts.gstatic.com/s/zillaslab/v11/dFa5ZfeM_74wlPZtksIFYoEf2HGjWlhzbaw.woff2',
      regular: 'https://fonts.gstatic.com/s/zillaslab/v11/dFa6ZfeM_74wlPZtksIFWjgw_HyIRlE.woff2',
    },
  },
  {
    family: 'Cormorant Garamond',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQAllvvAWJ5heb_w.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQWlhvvAWJ5heb_w.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQdl9vvAWJ5heb_w.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorantgaramond/v16/co3YmX5slCNuHLi8bLeY9MK7whWMhyjQEl5vvAWJ5heb_w.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorantgaramond/v16/co3bmX5slCNuHLi8bLeY9MK7whWMhyjoq3FLsS6V7w.woff2',
    },
  },
  {
    family: 'Fira Sans Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOjEADFm8hSaQTFG18FErVhsC9x-tarWZXtrelQfx9CjA.woff2',
      '200': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWTnMiMZ-cxZblY4.woff2',
      '300': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWV3PiMZ-cxZblY4.woff2',
      '500': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWQXOiMZ-cxZblY4.woff2',
      '600': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWSnJiMZ-cxZblY4.woff2',
      '700': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWU3IiMZ-cxZblY4.woff2',
      '800': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWVHLiMZ-cxZblY4.woff2',
      '900': 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWXXKiMZ-cxZblY4.woff2',
      regular: 'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOhEADFm8hSaQTFG18FErVhsC9x-tarYfTnrMtVbx8.woff2',
    },
  },
  {
    family: 'Noto Sans Arabic',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyG2vvnCBFQLaig.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfSGyvvnCBFQLaig.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCflmyvvnCBFQLaig.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCf-myvvnCBFQLaig.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfFmuvvnCBFQLaig.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfL2uvvnCBFQLaig.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfSGuvvnCBFQLaig.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfYWuvvnCBFQLaig.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansarabic/v18/nwpxtLGrOAZMl5nJ_wfgRg3DrWFZWsnVBJ_sS6tlqHHFlhQ5l3sQWIHPqzCfyGyvvnCBFQLaig.woff2',
    },
  },
  {
    family: 'Shadows Into Light',
    files: {
      regular: 'https://fonts.gstatic.com/s/shadowsintolight/v19/UqyNK9UOIntux_czAvDQx_ZcHqZXBNQDd8r4xzSMYA.woff2',
    },
  },
  {
    family: 'Lexend',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsX_LVte6KuGEo.woff2',
      '200': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC7sW_LVte6KuGEo.woff2',
      '300': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC2UW_LVte6KuGEo.woff2',
      '500': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WCwkW_LVte6KuGEo.woff2',
      '600': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC-UR_LVte6KuGEo.woff2',
      '700': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC9wR_LVte6KuGEo.woff2',
      '800': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC7sR_LVte6KuGEo.woff2',
      '900': 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WC5IR_LVte6KuGEo.woff2',
      regular: 'https://fonts.gstatic.com/s/lexend/v19/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsW_LVte6KuGEo.woff2',
    },
  },
  {
    family: 'Asap',
    files: {
      '100': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqQsK2OXoA7Glw.woff2',
      '200': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYEqUsK2OXoA7Glw.woff2',
      '300': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYzKUsK2OXoA7Glw.woff2',
      '500': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYoKUsK2OXoA7Glw.woff2',
      '600': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYTKIsK2OXoA7Glw.woff2',
      '700': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYdaIsK2OXoA7Glw.woff2',
      '800': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYEqIsK2OXoA7Glw.woff2',
      '900': 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYO6IsK2OXoA7Glw.woff2',
      regular: 'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqUsK2OXoA7Glw.woff2',
    },
  },
  {
    family: 'Barlow Semi Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlphgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfG4qqKk8ogoSP.woff2',
      '200': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRft6uPBWEki52WfA.woff2',
      '300': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf06iPBWEki52WfA.woff2',
      '500': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfi6mPBWEki52WfA.woff2',
      '600': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfp66PBWEki52WfA.woff2',
      '700': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfw6-PBWEki52WfA.woff2',
      '800': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf36yPBWEki52WfA.woff2',
      '900': 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf-62PBWEki52WfA.woff2',
      regular: 'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpvgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRneoCrCEo4gg.woff2',
    },
  },
  {
    family: 'Plus Jakarta Sans',
    files: {
      '200': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_KU7NTxXUEKi4Rw.woff2',
      '300': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_907NTxXUEKi4Rw.woff2',
      '500': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_m07NTxXUEKi4Rw.woff2',
      '600': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_d0nNTxXUEKi4Rw.woff2',
      '700': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_TknNTxXUEKi4Rw.woff2',
      '800': 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_KUnNTxXUEKi4Rw.woff2',
      regular: 'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_qU7NTxXUEKi4Rw.woff2',
    },
  },
  {
    family: 'Material Icons Two Tone',
    files: {
      regular: 'https://fonts.gstatic.com/s/materialiconstwotone/v112/hESh6WRmNCxEqUmNyh3JDeGxjVVyMg4tHGctNCu0NjDrH_77.woff2',
    },
  },
  {
    family: 'Abril Fatface',
    files: {
      regular: 'https://fonts.gstatic.com/s/abrilfatface/v23/zOL64pLDlL1D99S8g8PtiKchm-VsjOLhZBY.woff2',
    },
  },
  {
    family: 'Satisfy',
    files: {
      regular: 'https://fonts.gstatic.com/s/satisfy/v21/rP2Hp2yn6lkG50LoOZGCHBeHFl0.woff2',
    },
  },
  {
    family: 'Archivo Black',
    files: {
      regular: 'https://fonts.gstatic.com/s/archivoblack/v21/HTxqL289NzCGg4MzN6KJ7eW6OY6P_x7yx3A.woff2',
    },
  },
  {
    family: 'Lilita One',
    files: {
      regular: 'https://fonts.gstatic.com/s/lilitaone/v15/i7dPIFZ9Zz-WBtRtedDbUEN2RFq7AwU.woff2',
    },
  },
  {
    family: 'Permanent Marker',
    files: {
      regular: 'https://fonts.gstatic.com/s/permanentmarker/v16/Fh4uPib9Iyv2ucM6pGQMWimMp004Ha-IfrT5nlk.woff2',
    },
  },
  {
    family: 'DM Serif Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/dmserifdisplay/v15/-nFnOHM81r4j6k0gjAW3mujVU2B2K_J709jy92k.woff2',
    },
  },
  {
    family: 'Tajawal',
    files: {
      '200': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l_6gLrNjiLlJ-G0.woff2',
      '300': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l5qjLrNjiLlJ-G0.woff2',
      '500': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l8KiLrNjiLlJ-G0.woff2',
      '700': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l4qkLrNjiLlJ-G0.woff2',
      '800': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l5anLrNjiLlJ-G0.woff2',
      '900': 'https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l7KmLrNjiLlJ-G0.woff2',
      regular: 'https://fonts.gstatic.com/s/tajawal/v9/Iura6YBj_oCad4k1rzOLCr5IlLA.woff2',
    },
  },
  {
    family: 'Indie Flower',
    files: {
      regular: 'https://fonts.gstatic.com/s/indieflower/v21/m8JVjfNVeKWVnh3QMuKkFcZla0GG1dKEDw.woff2',
    },
  },
  {
    family: 'IBM Plex Serif',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizBREVNn1dOx-zrZ2X3pZvkTi182zcZj1bIkNo.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizAREVNn1dOx-zrZ2X3pZvkTi3Q-hI2oVrBicOg.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizAREVNn1dOx-zrZ2X3pZvkTi20-RI2oVrBicOg.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizAREVNn1dOx-zrZ2X3pZvkTi3s-BI2oVrBicOg.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizAREVNn1dOx-zrZ2X3pZvkTi3A_xI2oVrBicOg.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizAREVNn1dOx-zrZ2X3pZvkTi2k_hI2oVrBicOg.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexserif/v19/jizDREVNn1dOx-zrZ2X3pZvkThUd0TY7ikbI.woff2',
    },
  },
  {
    family: 'Nanum Myeongjo',
    files: {
      '700': 'https://fonts.gstatic.com/s/nanummyeongjo/v22/9Bty3DZF0dXLMZlywRbVRNhxy2pXV1AxpfCs5Kos.woff2',
      '800': 'https://fonts.gstatic.com/s/nanummyeongjo/v22/9Bty3DZF0dXLMZlywRbVRNhxy2pLVFAxpfCs5Kos.woff2',
      regular: 'https://fonts.gstatic.com/s/nanummyeongjo/v22/9Btx3DZF0dXLMZlywRbVRNhxy1LueHQ8juyl.woff2',
    },
  },
  {
    family: 'Merriweather Sans',
    files: {
      '300': 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZ_O4li-EG7xFHnQ.woff2',
      '500': 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZkO4li-EG7xFHnQ.woff2',
      '600': 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZfOkli-EG7xFHnQ.woff2',
      '700': 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZRekli-EG7xFHnQ.woff2',
      '800': 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZIukli-EG7xFHnQ.woff2',
      regular: 'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4li-EG7xFHnQ.woff2',
    },
  },
  {
    family: 'Domine',
    files: {
      '500': 'https://fonts.gstatic.com/s/domine/v20/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X0DAI1gVErGuW8Q.woff2',
      '600': 'https://fonts.gstatic.com/s/domine/v20/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X6zHI1gVErGuW8Q.woff2',
      '700': 'https://fonts.gstatic.com/s/domine/v20/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X5XHI1gVErGuW8Q.woff2',
      regular: 'https://fonts.gstatic.com/s/domine/v20/L0xhDFMnlVwD4h3Lt9JWnbX3jG-2X3LAI1gVErGuW8Q.woff2',
    },
  },
  {
    family: 'Questrial',
    files: {
      regular: 'https://fonts.gstatic.com/s/questrial/v18/QdVUSTchPBm7nuUeVf7EvCtkm20oJA.woff2',
    },
  },
  {
    family: 'M PLUS 1p',
    files: {
      '100': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tleuShHdiFyPFzBRrQnDQFUW3aq-5N.woff2',
      '300': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tmeuShHdiFyPFzBRrQVBYgfkPWovdU4w.woff2',
      '500': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tmeuShHdiFyPFzBRrQDBcgfkPWovdU4w.woff2',
      '700': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tmeuShHdiFyPFzBRrQRBEgfkPWovdU4w.woff2',
      '800': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tmeuShHdiFyPFzBRrQWBIgfkPWovdU4w.woff2',
      '900': 'https://fonts.gstatic.com/s/mplus1p/v28/e3tmeuShHdiFyPFzBRrQfBMgfkPWovdU4w.woff2',
      regular: 'https://fonts.gstatic.com/s/mplus1p/v28/e3tjeuShHdiFyPFzBRro_T4Ec2jKqw.woff2',
    },
  },
  {
    family: 'Rowdies',
    files: {
      '300': 'https://fonts.gstatic.com/s/rowdies/v17/ptRMTieMYPNBAK219hth5OvyKQNute8.woff2',
      '700': 'https://fonts.gstatic.com/s/rowdies/v17/ptRMTieMYPNBAK219gtm5OvyKQNute8.woff2',
      regular: 'https://fonts.gstatic.com/s/rowdies/v17/ptRJTieMYPNBAK21zrJJwObZNQo.woff2',
    },
  },
  {
    family: 'Sora',
    files: {
      '100': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSdSn3-PIwNhBti0.woff2',
      '200': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSfSnn-PIwNhBti0.woff2',
      '300': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmScMnn-PIwNhBti0.woff2',
      '500': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSdgnn-PIwNhBti0.woff2',
      '600': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSeMmX-PIwNhBti0.woff2',
      '700': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSe1mX-PIwNhBti0.woff2',
      '800': 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSfSmX-PIwNhBti0.woff2',
      regular: 'https://fonts.gstatic.com/s/sora/v12/xMQOuFFYT72X5wkB_18qmnndmSdSnn-PIwNhBti0.woff2',
    },
  },
  {
    family: 'Yanone Kaffeesatz',
    files: {
      '200': 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftodtWpdWuLCnXkVA.woff2',
      '300': 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoqNWpdWuLCnXkVA.woff2',
      '500': 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoxNWpdWuLCnXkVA.woff2',
      '600': 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoKNKpdWuLCnXkVA.woff2',
      '700': 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIftoEdKpdWuLCnXkVA.woff2',
      regular: 'https://fonts.gstatic.com/s/yanonekaffeesatz/v30/3y9I6aknfjLm_3lMKjiMgmUUYBs04aUXNxt9gW2LIfto9tWpdWuLCnXkVA.woff2',
    },
  },
  {
    family: 'Signika',
    files: {
      '300': 'https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r93zuYyDMngt4xjw.woff2',
      '500': 'https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r9szuYyDMngt4xjw.woff2',
      '600': 'https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r9XzyYyDMngt4xjw.woff2',
      '700': 'https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r9ZjyYyDMngt4xjw.woff2',
      regular: 'https://fonts.gstatic.com/s/signika/v25/vEF72_JTCgwQ5ejvMV0Ox_Kg1UwJ0tKfX4zNpD8E4ASzH1r9gTuYyDMngt4xjw.woff2',
    },
  },
  {
    family: 'Catamaran',
    files: {
      '100': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjc1azXuluiLyw.woff2',
      '200': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPPjd1azXuluiLyw.woff2',
      '300': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPCbd1azXuluiLyw.woff2',
      '500': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPErd1azXuluiLyw.woff2',
      '600': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPKba1azXuluiLyw.woff2',
      '700': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPJ_a1azXuluiLyw.woff2',
      '800': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPPja1azXuluiLyw.woff2',
      '900': 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPNHa1azXuluiLyw.woff2',
      regular: 'https://fonts.gstatic.com/s/catamaran/v19/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd1azXuluiLyw.woff2',
    },
  },
  {
    family: 'Crimson Pro',
    files: {
      '200': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZTm18PZE_VNWoyQ.woff2',
      '300': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZkG18PZE_VNWoyQ.woff2',
      '500': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZ_G18PZE_VNWoyQ.woff2',
      '600': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZEGp8PZE_VNWoyQ.woff2',
      '700': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZKWp8PZE_VNWoyQ.woff2',
      '800': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZTmp8PZE_VNWoyQ.woff2',
      '900': 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZZ2p8PZE_VNWoyQ.woff2',
      regular: 'https://fonts.gstatic.com/s/crimsonpro/v24/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZzm18PZE_VNWoyQ.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Arabic',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3MZRtWPQCuHme67tEYUIx3Kh0PHR9N6YNe3PW5eMlAMg0.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPy_dCWVsVJKxTs.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YOW_tCWVsVJKxTs.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPO_9CWVsVJKxTs.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YPi-NCWVsVJKxTs.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3NZRtWPQCuHme67tEYUIx3Kh0PHR9N6YOG-dCWVsVJKxTs.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsansarabic/v12/Qw3CZRtWPQCuHme67tEYUIx3Kh0PHR9N6bs_1vSbfdlA.woff2',
    },
  },
  {
    family: 'Urbanist',
    files: {
      '100': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx8fE5OrS8SlKw.woff2',
      '200': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDSx4fE5OrS8SlKw.woff2',
      '300': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDlR4fE5OrS8SlKw.woff2',
      '500': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqD-R4fE5OrS8SlKw.woff2',
      '600': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDFRkfE5OrS8SlKw.woff2',
      '700': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDLBkfE5OrS8SlKw.woff2',
      '800': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDSxkfE5OrS8SlKw.woff2',
      '900': 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDYhkfE5OrS8SlKw.woff2',
      regular: 'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx4fE5OrS8SlKw.woff2',
    },
  },
  {
    family: 'Source Serif 4',
    files: {
      '200': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjipdqrhlXD-wGvjU.woff2',
      '300': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjiklqrhlXD-wGvjU.woff2',
      '500': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjiiVqrhlXD-wGvjU.woff2',
      '600': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjisltrhlXD-wGvjU.woff2',
      '700': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjivBtrhlXD-wGvjU.woff2',
      '800': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjipdtrhlXD-wGvjU.woff2',
      '900': 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjir5trhlXD-wGvjU.woff2',
      regular: 'https://fonts.gstatic.com/s/sourceserif4/v8/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjihdqrhlXD-wGvjU.woff2',
    },
  },
  {
    family: 'Roboto Flex',
    files: {
      regular:
        'https://fonts.gstatic.com/s/robotoflex/v26/NaNnepOXO_NexZs0b5QrzlOHb8wCikXpYqmZsWI-__OGbt8jZktqc2V3Zs0KvDLdBP8SBZtOs2IifRuUZQMsPJtUsR4DEK6cULNeUx9XgTnH37Ha_FIAp4Fm0PP1hw45DntW2x0wZGzhPmr1YNMYKYn9_1IQXGwJAiUJVUMdN5YUW4O8HtSoXjC1z3QSabshNFVe3e0O5j3ZjrZCu23Qd4G0EBysQNK-QKavMl1cKq3tHXtXi8mzLjaAQbSunCNCKMY.woff2',
    },
  },
  {
    family: 'Almarai',
    files: {
      '300': 'https://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS_anhn2coq72sXg.woff2',
      '700': 'https://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS-aghn2coq72sXg.woff2',
      '800': 'https://fonts.gstatic.com/s/almarai/v12/tssoApxBaigK_hnnS_qjhn2coq72sXg.woff2',
      regular: 'https://fonts.gstatic.com/s/almarai/v12/tsstApxBaigK_hnnc1-PonC3vqc.woff2',
    },
  },
  {
    family: 'Sarabun',
    files: {
      '100': 'https://fonts.gstatic.com/s/sarabun/v15/DtVhJx26TKEr37c9YHZJn3YI5gnOpg.woff2',
      '200': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YNpoulkm6gDXvwE.woff2',
      '300': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YL5rulkm6gDXvwE.woff2',
      '500': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YOZqulkm6gDXvwE.woff2',
      '600': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YMptulkm6gDXvwE.woff2',
      '700': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YK5sulkm6gDXvwE.woff2',
      '800': 'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YLJvulkm6gDXvwE.woff2',
      regular: 'https://fonts.gstatic.com/s/sarabun/v15/DtVjJx26TKEr37c9WBdDnlQN9gk.woff2',
    },
  },
  {
    family: 'Noticia Text',
    files: {
      '700': 'https://fonts.gstatic.com/s/noticiatext/v15/VuJpdNDF2Yv9qppOePKYRP1-3R59umHRrDH0eA.woff2',
      regular: 'https://fonts.gstatic.com/s/noticiatext/v15/VuJ2dNDF2Yv9qppOePKYRP1GZDFZt0rNpQ.woff2',
    },
  },
  {
    family: 'Archivo Narrow',
    files: {
      '500': 'https://fonts.gstatic.com/s/archivonarrow/v30/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvHlGKoXOtFCQ76Q.woff2',
      '600': 'https://fonts.gstatic.com/s/archivonarrow/v30/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhv8laKoXOtFCQ76Q.woff2',
      '700': 'https://fonts.gstatic.com/s/archivonarrow/v30/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvy1aKoXOtFCQ76Q.woff2',
      regular: 'https://fonts.gstatic.com/s/archivonarrow/v30/tss5ApVBdCYD5Q7hcxTE1ArZ0Zz8oY2KRmwvKhhvLFGKoXOtFCQ76Q.woff2',
    },
  },
  {
    family: 'Noto Kufi Arabic',
    files: {
      '100': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5v3obKnLSmf5yD.woff2',
      '200': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7v34bKnLSmf5yD.woff2',
      '300': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh4x34bKnLSmf5yD.woff2',
      '500': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5d34bKnLSmf5yD.woff2',
      '600': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh6x2IbKnLSmf5yD.woff2',
      '700': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh6I2IbKnLSmf5yD.woff2',
      '800': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7v2IbKnLSmf5yD.woff2',
      '900': 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh7G2IbKnLSmf5yD.woff2',
      regular: 'https://fonts.gstatic.com/s/notokufiarabic/v21/CSRp4ydQnPyaDxEXLFF6LZVLKrodhu8t57o1kDc5Wh5v34bKnLSmf5yD.woff2',
    },
  },
  {
    family: 'Didact Gothic',
    files: {
      regular: 'https://fonts.gstatic.com/s/didactgothic/v20/ahcfv8qz1zt6hCC5G4F_P4ASpUmSp0LlcyQ.woff2',
    },
  },
  {
    family: 'Acme',
    files: {
      regular: 'https://fonts.gstatic.com/s/acme/v25/RrQfboBx-C5_bxjLb23lzLk.woff2',
    },
  },
  {
    family: 'Orbitron',
    files: {
      '500': 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyKS6xo2IyXjU1pg.woff2',
      '600': 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyxSmxo2IyXjU1pg.woff2',
      '700': 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1ny_Cmxo2IyXjU1pg.woff2',
      '800': 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nymymxo2IyXjU1pg.woff2',
      '900': 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nysimxo2IyXjU1pg.woff2',
      regular: 'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6xo2IyXjU1pg.woff2',
    },
  },
  {
    family: 'Vollkorn',
    files: {
      '500': 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2AnGuHGOdEbD63w.woff2',
      '600': 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df27nauHGOdEbD63w.woff2',
      '700': 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df213auHGOdEbD63w.woff2',
      '800': 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2sHauHGOdEbD63w.woff2',
      '900': 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2mXauHGOdEbD63w.woff2',
      regular: 'https://fonts.gstatic.com/s/vollkorn/v23/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGuHGOdEbD63w.woff2',
    },
  },
  {
    family: 'Cinzel',
    files: {
      '500': 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-uTnTY_vDE5ZdqU.woff2',
      '600': 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-gjgTY_vDE5ZdqU.woff2',
      '700': 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-jHgTY_vDE5ZdqU.woff2',
      '800': 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-lbgTY_vDE5ZdqU.woff2',
      '900': 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-n_gTY_vDE5ZdqU.woff2',
      regular: 'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnTY_vDE5ZdqU.woff2',
    },
  },
  {
    family: 'Frank Ruhl Libre',
    files: {
      '300': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw6bYVqVPxR2EUR_.woff2',
      '500': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw73YVqVPxR2EUR_.woff2',
      '600': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4bZlqVPxR2EUR_.woff2',
      '700': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4iZlqVPxR2EUR_.woff2',
      '800': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw5FZlqVPxR2EUR_.woff2',
      '900': 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw5sZlqVPxR2EUR_.woff2',
      regular: 'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw7FYVqVPxR2EUR_.woff2',
    },
  },
  {
    family: 'Montserrat Alternates',
    files: {
      '100': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFThWacfw6zH4dthXcyms1lPpC8I_b0juU0xiKfQKphL03l4.woff2',
      '200': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xJIb1BbZH2mBhkw.woff2',
      '300': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xQIX1BbZH2mBhkw.woff2',
      '500': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xGIT1BbZH2mBhkw.woff2',
      '600': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xNIP1BbZH2mBhkw.woff2',
      '700': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xUIL1BbZH2mBhkw.woff2',
      '800': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xTIH1BbZH2mBhkw.woff2',
      '900': 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xaID1BbZH2mBhkw.woff2',
      regular: 'https://fonts.gstatic.com/s/montserratalternates/v17/mFTvWacfw6zH4dthXcyms1lPpC8I_b0juU0J6a3RCJ1b0w.woff2',
    },
  },
  {
    family: 'Exo',
    files: {
      '100': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM2CwZsOl4p5Is.woff2',
      '200': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4tM3CwZsOl4p5Is.woff2',
      '300': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4g03CwZsOl4p5Is.woff2',
      '500': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4mE3CwZsOl4p5Is.woff2',
      '600': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4o0wCwZsOl4p5Is.woff2',
      '700': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4rQwCwZsOl4p5Is.woff2',
      '800': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4tMwCwZsOl4p5Is.woff2',
      '900': 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4vowCwZsOl4p5Is.woff2',
      regular: 'https://fonts.gstatic.com/s/exo/v21/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3CwZsOl4p5Is.woff2',
    },
  },
  {
    family: 'Russo One',
    files: {
      regular: 'https://fonts.gstatic.com/s/russoone/v16/Z9XUDmZRWg6M1LvRYsH-zcOInrib9Q.woff2',
    },
  },
  {
    family: 'Bree Serif',
    files: {
      regular: 'https://fonts.gstatic.com/s/breeserif/v17/4UaHrEJCrhhnVA3DgluAx6jj5pN1MwI.woff2',
    },
  },
  {
    family: 'Alegreya Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUt9_-1phKLFgshYDvh6Vwt5TltvWdShm5bsg.woff2',
      '300': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5fFPmEh8imdCqxI.woff2',
      '500': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5alOmEh8imdCqxI.woff2',
      '700': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5eFImEh8imdCqxI.woff2',
      '800': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5f1LmEh8imdCqxI.woff2',
      '900': 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUu9_-1phKLFgshYDvh6Vwt5dlKmEh8imdCqxI.woff2',
      regular: 'https://fonts.gstatic.com/s/alegreyasans/v24/5aUz9_-1phKLFgshYDvh6Vwt3VhnvEVXlm4.woff2',
    },
  },
  {
    family: 'Amatic SC',
    files: {
      '700': 'https://fonts.gstatic.com/s/amaticsc/v26/TUZ3zwprpvBS1izr_vOMscG6fL8D3WTy-A.woff2',
      regular: 'https://fonts.gstatic.com/s/amaticsc/v26/TUZyzwprpvBS1izr_vO0CO6ecZQf1A.woff2',
    },
  },
  {
    family: 'ABeeZee',
    files: {
      regular: 'https://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6teukbcHCpE.woff2',
    },
  },
  {
    family: 'Marcellus',
    files: {
      regular: 'https://fonts.gstatic.com/s/marcellus/v13/wEO_EBrOk8hQLDvIAF8FVPAL3EsHiA.woff2',
    },
  },
  {
    family: 'Alegreya',
    files: {
      '500': 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGxBUI-aCisSGVrw.woff2',
      '600': 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGKBII-aCisSGVrw.woff2',
      '700': 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGERII-aCisSGVrw.woff2',
      '800': 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGdhII-aCisSGVrw.woff2',
      '900': 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGXxII-aCisSGVrw.woff2',
      regular: 'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI-aCisSGVrw.woff2',
    },
  },
  {
    family: 'Kalam',
    files: {
      '300': 'https://fonts.gstatic.com/s/kalam/v16/YA9Qr0Wd4kDdMtD6GgLOmCUItqGt.woff2',
      '700': 'https://fonts.gstatic.com/s/kalam/v16/YA9Qr0Wd4kDdMtDqHQLOmCUItqGt.woff2',
      regular: 'https://fonts.gstatic.com/s/kalam/v16/YA9dr0Wd4kDdMuhTMibDszkB.woff2',
    },
  },
  {
    family: 'Be Vietnam Pro',
    files: {
      '100': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVNSTAyLFyeg_IDWvOJmVES_HRUBXoYYbAiah8.woff2',
      '200': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HT4JF83T7wrcwap.woff2',
      '300': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HScJ183T7wrcwap.woff2',
      '500': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HTEJl83T7wrcwap.woff2',
      '600': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HToIV83T7wrcwap.woff2',
      '700': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSMIF83T7wrcwap.woff2',
      '800': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSQI183T7wrcwap.woff2',
      '900': 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HS0Il83T7wrcwap.woff2',
      regular: 'https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_Ew1D3s6ZKAi.woff2',
    },
  },
  {
    family: 'Tinos',
    files: {
      '700': 'https://fonts.gstatic.com/s/tinos/v24/buE1poGnedXvwj1AW0Fs2i43-cxL.woff2',
      regular: 'https://fonts.gstatic.com/s/tinos/v24/buE4poGnedXvwgX5dGVh8TI-.woff2',
    },
  },
  {
    family: 'Spectral',
    files: {
      '200': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9v2s13DY_etWWIJ.woff2',
      '300': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uSsF3DY_etWWIJ.woff2',
      '500': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vKsV3DY_etWWIJ.woff2',
      '600': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vmtl3DY_etWWIJ.woff2',
      '700': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uCt13DY_etWWIJ.woff2',
      '800': 'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uetF3DY_etWWIJ.woff2',
      regular: 'https://fonts.gstatic.com/s/spectral/v13/rnCr-xNNww_2s0amA-M7mHnOSOuk.woff2',
    },
  },
  {
    family: 'Zeyada',
    files: {
      regular: 'https://fonts.gstatic.com/s/zeyada/v19/11hAGpPTxVPUbgZDMWatWKaZ3g.woff2',
    },
  },
  {
    family: 'Alfa Slab One',
    files: {
      regular: 'https://fonts.gstatic.com/s/alfaslabone/v19/6NUQ8FmMKwSEKjnm5-4v-4Jh6dBretWvYmE.woff2',
    },
  },
  {
    family: 'Saira Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRMQgErUN8XuHNEtX81i9TmEkrnwetF2omSrzS8.woff2',
      '200': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnbcpg9aeepi2lHw.woff2',
      '300': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnCclg9aeepi2lHw.woff2',
      '500': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnUchg9aeepi2lHw.woff2',
      '600': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnfc9g9aeepi2lHw.woff2',
      '700': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnGc5g9aeepi2lHw.woff2',
      '800': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnBc1g9aeepi2lHw.woff2',
      '900': 'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnIcxg9aeepi2lHw.woff2',
      regular: 'https://fonts.gstatic.com/s/sairacondensed/v11/EJROQgErUN8XuHNEtX81i9TmEkrfoOFE-IyCrw.woff2',
    },
  },
  {
    family: 'Mate',
    files: {
      regular: 'https://fonts.gstatic.com/s/mate/v17/m8JdjftRd7WZ2zi8WoXSaLU.woff2',
    },
  },
  {
    family: 'Philosopher',
    files: {
      '700': 'https://fonts.gstatic.com/s/philosopher/v19/vEFI2_5QCwIS4_Dhez5jcWjVamgZ-NaXXq7H.woff2',
      regular: 'https://fonts.gstatic.com/s/philosopher/v19/vEFV2_5QCwIS4_Dhez5jcVBsRUwU08qe.woff2',
    },
  },
  {
    family: 'Great Vibes',
    files: {
      regular: 'https://fonts.gstatic.com/s/greatvibes/v18/RWmMoKWR9v4ksMfaWd_JN-XHg6UKDXlq.woff2',
    },
  },
  {
    family: 'Encode Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHiZtCP7FJCt2c.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHjZtCP7FJCt2c.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGD_jZtCP7FJCt2c.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGFPjZtCP7FJCt2c.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGL_kZtCP7FJCt2c.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGIbkZtCP7FJCt2c.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHkZtCP7FJCt2c.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGMjkZtCP7FJCt2c.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjZtCP7FJCt2c.woff2',
    },
  },
  {
    family: 'Chivo',
    files: {
      '100': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB7ukmDSFXjQiQ.woff2',
      '200': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_PB_ukmDSFXjQiQ.woff2',
      '300': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_4h_ukmDSFXjQiQ.woff2',
      '500': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_jh_ukmDSFXjQiQ.woff2',
      '600': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_YhjukmDSFXjQiQ.woff2',
      '700': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_WxjukmDSFXjQiQ.woff2',
      '800': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_PBjukmDSFXjQiQ.woff2',
      '900': 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_FRjukmDSFXjQiQ.woff2',
      regular: 'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB_ukmDSFXjQiQ.woff2',
    },
  },
  {
    family: 'Cormorant',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFk9TQ7Fg7A2uwYs.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFiNTQ7Fg7A2uwYs.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFs9UQ7Fg7A2uwYs.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFvZUQ7Fg7A2uwYs.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorant/v21/H4c2BXOCl9bbnla_nHIA47NMUjsNbCVrFhFTQ7Fg7A2uwYs.woff2',
    },
  },
  {
    family: 'Changa',
    files: {
      '200': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZy2xQjXp9htf1ZM.woff2',
      '300': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ_OxQjXp9htf1ZM.woff2',
      '500': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ5-xQjXp9htf1ZM.woff2',
      '600': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ3O2QjXp9htf1ZM.woff2',
      '700': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ0q2QjXp9htf1ZM.woff2',
      '800': 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZy22QjXp9htf1ZM.woff2',
      regular: 'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xQjXp9htf1ZM.woff2',
    },
  },
  {
    family: 'Lexend Deca',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48MxAqRPCqLNflg.woff2',
      '200': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cM1AqRPCqLNflg.woff2',
      '300': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4rs1AqRPCqLNflg.woff2',
      '500': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4ws1AqRPCqLNflg.woff2',
      '600': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4LspAqRPCqLNflg.woff2',
      '700': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4F8pAqRPCqLNflg.woff2',
      '800': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cMpAqRPCqLNflg.woff2',
      '900': 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4WcpAqRPCqLNflg.woff2',
      regular: 'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1AqRPCqLNflg.woff2',
    },
  },
  {
    family: 'Libre Caslon Text',
    files: {
      '700': 'https://fonts.gstatic.com/s/librecaslontext/v5/DdT578IGsGw1aF1JU10PUbTvNNaDMfID8sdmNR-8ssPt.woff2',
      regular: 'https://fonts.gstatic.com/s/librecaslontext/v5/DdT878IGsGw1aF1JU10PUbTvNNaDMcq63eNrHgO1.woff2',
    },
  },
  {
    family: 'Khand',
    files: {
      '300': 'https://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bL5cFEyZwaH__-C.woff2',
      '500': 'https://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bKhcVEyZwaH__-C.woff2',
      '600': 'https://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bKNdlEyZwaH__-C.woff2',
      '700': 'https://fonts.gstatic.com/s/khand/v17/TwMN-IINQlQQ0bLpd1EyZwaH__-C.woff2',
      regular: 'https://fonts.gstatic.com/s/khand/v17/TwMA-IINQlQQ0YpQWHU_TBqO.woff2',
    },
  },
  {
    family: 'Concert One',
    files: {
      regular: 'https://fonts.gstatic.com/s/concertone/v21/VEM1Ro9xs5PjtzCu-srDqRTghv-CuVAQ.woff2',
    },
  },
  {
    family: 'Noto Serif KR',
    files: {
      '200': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTihC8O5ZNH1ahck.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTkxB8O5ZNH1ahck.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXThRA8O5ZNH1ahck.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTjhH8O5ZNH1ahck.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTlxG8O5ZNH1ahck.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifkr/v20/3JnmSDn90Gmq2mr3blnHaTZXTmRE8O5ZNH1ahck.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifkr/v20/3Jn7SDn90Gmq2mr3blnHaTZXduVp1ONyKHQ.woff2',
    },
  },
  {
    family: 'Amiri',
    files: {
      '700': 'https://fonts.gstatic.com/s/amiri/v27/J7acnpd8CGxBHp2VkZY9xJ9CGyAa.woff2',
      regular: 'https://fonts.gstatic.com/s/amiri/v27/J7aRnpd8CGxBHqUsvrIw74NL.woff2',
    },
  },
  {
    family: 'Prata',
    files: {
      regular: 'https://fonts.gstatic.com/s/prata/v20/6xKhdSpbNNCT-vWNAG_5LWwJ.woff2',
    },
  },
  {
    family: 'Noto Sans Thai',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RspzR-QRvzzXg.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUxRtpzR-QRvzzXg.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU8ptpzR-QRvzzXg.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU6ZtpzR-QRvzzXg.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU0pqpzR-QRvzzXg.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU3NqpzR-QRvzzXg.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUxRqpzR-QRvzzXg.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUz1qpzR-QRvzzXg.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansthai/v25/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RtpzR-QRvzzXg.woff2',
    },
  },
  {
    family: 'Martel',
    files: {
      '200': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVqekagBbX9vnDzw.woff2',
      '300': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVzeoagBbX9vnDzw.woff2',
      '600': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVuewagBbX9vnDzw.woff2',
      '700': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XV3e0agBbX9vnDzw.woff2',
      '800': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XVwe4agBbX9vnDzw.woff2',
      '900': 'https://fonts.gstatic.com/s/martel/v10/PN_yRfK9oXHga0XV5e8agBbX9vnDzw.woff2',
      regular: 'https://fonts.gstatic.com/s/martel/v10/PN_xRfK9oXHga0XtZMI-jT3L_w.woff2',
    },
  },
  {
    family: 'Courgette',
    files: {
      regular: 'https://fonts.gstatic.com/s/courgette/v17/wEO_EBrAnc9BLjLQAUkFVPAL3EsHiA.woff2',
    },
  },
  {
    family: 'Old Standard TT',
    files: {
      '700': 'https://fonts.gstatic.com/s/oldstandardtt/v20/MwQrbh3o1vLImiwAVvYawgcf2eVWEX-dSVxeb80flQ.woff2',
      regular: 'https://fonts.gstatic.com/s/oldstandardtt/v20/MwQubh3o1vLImiwAVvYawgcf2eVuqFC5RHdCZg.woff2',
    },
  },
  {
    family: 'Passion One',
    files: {
      '700': 'https://fonts.gstatic.com/s/passionone/v18/Pby6FmL8HhTPqbjUzux3JEMq037twpYcuH8y.woff2',
      '900': 'https://fonts.gstatic.com/s/passionone/v18/Pby6FmL8HhTPqbjUzux3JEMS0X7twpYcuH8y.woff2',
      regular: 'https://fonts.gstatic.com/s/passionone/v18/PbynFmL8HhTPqbjUzux3JHuT_Frg6YoV.woff2',
    },
  },
  {
    family: 'Patua One',
    files: {
      regular: 'https://fonts.gstatic.com/s/patuaone/v20/ZXuke1cDvLCKLDcimxBI4fNvNA9LuA.woff2',
    },
  },
  {
    family: 'Righteous',
    files: {
      regular: 'https://fonts.gstatic.com/s/righteous/v17/1cXxaUPXBpj2rGoU7C9minuEicG01A.woff2',
    },
  },
  {
    family: 'Merienda',
    files: {
      '300': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5JHhoTE78QGBV0A.woff2',
      '500': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5SHhoTE78QGBV0A.woff2',
      '600': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5pH9oTE78QGBV0A.woff2',
      '700': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5nX9oTE78QGBV0A.woff2',
      '800': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5-n9oTE78QGBV0A.woff2',
      '900': 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5039oTE78QGBV0A.woff2',
      regular: 'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5enhoTE78QGBV0A.woff2',
    },
  },
  {
    family: 'Lobster Two',
    files: {
      '700': 'https://fonts.gstatic.com/s/lobstertwo/v20/BngRUXZGTXPUvIoyV6yN5-92w4CEyxyKeuDp.woff2',
      regular: 'https://fonts.gstatic.com/s/lobstertwo/v20/BngMUXZGTXPUvIoyV6yN59fP7KSJ4ACD.woff2',
    },
  },
  {
    family: 'Cardo',
    files: {
      '700': 'https://fonts.gstatic.com/s/cardo/v19/wlpygwjKBV1pqhND-aQU82JHaTBX.woff2',
      regular: 'https://fonts.gstatic.com/s/cardo/v19/wlp_gwjKBV1pqiv61oAZ2H5O.woff2',
    },
  },
  {
    family: 'Noto Sans Display',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cLVTSQ2iHrvWM.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp__cKVTSQ2iHrvWM.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_ykKVTSQ2iHrvWM.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_0UKVTSQ2iHrvWM.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_6kNVTSQ2iHrvWM.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_5ANVTSQ2iHrvWM.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp__cNVTSQ2iHrvWM.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_94NVTSQ2iHrvWM.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansdisplay/v26/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKVTSQ2iHrvWM.woff2',
    },
  },
  {
    family: 'PT Sans Caption',
    files: {
      '700': 'https://fonts.gstatic.com/s/ptsanscaption/v19/0FlJVP6Hrxmt7-fsUFhlFXNIlpcSwSrUTgWuz38Tgg.woff2',
      regular: 'https://fonts.gstatic.com/s/ptsanscaption/v19/0FlMVP6Hrxmt7-fsUFhlFXNIlpcqeAXwQy6yxg.woff2',
    },
  },
  {
    family: 'Asap Condensed',
    files: {
      '200': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO9DSWlBgGqgp-pO.woff2',
      '300': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO8nSmlBgGqgp-pO.woff2',
      '500': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO9_S2lBgGqgp-pO.woff2',
      '600': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO9TTGlBgGqgp-pO.woff2',
      '700': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO83TWlBgGqgp-pO.woff2',
      '800': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO8rTmlBgGqgp-pO.woff2',
      '900': 'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO8PT2lBgGqgp-pO.woff2',
      regular: 'https://fonts.gstatic.com/s/asapcondensed/v17/pxidypY1o9NHyXh3WvSbGSggdNeOYk1Mq3ap.woff2',
    },
  },
  {
    family: 'Ubuntu Condensed',
    files: {
      regular: 'https://fonts.gstatic.com/s/ubuntucondensed/v16/u-4k0rCzjgs5J7oXnJcM_0kACGMtf-LVqvHoJXw.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8nN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY7KyK7BgYsMDhM.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY5m6Yvur4cFFwq5.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY4C6ovur4cFFwq5.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY5a64vur4cFFwq5.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY527Ivur4cFFwq5.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8gN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHY4S7Yvur4cFFwq5.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsanscondensed/v14/Gg8lN4UfRSqiPg7Jn2ZI12V4DCEwkj1E4LVeHbarwq_jhJsM.woff2',
    },
  },
  {
    family: 'Cantarell',
    files: {
      '700': 'https://fonts.gstatic.com/s/cantarell/v17/B50IF7ZDq37KMUvlO01xN4dOEYSeJY8GgQ.woff2',
      regular: 'https://fonts.gstatic.com/s/cantarell/v17/B50NF7ZDq37KMUvlO01JjqhqHK-CLA.woff2',
    },
  },
  {
    family: 'League Spartan',
    files: {
      '100': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oXpAcdcFguczA.woff2',
      '200': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMfoTpAcdcFguczA.woff2',
      '300': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMoITpAcdcFguczA.woff2',
      '500': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMzITpAcdcFguczA.woff2',
      '600': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMIIPpAcdcFguczA.woff2',
      '700': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMGYPpAcdcFguczA.woff2',
      '800': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMfoPpAcdcFguczA.woff2',
      '900': 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMV4PpAcdcFguczA.woff2',
      regular: 'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oTpAcdcFguczA.woff2',
    },
  },
  {
    family: 'Josefin Slab',
    files: {
      '100': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W71mtd3w3K6CcEyI.woff2',
      '200': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W79msd3w3K6CcEyI.woff2',
      '300': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W7wesd3w3K6CcEyI.woff2',
      '500': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W72usd3w3K6CcEyI.woff2',
      '600': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W74erd3w3K6CcEyI.woff2',
      '700': 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W776rd3w3K6CcEyI.woff2',
      regular: 'https://fonts.gstatic.com/s/josefinslab/v26/lW-swjwOK3Ps5GSJlNNkMalNpiZe_ldbOR4W71msd3w3K6CcEyI.woff2',
    },
  },
  {
    family: 'Sawarabi Mincho',
    files: {
      regular: 'https://fonts.gstatic.com/s/sawarabimincho/v17/8QIRdiDaitzr7brc8ahpxt6GcIJTKKhP46UDUw.woff2',
    },
  },
  {
    family: 'Space Mono',
    files: {
      '700': 'https://fonts.gstatic.com/s/spacemono/v13/i7dMIFZifjKcF5UAWdDRaPpZYFeQHwyVd3U.woff2',
      regular: 'https://fonts.gstatic.com/s/spacemono/v13/i7dPIFZifjKcF5UAWdDRUEN2RFq7AwU.woff2',
    },
  },
  {
    family: 'Neuton',
    files: {
      '200': 'https://fonts.gstatic.com/s/neuton/v22/UMBQrPtMoH62xUZKAKkffwD5Drog6Q.woff2',
      '300': 'https://fonts.gstatic.com/s/neuton/v22/UMBQrPtMoH62xUZKZKoffwD5Drog6Q.woff2',
      '700': 'https://fonts.gstatic.com/s/neuton/v22/UMBQrPtMoH62xUZKdK0ffwD5Drog6Q.woff2',
      '800': 'https://fonts.gstatic.com/s/neuton/v22/UMBQrPtMoH62xUZKaK4ffwD5Drog6Q.woff2',
      regular: 'https://fonts.gstatic.com/s/neuton/v22/UMBTrPtMoH62xUZyzYI7civlBw.woff2',
    },
  },
  {
    family: 'Francois One',
    files: {
      regular: 'https://fonts.gstatic.com/s/francoisone/v21/_Xmr-H4zszafZw3A-KPSZutNwwKQu_avAg.woff2',
    },
  },
  {
    family: 'Titan One',
    files: {
      regular: 'https://fonts.gstatic.com/s/titanone/v15/mFTzWbsGxbbS_J5cQcjyljIn2Etikg.woff2',
    },
  },
  {
    family: 'Sacramento',
    files: {
      regular: 'https://fonts.gstatic.com/s/sacramento/v15/buEzpo6gcdjy0EiZMBUG0C8V_NxLeiw.woff2',
    },
  },
  {
    family: 'Noto Serif TC',
    files: {
      '200': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0Bvr8vbXxGTsoOAX4.woff2',
      '300': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvtssbXxGTsoOAX4.woff2',
      '500': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvoMtbXxGTsoOAX4.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0Bvq8qbXxGTsoOAX4.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvssrbXxGTsoOAX4.woff2',
      '900': 'https://fonts.gstatic.com/s/notoseriftc/v23/XLY9IZb5bJNDGYxLBibeHZ0BvvMpbXxGTsoOAX4.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriftc/v23/XLYgIZb5bJNDGYxLBibeHZ0BhnIESXFtUsM.woff2',
    },
  },
  {
    family: 'Alice',
    files: {
      regular: 'https://fonts.gstatic.com/s/alice/v20/OpNCnoEEmtHa6FcMpA_chzJ0.woff2',
    },
  },
  {
    family: 'Yantramanav',
    files: {
      '100': 'https://fonts.gstatic.com/s/yantramanav/v13/flU-Rqu5zY00QEpyWJYWN5-QXeZzDB41rZg.woff2',
      '300': 'https://fonts.gstatic.com/s/yantramanav/v13/flUhRqu5zY00QEpyWJYWN59Yf8NcIhI8tIHh.woff2',
      '500': 'https://fonts.gstatic.com/s/yantramanav/v13/flUhRqu5zY00QEpyWJYWN58AfsNcIhI8tIHh.woff2',
      '700': 'https://fonts.gstatic.com/s/yantramanav/v13/flUhRqu5zY00QEpyWJYWN59IeMNcIhI8tIHh.woff2',
      '900': 'https://fonts.gstatic.com/s/yantramanav/v13/flUhRqu5zY00QEpyWJYWN59wesNcIhI8tIHh.woff2',
      regular: 'https://fonts.gstatic.com/s/yantramanav/v13/flU8Rqu5zY00QEpyWJYWN6fxV-dRCQ41.woff2',
    },
  },
  {
    family: 'Luckiest Guy',
    files: {
      regular: 'https://fonts.gstatic.com/s/luckiestguy/v22/_gP_1RrxsjcxVyin9l9n_j2RT9R3qDpraA.woff2',
    },
  },
  {
    family: 'Oleo Script',
    files: {
      '700': 'https://fonts.gstatic.com/s/oleoscript/v14/raxkHieDvtMOe0iICsUccCDmnmrd2zqUKafv.woff2',
      regular: 'https://fonts.gstatic.com/s/oleoscript/v14/rax5HieDvtMOe0iICsUccBhfsU7Q8Cad.woff2',
    },
  },
  {
    family: 'Quattrocento Sans',
    files: {
      '700': 'https://fonts.gstatic.com/s/quattrocentosans/v18/va9Z4lja2NVIDdIAAoMR5MfuElaRB0RykmrTN33AiasJ.woff2',
      regular: 'https://fonts.gstatic.com/s/quattrocentosans/v18/va9c4lja2NVIDdIAAoMR5MfuElaRB3zLvU7eHGHJ.woff2',
    },
  },
  {
    family: 'Crete Round',
    files: {
      regular: 'https://fonts.gstatic.com/s/creteround/v14/55xoey1sJNPjPiv1ZZZrxJ1527zAKnxN.woff2',
    },
  },
  {
    family: 'Arsenal',
    files: {
      '700': 'https://fonts.gstatic.com/s/arsenal/v12/wXKuE3kQtZQ4pF3D7-P5JeEAmX8yrdk.woff2',
      regular: 'https://fonts.gstatic.com/s/arsenal/v12/wXKrE3kQtZQ4pF3D11rWAewrhXY.woff2',
    },
  },
  {
    family: 'Paytone One',
    files: {
      regular: 'https://fonts.gstatic.com/s/paytoneone/v23/0nksC9P7MfYHj2oFtYm2CiTvivr9iBq_.woff2',
    },
  },
  {
    family: 'Mate SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/matesc/v22/-nF8OGQ1-uoVr2wKyiDZ95OkJwA.woff2',
    },
  },
  {
    family: 'Kaushan Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/kaushanscript/v16/vm8vdRfvXFLG3OLnsO15WYS5DF76ytN3M48a.woff2',
    },
  },
  {
    family: 'Noto Sans Bengali',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolKudWk8izI0lc.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsglLudWk8izI0lc.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmstdLudWk8izI0lc.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsrtLudWk8izI0lc.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsldMudWk8izI0lc.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6Kmsm5MudWk8izI0lc.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsglMudWk8izI0lc.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsiBMudWk8izI0lc.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolLudWk8izI0lc.woff2',
    },
  },
  {
    family: 'Gloria Hallelujah',
    files: {
      regular: 'https://fonts.gstatic.com/s/gloriahallelujah/v21/LYjYdHv3kUk9BMV96EIswT9DIbW-MLS33TKEvkCF.woff2',
    },
  },
  {
    family: 'Gothic A1',
    files: {
      '100': 'https://fonts.gstatic.com/s/gothica1/v13/CSR74z5ZnPydRjlCCwlCCMcvYtd2vfwk.woff2',
      '200': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCpOYKTfl6tOU9Eg.woff2',
      '300': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCwOUKTfl6tOU9Eg.woff2',
      '500': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCmOQKTfl6tOU9Eg.woff2',
      '600': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCtOMKTfl6tOU9Eg.woff2',
      '700': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlC0OIKTfl6tOU9Eg.woff2',
      '800': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCzOEKTfl6tOU9Eg.woff2',
      '900': 'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlC6OAKTfl6tOU9Eg.woff2',
      regular: 'https://fonts.gstatic.com/s/gothica1/v13/CSR94z5ZnPydRjlCCwl6ac0uQNJmvQ.woff2',
    },
  },
  {
    family: 'Ubuntu Mono',
    files: {
      '700': 'https://fonts.gstatic.com/s/ubuntumono/v17/KFO-CneDtsqEr0keqCMhbC-BL-H3v4xGemO1.woff2',
      regular: 'https://fonts.gstatic.com/s/ubuntumono/v17/KFOjCneDtsqEr0keqCMhbBc4AMX6lJBP.woff2',
    },
  },
  {
    family: 'Bodoni Moda',
    files: {
      '500': 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oXzawIVytVjMYwE.woff2',
      '600': 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oZDdwIVytVjMYwE.woff2',
      '700': 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oandwIVytVjMYwE.woff2',
      '800': 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oc7dwIVytVjMYwE.woff2',
      '900': 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oefdwIVytVjMYwE.woff2',
      regular: 'https://fonts.gstatic.com/s/bodonimoda/v25/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oU7awIVytVjMYwE.woff2',
    },
  },
  {
    family: 'Saira',
    files: {
      '100': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rDos07lwYmUVY.woff2',
      '200': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA79rCos07lwYmUVY.woff2',
      '300': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA7wTCos07lwYmUVY.woff2',
      '500': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA72jCos07lwYmUVY.woff2',
      '600': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA74TFos07lwYmUVY.woff2',
      '700': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA773Fos07lwYmUVY.woff2',
      '800': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA79rFos07lwYmUVY.woff2',
      '900': 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA7_PFos07lwYmUVY.woff2',
      regular: 'https://fonts.gstatic.com/s/saira/v20/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rCos07lwYmUVY.woff2',
    },
  },
  {
    family: 'Unbounded',
    files: {
      '200': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG65jx04jHgP6LR0Y.woff2',
      '300': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG60bx04jHgP6LR0Y.woff2',
      '500': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6yrx04jHgP6LR0Y.woff2',
      '600': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG68b204jHgP6LR0Y.woff2',
      '700': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6__204jHgP6LR0Y.woff2',
      '800': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG65j204jHgP6LR0Y.woff2',
      '900': 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG67H204jHgP6LR0Y.woff2',
      regular: 'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6xjx04jHgP6LR0Y.woff2',
    },
  },
  {
    family: 'Readex Pro',
    files: {
      '200': 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCYUSmh2sglvjkag.woff2',
      '300': 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCv0Smh2sglvjkag.woff2',
      '500': 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTC00Smh2sglvjkag.woff2',
      '600': 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCP0Omh2sglvjkag.woff2',
      '700': 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTCBkOmh2sglvjkag.woff2',
      regular: 'https://fonts.gstatic.com/s/readexpro/v21/SLXnc1bJ7HE5YDoGPuzj_dh8uc7wUy8ZQQyX2KY8TL0kGZN6blTC4USmh2sglvjkag.woff2',
    },
  },
  {
    family: 'Alata',
    files: {
      regular: 'https://fonts.gstatic.com/s/alata/v9/PbytFmztEwbIofe_xKcRQEOX.woff2',
    },
  },
  {
    family: 'Pathway Gothic One',
    files: {
      regular: 'https://fonts.gstatic.com/s/pathwaygothicone/v15/MwQrbgD32-KAvjkYGNUUxAtW7pEBwx-dSVxeb80flQ.woff2',
    },
  },
  {
    family: 'Rubik Mono One',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmonoone/v18/UqyJK8kPP3hjw6ANTdfRk9YSN-81RqQrc_j9.woff2',
    },
  },
  {
    family: 'Yellowtail',
    files: {
      regular: 'https://fonts.gstatic.com/s/yellowtail/v22/OZpGg_pnoDtINPfRIlLotlnNwED-b4g.woff2',
    },
  },
  {
    family: 'DM Serif Text',
    files: {
      regular: 'https://fonts.gstatic.com/s/dmseriftext/v12/rnCu-xZa_krGokauCeNq1wWyafaPXHIJErY.woff2',
    },
  },
  {
    family: 'El Messiri',
    files: {
      '500': 'https://fonts.gstatic.com/s/elmessiri/v22/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuXCe65lhj3OoapG.woff2',
      '600': 'https://fonts.gstatic.com/s/elmessiri/v22/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUufK5lhj3OoapG.woff2',
      '700': 'https://fonts.gstatic.com/s/elmessiri/v22/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuUXfK5lhj3OoapG.woff2',
      regular: 'https://fonts.gstatic.com/s/elmessiri/v22/K2FhfZBRmr9vQ1pHEey6GIGo8_pv3myYjuXwe65lhj3OoapG.woff2',
    },
  },
  {
    family: 'Quattrocento',
    files: {
      '700': 'https://fonts.gstatic.com/s/quattrocento/v21/OZpbg_xvsDZQL_LKIF7q4jP_eE3fcqPZsXcM9w.woff2',
      regular: 'https://fonts.gstatic.com/s/quattrocento/v21/OZpEg_xvsDZQL_LKIF7q4jPHwWL7f4jFuA.woff2',
    },
  },
  {
    family: 'Gruppo',
    files: {
      regular: 'https://fonts.gstatic.com/s/gruppo/v21/WwkfxPmzE06v_ZWFXHDAOIEQUQ.woff2',
    },
  },
  {
    family: 'Black Ops One',
    files: {
      regular: 'https://fonts.gstatic.com/s/blackopsone/v20/qWcsB6-ypo7xBdr6Xshe96H3WDnRtjkho4M.woff2',
    },
  },
  {
    family: 'Noto Sans Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNI49_XVEQQL8Y.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_NNJ49_XVEQQL8Y.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_A1J49_XVEQQL8Y.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_GFJ49_XVEQQL8Y.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_I1O49_XVEQQL8Y.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_LRO49_XVEQQL8Y.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_NNO49_XVEQQL8Y.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_PpO49_XVEQQL8Y.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansmono/v30/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNJ49_XVEQQL8Y.woff2',
    },
  },
  {
    family: 'Architects Daughter',
    files: {
      regular: 'https://fonts.gstatic.com/s/architectsdaughter/v18/KtkxAKiDZI_td1Lkx62xHZHDtgO_Y-bvfYtq4szgE-Q.woff2',
    },
  },
  {
    family: 'Sawarabi Gothic',
    files: {
      regular: 'https://fonts.gstatic.com/s/sawarabigothic/v12/x3d4ckfVaqqa-BEj-I9mE65u3k3NACk3E2YljQ.woff2',
    },
  },
  {
    family: 'Albert Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5L_qY32TxAj1g.woff2',
      '200': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHK5P_qY32TxAj1g.woff2',
      '300': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSH9ZP_qY32TxAj1g.woff2',
      '500': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHmZP_qY32TxAj1g.woff2',
      '600': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHdZT_qY32TxAj1g.woff2',
      '700': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHTJT_qY32TxAj1g.woff2',
      '800': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHK5T_qY32TxAj1g.woff2',
      '900': 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHApT_qY32TxAj1g.woff2',
      regular: 'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5P_qY32TxAj1g.woff2',
    },
  },
  {
    family: 'Roboto Serif',
    files: {
      '100':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliosp6J2Af5fR4k.woff2',
      '200':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElqotp6J2Af5fR4k.woff2',
      '300':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElnQtp6J2Af5fR4k.woff2',
      '500':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElhgtp6J2Af5fR4k.woff2',
      '600':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElvQqp6J2Af5fR4k.woff2',
      '700':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEls0qp6J2Af5fR4k.woff2',
      '800':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElqoqp6J2Af5fR4k.woff2',
      '900':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEloMqp6J2Af5fR4k.woff2',
      regular:
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliotp6J2Af5fR4k.woff2',
    },
  },
  {
    family: 'Zen Kaku Gothic New',
    files: {
      '300': 'https://fonts.gstatic.com/s/zenkakugothicnew/v15/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqpdKaWHSTGlMyd8.woff2',
      '500': 'https://fonts.gstatic.com/s/zenkakugothicnew/v15/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqs9LaWHSTGlMyd8.woff2',
      '700': 'https://fonts.gstatic.com/s/zenkakugothicnew/v15/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqodNaWHSTGlMyd8.woff2',
      '900': 'https://fonts.gstatic.com/s/zenkakugothicnew/v15/gNMVW2drQpDw0GjzrVNFf_valaDBcznOqr9PaWHSTGlMyd8.woff2',
      regular: 'https://fonts.gstatic.com/s/zenkakugothicnew/v15/gNMYW2drQpDw0GjzrVNFf_valaDBcznOkj5iTWz5UGA.woff2',
    },
  },
  {
    family: 'Eczar',
    files: {
      '500': 'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXL96WrDIVKWJKWg.woff2',
      '600': 'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXw9mWrDIVKWJKWg.woff2',
      '700': 'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDX-tmWrDIVKWJKWg.woff2',
      '800': 'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXndmWrDIVKWJKWg.woff2',
      regular: 'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXHd6WrDIVKWJKWg.woff2',
    },
  },
  {
    family: 'Inter Tight',
    files: {
      '100': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw6qWSRToK8EPg.woff2',
      '200': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjjw-qWSRToK8EPg.woff2',
      '300': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjUQ-qWSRToK8EPg.woff2',
      '500': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjPQ-qWSRToK8EPg.woff2',
      '600': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj0QiqWSRToK8EPg.woff2',
      '700': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj6AiqWSRToK8EPg.woff2',
      '800': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjjwiqWSRToK8EPg.woff2',
      '900': 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjpgiqWSRToK8EPg.woff2',
      regular: 'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw-qWSRToK8EPg.woff2',
    },
  },
  {
    family: 'Noto Naskh Arabic',
    files: {
      '500': 'https://fonts.gstatic.com/s/notonaskharabic/v33/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwj85kqa0z9_Mnuw.woff2',
      '600': 'https://fonts.gstatic.com/s/notonaskharabic/v33/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwY8lkqa0z9_Mnuw.woff2',
      '700': 'https://fonts.gstatic.com/s/notonaskharabic/v33/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwWslkqa0z9_Mnuw.woff2',
      regular: 'https://fonts.gstatic.com/s/notonaskharabic/v33/RrQ5bpV-9Dd1b1OAGA6M9PkyDuVBePeKNaxcsss0Y7bwvc5kqa0z9_Mnuw.woff2',
    },
  },
  {
    family: 'Yeseva One',
    files: {
      regular: 'https://fonts.gstatic.com/s/yesevaone/v22/OpNJno4ck8vc-xYpwWWxpi9fWhXD00c.woff2',
    },
  },
  {
    family: 'Libre Barcode 39',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcode39/v21/-nFnOHM08vwC6h8Li1eQnP_AHzI2K_J709jy92k.woff2',
    },
  },
  {
    family: 'Sanchez',
    files: {
      regular: 'https://fonts.gstatic.com/s/sanchez/v15/Ycm2sZJORluHnXbITmtb_BwE1l0.woff2',
    },
  },
  {
    family: 'Encode Sans Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_76_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-5a-MLQoFI2KR.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-SY6pAiQJKnuIFA.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-LY2pAiQJKnuIFA.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-dYypAiQJKnuIFA.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-WYupAiQJKnuIFA.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-PYqpAiQJKnuIFA.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-IYmpAiQJKnuIFA.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-BYipAiQJKnuIFA.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_16_LD37rqfuwxyIuaZhE6cRXOLtm2gfTGhKWNDw8VIw.woff2',
    },
  },
  {
    family: 'Rokkitt',
    files: {
      '100': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1rydpDOE76HvN6n.woff2',
      '200': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pyd5DOE76HvN6n.woff2',
      '300': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1qsd5DOE76HvN6n.woff2',
      '500': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1rAd5DOE76HvN6n.woff2',
      '600': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oscJDOE76HvN6n.woff2',
      '700': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oVcJDOE76HvN6n.woff2',
      '800': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pycJDOE76HvN6n.woff2',
      '900': 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pbcJDOE76HvN6n.woff2',
      regular: 'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1ryd5DOE76HvN6n.woff2',
    },
  },
  {
    family: 'Antic Slab',
    files: {
      regular: 'https://fonts.gstatic.com/s/anticslab/v16/bWt97fPFfRzkCa9Jlp6IWcdWXW5p5Qo.woff2',
    },
  },
  {
    family: 'Fraunces',
    files: {
      '100':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxqjC_TShUtWNg.woff2',
      '200':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcNxujC_TShUtWNg.woff2',
      '300':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIc6RujC_TShUtWNg.woff2',
      '500':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIchRujC_TShUtWNg.woff2',
      '600':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcaRyjC_TShUtWNg.woff2',
      '700':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcUByjC_TShUtWNg.woff2',
      '800':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcNxyjC_TShUtWNg.woff2',
      '900':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcHhyjC_TShUtWNg.woff2',
      regular:
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxujC_TShUtWNg.woff2',
    },
  },
  {
    family: 'Cookie',
    files: {
      regular: 'https://fonts.gstatic.com/s/cookie/v21/syky-y18lb0tSbfNkACT9tPdpw.woff2',
    },
  },
  {
    family: 'Commissioner',
    files: {
      '100':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTMNcGPK7Fu0jUdk.woff2',
      '200':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTENdGPK7Fu0jUdk.woff2',
      '300':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTJ1dGPK7Fu0jUdk.woff2',
      '500':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTPFdGPK7Fu0jUdk.woff2',
      '600':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTB1aGPK7Fu0jUdk.woff2',
      '700':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTCRaGPK7Fu0jUdk.woff2',
      '800':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTENaGPK7Fu0jUdk.woff2',
      '900':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTGpaGPK7Fu0jUdk.woff2',
      regular:
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTMNdGPK7Fu0jUdk.woff2',
    },
  },
  {
    family: 'Macondo',
    files: {
      regular: 'https://fonts.gstatic.com/s/macondo/v25/RrQQboN9-iB1IXmOS2DO0LBBd4Y.woff2',
    },
  },
  {
    family: 'Cuprum',
    files: {
      '500': 'https://fonts.gstatic.com/s/cuprum/v25/dg45_pLmvrkcOkBnKsOzXyGWTBcmg9f6ZjnSJjQjgnU.woff2',
      '600': 'https://fonts.gstatic.com/s/cuprum/v25/dg45_pLmvrkcOkBnKsOzXyGWTBcmgzv9ZjnSJjQjgnU.woff2',
      '700': 'https://fonts.gstatic.com/s/cuprum/v25/dg45_pLmvrkcOkBnKsOzXyGWTBcmgwL9ZjnSJjQjgnU.woff2',
      regular: 'https://fonts.gstatic.com/s/cuprum/v25/dg45_pLmvrkcOkBnKsOzXyGWTBcmg-X6ZjnSJjQjgnU.woff2',
    },
  },
  {
    family: 'Poiret One',
    files: {
      regular: 'https://fonts.gstatic.com/s/poiretone/v16/UqyVK80NJXN4zfRgbdfbk5xWVscxdKE.woff2',
    },
  },
  {
    family: 'Fira Sans Extra Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPMcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3ZyuulWarE9ncg.woff2',
      '200': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3TCPn3q0oEZ-a2Q.woff2',
      '300': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3VSMn3q0oEZ-a2Q.woff2',
      '500': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3QyNn3q0oEZ-a2Q.woff2',
      '600': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3SCKn3q0oEZ-a2Q.woff2',
      '700': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3USLn3q0oEZ-a2Q.woff2',
      '800': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3ViIn3q0oEZ-a2Q.woff2',
      '900': 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3XyJn3q0oEZ-a2Q.woff2',
      regular: 'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPKcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda5f2ku3efvE8.woff2',
    },
  },
  {
    family: 'Special Elite',
    files: {
      regular: 'https://fonts.gstatic.com/s/specialelite/v18/XLYgIZbkc4JPUL5CVArUVL0nhnIESXFtUsM.woff2',
    },
  },
  {
    family: 'Bungee',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungee/v13/N0bU2SZBIuF2PU_ED350Kd_PmA.woff2',
    },
  },
  {
    family: 'Sen',
    files: {
      '500': 'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISBi5H4vKlD9q78A.woff2',
      '600': 'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISPS-H4vKlD9q78A.woff2',
      '700': 'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISM2-H4vKlD9q78A.woff2',
      '800': 'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISKq-H4vKlD9q78A.woff2',
      regular: 'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISCq5H4vKlD9q78A.woff2',
    },
  },
  {
    family: 'Unna',
    files: {
      '700': 'https://fonts.gstatic.com/s/unna/v23/AYCLpXzofN0NMiQusGzpRFpr3vc.woff2',
      regular: 'https://fonts.gstatic.com/s/unna/v23/AYCEpXzofN0NCp0BlGHCWFM.woff2',
    },
  },
  {
    family: 'Gelasio',
    files: {
      '500': 'https://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_N2CRGQsnIJkWL4.woff2',
      '600': 'https://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_PGFRGQsnIJkWL4.woff2',
      '700': 'https://fonts.gstatic.com/s/gelasio/v10/cIf4MaFfvUQxTTqS_JWERGQsnIJkWL4.woff2',
      regular: 'https://fonts.gstatic.com/s/gelasio/v10/cIf9MaFfvUQxTTqSxCyrYGkHgIs.woff2',
    },
  },
  {
    family: 'Literata',
    files: {
      '200': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbJG_F_PcTWCWp8g.woff2',
      '300': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbE-_F_PcTWCWp8g.woff2',
      '500': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbCO_F_PcTWCWp8g.woff2',
      '600': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbM-4F_PcTWCWp8g.woff2',
      '700': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbPa4F_PcTWCWp8g.woff2',
      '800': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbJG4F_PcTWCWp8g.woff2',
      '900': 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbLi4F_PcTWCWp8g.woff2',
      regular: 'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbBG_F_PcTWCWp8g.woff2',
    },
  },
  {
    family: 'Silkscreen',
    files: {
      '700': 'https://fonts.gstatic.com/s/silkscreen/v4/m8JUjfVPf62XiF7kO-i9aAhATm6o2dudFvc.woff2',
      regular: 'https://fonts.gstatic.com/s/silkscreen/v4/m8JXjfVPf62XiF7kO-i9ULFvamODxdI.woff2',
    },
  },
  {
    family: 'Alegreya Sans SC',
    files: {
      '100': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGn4-RGJqfMvt7P8FUr0Q1j-Hf1Dipl9w5FPYtmMg.woff2',
      '300': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DuJH0iFrMYJ_K-4.woff2',
      '500': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DrpG0iFrMYJ_K-4.woff2',
      '700': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DvJA0iFrMYJ_K-4.woff2',
      '800': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1Du5D0iFrMYJ_K-4.woff2',
      '900': 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGm4-RGJqfMvt7P8FUr0Q1j-Hf1DspC0iFrMYJ_K-4.woff2',
      regular: 'https://fonts.gstatic.com/s/alegreyasanssc/v23/mtGh4-RGJqfMvt7P8FUr0Q1j-Hf1Nktv9ixALYs.woff2',
    },
  },
  {
    family: 'Patrick Hand',
    files: {
      regular: 'https://fonts.gstatic.com/s/patrickhand/v23/LDI1apSQOAYtSuYWp8ZhfYeMXMjKm7sp8g.woff2',
    },
  },
  {
    family: 'Allura',
    files: {
      regular: 'https://fonts.gstatic.com/s/allura/v21/9oRPNYsQpS4zjuAPiQIXPtrrGA.woff2',
    },
  },
  {
    family: 'Tangerine',
    files: {
      '700': 'https://fonts.gstatic.com/s/tangerine/v17/Iurd6Y5j_oScZZow4VO5srNpiZtM6G0t9w.woff2',
      regular: 'https://fonts.gstatic.com/s/tangerine/v17/IurY6Y5j_oScZZow4VOBC5xNhLBQ4Q.woff2',
    },
  },
  {
    family: 'Bangers',
    files: {
      regular: 'https://fonts.gstatic.com/s/bangers/v24/FeVQS0BTqb0h60ACL5xa2bxii28.woff2',
    },
  },
  {
    family: 'Creepster',
    files: {
      regular: 'https://fonts.gstatic.com/s/creepster/v13/AlZy_zVUqJz4yMrniH4hcHf4XB0Tow.woff2',
    },
  },
  {
    family: 'Advent Pro',
    files: {
      '100': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyJPSZoonw1aBA.woff2',
      '200': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLwyNPSZoonw1aBA.woff2',
      '300': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLHSNPSZoonw1aBA.woff2',
      '500': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLcSNPSZoonw1aBA.woff2',
      '600': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLnSRPSZoonw1aBA.woff2',
      '700': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLpCRPSZoonw1aBA.woff2',
      '800': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLwyRPSZoonw1aBA.woff2',
      '900': 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpL6iRPSZoonw1aBA.woff2',
      regular: 'https://fonts.gstatic.com/s/adventpro/v28/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyNPSZoonw1aBA.woff2',
    },
  },
  {
    family: 'Aleo',
    files: {
      '100': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJ3G2P4HI4qCBtJ.woff2',
      '200': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KL3GmP4HI4qCBtJ.woff2',
      '300': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KIpGmP4HI4qCBtJ.woff2',
      '500': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJFGmP4HI4qCBtJ.woff2',
      '600': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KKpHWP4HI4qCBtJ.woff2',
      '700': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KKQHWP4HI4qCBtJ.woff2',
      '800': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KL3HWP4HI4qCBtJ.woff2',
      '900': 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KLeHWP4HI4qCBtJ.woff2',
      regular: 'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJ3GmP4HI4qCBtJ.woff2',
    },
  },
  {
    family: 'News Cycle',
    files: {
      '700': 'https://fonts.gstatic.com/s/newscycle/v23/CSR54z1Qlv-GDxkbKVQ_dFsvaNZUuOwkC2s.woff2',
      regular: 'https://fonts.gstatic.com/s/newscycle/v23/CSR64z1Qlv-GDxkbKVQ_TOIATNt_pOU.woff2',
    },
  },
  {
    family: 'Taviraj',
    files: {
      '100': 'https://fonts.gstatic.com/s/taviraj/v13/ahcbv8Cj3ylylTXzRIorUsN1jU2gog.woff2',
      '200': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRCYKd-xbgUS5u0s.woff2',
      '300': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzREIJd-xbgUS5u0s.woff2',
      '500': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRBoId-xbgUS5u0s.woff2',
      '600': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRDYPd-xbgUS5u0s.woff2',
      '700': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRFIOd-xbgUS5u0s.woff2',
      '800': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRE4Nd-xbgUS5u0s.woff2',
      '900': 'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRGoMd-xbgUS5u0s.woff2',
      regular: 'https://fonts.gstatic.com/s/taviraj/v13/ahcZv8Cj3ylylTXzfOshU-FwnU0.woff2',
    },
  },
  {
    family: 'Staatliches',
    files: {
      regular: 'https://fonts.gstatic.com/s/staatliches/v13/HI_OiY8KO6hCsQSoAPmtMbeZtJG9O9PS.woff2',
    },
  },
  {
    family: 'Mitr',
    files: {
      '200': 'https://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8fMZFJXUc1NECPY.woff2',
      '300': 'https://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8ZcaFJXUc1NECPY.woff2',
      '500': 'https://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8c8bFJXUc1NECPY.woff2',
      '600': 'https://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8eMcFJXUc1NECPY.woff2',
      '700': 'https://fonts.gstatic.com/s/mitr/v11/pxiEypw5ucZF8YcdFJXUc1NECPY.woff2',
      regular: 'https://fonts.gstatic.com/s/mitr/v11/pxiLypw5ucZFyT4yMJj_b1o.woff2',
    },
  },
  {
    family: 'DM Mono',
    files: {
      '300': 'https://fonts.gstatic.com/s/dmmono/v14/aFTR7PB1QTsUX8KYvrGyIYGnbKX9Rlk.woff2',
      '500': 'https://fonts.gstatic.com/s/dmmono/v14/aFTR7PB1QTsUX8KYvumzIYGnbKX9Rlk.woff2',
      regular: 'https://fonts.gstatic.com/s/dmmono/v14/aFTU7PB1QTsUX8KYhhiaBYyMcKw.woff2',
    },
  },
  {
    family: 'Tenor Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/tenorsans/v19/bx6ANxqUneKx06UkIXISr3dyC22IyqI.woff2',
    },
  },
  {
    family: 'Playfair Display SC',
    files: {
      '700': 'https://fonts.gstatic.com/s/playfairdisplaysc/v17/ke80OhoaMkR6-hSn7kbHVoFf7ZfgMPr_nQIpNc4dL4IUMyE.woff2',
      '900': 'https://fonts.gstatic.com/s/playfairdisplaysc/v17/ke80OhoaMkR6-hSn7kbHVoFf7ZfgMPr_nTorNc4dL4IUMyE.woff2',
      regular: 'https://fonts.gstatic.com/s/playfairdisplaysc/v17/ke85OhoaMkR6-hSn7kbHVoFf7ZfgMPr_pbsGEcM2M4s.woff2',
    },
  },
  {
    family: 'Antonio',
    files: {
      '100': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxx8BtNY2DwSXlM.woff2',
      '200': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVzx8RtNY2DwSXlM.woff2',
      '300': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVwv8RtNY2DwSXlM.woff2',
      '500': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxD8RtNY2DwSXlM.woff2',
      '600': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVyv9htNY2DwSXlM.woff2',
      '700': 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVyW9htNY2DwSXlM.woff2',
      regular: 'https://fonts.gstatic.com/s/antonio/v19/gNMbW3NwSYq_9WD34ngK5F8vR8T0PVxx8RtNY2DwSXlM.woff2',
    },
  },
  {
    family: 'Comic Neue',
    files: {
      '300': 'https://fonts.gstatic.com/s/comicneue/v8/4UaErEJDsxBrF37olUeD_wHLwp5eLwtHJlc.woff2',
      '700': 'https://fonts.gstatic.com/s/comicneue/v8/4UaErEJDsxBrF37olUeD_xHMwp5eLwtHJlc.woff2',
      regular: 'https://fonts.gstatic.com/s/comicneue/v8/4UaHrEJDsxBrF37olUeDx6jj5pN1MwI.woff2',
    },
  },
  {
    family: 'Rubik Bubbles',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikbubbles/v3/JIA1UVdwbHFJtwA7Us1BPFbRNTQNfDxyRXI.woff2',
    },
  },
  {
    family: 'Kumbh Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQkZcA9LTuUkqaLg.woff2',
      '200': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQEZYA9LTuUkqaLg.woff2',
      '300': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQz5YA9LTuUkqaLg.woff2',
      '500': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQo5YA9LTuUkqaLg.woff2',
      '600': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQT5EA9LTuUkqaLg.woff2',
      '700': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQdpEA9LTuUkqaLg.woff2',
      '800': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQEZEA9LTuUkqaLg.woff2',
      '900': 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQOJEA9LTuUkqaLg.woff2',
      regular: 'https://fonts.gstatic.com/s/kumbhsans/v22/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQkZYA9LTuUkqaLg.woff2',
    },
  },
  {
    family: 'Red Hat Text',
    files: {
      '300': 'https://fonts.gstatic.com/s/redhattext/v14/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML-ZwVrPacYVFtIY.woff2',
      '500': 'https://fonts.gstatic.com/s/redhattext/v14/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML4pwVrPacYVFtIY.woff2',
      '600': 'https://fonts.gstatic.com/s/redhattext/v14/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML2Z3VrPacYVFtIY.woff2',
      '700': 'https://fonts.gstatic.com/s/redhattext/v14/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML193VrPacYVFtIY.woff2',
      regular: 'https://fonts.gstatic.com/s/redhattext/v14/RrQCbohi_ic6B3yVSzGBrMx6ZI_cy1A6Ok2ML7hwVrPacYVFtIY.woff2',
    },
  },
  {
    family: 'JetBrains Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yK1jOFmUsaaDhw.woff2',
      '200': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8SKxjOFmUsaaDhw.woff2',
      '300': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8lqxjOFmUsaaDhw.woff2',
      '500': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8-qxjOFmUsaaDhw.woff2',
      '600': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8FqtjOFmUsaaDhw.woff2',
      '700': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8L6tjOFmUsaaDhw.woff2',
      '800': 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8SKtjOFmUsaaDhw.woff2',
      regular: 'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxjOFmUsaaDhw.woff2',
    },
  },
  {
    family: 'Carter One',
    files: {
      regular: 'https://fonts.gstatic.com/s/carterone/v17/q5uCsoe5IOB2-pXv9UcNIxF2hYxREMs.woff2',
    },
  },
  {
    family: 'Fugaz One',
    files: {
      regular: 'https://fonts.gstatic.com/s/fugazone/v19/rax_HiWKp9EAITukFslMARJek0vA8A.woff2',
    },
  },
  {
    family: 'Courier Prime',
    files: {
      '700': 'https://fonts.gstatic.com/s/courierprime/v9/u-4k0q2lgwslOqpF_6gQ8kELY7pMf-LVqvHoJXw.woff2',
      regular: 'https://fonts.gstatic.com/s/courierprime/v9/u-450q2lgwslOqpF_6gQ8kELWwNjW-_-tvg.woff2',
    },
  },
  {
    family: 'Kosugi Maru',
    files: {
      regular: 'https://fonts.gstatic.com/s/kosugimaru/v14/0nksC9PgP_wGh21A2KeqGiTvivr9iBq_.woff2',
    },
  },
  {
    family: 'Handlee',
    files: {
      regular: 'https://fonts.gstatic.com/s/handlee/v18/-F6xfjBsISg9aMakDm_6oilJ3ik.woff2',
    },
  },
  {
    family: 'STIX Two Text',
    files: {
      '500': 'https://fonts.gstatic.com/s/stixtwotext/v12/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5YihS2SOdWxFMN1WD.woff2',
      '600': 'https://fonts.gstatic.com/s/stixtwotext/v12/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5Yii-3iOdWxFMN1WD.woff2',
      '700': 'https://fonts.gstatic.com/s/stixtwotext/v12/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5YiiH3iOdWxFMN1WD.woff2',
      regular: 'https://fonts.gstatic.com/s/stixtwotext/v12/YA9Gr02F12Xkf5whdwKf11l0jbKkeidMTtZ5Yihg2SOdWxFMN1WD.woff2',
    },
  },
  {
    family: 'Secular One',
    files: {
      regular: 'https://fonts.gstatic.com/s/secularone/v12/8QINdiTajsj_87rMuMdKypDgMul7LJpK.woff2',
    },
  },
  {
    family: 'PT Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/ptmono/v13/9oRONYoBnWILk-9ArC05MtPyAcg.woff2',
    },
  },
  {
    family: 'Mukta Malar',
    files: {
      '200': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMwBtAE62ruoAZW.woff2',
      '300': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINUBdAE62ruoAZW.woff2',
      '500': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMMBNAE62ruoAZW.woff2',
      '600': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMgA9AE62ruoAZW.woff2',
      '700': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINEAtAE62ruoAZW.woff2',
      '800': 'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINYAdAE62ruoAZW.woff2',
      regular: 'https://fonts.gstatic.com/s/muktamalar/v12/MCoXzAXyz8LOE2FpJMxZqLv9LfQJwHbn.woff2',
    },
  },
  {
    family: 'Amaranth',
    files: {
      '700': 'https://fonts.gstatic.com/s/amaranth/v18/KtkpALODe433f0j1zMF-OPWn6WDfFpuc.woff2',
      regular: 'https://fonts.gstatic.com/s/amaranth/v18/KtkuALODe433f0j1zPnHF9GqwnzW.woff2',
    },
  },
  {
    family: 'Abhaya Libre',
    files: {
      '500': 'https://fonts.gstatic.com/s/abhayalibre/v17/e3t5euGtX-Co5MNzeAOqinEYj2ryr9xI6oYtBA.woff2',
      '600': 'https://fonts.gstatic.com/s/abhayalibre/v17/e3t5euGtX-Co5MNzeAOqinEYo23yr9xI6oYtBA.woff2',
      '700': 'https://fonts.gstatic.com/s/abhayalibre/v17/e3t5euGtX-Co5MNzeAOqinEYx2zyr9xI6oYtBA.woff2',
      '800': 'https://fonts.gstatic.com/s/abhayalibre/v17/e3t5euGtX-Co5MNzeAOqinEY22_yr9xI6oYtBA.woff2',
      regular: 'https://fonts.gstatic.com/s/abhayalibre/v17/e3tmeuGtX-Co5MNzeAOqinEgfkPWovdU4w.woff2',
    },
  },
  {
    family: 'Parisienne',
    files: {
      regular: 'https://fonts.gstatic.com/s/parisienne/v13/E21i_d3kivvAkxhLEVZpcyp6DuKuavM.woff2',
    },
  },
  {
    family: 'Adamina',
    files: {
      regular: 'https://fonts.gstatic.com/s/adamina/v21/j8_r6-DH1bjoc-dwu-_eETl4Bno.woff2',
    },
  },
  {
    family: 'Yatra One',
    files: {
      regular: 'https://fonts.gstatic.com/s/yatraone/v14/C8ch4copsHzj8p7NaF0xxlOBbRDvXw.woff2',
    },
  },
  {
    family: 'Vidaloka',
    files: {
      regular: 'https://fonts.gstatic.com/s/vidaloka/v18/7cHrv4c3ipenMKlEass5yn4hnCci.woff2',
    },
  },
  {
    family: 'Viga',
    files: {
      regular: 'https://fonts.gstatic.com/s/viga/v14/xMQbuFFdSaiX_QcjD4e2OX8.woff2',
    },
  },
  {
    family: 'Syne',
    files: {
      '500': 'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_0KuT6hR47NCV5Z.woff2',
      '600': 'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_3mvj6hR47NCV5Z.woff2',
      '700': 'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_3fvj6hR47NCV5Z.woff2',
      '800': 'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_24vj6hR47NCV5Z.woff2',
      regular: 'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_04uT6hR47NCV5Z.woff2',
    },
  },
  {
    family: 'Noto Sans Devanagari',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQky-UzoFoW4Ow.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlfQly-UzoFoW4Ow.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlSoly-UzoFoW4Ow.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlUYly-UzoFoW4Ow.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08Alaoiy-UzoFoW4Ow.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlZMiy-UzoFoW4Ow.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlfQiy-UzoFoW4Ow.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08Ald0iy-UzoFoW4Ow.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQly-UzoFoW4Ow.woff2',
    },
  },
  {
    family: 'Pangolin',
    files: {
      regular: 'https://fonts.gstatic.com/s/pangolin/v11/cY9GfjGcW0FPpi-tWPfP5d3aiLBG.woff2',
    },
  },
  {
    family: 'Gudea',
    files: {
      '700': 'https://fonts.gstatic.com/s/gudea/v15/neIIzCqgsI0mp9gz26WDHK06UY30.woff2',
      regular: 'https://fonts.gstatic.com/s/gudea/v15/neIFzCqgsI0mp-CK9IGON7Ez.woff2',
    },
  },
  {
    family: 'Pridi',
    files: {
      '200': 'https://fonts.gstatic.com/s/pridi/v13/2sDdZG5JnZLfkc1SiE0mRUG0AqUc.woff2',
      '300': 'https://fonts.gstatic.com/s/pridi/v13/2sDdZG5JnZLfkc02i00mRUG0AqUc.woff2',
      '500': 'https://fonts.gstatic.com/s/pridi/v13/2sDdZG5JnZLfkc1uik0mRUG0AqUc.woff2',
      '600': 'https://fonts.gstatic.com/s/pridi/v13/2sDdZG5JnZLfkc1CjU0mRUG0AqUc.woff2',
      '700': 'https://fonts.gstatic.com/s/pridi/v13/2sDdZG5JnZLfkc0mjE0mRUG0AqUc.woff2',
      regular: 'https://fonts.gstatic.com/s/pridi/v13/2sDQZG5JnZLfkfWfo2krbl29.woff2',
    },
  },
  {
    family: 'Homemade Apple',
    files: {
      regular: 'https://fonts.gstatic.com/s/homemadeapple/v22/Qw3EZQFXECDrI2q789EKQZJob3x4Vnksi4M7.woff2',
    },
  },
  {
    family: 'Faustina',
    files: {
      '300': 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHls3IEvHFWWe8tbEg.woff2',
      '500': 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlssIEvHFWWe8tbEg.woff2',
      '600': 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsXIYvHFWWe8tbEg.woff2',
      '700': 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsZYYvHFWWe8tbEg.woff2',
      '800': 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsAoYvHFWWe8tbEg.woff2',
      regular: 'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsgoEvHFWWe8tbEg.woff2',
    },
  },
  {
    family: 'Baskervville',
    files: {
      regular: 'https://fonts.gstatic.com/s/baskervville/v16/YA9Ur0yU4l_XOrogbkun3kQgspOohvbJ9A.woff2',
    },
  },
  {
    family: 'Blinker',
    files: {
      '100': 'https://fonts.gstatic.com/s/blinker/v13/cIf_MaFatEE-VTaP_E2hYUsCkIt9QQ.woff2',
      '200': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_OGARGQsnIJkWL4.woff2',
      '300': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_IWDRGQsnIJkWL4.woff2',
      '600': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_PGFRGQsnIJkWL4.woff2',
      '700': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_JWERGQsnIJkWL4.woff2',
      '800': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_ImHRGQsnIJkWL4.woff2',
      '900': 'https://fonts.gstatic.com/s/blinker/v13/cIf4MaFatEE-VTaP_K2GRGQsnIJkWL4.woff2',
      regular: 'https://fonts.gstatic.com/s/blinker/v13/cIf9MaFatEE-VTaPxCyrYGkHgIs.woff2',
    },
  },
  {
    family: 'Cousine',
    files: {
      '700': 'https://fonts.gstatic.com/s/cousine/v27/d6lNkaiiRdih4SpP9Z8K6TvG09BlnmQ.woff2',
      regular: 'https://fonts.gstatic.com/s/cousine/v27/d6lIkaiiRdih4SpPzSYlzTbtz9k.woff2',
    },
  },
  {
    family: 'Zen Maru Gothic',
    files: {
      '300': 'https://fonts.gstatic.com/s/zenmarugothic/v16/o-0XIpIxzW5b-RxT-6A8jWAtCp-cQWpCOZqa_ajlvw.woff2',
      '500': 'https://fonts.gstatic.com/s/zenmarugothic/v16/o-0XIpIxzW5b-RxT-6A8jWAtCp-cGWtCOZqa_ajlvw.woff2',
      '700': 'https://fonts.gstatic.com/s/zenmarugothic/v16/o-0XIpIxzW5b-RxT-6A8jWAtCp-cUW1COZqa_ajlvw.woff2',
      '900': 'https://fonts.gstatic.com/s/zenmarugothic/v16/o-0XIpIxzW5b-RxT-6A8jWAtCp-caW9COZqa_ajlvw.woff2',
      regular: 'https://fonts.gstatic.com/s/zenmarugothic/v16/o-0SIpIxzW5b-RxT-6A8jWAtCp-k6EJmNLGG9A.woff2',
    },
  },
  {
    family: 'Six Caps',
    files: {
      regular: 'https://fonts.gstatic.com/s/sixcaps/v20/6ae_4KGrU7VR7bNmabcX9XXaPCop.woff2',
    },
  },
  {
    family: 'Sriracha',
    files: {
      regular: 'https://fonts.gstatic.com/s/sriracha/v14/0nkrC9D4IuYBgWcI9ObdRQDioeb0.woff2',
    },
  },
  {
    family: 'Sofia',
    files: {
      regular: 'https://fonts.gstatic.com/s/sofia/v14/8QIHdirahM3j_vu7sowsrqjk.woff2',
    },
  },
  {
    family: 'Ropa Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/ropasans/v15/EYqxmaNOzLlWtsZSScyKXzloU5KP2g.woff2',
    },
  },
  {
    family: 'Volkhov',
    files: {
      '700': 'https://fonts.gstatic.com/s/volkhov/v17/SlGVmQieoJcKemNeeY4hoHFYbDQUego.woff2',
      regular: 'https://fonts.gstatic.com/s/volkhov/v17/SlGQmQieoJcKemNeQTcOhHxzcD0.woff2',
    },
  },
  {
    family: 'Baloo 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdgozapq9Fat7WcN.woff2',
      '600': 'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdjEyqpq9Fat7WcN.woff2',
      '700': 'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdj9yqpq9Fat7WcN.woff2',
      '800': 'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdiayqpq9Fat7WcN.woff2',
      regular: 'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdgazapq9Fat7WcN.woff2',
    },
  },
  {
    family: 'Forum',
    files: {
      regular: 'https://fonts.gstatic.com/s/forum/v18/6aey4Ky-Vb8Ew_ITMJMa3mnT.woff2',
    },
  },
  {
    family: 'Press Start 2P',
    files: {
      regular: 'https://fonts.gstatic.com/s/pressstart2p/v15/e3t4euO8T-267oIAQAu6jDQyK0nXgPJE4580.woff2',
    },
  },
  {
    family: 'Jura',
    files: {
      '300': 'https://fonts.gstatic.com/s/jura/v31/z7NOdRfiaC4Vd8hhoPzfb5vBTP0D7aukTfmrH_rt.woff2',
      '500': 'https://fonts.gstatic.com/s/jura/v31/z7NOdRfiaC4Vd8hhoPzfb5vBTP1v7aukTfmrH_rt.woff2',
      '600': 'https://fonts.gstatic.com/s/jura/v31/z7NOdRfiaC4Vd8hhoPzfb5vBTP2D6qukTfmrH_rt.woff2',
      '700': 'https://fonts.gstatic.com/s/jura/v31/z7NOdRfiaC4Vd8hhoPzfb5vBTP266qukTfmrH_rt.woff2',
      regular: 'https://fonts.gstatic.com/s/jura/v31/z7NOdRfiaC4Vd8hhoPzfb5vBTP1d7aukTfmrH_rt.woff2',
    },
  },
  {
    family: 'Lalezar',
    files: {
      regular: 'https://fonts.gstatic.com/s/lalezar/v14/zrfl0HLVx-HwTP82UaXyIiL0RCg.woff2',
    },
  },
  {
    family: 'Alex Brush',
    files: {
      regular: 'https://fonts.gstatic.com/s/alexbrush/v22/SZc83FzrJKuqFbwMKk6EtUf57DtOmCc.woff2',
    },
  },
  {
    family: 'Bad Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/badscript/v16/6NUT8F6PJgbFWQn47_x7lOkuzd1AZtw.woff2',
    },
  },
  {
    family: 'Noto Serif SC',
    files: {
      '200': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mm63SzVBEtERe7U.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mgq0SzVBEtERe7U.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mlK1SzVBEtERe7U.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mn6ySzVBEtERe7U.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7mhqzSzVBEtERe7U.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifsc/v22/H4c8BXePl9DZ0Xe7gG9cyOj7miKxSzVBEtERe7U.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifsc/v22/H4chBXePl9DZ0Xe7gG9cyOj7oqOcbzhqDtg.woff2',
    },
  },
  {
    family: 'Epilogue',
    files: {
      '100': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDLiCZXVigHPVA.woff2',
      '200': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXsDPiCZXVigHPVA.woff2',
      '300': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXbjPiCZXVigHPVA.woff2',
      '500': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXAjPiCZXVigHPVA.woff2',
      '600': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX7jTiCZXVigHPVA.woff2',
      '700': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX1zTiCZXVigHPVA.woff2',
      '800': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXsDTiCZXVigHPVA.woff2',
      '900': 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXmTTiCZXVigHPVA.woff2',
      regular: 'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDPiCZXVigHPVA.woff2',
    },
  },
  {
    family: 'Saira Semi Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MN6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXdvaOY8rXT-8V8.woff2',
      '200': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXfDScMTg3j36Ebz.woff2',
      '300': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXenSsMTg3j36Ebz.woff2',
      '500': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXf_S8MTg3j36Ebz.woff2',
      '600': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXfTTMMTg3j36Ebz.woff2',
      '700': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXe3TcMTg3j36Ebz.woff2',
      '800': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXerTsMTg3j36Ebz.woff2',
      '900': 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXePT8MTg3j36Ebz.woff2',
      regular: 'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MD6c-2-nnJkHxyCjRcnMHcWVWV1cWRRU8OYuceqGT-.woff2',
    },
  },
  {
    family: 'Hind Vadodara',
    files: {
      '300': 'https://fonts.gstatic.com/s/hindvadodara/v13/neIQzCKvrIcn5pbuuuriV9tTSDn3iXY0oSOL2Yw.woff2',
      '500': 'https://fonts.gstatic.com/s/hindvadodara/v13/neIQzCKvrIcn5pbuuuriV9tTSGH2iXY0oSOL2Yw.woff2',
      '600': 'https://fonts.gstatic.com/s/hindvadodara/v13/neIQzCKvrIcn5pbuuuriV9tTSE3xiXY0oSOL2Yw.woff2',
      '700': 'https://fonts.gstatic.com/s/hindvadodara/v13/neIQzCKvrIcn5pbuuuriV9tTSCnwiXY0oSOL2Yw.woff2',
      regular: 'https://fonts.gstatic.com/s/hindvadodara/v13/neINzCKvrIcn5pbuuuriV9tTcJDfrXsfvSo.woff2',
    },
  },
  {
    family: 'Bai Jamjuree',
    files: {
      '200': 'https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0kePulpA1-yiSgA.woff2',
      '300': 'https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa09eDulpA1-yiSgA.woff2',
      '500': 'https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0reHulpA1-yiSgA.woff2',
      '600': 'https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa0gebulpA1-yiSgA.woff2',
      '700': 'https://fonts.gstatic.com/s/baijamjuree/v11/LDIqapSCOBt_aeQQ7ftydoa05efulpA1-yiSgA.woff2',
      regular: 'https://fonts.gstatic.com/s/baijamjuree/v11/LDI1apSCOBt_aeQQ7ftydoaMXMjKm7sp8g.woff2',
    },
  },
  {
    family: 'Mr Dafoe',
    files: {
      regular: 'https://fonts.gstatic.com/s/mrdafoe/v14/lJwE-pIzkS5NXuMMrGivg7MCxz_C.woff2',
    },
  },
  {
    family: 'Londrina Solid',
    files: {
      '100': 'https://fonts.gstatic.com/s/londrinasolid/v17/flUjRq6sw40kQEJxWNgkLuudGfs9KBMesZHhV64.woff2',
      '300': 'https://fonts.gstatic.com/s/londrinasolid/v17/flUiRq6sw40kQEJxWNgkLuudGfv1CjYxn53oTrcL.woff2',
      '900': 'https://fonts.gstatic.com/s/londrinasolid/v17/flUiRq6sw40kQEJxWNgkLuudGfvdDzYxn53oTrcL.woff2',
      regular: 'https://fonts.gstatic.com/s/londrinasolid/v17/flUhRq6sw40kQEJxWNgkLuudGcNcIhI8tIHh.woff2',
    },
  },
  {
    family: 'Playball',
    files: {
      regular: 'https://fonts.gstatic.com/s/playball/v20/TK3gWksYAxQ7jbsKcj8Gl-tPKo2t.woff2',
    },
  },
  {
    family: 'Electrolize',
    files: {
      regular: 'https://fonts.gstatic.com/s/electrolize/v18/cIf5Ma1dtE0zSiGSiED7AUEDso5tQafB.woff2',
    },
  },
  {
    family: 'Fira Mono',
    files: {
      '500': 'https://fonts.gstatic.com/s/firamono/v14/N0bS2SlFPv1weGeLZDto1d33nP3VaZBRBQ.woff2',
      '700': 'https://fonts.gstatic.com/s/firamono/v14/N0bS2SlFPv1weGeLZDtondv3nP3VaZBRBQ.woff2',
      regular: 'https://fonts.gstatic.com/s/firamono/v14/N0bX2SlFPv1weGeLZDtQJPTTkdbJYA.woff2',
    },
  },
  {
    family: 'Shippori Mincho',
    files: {
      '500': 'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4L9am4ZEO5--2zg.woff2',
      '600': 'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4A9Gm4ZEO5--2zg.woff2',
      '700': 'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4Z9Cm4ZEO5--2zg.woff2',
      '800': 'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4e9Om4ZEO5--2zg.woff2',
      regular: 'https://fonts.gstatic.com/s/shipporimincho/v14/VdGGAZweH5EbgHY6YExcZfDoj0BA3v-C7LoS7g.woff2',
    },
  },
  {
    family: 'Reenie Beanie',
    files: {
      regular: 'https://fonts.gstatic.com/s/reeniebeanie/v20/z7NSdR76eDkaJKZJFkkjuvWxbPi_qoOgf_w.woff2',
    },
  },
  {
    family: 'Varela',
    files: {
      regular: 'https://fonts.gstatic.com/s/varela/v16/DPEtYwqExx0AWHXJARQFfvzDsQ.woff2',
    },
  },
  {
    family: 'Ultra',
    files: {
      regular: 'https://fonts.gstatic.com/s/ultra/v23/zOLy4prXmrtY-tT_yLOD6NxF.woff2',
    },
  },
  {
    family: 'Cabin Condensed',
    files: {
      '500': 'https://fonts.gstatic.com/s/cabincondensed/v20/nwpJtK6mNhBK2err_hqkYhHRqmwilMH96V15-K1oqQ.woff2',
      '600': 'https://fonts.gstatic.com/s/cabincondensed/v20/nwpJtK6mNhBK2err_hqkYhHRqmwiuMb96V15-K1oqQ.woff2',
      '700': 'https://fonts.gstatic.com/s/cabincondensed/v20/nwpJtK6mNhBK2err_hqkYhHRqmwi3Mf96V15-K1oqQ.woff2',
      regular: 'https://fonts.gstatic.com/s/cabincondensed/v20/nwpMtK6mNhBK2err_hqkYhHRqmwaZejZ5HZl8Q.woff2',
    },
  },
  {
    family: 'Audiowide',
    files: {
      regular: 'https://fonts.gstatic.com/s/audiowide/v20/l7gdbjpo0cum0ckerWCtlAXPExpQBw.woff2',
    },
  },
  {
    family: 'Castoro',
    files: {
      regular: 'https://fonts.gstatic.com/s/castoro/v19/1q2GY5yMCld3-O4cHY1EzOYenEU.woff2',
    },
  },
  {
    family: 'Anonymous Pro',
    files: {
      '700': 'https://fonts.gstatic.com/s/anonymouspro/v21/rP2cp2a15UIB7Un-bOeISG3pFuAT0CzW7KOywKo.woff2',
      regular: 'https://fonts.gstatic.com/s/anonymouspro/v21/rP2Bp2a15UIB7Un-bOeISG3pLlk89CH98Ko.woff2',
    },
  },
  {
    family: 'Ruda',
    files: {
      '500': 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJ3si_72KiSGg-H.woff2',
      '600': 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKbtS_72KiSGg-H.woff2',
      '700': 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKitS_72KiSGg-H.woff2',
      '800': 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaLFtS_72KiSGg-H.woff2',
      '900': 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaLstS_72KiSGg-H.woff2',
      regular: 'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJFsi_72KiSGg-H.woff2',
    },
  },
  {
    family: 'Nanum Pen Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/nanumpenscript/v19/daaDSSYiLGqEal3MvdA_FOL_3FkN2zv-aMFCcTU.woff2',
    },
  },
  {
    family: 'Hammersmith One',
    files: {
      regular: 'https://fonts.gstatic.com/s/hammersmithone/v17/qWcyB624q4L_C4jGQ9IK0O_dFlnbtxsks4MRXw.woff2',
    },
  },
  {
    family: 'Istok Web',
    files: {
      '700': 'https://fonts.gstatic.com/s/istokweb/v24/3qTqojGmgSyUukBzKslhvU5a-2kUYBfcMw.woff2',
      regular: 'https://fonts.gstatic.com/s/istokweb/v24/3qTvojGmgSyUukBzKslZBGF-9kIIaQ.woff2',
    },
  },
  {
    family: 'Neucha',
    files: {
      regular: 'https://fonts.gstatic.com/s/neucha/v17/q5uGsou0JOdh94bvvwNsCxVEgA.woff2',
    },
  },
  {
    family: 'Sorts Mill Goudy',
    files: {
      regular: 'https://fonts.gstatic.com/s/sortsmillgoudy/v15/Qw3GZR9MED_6PSuS_50nEaVrfzgEXHgOjpM75PE.woff2',
    },
  },
  {
    family: 'Marck Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/marckscript/v20/nwpTtK2oNgBA3Or78gapdwuCyiI-aMPF7Q.woff2',
    },
  },
  {
    family: 'Unica One',
    files: {
      regular: 'https://fonts.gstatic.com/s/unicaone/v18/DPEuYwWHyAYGVTSmalshc9ffuEY7FA.woff2',
    },
  },
  {
    family: 'Lusitana',
    files: {
      '700': 'https://fonts.gstatic.com/s/lusitana/v13/CSR74z9ShvucWzsMKyDmaccvYtd2vfwk.woff2',
      regular: 'https://fonts.gstatic.com/s/lusitana/v13/CSR84z9ShvucWzsMKxhfRuMiSct_.woff2',
    },
  },
  {
    family: 'Koulen',
    files: {
      regular: 'https://fonts.gstatic.com/s/koulen/v28/AMOQz46as3KIBPeWh3A9kuYMUg.woff2',
    },
  },
  {
    family: 'Mada',
    files: {
      '200': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFlOkHk12-m9x2iC.woff2',
      '300': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFmQkHk12-m9x2iC.woff2',
      '500': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFn8kHk12-m9x2iC.woff2',
      '600': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFkQl3k12-m9x2iC.woff2',
      '700': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFkpl3k12-m9x2iC.woff2',
      '800': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFlOl3k12-m9x2iC.woff2',
      '900': 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFlnl3k12-m9x2iC.woff2',
      regular: 'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFnOkHk12-m9x2iC.woff2',
    },
  },
  {
    family: 'Alef',
    files: {
      '700': 'https://fonts.gstatic.com/s/alef/v21/FeVQS0NQpLYglo50L5xa2bxii28.woff2',
      regular: 'https://fonts.gstatic.com/s/alef/v21/FeVfS0NQpLYgrjdbC5FxxbU.woff2',
    },
  },
  {
    family: 'Monda',
    files: {
      '700': 'https://fonts.gstatic.com/s/monda/v16/TK3gWkYFABsmjsLaGz8Gl-tPKo2t.woff2',
      regular: 'https://fonts.gstatic.com/s/monda/v16/TK3tWkYFABsmjvpjNBsLvPdG.woff2',
    },
  },
  {
    family: 'Itim',
    files: {
      regular: 'https://fonts.gstatic.com/s/itim/v14/0nknC9ziJOYewAFKkc7ZdwU.woff2',
    },
  },
  {
    family: 'Noto Serif Bengali',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAH3qi4LjQH8yD.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfeAHnqi4LjQH8yD.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfdeHnqi4LjQH8yD.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcyHnqi4LjQH8yD.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffeGXqi4LjQH8yD.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffnGXqi4LjQH8yD.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfeAGXqi4LjQH8yD.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfepGXqi4LjQH8yD.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAHnqi4LjQH8yD.woff2',
    },
  },
  {
    family: 'Rock Salt',
    files: {
      regular: 'https://fonts.gstatic.com/s/rocksalt/v22/MwQ0bhv11fWD6QsAVOZbtUk7hbBWrA.woff2',
    },
  },
  {
    family: 'League Gothic',
    files: {
      regular: 'https://fonts.gstatic.com/s/leaguegothic/v11/qFdR35CBi4tvBz81xy7WG7ep-BQAY7Krj7feObpH_-ajidQ6Q9hn.woff2',
    },
  },
  {
    family: 'Mandali',
    files: {
      regular: 'https://fonts.gstatic.com/s/mandali/v14/LhWlMVbYOfASNfNUVFw1ZPdcKtA.woff2',
    },
  },
  {
    family: 'Niramit',
    files: {
      '200': 'https://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVXx7ti2Er5_BdZ8.woff2',
      '300': 'https://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVRh4ti2Er5_BdZ8.woff2',
      '500': 'https://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVUB5ti2Er5_BdZ8.woff2',
      '600': 'https://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVWx-ti2Er5_BdZ8.woff2',
      '700': 'https://fonts.gstatic.com/s/niramit/v10/I_urMpWdvgLdNxVLVQh_ti2Er5_BdZ8.woff2',
      regular: 'https://fonts.gstatic.com/s/niramit/v10/I_uuMpWdvgLdNxVLbbFQkiCvs5Y.woff2',
    },
  },
  {
    family: 'Quantico',
    files: {
      '700': 'https://fonts.gstatic.com/s/quantico/v17/rax5HiSdp9cPL3KIF7TQARhfsU7Q8Cad.woff2',
      regular: 'https://fonts.gstatic.com/s/quantico/v17/rax-HiSdp9cPL3KIF4xpLjxSmlLZ.woff2',
    },
  },
  {
    family: 'Atkinson Hyperlegible',
    files: {
      '700': 'https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt73C1KxNDXMspQ1lPyU89-1h6ONRlW45G8WbcNdi-OZFy-FA.woff2',
      regular: 'https://fonts.gstatic.com/s/atkinsonhyperlegible/v11/9Bt23C1KxNDXMspQ1lPyU89-1h6ONRlW45GE4JgpewSSbQ.woff2',
    },
  },
  {
    family: 'Gilda Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/gildadisplay/v18/t5tmIRoYMoaYG0WEOh7HwMeR7TzFrpOHYh4.woff2',
    },
  },
  {
    family: 'Julius Sans One',
    files: {
      regular: 'https://fonts.gstatic.com/s/juliussansone/v18/1Pt2g8TAX_SGgBGUi0tGOYEga5W-wHEW6aGXHw.woff2',
    },
  },
  {
    family: 'BIZ UDPGothic',
    files: {
      '700': 'https://fonts.gstatic.com/s/bizudpgothic/v10/hESq6X5pHAIBjmS84VL0Bue85skjZWQnTABCSQo.woff2',
      regular: 'https://fonts.gstatic.com/s/bizudpgothic/v10/hES36X5pHAIBjmS84VL0Bue83nAMQWkMUAk.woff2',
    },
  },
  {
    family: 'Actor',
    files: {
      regular: 'https://fonts.gstatic.com/s/actor/v17/wEOzEBbCkc5cO3ehXygtUMIO.woff2',
    },
  },
  {
    family: 'Pragati Narrow',
    files: {
      '700': 'https://fonts.gstatic.com/s/pragatinarrow/v13/vm8sdRf0T0bS1ffgsPB7WZ-mD2ZD5fd6GJMTlo_4.woff2',
      regular: 'https://fonts.gstatic.com/s/pragatinarrow/v13/vm8vdRf0T0bS1ffgsPB7WZ-mD176ytN3M48a.woff2',
    },
  },
  {
    family: 'Krub',
    files: {
      '200': 'https://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZo47KLR4R6gWaf8.woff2',
      '300': 'https://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZuo4KLR4R6gWaf8.woff2',
      '500': 'https://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZrI5KLR4R6gWaf8.woff2',
      '600': 'https://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZp4-KLR4R6gWaf8.woff2',
      '700': 'https://fonts.gstatic.com/s/krub/v9/sZlEdRyC6CRYZvo_KLR4R6gWaf8.woff2',
      regular: 'https://fonts.gstatic.com/s/krub/v9/sZlLdRyC6CRYXkMQDLlTW6E.woff2',
    },
  },
  {
    family: 'Share Tech Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/sharetechmono/v15/J7aHnp1uDWRBEqV98dVQztYldFc7oQsEIc3Xew.woff2',
    },
  },
  {
    family: 'BenchNine',
    files: {
      '300': 'https://fonts.gstatic.com/s/benchnine/v16/ahcev8612zF4jxrwMosT--tRgGa8q0v8ag.woff2',
      '700': 'https://fonts.gstatic.com/s/benchnine/v16/ahcev8612zF4jxrwMosT6-xRgGa8q0v8ag.woff2',
      regular: 'https://fonts.gstatic.com/s/benchnine/v16/ahcbv8612zF4jxrwMosrUsN1jU2gog.woff2',
    },
  },
  {
    family: 'Gochi Hand',
    files: {
      regular: 'https://fonts.gstatic.com/s/gochihand/v23/hES06XlsOjtJsgCkx1PkTov1-n0nXWA.woff2',
    },
  },
  {
    family: 'Noto Sans Tamil',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGor0UqKDt_EvT.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tGo70UqKDt_EvT.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7uYo70UqKDt_EvT.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7v0o70UqKDt_EvT.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7sYpL0UqKDt_EvT.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7shpL0UqKDt_EvT.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tGpL0UqKDt_EvT.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tvpL0UqKDt_EvT.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGo70UqKDt_EvT.woff2',
    },
  },
  {
    family: 'Cutive Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/cutivemono/v20/m8JWjfRfY7WVjVi2E-K9H5RARG-K3Mud.woff2',
    },
  },
  {
    family: 'Sarala',
    files: {
      '700': 'https://fonts.gstatic.com/s/sarala/v12/uK_x4riEZv4o1w9ptjI3P9WYVkMpXA.woff2',
      regular: 'https://fonts.gstatic.com/s/sarala/v12/uK_y4riEZv4o1w9RDx0TMv6EXw.woff2',
    },
  },
  {
    family: 'Rakkas',
    files: {
      regular: 'https://fonts.gstatic.com/s/rakkas/v19/Qw3cZQlNHiblL3j_k9tPOeMcCw.woff2',
    },
  },
  {
    family: 'Black Han Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/blackhansans/v17/ea8Aad44WunzF9a-dL6toA8r8nqQIXSkH-Hc.woff2',
    },
  },
  {
    family: 'Nothing You Could Do',
    files: {
      regular: 'https://fonts.gstatic.com/s/nothingyoucoulddo/v19/oY1B8fbBpaP5OX3DtrRYf_Q2BPB1SnfZb0OMl1ol2Ymo.woff2',
    },
  },
  {
    family: 'Monoton',
    files: {
      regular: 'https://fonts.gstatic.com/s/monoton/v19/5h1aiZUrOngCibe4fkPBQ2S7FU8.woff2',
    },
  },
  {
    family: 'Cinzel Decorative',
    files: {
      '700': 'https://fonts.gstatic.com/s/cinzeldecorative/v16/daaHSScvJGqLYhG8nNt8KPPswUAPniZoaelGQzCLlQXE.woff2',
      '900': 'https://fonts.gstatic.com/s/cinzeldecorative/v16/daaHSScvJGqLYhG8nNt8KPPswUAPniZQa-lGQzCLlQXE.woff2',
      regular: 'https://fonts.gstatic.com/s/cinzeldecorative/v16/daaCSScvJGqLYhG8nNt8KPPswUAPnh7RRs1LaCyC.woff2',
    },
  },
  {
    family: 'Fira Code',
    files: {
      '300': 'https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_GNsFVLxN87gsj0.woff2',
      '500': 'https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_A9sFVLxN87gsj0.woff2',
      '600': 'https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_ONrFVLxN87gsj0.woff2',
      '700': 'https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_NprFVLxN87gsj0.woff2',
      regular: 'https://fonts.gstatic.com/s/firacode/v22/uU9eCBsR6Z2vfE9aq3bL0fxyUs4tcw4W_D1sFVLxN87gsj0.woff2',
    },
  },
  {
    family: 'Ramabhadra',
    files: {
      regular: 'https://fonts.gstatic.com/s/ramabhadra/v15/EYq2maBOwqRW9P1SQ83LehZGX5uWw3o.woff2',
    },
  },
  {
    family: 'Pontano Sans',
    files: {
      '300': 'https://fonts.gstatic.com/s/pontanosans/v17/qFdW35GdgYR8EzR6oBLDHa3wyRf8W8eBM6XLOSzMncOMp9gzWsE.woff2',
      '500': 'https://fonts.gstatic.com/s/pontanosans/v17/qFdW35GdgYR8EzR6oBLDHa3wyRf8W8eBM6XLOUDMncOMp9gzWsE.woff2',
      '600': 'https://fonts.gstatic.com/s/pontanosans/v17/qFdW35GdgYR8EzR6oBLDHa3wyRf8W8eBM6XLOazLncOMp9gzWsE.woff2',
      '700': 'https://fonts.gstatic.com/s/pontanosans/v17/qFdW35GdgYR8EzR6oBLDHa3wyRf8W8eBM6XLOZXLncOMp9gzWsE.woff2',
      regular: 'https://fonts.gstatic.com/s/pontanosans/v17/qFdW35GdgYR8EzR6oBLDHa3wyRf8W8eBM6XLOXLMncOMp9gzWsE.woff2',
    },
  },
  {
    family: 'Libre Bodoni',
    files: {
      '500': 'https://fonts.gstatic.com/s/librebodoni/v5/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6L9fwWnZcOb3U3s.woff2',
      '600': 'https://fonts.gstatic.com/s/librebodoni/v5/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6FNYwWnZcOb3U3s.woff2',
      '700': 'https://fonts.gstatic.com/s/librebodoni/v5/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6GpYwWnZcOb3U3s.woff2',
      regular: 'https://fonts.gstatic.com/s/librebodoni/v5/_Xm--H45qDWDYULr5OfyZudXzSBgY2oMBGte6I1fwWnZcOb3U3s.woff2',
    },
  },
  {
    family: 'Martel Sans',
    files: {
      '200': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hAX5suCFUknqMxQ.woff2',
      '300': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBz5cuCFUknqMxQ.woff2',
      '600': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hAH48uCFUknqMxQ.woff2',
      '700': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBj4suCFUknqMxQ.woff2',
      '800': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hB_4cuCFUknqMxQ.woff2',
      '900': 'https://fonts.gstatic.com/s/martelsans/v12/h0GxssGi7VdzDgKjM-4d8hBb4MuCFUknqMxQ.woff2',
      regular: 'https://fonts.gstatic.com/s/martelsans/v12/h0GsssGi7VdzDgKjM-4d8ijaze-PPlUu.woff2',
    },
  },
  {
    family: 'Damion',
    files: {
      regular: 'https://fonts.gstatic.com/s/damion/v14/hv-XlzJ3KEUe_YZUaGY3MTFgVg.woff2',
    },
  },
  {
    family: 'Rufina',
    files: {
      '700': 'https://fonts.gstatic.com/s/rufina/v15/Yq6W-LyURyLy-aKKHztAucxenxE0SA.woff2',
      regular: 'https://fonts.gstatic.com/s/rufina/v15/Yq6V-LyURyLy-aKyphRktOdClg.woff2',
    },
  },
  {
    family: 'Material Symbols Sharp',
    files: {
      '100':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxOLozCLJ1H7-knk.woff2',
      '200':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxMLojCLJ1H7-knk.woff2',
      '300':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxPVojCLJ1H7-knk.woff2',
      '500':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxO5ojCLJ1H7-knk.woff2',
      '600':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxNVpTCLJ1H7-knk.woff2',
      '700':
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxNspTCLJ1H7-knk.woff2',
      regular:
        'https://fonts.gstatic.com/s/materialsymbolssharp/v166/gNNBW2J8Roq16WD5tFNRaeLQk6-SHQ_R00k4c2_whPnoY9ruReaU4bHmz74m0ZkGH-VBYe1x0TV6x4yFH8F-H5OdzEL3sVTgJtfbYxOLojCLJ1H7-knk.woff2',
    },
  },
  {
    family: 'Covered By Your Grace',
    files: {
      regular: 'https://fonts.gstatic.com/s/coveredbyyourgrace/v15/QGYwz-AZahWOJJI9kykWW9mD6opopoqXSOS0EwItq6bFIg.woff2',
    },
  },
  {
    family: 'Playfair',
    files: {
      '300':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPlKetgYoSMw5ifm.woff2',
      '500':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPkmetgYoSMw5ifm.woff2',
      '600':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPnKfdgYoSMw5ifm.woff2',
      '700':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPnzfdgYoSMw5ifm.woff2',
      '800':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPmUfdgYoSMw5ifm.woff2',
      '900':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPm9fdgYoSMw5ifm.woff2',
      regular:
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPkUetgYoSMw5ifm.woff2',
    },
  },
  {
    family: 'Dela Gothic One',
    files: {
      regular: 'https://fonts.gstatic.com/s/delagothicone/v15/hESp6XxvMDRA-2eD0lXpDa6QkBAGQEsJQAlbUA.woff2',
    },
  },
  {
    family: 'VT323',
    files: {
      regular: 'https://fonts.gstatic.com/s/vt323/v17/pxiKyp0ihIEF2hsdHpT2dkNE.woff2',
    },
  },
  {
    family: 'Italianno',
    files: {
      regular: 'https://fonts.gstatic.com/s/italianno/v17/dg4n_p3sv6gCJkwzT6RnipYpQwM-gg.woff2',
    },
  },
  {
    family: 'Nova Square',
    files: {
      regular: 'https://fonts.gstatic.com/s/novasquare/v24/RrQUbo9-9DV7b06QHgSWsZhFRYMgGtWA.woff2',
    },
  },
  {
    family: 'Khula',
    files: {
      '300': 'https://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-ljCvRrC59XwXD.woff2',
      '600': 'https://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G_RiivRrC59XwXD.woff2',
      '700': 'https://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-1iyvRrC59XwXD.woff2',
      '800': 'https://fonts.gstatic.com/s/khula/v12/OpNPnoEOns3V7G-piCvRrC59XwXD.woff2',
      regular: 'https://fonts.gstatic.com/s/khula/v12/OpNCnoEOns3V7FcMpA_chzJ0.woff2',
    },
  },
  {
    family: 'Hanken Grotesk',
    files: {
      '100': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2da5PpNzXhRKA.woff2',
      '200': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcM2Za5PpNzXhRKA.woff2',
      '300': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Nc7WZa5PpNzXhRKA.woff2',
      '500': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcgWZa5PpNzXhRKA.woff2',
      '600': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcbWFa5PpNzXhRKA.woff2',
      '700': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcVGFa5PpNzXhRKA.woff2',
      '800': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcM2Fa5PpNzXhRKA.woff2',
      '900': 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcGmFa5PpNzXhRKA.woff2',
      regular: 'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2Za5PpNzXhRKA.woff2',
    },
  },
  {
    family: 'Andika',
    files: {
      '700': 'https://fonts.gstatic.com/s/andika/v25/mem8Ya6iyW-Lwqg40ZM1V5caXcl0Aw.woff2',
      regular: 'https://fonts.gstatic.com/s/andika/v25/mem_Ya6iyW-LwqgAaLwRWrwGVA.woff2',
    },
  },
  {
    family: 'Basic',
    files: {
      regular: 'https://fonts.gstatic.com/s/basic/v17/xfu_0WLxV2_XKQNy4lDVyR7D.woff2',
    },
  },
  {
    family: 'Jaldi',
    files: {
      '700': 'https://fonts.gstatic.com/s/jaldi/v12/or3hQ67z0_CI33voSbTyLLQ1niPn.woff2',
      regular: 'https://fonts.gstatic.com/s/jaldi/v12/or3sQ67z0_CI30NRZpD_B6g8.woff2',
    },
  },
  {
    family: 'Noto Sans Malayalam',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuH9AVzEr6HxEA.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_xuD9AVzEr6HxEA.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_GOD9AVzEr6HxEA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_dOD9AVzEr6HxEA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_mOf9AVzEr6HxEA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_oef9AVzEr6HxEA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_xuf9AVzEr6HxEA.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_7-f9AVzEr6HxEA.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuD9AVzEr6HxEA.woff2',
    },
  },
  {
    family: 'Big Shoulders Display',
    files: {
      '100': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY86JFs6SRP4yZQ.woff2',
      '200': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdQ87JFs6SRP4yZQ.woff2',
      '300': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YddE7JFs6SRP4yZQ.woff2',
      '500': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0Ydb07JFs6SRP4yZQ.woff2',
      '600': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdVE8JFs6SRP4yZQ.woff2',
      '700': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdWg8JFs6SRP4yZQ.woff2',
      '800': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdQ88JFs6SRP4yZQ.woff2',
      '900': 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdSY8JFs6SRP4yZQ.woff2',
      regular: 'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY87JFs6SRP4yZQ.woff2',
    },
  },
  {
    family: 'Pinyon Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/pinyonscript/v21/6xKpdSJbL9-e9LuoeQiDRQR8aOfQO4bhiDY.woff2',
    },
  },
  {
    family: 'Short Stack',
    files: {
      regular: 'https://fonts.gstatic.com/s/shortstack/v15/bMrzmS2X6p0jZC6EcmPFX-SXcX8D0nq6.woff2',
    },
  },
  {
    family: 'Kreon',
    files: {
      '300': 'https://fonts.gstatic.com/s/kreon/v37/t5t9IRIUKY-TFF_LW5lnMR3v2DnvPNimfzUfp2dWNg.woff2',
      '500': 'https://fonts.gstatic.com/s/kreon/v37/t5t9IRIUKY-TFF_LW5lnMR3v2DnvUNimfzUfp2dWNg.woff2',
      '600': 'https://fonts.gstatic.com/s/kreon/v37/t5t9IRIUKY-TFF_LW5lnMR3v2DnvvN-mfzUfp2dWNg.woff2',
      '700': 'https://fonts.gstatic.com/s/kreon/v37/t5t9IRIUKY-TFF_LW5lnMR3v2Dnvhd-mfzUfp2dWNg.woff2',
      regular: 'https://fonts.gstatic.com/s/kreon/v37/t5t9IRIUKY-TFF_LW5lnMR3v2DnvYtimfzUfp2dWNg.woff2',
    },
  },
  {
    family: 'Changa One',
    files: {
      regular: 'https://fonts.gstatic.com/s/changaone/v20/xfu00W3wXn3QLUJXhzq46APouLfbK64.woff2',
    },
  },
  {
    family: 'Noto Sans Hebrew',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4utpyJltutR2g.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX94qtpyJltutR2g.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXKYqtpyJltutR2g.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXRYqtpyJltutR2g.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXqY2tpyJltutR2g.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXkI2tpyJltutR2g.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX942tpyJltutR2g.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX3o2tpyJltutR2g.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4qtpyJltutR2g.woff2',
    },
  },
  {
    family: 'Holtwood One SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/holtwoodonesc/v20/yYLx0hLR0P-3vMFSk1TCq3Txg5B3dLb6LZttyg.woff2',
    },
  },
  {
    family: 'Economica',
    files: {
      '700': 'https://fonts.gstatic.com/s/economica/v15/Qw3aZQZaHCLgIWa29ZBTjeckD3Z5dHw8iw.woff2',
      regular: 'https://fonts.gstatic.com/s/economica/v15/Qw3fZQZaHCLgIWa29ZBrNMgAAl1lfQ.woff2',
    },
  },
  {
    family: 'Quintessential',
    files: {
      regular: 'https://fonts.gstatic.com/s/quintessential/v22/fdNn9sOGq31Yjnh3qWU14DdtjY51S7kmAyxM.woff2',
    },
  },
  {
    family: 'Rammetto One',
    files: {
      regular: 'https://fonts.gstatic.com/s/rammettoone/v18/LhWiMV3HOfMbMetJG3lQDpp9N_uciu-_SQ.woff2',
    },
  },
  {
    family: 'Amita',
    files: {
      '700': 'https://fonts.gstatic.com/s/amita/v18/HhyXU5si9Om7PTHTLtCHOopCTKkI.woff2',
      regular: 'https://fonts.gstatic.com/s/amita/v18/HhyaU5si9Om7PQlqAfSKEZZL.woff2',
    },
  },
  {
    family: 'Shrikhand',
    files: {
      regular: 'https://fonts.gstatic.com/s/shrikhand/v15/a8IbNovtLWfR7T7bMJwbAYiQ0zhMtA.woff2',
    },
  },
  {
    family: 'Trocchi',
    files: {
      regular: 'https://fonts.gstatic.com/s/trocchi/v17/qWcqB6WkuIDxDZLcDr5UvMeTYD0.woff2',
    },
  },
  {
    family: 'Saira Extra Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFsOHYr-vcC7h8MklGBkrvmUG9rbpkisrTri0j09i5ss3a3.woff2',
      '200': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrJ2nR2QBgum-uoQ.woff2',
      '300': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrQ2rR2QBgum-uoQ.woff2',
      '500': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrG2vR2QBgum-uoQ.woff2',
      '600': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrN2zR2QBgum-uoQ.woff2',
      '700': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrU23R2QBgum-uoQ.woff2',
      '800': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrT27R2QBgum-uoQ.woff2',
      '900': 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTra2_R2QBgum-uoQ.woff2',
      regular: 'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFiOHYr-vcC7h8MklGBkrvmUG9rbpkisrTT6kL11Ct8sw.woff2',
    },
  },
  {
    family: 'Sansita',
    files: {
      '700': 'https://fonts.gstatic.com/s/sansita/v11/QldLNTRRphEb_-V7JKWUaXx0wqVv3_g.woff2',
      '800': 'https://fonts.gstatic.com/s/sansita/v11/QldLNTRRphEb_-V7JLmXaXx0wqVv3_g.woff2',
      '900': 'https://fonts.gstatic.com/s/sansita/v11/QldLNTRRphEb_-V7JJ2WaXx0wqVv3_g.woff2',
      regular: 'https://fonts.gstatic.com/s/sansita/v11/QldONTRRphEb_-V7HBy7TXFf3qw.woff2',
    },
  },
  {
    family: 'Telex',
    files: {
      regular: 'https://fonts.gstatic.com/s/telex/v17/ieVw2Y1fKWmIO9fWB1piKFIf.woff2',
    },
  },
  {
    family: 'Caveat Brush',
    files: {
      regular: 'https://fonts.gstatic.com/s/caveatbrush/v11/EYq0maZfwr9S9-ETZc3fKXtMXrmT03pdQw.woff2',
    },
  },
  {
    family: 'Leckerli One',
    files: {
      regular: 'https://fonts.gstatic.com/s/leckerlione/v20/V8mCoQH8VCsNttEnxnGQ-1itKJxcBtItFw.woff2',
    },
  },
  {
    family: 'Voltaire',
    files: {
      regular: 'https://fonts.gstatic.com/s/voltaire/v20/1Pttg8PcRfSblAvGvQotYKVnBOif.woff2',
    },
  },
  {
    family: 'GFS Didot',
    files: {
      regular: 'https://fonts.gstatic.com/s/gfsdidot/v15/Jqzh5TybZ9vZMWFssvwiEufGFSCGAA.woff2',
    },
  },
  {
    family: 'Sofia Sans Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-CsksQO3OfwQQ.woff2',
      '200': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqB-GsksQO3OfwQQ.woff2',
      '300': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUq2eGsksQO3OfwQQ.woff2',
      '500': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqteGsksQO3OfwQQ.woff2',
      '600': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqWeasksQO3OfwQQ.woff2',
      '700': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqYOasksQO3OfwQQ.woff2',
      '800': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqB-asksQO3OfwQQ.woff2',
      '900': 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqLuasksQO3OfwQQ.woff2',
      regular: 'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-GsksQO3OfwQQ.woff2',
    },
  },
  {
    family: 'Palanquin',
    files: {
      '100': 'https://fonts.gstatic.com/s/palanquin/v13/9XUhlJ90n1fBFg7ceXwUEltN7rWmZzTH.woff2',
      '200': 'https://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUvnpowZuqbi3ezg.woff2',
      '300': 'https://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwU2nlowZuqbi3ezg.woff2',
      '500': 'https://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUgnhowZuqbi3ezg.woff2',
      '600': 'https://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUrn9owZuqbi3ezg.woff2',
      '700': 'https://fonts.gstatic.com/s/palanquin/v13/9XUilJ90n1fBFg7ceXwUyn5owZuqbi3ezg.woff2',
      regular: 'https://fonts.gstatic.com/s/palanquin/v13/9XUnlJ90n1fBFg7ceXwsc1FMzLC2Zw.woff2',
    },
  },
  {
    family: 'Newsreader',
    files: {
      '200': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438w-I_ACexEPjCggA.woff2',
      '300': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wJo_ACexEPjCggA.woff2',
      '500': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wSo_ACexEPjCggA.woff2',
      '600': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wpojACexEPjCggA.woff2',
      '700': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wn4jACexEPjCggA.woff2',
      '800': 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438w-IjACexEPjCggA.woff2',
      regular: 'https://fonts.gstatic.com/s/newsreader/v20/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438weI_ACexEPjCggA.woff2',
    },
  },
  {
    family: 'Reem Kufi',
    files: {
      '500': 'https://fonts.gstatic.com/s/reemkufi/v21/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQttRnEGSf3qGuvM4.woff2',
      '600': 'https://fonts.gstatic.com/s/reemkufi/v21/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtjhgEGSf3qGuvM4.woff2',
      '700': 'https://fonts.gstatic.com/s/reemkufi/v21/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtgFgEGSf3qGuvM4.woff2',
      regular: 'https://fonts.gstatic.com/s/reemkufi/v21/2sDPZGJLip7W2J7v7wQZZE1I0yCmYzzQtuZnEGSf3qGuvM4.woff2',
    },
  },
  {
    family: 'Berkshire Swash',
    files: {
      regular: 'https://fonts.gstatic.com/s/berkshireswash/v20/ptRRTi-cavZOGqCvnNJDl5m5XmNPqMQybX4pQA.woff2',
    },
  },
  {
    family: 'Rozha One',
    files: {
      regular: 'https://fonts.gstatic.com/s/rozhaone/v15/AlZy_zVFtYP12Zncg2khcHf4XB0Tow.woff2',
    },
  },
  {
    family: 'Sintony',
    files: {
      '700': 'https://fonts.gstatic.com/s/sintony/v15/XoHj2YDqR7-98cVUGYgIn9IDkjLp6C8.woff2',
      regular: 'https://fonts.gstatic.com/s/sintony/v15/XoHm2YDqR7-98cVUITEnu98ojjs.woff2',
    },
  },
  {
    family: 'Fredoka',
    files: {
      '300': 'https://fonts.gstatic.com/s/fredoka/v14/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OryLME-OLlNldbw.woff2',
      '500': 'https://fonts.gstatic.com/s/fredoka/v14/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OwyLME-OLlNldbw.woff2',
      '600': 'https://fonts.gstatic.com/s/fredoka/v14/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OLyXME-OLlNldbw.woff2',
      '700': 'https://fonts.gstatic.com/s/fredoka/v14/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3OFiXME-OLlNldbw.woff2',
      regular: 'https://fonts.gstatic.com/s/fredoka/v14/X7nP4b87HvSqjb_WIi2yDCRwoQ_k7367_B-i2yQag0-mac3O8SLME-OLlNldbw.woff2',
    },
  },
  {
    family: 'Calistoga',
    files: {
      regular: 'https://fonts.gstatic.com/s/calistoga/v15/6NUU8F2OJg6MeR7l4e0vscYAwdRZfw.woff2',
    },
  },
  {
    family: 'Racing Sans One',
    files: {
      regular: 'https://fonts.gstatic.com/s/racingsansone/v15/sykr-yRtm7EvTrXNxkv5jfKKyDCwKnrmWpIBtA.woff2',
    },
  },
  {
    family: 'Oxanium',
    files: {
      '200': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G83JfniJBXQ7d67x.woff2',
      '300': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G80XfniJBXQ7d67x.woff2',
      '500': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G817fniJBXQ7d67x.woff2',
      '600': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82XeXiJBXQ7d67x.woff2',
      '700': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82ueXiJBXQ7d67x.woff2',
      '800': 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G83JeXiJBXQ7d67x.woff2',
      regular: 'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G81JfniJBXQ7d67x.woff2',
    },
  },
  {
    family: 'Laila',
    files: {
      '300': 'https://fonts.gstatic.com/s/laila/v15/LYjBdG_8nE8jDLzxogNFh14nVcfe.woff2',
      '500': 'https://fonts.gstatic.com/s/laila/v15/LYjBdG_8nE8jDLypowNFh14nVcfe.woff2',
      '600': 'https://fonts.gstatic.com/s/laila/v15/LYjBdG_8nE8jDLyFpANFh14nVcfe.woff2',
      '700': 'https://fonts.gstatic.com/s/laila/v15/LYjBdG_8nE8jDLzhpQNFh14nVcfe.woff2',
      regular: 'https://fonts.gstatic.com/s/laila/v15/LYjMdG_8nE8jDIRYiidIrEIu.woff2',
    },
  },
  {
    family: 'Days One',
    files: {
      regular: 'https://fonts.gstatic.com/s/daysone/v18/mem9YaCnxnKRiYZOCLYQeLkWVNBt.woff2',
    },
  },
  {
    family: 'Averia Serif Libre',
    files: {
      '300': 'https://fonts.gstatic.com/s/averiaseriflibre/v18/neIVzD2ms4wxr6GvjeD0X88SHPyX2xYGCSmqxKcqdrKvbQ.woff2',
      '700': 'https://fonts.gstatic.com/s/averiaseriflibre/v18/neIVzD2ms4wxr6GvjeD0X88SHPyX2xYGGS6qxKcqdrKvbQ.woff2',
      regular: 'https://fonts.gstatic.com/s/averiaseriflibre/v18/neIWzD2ms4wxr6GvjeD0X88SHPyX2xY-oAGOyYw2fw.woff2',
    },
  },
  {
    family: 'Geologica',
    files: {
      '100':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDx_qQ-YYAXWnqFs.woff2',
      '200':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD5_rQ-YYAXWnqFs.woff2',
      '300':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD0HrQ-YYAXWnqFs.woff2',
      '500':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDy3rQ-YYAXWnqFs.woff2',
      '600':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD8HsQ-YYAXWnqFs.woff2',
      '700':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD_jsQ-YYAXWnqFs.woff2',
      '800':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD5_sQ-YYAXWnqFs.woff2',
      '900':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD7bsQ-YYAXWnqFs.woff2',
      regular:
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDx_rQ-YYAXWnqFs.woff2',
    },
  },
  {
    family: 'Rubik Moonrocks',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmoonrocks/v5/845ANMAmAI2VUZMLu_W0M7HqlDHnWMD7JGy1Sw.woff2',
    },
  },
  {
    family: 'Yrsa',
    files: {
      '300': 'https://fonts.gstatic.com/s/yrsa/v20/wlprgwnQFlxs_wD3CFSMYmFaaCjASNNQ9rRPfrKu.woff2',
      '500': 'https://fonts.gstatic.com/s/yrsa/v20/wlprgwnQFlxs_wD3CFSMYmFaaCisSNNQ9rRPfrKu.woff2',
      '600': 'https://fonts.gstatic.com/s/yrsa/v20/wlprgwnQFlxs_wD3CFSMYmFaaChAT9NQ9rRPfrKu.woff2',
      '700': 'https://fonts.gstatic.com/s/yrsa/v20/wlprgwnQFlxs_wD3CFSMYmFaaCh5T9NQ9rRPfrKu.woff2',
      regular: 'https://fonts.gstatic.com/s/yrsa/v20/wlprgwnQFlxs_wD3CFSMYmFaaCieSNNQ9rRPfrKu.woff2',
    },
  },
  {
    family: 'Rye',
    files: {
      regular: 'https://fonts.gstatic.com/s/rye/v15/r05XGLJT86YDE5TsXOqx4w.woff2',
    },
  },
  {
    family: 'Calligraffitti',
    files: {
      regular: 'https://fonts.gstatic.com/s/calligraffitti/v19/46k2lbT3XjDVqJw3DCmCFjE0vnFcM5ZBpYN-.woff2',
    },
  },
  {
    family: 'Karma',
    files: {
      '300': 'https://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLjDY8Z6uqzGQC_-.woff2',
      '500': 'https://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLibYsZ6uqzGQC_-.woff2',
      '600': 'https://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLi3ZcZ6uqzGQC_-.woff2',
      '700': 'https://fonts.gstatic.com/s/karma/v16/va9F4kzAzMZRGLjTZMZ6uqzGQC_-.woff2',
      regular: 'https://fonts.gstatic.com/s/karma/v16/va9I4kzAzMZRGIBqS-J3kbDP.woff2',
    },
  },
  {
    family: 'Alexandria',
    files: {
      '100': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7T6bCHJ8BRq0b.woff2',
      '200': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9p7TqbCHJ8BRq0b.woff2',
      '300': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9qlTqbCHJ8BRq0b.woff2',
      '500': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9rJTqbCHJ8BRq0b.woff2',
      '600': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9olSabCHJ8BRq0b.woff2',
      '700': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9ocSabCHJ8BRq0b.woff2',
      '800': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9p7SabCHJ8BRq0b.woff2',
      '900': 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9pSSabCHJ8BRq0b.woff2',
      regular: 'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7TqbCHJ8BRq0b.woff2',
    },
  },
  {
    family: 'Allerta Stencil',
    files: {
      regular: 'https://fonts.gstatic.com/s/allertastencil/v22/HTx0L209KT-LmIE9N7OR6eiycOeF_jz313DuvQ.woff2',
    },
  },
  {
    family: 'Syncopate',
    files: {
      '700': 'https://fonts.gstatic.com/s/syncopate/v21/pe0pMIuPIYBCpEV5eFdKvtKaBvRue1UwVg.woff2',
      regular: 'https://fonts.gstatic.com/s/syncopate/v21/pe0sMIuPIYBCpEV5eFdyB_2-C99ycg.woff2',
    },
  },
  {
    family: 'Charm',
    files: {
      '700': 'https://fonts.gstatic.com/s/charm/v11/7cHrv4oii5K0Md6TDss5yn4hnCci.woff2',
      regular: 'https://fonts.gstatic.com/s/charm/v11/7cHmv4oii5K0MeYqIe804WIo.woff2',
    },
  },
  {
    family: 'Cormorant Infant',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN9951w3_DYrQqcdJrk.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN995wQ2_DYrQqcdJrk.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN995ygx_DYrQqcdJrk.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorantinfant/v17/HhyIU44g9vKiM1sORYSiWeAsLN9950ww_DYrQqcdJrk.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorantinfant/v17/HhyPU44g9vKiM1sORYSiWeAsLN993_Uf2DsAXq4.woff2',
    },
  },
  {
    family: 'Chewy',
    files: {
      regular: 'https://fonts.gstatic.com/s/chewy/v18/uK_94ruUb-k-wk50IDMfO-ed.woff2',
    },
  },
  {
    family: 'Mrs Saint Delafield',
    files: {
      regular: 'https://fonts.gstatic.com/s/mrssaintdelafield/v13/v6-IGZDIOVXH9xtmTZfRagunqBw5WC62cKstLsubB2w.woff2',
    },
  },
  {
    family: 'Lemonada',
    files: {
      '300': 'https://fonts.gstatic.com/s/lemonada/v28/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGJOt2nPWc3Z2pTg.woff2',
      '500': 'https://fonts.gstatic.com/s/lemonada/v28/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGSOt2nPWc3Z2pTg.woff2',
      '600': 'https://fonts.gstatic.com/s/lemonada/v28/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGpOx2nPWc3Z2pTg.woff2',
      '700': 'https://fonts.gstatic.com/s/lemonada/v28/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGnex2nPWc3Z2pTg.woff2',
      regular: 'https://fonts.gstatic.com/s/lemonada/v28/0QI-MXFD9oygTWy_R-FFlwV-bgfR7QJGeut2nPWc3Z2pTg.woff2',
    },
  },
  {
    family: 'Armata',
    files: {
      regular: 'https://fonts.gstatic.com/s/armata/v20/gokvH63_HV5jQ-E9kT53Q2u_mQ.woff2',
    },
  },
  {
    family: 'Cabin Sketch',
    files: {
      '700': 'https://fonts.gstatic.com/s/cabinsketch/v21/QGY2z_kZZAGCONcK2A4bGOj0I_1o5NLyI4CMFw.woff2',
      regular: 'https://fonts.gstatic.com/s/cabinsketch/v21/QGYpz_kZZAGCONcK2A4bGOjMmtJM6fnuKg.woff2',
    },
  },
  {
    family: 'PT Serif Caption',
    files: {
      regular: 'https://fonts.gstatic.com/s/ptserifcaption/v17/ieVl2ZhbGCW-JoW6S34pSDpqYKU059CxDCs5cvI.woff2',
    },
  },
  {
    family: 'Coda',
    files: {
      '800': 'https://fonts.gstatic.com/s/coda/v21/SLXIc1jY5nQ8HeIgTpumw9t1cX8.woff2',
      regular: 'https://fonts.gstatic.com/s/coda/v21/SLXHc1jY5nQ8JUcMapaN39I.woff2',
    },
  },
  {
    family: 'Squada One',
    files: {
      regular: 'https://fonts.gstatic.com/s/squadaone/v18/BCasqZ8XsOrx4mcOk6MtWaU8WDBkHgs.woff2',
    },
  },
  {
    family: 'Petrona',
    files: {
      '100': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsAREH452Mvds.woff2',
      '200': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4NsQREH452Mvds.woff2',
      '300': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk7TsQREH452Mvds.woff2',
      '500': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6_sQREH452Mvds.woff2',
      '600': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5TtgREH452Mvds.woff2',
      '700': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5qtgREH452Mvds.woff2',
      '800': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4NtgREH452Mvds.woff2',
      '900': 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4ktgREH452Mvds.woff2',
      regular: 'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsQREH452Mvds.woff2',
    },
  },
  {
    family: 'Anuphan',
    files: {
      '100': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCkY9A4hGmW927Gu.woff2',
      '200': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCmY9Q4hGmW927Gu.woff2',
      '300': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZClG9Q4hGmW927Gu.woff2',
      '500': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCkq9Q4hGmW927Gu.woff2',
      '600': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCnG8g4hGmW927Gu.woff2',
      '700': 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCn_8g4hGmW927Gu.woff2',
      regular: 'https://fonts.gstatic.com/s/anuphan/v3/2sDBZGxYgY7LkLT0s2Yrm5UhuLoIZCkY9Q4hGmW927Gu.woff2',
    },
  },
  {
    family: 'Athiti',
    files: {
      '200': 'https://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAxDNyB_2-C99ycg.woff2',
      '300': 'https://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAoDByB_2-C99ycg.woff2',
      '500': 'https://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wA-DFyB_2-C99ycg.woff2',
      '600': 'https://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wA1DZyB_2-C99ycg.woff2',
      '700': 'https://fonts.gstatic.com/s/athiti/v12/pe0sMISdLIZIv1wAsDdyB_2-C99ycg.woff2',
      regular: 'https://fonts.gstatic.com/s/athiti/v12/pe0vMISdLIZIv1w4CRhWCtaiAg.woff2',
    },
  },
  {
    family: 'Arapey',
    files: {
      regular: 'https://fonts.gstatic.com/s/arapey/v16/-W__XJn-UDDA2RC6YtAcZkIzeg.woff2',
    },
  },
  {
    family: 'Spinnaker',
    files: {
      regular: 'https://fonts.gstatic.com/s/spinnaker/v19/w8gYH2oyX-I0_rvR6Hmn2XwLqOqSBg.woff2',
    },
  },
  {
    family: 'Balsamiq Sans',
    files: {
      '700': 'https://fonts.gstatic.com/s/balsamiqsans/v14/P5sZzZiAbNrN8SB3lQQX7PncyWUyBYpmAzLFRQI.woff2',
      regular: 'https://fonts.gstatic.com/s/balsamiqsans/v14/P5sEzZiAbNrN8SB3lQQX7Pnc8dwdIYdNHzs.woff2',
    },
  },
  {
    family: 'Just Another Hand',
    files: {
      regular: 'https://fonts.gstatic.com/s/justanotherhand/v19/845CNN4-AJyIGvIou-6yJKyptyOpOcr6BmmlS5aw.woff2',
    },
  },
  {
    family: 'Michroma',
    files: {
      regular: 'https://fonts.gstatic.com/s/michroma/v19/PN_zRfy9qWD8fEagAMg_rzjb_-Da.woff2',
    },
  },
  {
    family: 'Hind Guntur',
    files: {
      '300': 'https://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_yGn1c2n9zaj5Ju.woff2',
      '500': 'https://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_zenlc2n9zaj5Ju.woff2',
      '600': 'https://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_zymVc2n9zaj5Ju.woff2',
      '700': 'https://fonts.gstatic.com/s/hindguntur/v12/wXKyE3UZrok56nvamSuJd_yWmFc2n9zaj5Ju.woff2',
      regular: 'https://fonts.gstatic.com/s/hindguntur/v12/wXKvE3UZrok56nvamSuJd8Qvt3M7tMDT.woff2',
    },
  },
  {
    family: 'Pathway Extreme',
    files: {
      '100':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak2Nx1Liw3igP5eg.woff2',
      '200':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakWN11Liw3igP5eg.woff2',
      '300':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakht11Liw3igP5eg.woff2',
      '500':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak6t11Liw3igP5eg.woff2',
      '600':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakBtp1Liw3igP5eg.woff2',
      '700':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakP9p1Liw3igP5eg.woff2',
      '800':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakWNp1Liw3igP5eg.woff2',
      '900':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakcdp1Liw3igP5eg.woff2',
      regular:
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak2N11Liw3igP5eg.woff2',
    },
  },
  {
    family: 'Sofia Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sa3orvKCXl8k.woff2',
      '200': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69D6sK3orvKCXl8k.woff2',
      '300': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69AksK3orvKCXl8k.woff2',
      '500': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69BIsK3orvKCXl8k.woff2',
      '600': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Ckt63orvKCXl8k.woff2',
      '700': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Cdt63orvKCXl8k.woff2',
      '800': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69D6t63orvKCXl8k.woff2',
      '900': 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69DTt63orvKCXl8k.woff2',
      regular: 'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sK3orvKCXl8k.woff2',
    },
  },
  {
    family: 'Zen Old Mincho',
    files: {
      '500': 'https://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb4Dqllf8dMgPgBu.woff2',
      '600': 'https://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb4vrVlf8dMgPgBu.woff2',
      '700': 'https://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb5LrFlf8dMgPgBu.woff2',
      '900': 'https://fonts.gstatic.com/s/zenoldmincho/v11/tss3ApVaYytLwxTqcxfMyBveyb5zrllf8dMgPgBu.woff2',
      regular: 'https://fonts.gstatic.com/s/zenoldmincho/v11/tss0ApVaYytLwxTqcxfMyBveyYbyg31S2s8p.woff2',
    },
  },
  {
    family: 'Cedarville Cursive',
    files: {
      regular: 'https://fonts.gstatic.com/s/cedarvillecursive/v17/yYL00g_a2veiudhUmxjo5VKkoqA-B_neILBxw8BeTg.woff2',
    },
  },
  {
    family: 'Mali',
    files: {
      '200': 'https://fonts.gstatic.com/s/mali/v10/N0bV2SRONuN4QOLlKlFaJdbWgdY.woff2',
      '300': 'https://fonts.gstatic.com/s/mali/v10/N0bV2SRONuN4QIbmKlFaJdbWgdY.woff2',
      '500': 'https://fonts.gstatic.com/s/mali/v10/N0bV2SRONuN4QN7nKlFaJdbWgdY.woff2',
      '600': 'https://fonts.gstatic.com/s/mali/v10/N0bV2SRONuN4QPLgKlFaJdbWgdY.woff2',
      '700': 'https://fonts.gstatic.com/s/mali/v10/N0bV2SRONuN4QJbhKlFaJdbWgdY.woff2',
      regular: 'https://fonts.gstatic.com/s/mali/v10/N0ba2SRONuN4eC_ODlxxOd8.woff2',
    },
  },
  {
    family: 'Alatsi',
    files: {
      regular: 'https://fonts.gstatic.com/s/alatsi/v11/TK3iWkUJAxQ2nLNGGzUHte5fKg.woff2',
    },
  },
  {
    family: 'La Belle Aurore',
    files: {
      regular: 'https://fonts.gstatic.com/s/labelleaurore/v20/RrQIbot8-mNYKnGNDkWlocovHeIIHueFNVmULg.woff2',
    },
  },
  {
    family: 'Antic',
    files: {
      regular: 'https://fonts.gstatic.com/s/antic/v19/TuGfUVB8XY5DRaZOodgzydtk.woff2',
    },
  },
  {
    family: 'Lustria',
    files: {
      regular: 'https://fonts.gstatic.com/s/lustria/v13/9oRONYodvDEyjuhOrC05MtPyAcg.woff2',
    },
  },
  {
    family: 'Aclonica',
    files: {
      regular: 'https://fonts.gstatic.com/s/aclonica/v22/K2FyfZJVlfNNSEBXGb7WCI6oBjLz.woff2',
    },
  },
  {
    family: 'Nanum Brush Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/nanumbrushscript/v22/wXK2E2wfpokopxzthSqPbcR5_gVaxazyi6Br1lO97Q.woff2',
    },
  },
  {
    family: 'Glegoo',
    files: {
      '700': 'https://fonts.gstatic.com/s/glegoo/v16/_Xmu-HQyrTKWaw2xN4a9DaRpzimMsg.woff2',
      regular: 'https://fonts.gstatic.com/s/glegoo/v16/_Xmt-HQyrTKWaw2JjqmZAI91xw.woff2',
    },
  },
  {
    family: 'Marcellus SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/marcellussc/v13/ke8iOgUHP1dg-Rmi6RWjbLEPhNydGKikhA.woff2',
    },
  },
  {
    family: 'Candal',
    files: {
      regular: 'https://fonts.gstatic.com/s/candal/v15/XoHn2YH6T7-t_8cNBB4Jt9Yxlw.woff2',
    },
  },
  {
    family: 'Aldrich',
    files: {
      regular: 'https://fonts.gstatic.com/s/aldrich/v21/MCoTzAn-1s3IGyJMZaUS3pP5H_E.woff2',
    },
  },
  {
    family: 'Shadows Into Light Two',
    files: {
      regular: 'https://fonts.gstatic.com/s/shadowsintolighttwo/v17/4iC86LVlZsRSjQhpWGedwyOoW-0A6_kpsyNmlA7NGLNnIF0.woff2',
    },
  },
  {
    family: 'Overpass Mono',
    files: {
      '300': 'https://fonts.gstatic.com/s/overpassmono/v16/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EWKokz2Xur-SmIr.woff2',
      '500': 'https://fonts.gstatic.com/s/overpassmono/v16/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EXmokz2Xur-SmIr.woff2',
      '600': 'https://fonts.gstatic.com/s/overpassmono/v16/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EUKpUz2Xur-SmIr.woff2',
      '700': 'https://fonts.gstatic.com/s/overpassmono/v16/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EUzpUz2Xur-SmIr.woff2',
      regular: 'https://fonts.gstatic.com/s/overpassmono/v16/_Xm5-H86tzKDdAPa-KPQZ-AC_COcRycquHlL6EXUokz2Xur-SmIr.woff2',
    },
  },
  {
    family: 'Julee',
    files: {
      regular: 'https://fonts.gstatic.com/s/julee/v25/TuGfUVB3RpZPQ6ZOodgzydtk.woff2',
    },
  },
  {
    family: 'Golos Text',
    files: {
      '500': 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plVjRQ5ZEr8zXcyx.woff2',
      '600': 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plWPQg5ZEr8zXcyx.woff2',
      '700': 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plW2Qg5ZEr8zXcyx.woff2',
      '800': 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plXRQg5ZEr8zXcyx.woff2',
      '900': 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plX4Qg5ZEr8zXcyx.woff2',
      regular: 'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plVRRQ5ZEr8zXcyx.woff2',
    },
  },
  {
    family: 'Vazirmatn',
    files: {
      '100': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgyORKZ72DF_QY.woff2',
      '200': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklegzORKZ72DF_QY.woff2',
      '300': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklTYzORKZ72DF_QY.woff2',
      '500': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklVozORKZ72DF_QY.woff2',
      '600': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklbY0ORKZ72DF_QY.woff2',
      '700': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklY80ORKZ72DF_QY.woff2',
      '800': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRkleg0ORKZ72DF_QY.woff2',
      '900': 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklcE0ORKZ72DF_QY.woff2',
      regular: 'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgzORKZ72DF_QY.woff2',
    },
  },
  {
    family: 'Baloo Bhaijaan 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyjSqP9L4ppfcyC.woff2',
      '600': 'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TxPTaP9L4ppfcyC.woff2',
      '700': 'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8Tx2TaP9L4ppfcyC.woff2',
      '800': 'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TwRTaP9L4ppfcyC.woff2',
      regular: 'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyRSqP9L4ppfcyC.woff2',
    },
  },
  {
    family: 'Kiwi Maru',
    files: {
      '300': 'https://fonts.gstatic.com/s/kiwimaru/v14/R70djykGkuuDep-hRg6gNCi0Uhn9R5ShnA.woff2',
      '500': 'https://fonts.gstatic.com/s/kiwimaru/v14/R70djykGkuuDep-hRg6gbCm0Uhn9R5ShnA.woff2',
      regular: 'https://fonts.gstatic.com/s/kiwimaru/v14/R70YjykGkuuDep-hRg6YnQCQXzLhTg.woff2',
    },
  },
  {
    family: 'Fredericka the Great',
    files: {
      regular: 'https://fonts.gstatic.com/s/frederickathegreat/v21/9Bt33CxNwt7aOctW2xjbCstzwVKsIBVV-9Shz7Ylch2L.woff2',
    },
  },
  {
    family: 'Kurale',
    files: {
      regular: 'https://fonts.gstatic.com/s/kurale/v11/4iCs6KV9e9dXjho6fQT3v02QFg.woff2',
    },
  },
  {
    family: 'Noto Serif Display',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd49gPaDU9hvzC.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVrd4tgPaDU9hvzC.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVoD4tgPaDU9hvzC.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpv4tgPaDU9hvzC.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVqD5dgPaDU9hvzC.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVq65dgPaDU9hvzC.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVrd5dgPaDU9hvzC.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVr05dgPaDU9hvzC.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd4tgPaDU9hvzC.woff2',
    },
  },
  {
    family: 'Boogaloo',
    files: {
      regular: 'https://fonts.gstatic.com/s/boogaloo/v23/kmK-Zq45GAvOdnaW6x1A_SrQo_1K.woff2',
    },
  },
  {
    family: 'Seaweed Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/seaweedscript/v15/bx6cNx6Tne2pxOATYE8C_Rsoe0WM-KcGVbLW.woff2',
    },
  },
  {
    family: 'Belleza',
    files: {
      regular: 'https://fonts.gstatic.com/s/belleza/v17/0nkoC9_pNeMfhX4BtcPyawzruP8.woff2',
    },
  },
  {
    family: 'Cantata One',
    files: {
      regular: 'https://fonts.gstatic.com/s/cantataone/v15/PlI5Fl60Nb5obNzNe2jslVxBt8CwfGaD.woff2',
    },
  },
  {
    family: 'Rancho',
    files: {
      regular: 'https://fonts.gstatic.com/s/rancho/v21/46kulbzmXjLaqZRlaGXgd0RY1g.woff2',
    },
  },
  {
    family: 'Grandstander',
    files: {
      '100': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1-_D33WttFGmQk.woff2',
      '200': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD9--D33WttFGmQk.woff2',
      '300': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQDwG-D33WttFGmQk.woff2',
      '500': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD22-D33WttFGmQk.woff2',
      '600': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD4G5D33WttFGmQk.woff2',
      '700': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD7i5D33WttFGmQk.woff2',
      '800': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD9-5D33WttFGmQk.woff2',
      '900': 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD_a5D33WttFGmQk.woff2',
      regular: 'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1--D33WttFGmQk.woff2',
    },
  },
  {
    family: 'K2D',
    files: {
      '100': 'https://fonts.gstatic.com/s/k2d/v11/J7aRnpF2V0ErE6UsvrIw74NL.woff2',
      '200': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Erv4QJkZw85ppSGw.woff2',
      '300': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Er24cJkZw85ppSGw.woff2',
      '500': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Erg4YJkZw85ppSGw.woff2',
      '600': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Err4EJkZw85ppSGw.woff2',
      '700': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Ery4AJkZw85ppSGw.woff2',
      '800': 'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Er14MJkZw85ppSGw.woff2',
      regular: 'https://fonts.gstatic.com/s/k2d/v11/J7aTnpF2V0ETcq8tnLcg7w.woff2',
    },
  },
  {
    family: 'Galada',
    files: {
      regular: 'https://fonts.gstatic.com/s/galada/v18/H4cmBXyGmcjXlUX-9yw-4Lqggw.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Thai',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JNje1VVIzcq1HzJq2AEdo2Tj_qvLqEatYgR8ZKUqcX.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqExvcFaOhGW74OXw.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqEovQFaOhGW74OXw.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqE-vUFaOhGW74OXw.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqE1vIFaOhGW74OXw.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JMje1VVIzcq1HzJq2AEdo2Tj_qvLqEsvMFaOhGW74OXw.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsansthai/v10/m8JPje1VVIzcq1HzJq2AEdo2Tj_qvLq8C9whZcNaUg.woff2',
    },
  },
  {
    family: 'Radio Canada',
    files: {
      '300': 'https://fonts.gstatic.com/s/radiocanada/v21/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nESkQPNJOdSSfOT.woff2',
      '500': 'https://fonts.gstatic.com/s/radiocanada/v21/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nF-kQPNJOdSSfOT.woff2',
      '600': 'https://fonts.gstatic.com/s/radiocanada/v21/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nGSlgPNJOdSSfOT.woff2',
      '700': 'https://fonts.gstatic.com/s/radiocanada/v21/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nGrlgPNJOdSSfOT.woff2',
      regular: 'https://fonts.gstatic.com/s/radiocanada/v21/XRX13ISXn0dBMcibU6jlAqr3ejLv5OLZYiYXik6db2P4jxxlsls-0nFMkQPNJOdSSfOT.woff2',
    },
  },
  {
    family: 'Wix Madefor Text',
    files: {
      '500': 'https://fonts.gstatic.com/s/wixmadefortext/v13/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cKNNOeAgpRt9rN5.woff2',
      '600': 'https://fonts.gstatic.com/s/wixmadefortext/v13/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cJhM-eAgpRt9rN5.woff2',
      '700': 'https://fonts.gstatic.com/s/wixmadefortext/v13/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cJYM-eAgpRt9rN5.woff2',
      '800': 'https://fonts.gstatic.com/s/wixmadefortext/v13/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cI_M-eAgpRt9rN5.woff2',
      regular: 'https://fonts.gstatic.com/s/wixmadefortext/v13/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cK_NOeAgpRt9rN5.woff2',
    },
  },
  {
    family: 'Bowlby One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bowlbyone/v23/taiPGmVuC4y96PFeqp8smouC_Z0wcK4.woff2',
    },
  },
  {
    family: 'Georama',
    files: {
      '100': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvktnAsL5_tgbg.woff2',
      '200': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5mvgtnAsL5_tgbg.woff2',
      '300': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5RPgtnAsL5_tgbg.woff2',
      '500': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5KPgtnAsL5_tgbg.woff2',
      '600': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5xP8tnAsL5_tgbg.woff2',
      '700': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5_f8tnAsL5_tgbg.woff2',
      '800': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5mv8tnAsL5_tgbg.woff2',
      '900': 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5s_8tnAsL5_tgbg.woff2',
      regular: 'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvgtnAsL5_tgbg.woff2',
    },
  },
  {
    family: 'BioRhyme',
    files: {
      '200': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OrIimiOki-gkRDE.woff2',
      '300': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OmwimiOki-gkRDE.woff2',
      '500': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OgAimiOki-gkRDE.woff2',
      '600': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OuwlmiOki-gkRDE.woff2',
      '700': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OtUlmiOki-gkRDE.woff2',
      '800': 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OrIlmiOki-gkRDE.woff2',
      regular: 'https://fonts.gstatic.com/s/biorhyme/v17/1cXeaULHBpDMsHYW_GZNh7loEHurwOIGadI205trrbeBgQs4OjIimiOki-gkRDE.woff2',
    },
  },
  {
    family: 'Alumni Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO5QrVsJ3C8qng.woff2',
      '200': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9uO9QrVsJ3C8qng.woff2',
      '300': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9Zu9QrVsJ3C8qng.woff2',
      '500': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9Cu9QrVsJ3C8qng.woff2',
      '600': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd95uhQrVsJ3C8qng.woff2',
      '700': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd93-hQrVsJ3C8qng.woff2',
      '800': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9uOhQrVsJ3C8qng.woff2',
      '900': 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9kehQrVsJ3C8qng.woff2',
      regular: 'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO9QrVsJ3C8qng.woff2',
    },
  },
  {
    family: 'Herr Von Muellerhoff',
    files: {
      regular: 'https://fonts.gstatic.com/s/herrvonmuellerhoff/v21/WBL6rFjRZkREW8WqmCWYLgCkQKXb4CAft3c__qJY3QPQ.woff2',
    },
  },
  {
    family: 'Suez One',
    files: {
      regular: 'https://fonts.gstatic.com/s/suezone/v13/taiJGmd_EZ6rqscQgNFMkIqg-I0w.woff2',
    },
  },
  {
    family: 'Bowlby One SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/bowlbyonesc/v25/DtVlJxerQqQm37tzN3wMug9Pzg38owhNjuE.woff2',
    },
  },
  {
    family: 'Corben',
    files: {
      '700': 'https://fonts.gstatic.com/s/corben/v21/LYjAdGzzklQtCMpFHCZgqHArXN7HWQ.woff2',
      regular: 'https://fonts.gstatic.com/s/corben/v21/LYjDdGzzklQtCMp9pQlEpVs3VQ.woff2',
    },
  },
  {
    family: 'Coming Soon',
    files: {
      regular: 'https://fonts.gstatic.com/s/comingsoon/v19/qWcuB6mzpYL7AJ2VfdQR1u-XUjjzsykh.woff2',
    },
  },
  {
    family: 'Jua',
    files: {
      regular: 'https://fonts.gstatic.com/s/jua/v15/co3KmW9ljjAjduDZCsKgsg.woff2',
    },
  },
  {
    family: 'Arizonia',
    files: {
      regular: 'https://fonts.gstatic.com/s/arizonia/v21/neIIzCemt4A5qa7mv6WDHK06UY30.woff2',
    },
  },
  {
    family: 'Encode Sans Expanded',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mx1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpJGKQZicoAbJlw.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLqCCNNXIwSP0XD.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKOCyNNXIwSP0XD.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLWCiNNXIwSP0XD.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpL6DSNNXIwSP0XD.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKeDCNNXIwSP0XD.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKCDyNNXIwSP0XD.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKmDiNNXIwSP0XD.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4m_1mF4GcnstG_Jh1QH6ac4hNLeNyeYUqonIwdAd5Ab.woff2',
    },
  },
  {
    family: 'Do Hyeon',
    files: {
      regular: 'https://fonts.gstatic.com/s/dohyeon/v18/TwMN-I8CRRU2zM86HFEyZwaH__-C.woff2',
    },
  },
  {
    family: 'Bevan',
    files: {
      regular: 'https://fonts.gstatic.com/s/bevan/v24/4iCj6KZ0a9NXjF8fUir7tlSJ.woff2',
    },
  },
  {
    family: 'Caudex',
    files: {
      '700': 'https://fonts.gstatic.com/s/caudex/v17/esDT311QOP6BJUrwdtekkJUCGpG-GQ.woff2',
      regular: 'https://fonts.gstatic.com/s/caudex/v17/esDQ311QOP6BJUrIz_iAnb4eEw.woff2',
    },
  },
  {
    family: 'Nobile',
    files: {
      '500': 'https://fonts.gstatic.com/s/nobile/v17/m8JQjflSeaOVl1iOqo7zdZ5BZmqa3A.woff2',
      '700': 'https://fonts.gstatic.com/s/nobile/v17/m8JQjflSeaOVl1iO4ojzdZ5BZmqa3A.woff2',
      regular: 'https://fonts.gstatic.com/s/nobile/v17/m8JTjflSeaOVl1i2W6fXeLVdbw.woff2',
    },
  },
  {
    family: 'M PLUS 1',
    files: {
      '100': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSe793ZcsGGycA.woff2',
      '200': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW51Sa793ZcsGGycA.woff2',
      '300': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5Cya793ZcsGGycA.woff2',
      '500': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5Zya793ZcsGGycA.woff2',
      '600': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5iyG793ZcsGGycA.woff2',
      '700': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5siG793ZcsGGycA.woff2',
      '800': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW51SG793ZcsGGycA.woff2',
      '900': 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5_CG793ZcsGGycA.woff2',
      regular: 'https://fonts.gstatic.com/s/mplus1/v7/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSa793ZcsGGycA.woff2',
    },
  },
  {
    family: 'Pattaya',
    files: {
      regular: 'https://fonts.gstatic.com/s/pattaya/v16/ea8ZadcqV_zkHY-XNdWn92ZEmVs.woff2',
    },
  },
  {
    family: 'Delius',
    files: {
      regular: 'https://fonts.gstatic.com/s/delius/v19/PN_xRfK0pW_9e1rtZMI-jT3L_w.woff2',
    },
  },
  {
    family: 'Graduate',
    files: {
      regular: 'https://fonts.gstatic.com/s/graduate/v17/C8cg4cs3o2n15t_2YxgU6X2NZAn2.woff2',
    },
  },
  {
    family: 'Brygada 1918',
    files: {
      '500': 'https://fonts.gstatic.com/s/brygada1918/v22/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y12f-VoWu5O3gbo.woff2',
      '600': 'https://fonts.gstatic.com/s/brygada1918/v22/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y7GY-VoWu5O3gbo.woff2',
      '700': 'https://fonts.gstatic.com/s/brygada1918/v22/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y4iY-VoWu5O3gbo.woff2',
      regular: 'https://fonts.gstatic.com/s/brygada1918/v22/pe08MI6eKpdGqlF5LANrM--ACNaeo8mTUIR_y2-f-VoWu5O3gbo.woff2',
    },
  },
  {
    family: 'Maitree',
    files: {
      '200': 'https://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklhGNWJSovLdh6OE.woff2',
      '300': 'https://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklnWOWJSovLdh6OE.woff2',
      '500': 'https://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrkli2PWJSovLdh6OE.woff2',
      '600': 'https://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklgGIWJSovLdh6OE.woff2',
      '700': 'https://fonts.gstatic.com/s/maitree/v10/MjQDmil5tffhpBrklmWJWJSovLdh6OE.woff2',
      regular: 'https://fonts.gstatic.com/s/maitree/v10/MjQGmil5tffhpBrkrtymfJmDoL4.woff2',
    },
  },
  {
    family: 'Kristi',
    files: {
      regular: 'https://fonts.gstatic.com/s/kristi/v21/uK_y4ricdeU6zwdRDx0TMv6EXw.woff2',
    },
  },
  {
    family: 'Livvic',
    files: {
      '100': 'https://fonts.gstatic.com/s/livvic/v14/rnCr-x1S2hzjrlffC-M7mHnOSOuk.woff2',
      '200': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlffp8Iet1fCQfK9WQ.woff2',
      '300': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlffw8Eet1fCQfK9WQ.woff2',
      '500': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlffm8Aet1fCQfK9WQ.woff2',
      '600': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlfft8cet1fCQfK9WQ.woff2',
      '700': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlff08Yet1fCQfK9WQ.woff2',
      '900': 'https://fonts.gstatic.com/s/livvic/v14/rnCq-x1S2hzjrlff68Qet1fCQfK9WQ.woff2',
      regular: 'https://fonts.gstatic.com/s/livvic/v14/rnCp-x1S2hzjrlfnauk6unzeSA.woff2',
    },
  },
  {
    family: 'Allerta',
    files: {
      regular: 'https://fonts.gstatic.com/s/allerta/v18/TwMO-IAHRlkbx940UnQdSQqO5uY.woff2',
    },
  },
  {
    family: 'Wallpoet',
    files: {
      regular: 'https://fonts.gstatic.com/s/wallpoet/v20/f0X10em2_8RnXVVdUNbr7cXP8L8G.woff2',
    },
  },
  {
    family: 'Ibarra Real Nova',
    files: {
      '500': 'https://fonts.gstatic.com/s/ibarrarealnova/v27/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXdS5MDoVT9TWIvS.woff2',
      '600': 'https://fonts.gstatic.com/s/ibarrarealnova/v27/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXe-48DoVT9TWIvS.woff2',
      '700': 'https://fonts.gstatic.com/s/ibarrarealnova/v27/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXeH48DoVT9TWIvS.woff2',
      regular: 'https://fonts.gstatic.com/s/ibarrarealnova/v27/sZlSdQiA-DBIDCcaWtQzL4BZHoiDundw4ATyjed3EXdg5MDoVT9TWIvS.woff2',
    },
  },
  {
    family: 'Kameron',
    files: {
      '500': 'https://fonts.gstatic.com/s/kameron/v16/vm8pdR7vXErQxuznqrUS3z1Uw3nq4NeFcbcevZPxCDLR.woff2',
      '600': 'https://fonts.gstatic.com/s/kameron/v16/vm8pdR7vXErQxuznqrUS3z1Uw3nq4NdpdrcevZPxCDLR.woff2',
      '700': 'https://fonts.gstatic.com/s/kameron/v16/vm8pdR7vXErQxuznqrUS3z1Uw3nq4NdQdrcevZPxCDLR.woff2',
      regular: 'https://fonts.gstatic.com/s/kameron/v16/vm8pdR7vXErQxuznqrUS3z1Uw3nq4Ne3cbcevZPxCDLR.woff2',
    },
  },
  {
    family: 'Sofia Sans Extra Condensed',
    files: {
      '100':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmmEejmM356GxA.woff2',
      '200':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLGmiEejmM356GxA.woff2',
      '300':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLxGiEejmM356GxA.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLqGiEejmM356GxA.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLRG-EejmM356GxA.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLfW-EejmM356GxA.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLGm-EejmM356GxA.woff2',
      '900':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLM2-EejmM356GxA.woff2',
      regular:
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmiEejmM356GxA.woff2',
    },
  },
  {
    family: 'Salsa',
    files: {
      regular: 'https://fonts.gstatic.com/s/salsa/v21/gNMKW3FiRpKj-imd8ncKEZez.woff2',
    },
  },
  {
    family: 'Klee One',
    files: {
      '600': 'https://fonts.gstatic.com/s/kleeone/v7/LDI2apCLNRc6A8oT4pbYF8Opc-bGkqIw.woff2',
      regular: 'https://fonts.gstatic.com/s/kleeone/v7/LDIxapCLNRc6A8oT4q4FOeekWPrP.woff2',
    },
  },
  {
    family: 'Podkova',
    files: {
      '500': 'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWt3zcU9EoporSHH.woff2',
      '600': 'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWubysU9EoporSHH.woff2',
      '700': 'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWuiysU9EoporSHH.woff2',
      '800': 'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWvFysU9EoporSHH.woff2',
      regular: 'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWtFzcU9EoporSHH.woff2',
    },
  },
  {
    family: 'Limelight',
    files: {
      regular: 'https://fonts.gstatic.com/s/limelight/v19/XLYkIZL7aopJVbZJHDuYOONGrnY2TA.woff2',
    },
  },
  {
    family: 'Bellefair',
    files: {
      regular: 'https://fonts.gstatic.com/s/bellefair/v14/kJExBuYY6AAuhiXUxG19-vA2pOdvDA.woff2',
    },
  },
  {
    family: 'Krona One',
    files: {
      regular: 'https://fonts.gstatic.com/s/kronaone/v14/jAnEgHdjHcjgfIb1ZcUCNI-h3cWkWg.woff2',
    },
  },
  {
    family: 'Annie Use Your Telescope',
    files: {
      regular: 'https://fonts.gstatic.com/s/annieuseyourtelescope/v18/daaLSS4tI2qYYl3Jq9s_Hu74xwktnlKxH6osGVGjkTfB3UUVZA.woff2',
    },
  },
  {
    family: 'Scada',
    files: {
      '700': 'https://fonts.gstatic.com/s/scada/v15/RLp8K5Pv5qumeVrU6BElRVfmZOE5.woff2',
      regular: 'https://fonts.gstatic.com/s/scada/v15/RLpxK5Pv5qumeWJtxzUobkvv.woff2',
    },
  },
  {
    family: 'Judson',
    files: {
      '700': 'https://fonts.gstatic.com/s/judson/v19/FeVSS0Fbvbc14Vxps5xQ2J5nm29Gww.woff2',
      regular: 'https://fonts.gstatic.com/s/judson/v19/FeVRS0Fbvbc14VxRCrN01bV7kg.woff2',
    },
  },
  {
    family: 'Palanquin Dark',
    files: {
      '500': 'https://fonts.gstatic.com/s/palanquindark/v14/xn76YHgl1nqmANMB-26xC7yuF8Z6ZW4wfcvN2KT4.woff2',
      '600': 'https://fonts.gstatic.com/s/palanquindark/v14/xn76YHgl1nqmANMB-26xC7yuF8ZWYm4wfcvN2KT4.woff2',
      '700': 'https://fonts.gstatic.com/s/palanquindark/v14/xn76YHgl1nqmANMB-26xC7yuF8YyY24wfcvN2KT4.woff2',
      regular: 'https://fonts.gstatic.com/s/palanquindark/v14/xn75YHgl1nqmANMB-26xC7yuF_6LTEo9VtfE.woff2',
    },
  },
  {
    family: 'Allison',
    files: {
      regular: 'https://fonts.gstatic.com/s/allison/v11/X7nl4b88AP2nkbvZOCOQ4MTgAgk.woff2',
    },
  },
  {
    family: 'Ephesis',
    files: {
      regular: 'https://fonts.gstatic.com/s/ephesis/v9/uU9PCBUS8IerL2VG7xbb3vyHmlI.woff2',
    },
  },
  {
    family: 'Grand Hotel',
    files: {
      regular: 'https://fonts.gstatic.com/s/grandhotel/v19/7Au7p_IgjDKdCRWuR1azpmQIEl0O0kEx.woff2',
    },
  },
  {
    family: 'Darker Grotesque',
    files: {
      '300': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXxpqn73-XFyZFUB.woff2',
      '500': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXwFqn73-XFyZFUB.woff2',
      '600': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXzprX73-XFyZFUB.woff2',
      '700': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXzQrX73-XFyZFUB.woff2',
      '800': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXy3rX73-XFyZFUB.woff2',
      '900': 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXyerX73-XFyZFUB.woff2',
      regular: 'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXw3qn73-XFyZFUB.woff2',
    },
  },
  {
    family: 'Pirata One',
    files: {
      regular: 'https://fonts.gstatic.com/s/pirataone/v22/I_urMpiDvgLdLh0fAtofti2Er5_BdZ8.woff2',
    },
  },
  {
    family: 'UnifrakturMaguntia',
    files: {
      regular: 'https://fonts.gstatic.com/s/unifrakturmaguntia/v20/WWXPlieVYwiGNomYU-ciRLRvEmK7oaVummxNNgNa1A.woff2',
    },
  },
  {
    family: 'Arbutus Slab',
    files: {
      regular: 'https://fonts.gstatic.com/s/arbutusslab/v16/oY1Z8e7OuLXkJGbXtr5ba7ZVbq8dJlaFAQ.woff2',
    },
  },
  {
    family: 'Schoolbell',
    files: {
      regular: 'https://fonts.gstatic.com/s/schoolbell/v18/92zQtBZWOrcgoe-fgnJIVxcQ6mRqfiQ.woff2',
    },
  },
  {
    family: 'Oranienbaum',
    files: {
      regular: 'https://fonts.gstatic.com/s/oranienbaum/v15/OZpHg_txtzZKMuXLIVrx-3zi7kz3dpHc.woff2',
    },
  },
  {
    family: 'Averia Libre',
    files: {
      '300': 'https://fonts.gstatic.com/s/averialibre/v16/2V0FKIcMGZEnV6xygz7eNjEarovtak7t-pQgTw.woff2',
      '700': 'https://fonts.gstatic.com/s/averialibre/v16/2V0FKIcMGZEnV6xygz7eNjEavoztak7t-pQgTw.woff2',
      regular: 'https://fonts.gstatic.com/s/averialibre/v16/2V0aKIcMGZEnV6xygz7eNjEiB6PJZ2Xx8w.woff2',
    },
  },
  {
    family: 'Marmelad',
    files: {
      regular: 'https://fonts.gstatic.com/s/marmelad/v18/Qw3eZQdSHj_jK2e-8tFOG-YMC0R8.woff2',
    },
  },
  {
    family: 'Enriqueta',
    files: {
      '500': 'https://fonts.gstatic.com/s/enriqueta/v17/gokpH6L7AUFrRvV44HVrv2mHndZEq6TTFw.woff2',
      '600': 'https://fonts.gstatic.com/s/enriqueta/v17/gokpH6L7AUFrRvV44HVrk26HndZEq6TTFw.woff2',
      '700': 'https://fonts.gstatic.com/s/enriqueta/v17/gokpH6L7AUFrRvV44HVr92-HndZEq6TTFw.woff2',
      regular: 'https://fonts.gstatic.com/s/enriqueta/v17/goksH6L7AUFrRvV44HVTTkCjkP1Yog.woff2',
    },
  },
  {
    family: 'Proza Libre',
    files: {
      '500': 'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyELbV__acpC69i6N.woff2',
      '600': 'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEL3UP_acpC69i6N.woff2',
      '700': 'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKTUf_acpC69i6N.woff2',
      '800': 'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKPUv_acpC69i6N.woff2',
      regular: 'https://fonts.gstatic.com/s/prozalibre/v9/LYjGdGHgj0k1DIQRyUEyyHoqftvXWYyz.woff2',
    },
  },
  {
    family: 'Niconne',
    files: {
      regular: 'https://fonts.gstatic.com/s/niconne/v15/w8gaH2QvRug1_rTfrQ6t2F4OuOo.woff2',
    },
  },
  {
    family: 'Alike',
    files: {
      regular: 'https://fonts.gstatic.com/s/alike/v21/HI_EiYEYI6BIoEjESZXAQ4-d.woff2',
    },
  },
  {
    family: 'IBM Plex Sans KR',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFM2-VJISZe3O_rc3ZVYh4aTwNOyra_WpzCpMrMfA.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyhqef7PsqMPVZb4.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyn6df7PsqMPVZb4.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFN2-VJISZe3O_rc3ZVYh4aTwNOyiacf7PsqMPVZb4.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFN2-VJISZe3O_rc3ZVYh4aTwNOygqbf7PsqMPVZb4.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFN2-VJISZe3O_rc3ZVYh4aTwNOym6af7PsqMPVZb4.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsanskr/v10/vEFK2-VJISZe3O_rc3ZVYh4aTwNO8te1W77HtMo.woff2',
    },
  },
  {
    family: 'Stardos Stencil',
    files: {
      '700': 'https://fonts.gstatic.com/s/stardosstencil/v15/X7n44bcuGPC8hrvEOHXOgaKCc2TpU3tTuw-t29HSHw.woff2',
      regular: 'https://fonts.gstatic.com/s/stardosstencil/v15/X7n94bcuGPC8hrvEOHXOgaKCc2TR6lR3tiSx0g.woff2',
    },
  },
  {
    family: 'Akshar',
    files: {
      '300': 'https://fonts.gstatic.com/s/akshar/v9/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSSgFy9WY94XsnPc.woff2',
      '500': 'https://fonts.gstatic.com/s/akshar/v9/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSUQFy9WY94XsnPc.woff2',
      '600': 'https://fonts.gstatic.com/s/akshar/v9/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSagCy9WY94XsnPc.woff2',
      '700': 'https://fonts.gstatic.com/s/akshar/v9/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSZECy9WY94XsnPc.woff2',
      regular: 'https://fonts.gstatic.com/s/akshar/v9/Yq6I-LyHWTfz9rGoqDaUbHvhkAUsSXYFy9WY94XsnPc.woff2',
    },
  },
  {
    family: 'Knewave',
    files: {
      regular: 'https://fonts.gstatic.com/s/knewave/v14/sykz-yx0lLcxQaSItS-9-trEvlQ.woff2',
    },
  },
  {
    family: 'Contrail One',
    files: {
      regular: 'https://fonts.gstatic.com/s/contrailone/v19/eLGbP-j_JA-kG0_Zo51noafdYEvt_c092w.woff2',
    },
  },
  {
    family: 'Bungee Shade',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungeeshade/v13/DtVkJxarWL0t2KdzK3oI_jks6yLSrwFUlw.woff2',
    },
  },
  {
    family: 'Yesteryear',
    files: {
      regular: 'https://fonts.gstatic.com/s/yesteryear/v18/dg4g_p78rroaKl8kRKo1r7kHTwonmyw.woff2',
    },
  },
  {
    family: 'Manjari',
    files: {
      '100': 'https://fonts.gstatic.com/s/manjari/v11/k3kSo8UPMOBO2w1UdbroLmvFIaOV8A.woff2',
      '700': 'https://fonts.gstatic.com/s/manjari/v11/k3kVo8UPMOBO2w1UdWLNC0TrLaqM6Q4.woff2',
      regular: 'https://fonts.gstatic.com/s/manjari/v11/k3kQo8UPMOBO2w1UTdviL0nAMaM.woff2',
    },
  },
  {
    family: 'Halant',
    files: {
      '300': 'https://fonts.gstatic.com/s/halant/v14/u-490qaujRI2Pbsvc_pCngZqcwdRXg.woff2',
      '500': 'https://fonts.gstatic.com/s/halant/v14/u-490qaujRI2PbsvK_tCngZqcwdRXg.woff2',
      '600': 'https://fonts.gstatic.com/s/halant/v14/u-490qaujRI2PbsvB_xCngZqcwdRXg.woff2',
      '700': 'https://fonts.gstatic.com/s/halant/v14/u-490qaujRI2PbsvY_1CngZqcwdRXg.woff2',
      regular: 'https://fonts.gstatic.com/s/halant/v14/u-4-0qaujRI2PbsX2tJmky12eg.woff2',
    },
  },
  {
    family: 'David Libre',
    files: {
      '500': 'https://fonts.gstatic.com/s/davidlibre/v16/snfzs0W_99N64iuYSvp4W8GIw7qeSjORSo9W.woff2',
      '700': 'https://fonts.gstatic.com/s/davidlibre/v16/snfzs0W_99N64iuYSvp4W8HAxbqeSjORSo9W.woff2',
      regular: 'https://fonts.gstatic.com/s/davidlibre/v16/snfus0W_99N64iuYSvp4W_l56p6TYS-Y.woff2',
    },
  },
  {
    family: 'Noto Sans Kannada',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvMzScMLsPKrkY.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrLvNzScMLsPKrkY.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrGXNzScMLsPKrkY.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrAnNzScMLsPKrkY.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrOXKzScMLsPKrkY.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrNzKzScMLsPKrkY.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrLvKzScMLsPKrkY.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrJLKzScMLsPKrkY.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanskannada/v27/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvNzScMLsPKrkY.woff2',
    },
  },
  {
    family: 'Markazi Text',
    files: {
      '500': 'https://fonts.gstatic.com/s/markazitext/v23/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtcaQT4YlBekmJLo.woff2',
      '600': 'https://fonts.gstatic.com/s/markazitext/v23/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtSqXT4YlBekmJLo.woff2',
      '700': 'https://fonts.gstatic.com/s/markazitext/v23/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtROXT4YlBekmJLo.woff2',
      regular: 'https://fonts.gstatic.com/s/markazitext/v23/sykh-ydym6AtQaiEtX7yhqb_rV1k_81ZVYYZtfSQT4YlBekmJLo.woff2',
    },
  },
  {
    family: 'Alegreya SC',
    files: {
      '500': 'https://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZZc-rU0Qqu2FXKD.woff2',
      '700': 'https://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYU_LU0Qqu2FXKD.woff2',
      '800': 'https://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYI_7U0Qqu2FXKD.woff2',
      '900': 'https://fonts.gstatic.com/s/alegreyasc/v25/taiTGmRtCJ62-O0HhNEa-ZYs_rU0Qqu2FXKD.woff2',
      regular: 'https://fonts.gstatic.com/s/alegreyasc/v25/taiOGmRtCJ62-O0HhNEa-a6t05E5abe_.woff2',
    },
  },
  {
    family: 'Average Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/averagesans/v16/1Ptpg8fLXP2dlAXR-HlJJNJPANqazVoK4A.woff2',
    },
  },
  {
    family: 'Sigmar One',
    files: {
      regular: 'https://fonts.gstatic.com/s/sigmarone/v18/co3DmWZ8kjZuErj9Ta3dk6bjp3Di8U0.woff2',
    },
  },
  {
    family: 'Metrophobic',
    files: {
      regular: 'https://fonts.gstatic.com/s/metrophobic/v23/sJoA3LZUhMSAPV_u0qwiAT-M737FPEEL.woff2',
    },
  },
  {
    family: 'B612 Mono',
    files: {
      '700': 'https://fonts.gstatic.com/s/b612mono/v14/kmK6Zq85QVWbN1eW6lJdayv4p89Pv7JGSg.woff2',
      regular: 'https://fonts.gstatic.com/s/b612mono/v14/kmK_Zq85QVWbN1eW6lJl0gTcquRTtg.woff2',
    },
  },
  {
    family: 'Ovo',
    files: {
      regular: 'https://fonts.gstatic.com/s/ovo/v17/yYLl0h7WyfzjzoQ5_3WVxA.woff2',
    },
  },
  {
    family: 'Encode Sans Semi Condensed',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT6oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1T19MRtQ9jpVUA.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1RZ1eFCbdTgTFmr.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Q91uFCbdTgTFmr.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Rl1-FCbdTgTFmr.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1RJ0OFCbdTgTFmr.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qt0eFCbdTgTFmr.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qx0uFCbdTgTFmr.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1QV0-FCbdTgTFmr.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT4oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG2yU_sVPRsjp.woff2',
    },
  },
  {
    family: 'B612',
    files: {
      '700': 'https://fonts.gstatic.com/s/b612/v12/3Jn9SDDxiSz34oWXPDWLTXUETuE.woff2',
      regular: 'https://fonts.gstatic.com/s/b612/v12/3JnySDDxiSz32jy4GDigUXw.woff2',
    },
  },
  {
    family: 'Irish Grover',
    files: {
      regular: 'https://fonts.gstatic.com/s/irishgrover/v23/buExpoi6YtLz2QW7LA4flVgf_f5Oaiw4cw.woff2',
    },
  },
  {
    family: 'Henny Penny',
    files: {
      regular: 'https://fonts.gstatic.com/s/hennypenny/v17/wXKvE3UZookzsxz_kjGSfMQvt3M7tMDT.woff2',
    },
  },
  {
    family: 'Trirong',
    files: {
      '100': 'https://fonts.gstatic.com/s/trirong/v15/7r3EqXNgp8wxdOdOl-go2IRl6ujngw.woff2',
      '200': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOl0QJ_atL5uH-mts.woff2',
      '300': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlyAK_atL5uH-mts.woff2',
      '500': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOl3gL_atL5uH-mts.woff2',
      '600': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOl1QM_atL5uH-mts.woff2',
      '700': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlzAN_atL5uH-mts.woff2',
      '800': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlywO_atL5uH-mts.woff2',
      '900': 'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlwgP_atL5uH-mts.woff2',
      regular: 'https://fonts.gstatic.com/s/trirong/v15/7r3GqXNgp8wxdOdOr4ki2aZg-ug.woff2',
    },
  },
  {
    family: 'Overlock',
    files: {
      '700': 'https://fonts.gstatic.com/s/overlock/v17/Z9XSDmdMWRiN1_T9Z7xizcmJvL2L9TLT.woff2',
      '900': 'https://fonts.gstatic.com/s/overlock/v17/Z9XSDmdMWRiN1_T9Z7xaz8mJvL2L9TLT.woff2',
      regular: 'https://fonts.gstatic.com/s/overlock/v17/Z9XVDmdMWRiN1_T9Z4Tb4u2El6GC.woff2',
    },
  },
  {
    family: 'Dawning of a New Day',
    files: {
      regular: 'https://fonts.gstatic.com/s/dawningofanewday/v20/t5t_IQMbOp2SEwuncwLRjMfIg1yYit_nAz8ehWJGNoBE.woff2',
    },
  },
  {
    family: 'Chonburi',
    files: {
      regular: 'https://fonts.gstatic.com/s/chonburi/v12/8AtqGs-wOpGRTBq66IWfFr3biAfZ.woff2',
    },
  },
  {
    family: 'Bubblegum Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/bubblegumsans/v20/AYCSpXb_Z9EORv1M5QTjEzMEtdaCzoPPb7R4.woff2',
    },
  },
  {
    family: 'Vollkorn SC',
    files: {
      '600': 'https://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVimhGluvYbPN5Yjn.woff2',
      '700': 'https://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVinFG1uvYbPN5Yjn.woff2',
      '900': 'https://fonts.gstatic.com/s/vollkornsc/v11/j8_y6-zQ3rXpceZj9cqnVin9GVuvYbPN5Yjn.woff2',
      regular: 'https://fonts.gstatic.com/s/vollkornsc/v11/j8_v6-zQ3rXpceZj9cqnVhF8NH-iSq_E.woff2',
    },
  },
  {
    family: 'Shippori Mincho B1',
    files: {
      '500': 'https://fonts.gstatic.com/s/shipporiminchob1/v21/wXK1E2wCr44tulPdnn-xbIpJ9RgT9-nKeolP23ih5H4Uug.woff2',
      '600': 'https://fonts.gstatic.com/s/shipporiminchob1/v21/wXK1E2wCr44tulPdnn-xbIpJ9RgT9-nKVo5P23ih5H4Uug.woff2',
      '700': 'https://fonts.gstatic.com/s/shipporiminchob1/v21/wXK1E2wCr44tulPdnn-xbIpJ9RgT9-nKMo9P23ih5H4Uug.woff2',
      '800': 'https://fonts.gstatic.com/s/shipporiminchob1/v21/wXK1E2wCr44tulPdnn-xbIpJ9RgT9-nKLoxP23ih5H4Uug.woff2',
      regular: 'https://fonts.gstatic.com/s/shipporiminchob1/v21/wXK2E2wCr44tulPdnn-xbIpJ9RgT9-nyi6Br1lO97Q.woff2',
    },
  },
  {
    family: 'Noto Sans Telugu',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezfqREbf-3v37w.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt-zbqREbf-3v37w.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntJTbqREbf-3v37w.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntSTbqREbf-3v37w.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntpTHqREbf-3v37w.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntnDHqREbf-3v37w.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt-zHqREbf-3v37w.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt0jHqREbf-3v37w.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanstelugu/v26/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezbqREbf-3v37w.woff2',
    },
  },
  {
    family: 'Biryani',
    files: {
      '200': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddYQyGTVSU-J-RxQ.woff2',
      '300': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddeAxGTVSU-J-RxQ.woff2',
      '600': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddZQ3GTVSU-J-RxQ.woff2',
      '700': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84YddfA2GTVSU-J-RxQ.woff2',
      '800': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84Yddew1GTVSU-J-RxQ.woff2',
      '900': 'https://fonts.gstatic.com/s/biryani/v13/hv-TlzNxIFoO84Yddcg0GTVSU-J-RxQ.woff2',
      regular: 'https://fonts.gstatic.com/s/biryani/v13/hv-WlzNxIFoO84YdTUkZPTh5T-s.woff2',
    },
  },
  {
    family: 'Rochester',
    files: {
      regular: 'https://fonts.gstatic.com/s/rochester/v22/6ae-4KCqVa4Zy6Fif-Uy2lvWNTMwoQ.woff2',
    },
  },
  {
    family: 'Lateef',
    files: {
      '200': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0bjyga6Tb9nQ-RA.woff2',
      '300': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0Cj-ga6Tb9nQ-RA.woff2',
      '500': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0Uj6ga6Tb9nQ-RA.woff2',
      '600': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0fjmga6Tb9nQ-RA.woff2',
      '700': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0Gjiga6Tb9nQ-RA.woff2',
      '800': 'https://fonts.gstatic.com/s/lateef/v30/hESz6XVnNCxEvkb0Bjuga6Tb9nQ-RA.woff2',
      regular: 'https://fonts.gstatic.com/s/lateef/v30/hESw6XVnNCxEvkbMoxeEZo_H_w.woff2',
    },
  },
  {
    family: 'Petit Formal Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/petitformalscript/v17/B50TF6xQr2TXJBnGOFME6u5OR83oRP5qoHzqP4gZSiE.woff2',
    },
  },
  {
    family: 'Sniglet',
    files: {
      '800': 'https://fonts.gstatic.com/s/sniglet/v17/cIf4MaFLtkE3UjaJ_ImHRGQsnIJkWL4.woff2',
      regular: 'https://fonts.gstatic.com/s/sniglet/v17/cIf9MaFLtkE3UjaJxCyrYGkHgIs.woff2',
    },
  },
  {
    family: 'Kosugi',
    files: {
      regular: 'https://fonts.gstatic.com/s/kosugi/v15/pxiFyp4_v8FCjlI4Mbr6f1pdEQ.woff2',
    },
  },
  {
    family: 'Magra',
    files: {
      '700': 'https://fonts.gstatic.com/s/magra/v14/uK_w4ruaZus72nbNDxcSEPuUX1ow.woff2',
      regular: 'https://fonts.gstatic.com/s/magra/v14/uK_94ruaZus72k50IDMfO-ed.woff2',
    },
  },
  {
    family: 'Fanwood Text',
    files: {
      regular: 'https://fonts.gstatic.com/s/fanwoodtext/v15/3XFtErwl05Ad_vSCF6Fq7xXGQNbY1P1Sbg.woff2',
    },
  },
  {
    family: 'Amiko',
    files: {
      '600': 'https://fonts.gstatic.com/s/amiko/v14/WwkdxPq1DFK04uJ9XXrBGoQAUco5.woff2',
      '700': 'https://fonts.gstatic.com/s/amiko/v14/WwkdxPq1DFK04uIZXHrBGoQAUco5.woff2',
      regular: 'https://fonts.gstatic.com/s/amiko/v14/WwkQxPq1DFK04tqgc17MMZgJ.woff2',
    },
  },
  {
    family: 'Aladin',
    files: {
      regular: 'https://fonts.gstatic.com/s/aladin/v24/ZgNSjPJFPrvJV5f17Cf4pGT2Ng.woff2',
    },
  },
  {
    family: 'Nixie One',
    files: {
      regular: 'https://fonts.gstatic.com/s/nixieone/v16/lW-8wjkKLXjg5y2o2uUoVeFzpS-yLw.woff2',
    },
  },
  {
    family: 'Goudy Bookletter 1911',
    files: {
      regular: 'https://fonts.gstatic.com/s/goudybookletter1911/v19/sykt-z54laciWfKv-kX8krex0jDiD2HbY6I5sBbXZ4IXAA.woff2',
    },
  },
  {
    family: 'Gurajada',
    files: {
      regular: 'https://fonts.gstatic.com/s/gurajada/v19/FwZY7-Qx308m-l-0Kd6F4sijpFu_.woff2',
    },
  },
  {
    family: 'Rambla',
    files: {
      '700': 'https://fonts.gstatic.com/s/rambla/v13/snfos0ip98hx6mrMn50qO_N4yJuDYQ.woff2',
      regular: 'https://fonts.gstatic.com/s/rambla/v13/snfrs0ip98hx6mr0JrIONthkwQ.woff2',
    },
  },
  {
    family: 'Instrument Sans',
    files: {
      '500': 'https://fonts.gstatic.com/s/instrumentsans/v1/pximypc9vsFDm051Uf6KVwgkfoSxQ0GsQv8ToedPibnr-yp2JGEJOH9npST3-QfwmS0v3_7Y.woff2',
      '600': 'https://fonts.gstatic.com/s/instrumentsans/v1/pximypc9vsFDm051Uf6KVwgkfoSxQ0GsQv8ToedPibnr-yp2JGEJOH9npSQb_gfwmS0v3_7Y.woff2',
      '700': 'https://fonts.gstatic.com/s/instrumentsans/v1/pximypc9vsFDm051Uf6KVwgkfoSxQ0GsQv8ToedPibnr-yp2JGEJOH9npSQi_gfwmS0v3_7Y.woff2',
      regular:
        'https://fonts.gstatic.com/s/instrumentsans/v1/pximypc9vsFDm051Uf6KVwgkfoSxQ0GsQv8ToedPibnr-yp2JGEJOH9npSTF-QfwmS0v3_7Y.woff2',
    },
  },
  {
    family: 'Baloo Da 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjA5sTNb55aRa7UE.woff2',
      '600': 'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDVtjNb55aRa7UE.woff2',
      '700': 'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDstjNb55aRa7UE.woff2',
      '800': 'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjCLtjNb55aRa7UE.woff2',
      regular: 'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjALsTNb55aRa7UE.woff2',
    },
  },
  {
    family: 'NTR',
    files: {
      regular: 'https://fonts.gstatic.com/s/ntr/v15/RLpzK5Xy0ZjiHWhs5TA4bg.woff2',
    },
  },
  {
    family: 'Fahkwang',
    files: {
      '200': 'https://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJHmZlUFipxkwjx.woff2',
      '300': 'https://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOIjmplUFipxkwjx.woff2',
      '500': 'https://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJ7m5lUFipxkwjx.woff2',
      '600': 'https://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOJXnJlUFipxkwjx.woff2',
      '700': 'https://fonts.gstatic.com/s/fahkwang/v16/Noa26Uj3zpmBOgbNpOIznZlUFipxkwjx.woff2',
      regular: 'https://fonts.gstatic.com/s/fahkwang/v16/Noax6Uj3zpmBOgbNpNqKsr1ZPTZ4.woff2',
    },
  },
  {
    family: 'Cherry Swash',
    files: {
      '700': 'https://fonts.gstatic.com/s/cherryswash/v20/i7dSIFByZjaNAMxtZcnfAy5E_FeaHi6QZ3WfYg.woff2',
      regular: 'https://fonts.gstatic.com/s/cherryswash/v20/i7dNIFByZjaNAMxtZcnfAy58RXi-EwWMbg.woff2',
    },
  },
  {
    family: 'Noto Sans Gujarati',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFgPJ_OdiEH0s.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wpFwPJ_OdiEH0s.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_z3FwPJ_OdiEH0s.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ybFwPJ_OdiEH0s.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_x3EAPJ_OdiEH0s.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_xOEAPJ_OdiEH0s.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wpEAPJ_OdiEH0s.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wAEAPJ_OdiEH0s.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansgujarati/v25/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFwPJ_OdiEH0s.woff2',
    },
  },
  {
    family: 'Noto Nastaliq Urdu',
    files: {
      '500': 'https://fonts.gstatic.com/s/notonastaliqurdu/v20/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qu3-DKif2-_8mEw.woff2',
      '600': 'https://fonts.gstatic.com/s/notonastaliqurdu/v20/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3QgH5DKif2-_8mEw.woff2',
      '700': 'https://fonts.gstatic.com/s/notonastaliqurdu/v20/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qjj5DKif2-_8mEw.woff2',
      regular: 'https://fonts.gstatic.com/s/notonastaliqurdu/v20/LhWNMUPbN-oZdNFcBy1-DJYsEoTq5pudQ9L940pGPkB3Qt_-DKif2-_8mEw.woff2',
    },
  },
  {
    family: 'Zen Antique',
    files: {
      regular: 'https://fonts.gstatic.com/s/zenantique/v12/AYCPpXPnd91Ma_Zf-Ri2JXJv7PKP5Z_G.woff2',
    },
  },
  {
    family: 'Arya',
    files: {
      '700': 'https://fonts.gstatic.com/s/arya/v19/ga6NawNG-HJdzfra3bqBaFg3dRE.woff2',
      regular: 'https://fonts.gstatic.com/s/arya/v19/ga6CawNG-HJd9UP1-beqdFE.woff2',
    },
  },
  {
    family: 'Zen Kaku Gothic Antique',
    files: {
      '300': 'https://fonts.gstatic.com/s/zenkakugothicantique/v15/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22cM9TauWJtyZyGU.woff2',
      '500': 'https://fonts.gstatic.com/s/zenkakugothicantique/v15/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22dU9DauWJtyZyGU.woff2',
      '700': 'https://fonts.gstatic.com/s/zenkakugothicantique/v15/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22cc8jauWJtyZyGU.woff2',
      '900': 'https://fonts.gstatic.com/s/zenkakugothicantique/v15/6qLVKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB22ck8DauWJtyZyGU.woff2',
      regular: 'https://fonts.gstatic.com/s/zenkakugothicantique/v15/6qLQKYkHvh-nlUpKPAdoVFBtfxDzIn1eCzpB21-l3RKjc4d7.woff2',
    },
  },
  {
    family: 'Hahmlet',
    files: {
      '100': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKOdjtbsO-aVxn.woff2',
      '200': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjKONjtbsO-aVxn.woff2',
      '300': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RgUONjtbsO-aVxn.woff2',
      '500': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4Rh4ONjtbsO-aVxn.woff2',
      '600': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RiUP9jtbsO-aVxn.woff2',
      '700': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RitP9jtbsO-aVxn.woff2',
      '800': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjKP9jtbsO-aVxn.woff2',
      '900': 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjjP9jtbsO-aVxn.woff2',
      regular: 'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKONjtbsO-aVxn.woff2',
    },
  },
  {
    family: 'Besley',
    files: {
      '500': 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fYTBSdFoFPOl8-E.woff2',
      '600': 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fWjGSdFoFPOl8-E.woff2',
      '700': 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fVHGSdFoFPOl8-E.woff2',
      '800': 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fTbGSdFoFPOl8-E.woff2',
      '900': 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fR_GSdFoFPOl8-E.woff2',
      regular: 'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fbbBSdFoFPOl8-E.woff2',
    },
  },
  {
    family: 'Miriam Libre',
    files: {
      '700': 'https://fonts.gstatic.com/s/miriamlibre/v14/DdT-798HsHwubBAqfkcBTL_X3LbbQMC7_-Z7Hg.woff2',
      regular: 'https://fonts.gstatic.com/s/miriamlibre/v14/DdTh798HsHwubBAqfkcBTL_vZZn_Teun9g.woff2',
    },
  },
  {
    family: 'Andada Pro',
    files: {
      '500': 'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DP7BY8ZFLzvIt2S.woff2',
      '600': 'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMXAo8ZFLzvIt2S.woff2',
      '700': 'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMuAo8ZFLzvIt2S.woff2',
      '800': 'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DNJAo8ZFLzvIt2S.woff2',
      regular: 'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DPJBY8ZFLzvIt2S.woff2',
    },
  },
  {
    family: 'McLaren',
    files: {
      regular: 'https://fonts.gstatic.com/s/mclaren/v17/2EbnL-ZuAXFqZFXISYMf8z2Yt_c.woff2',
    },
  },
  {
    family: 'Coustard',
    files: {
      '900': 'https://fonts.gstatic.com/s/coustard/v16/3XFuErgg3YsZ5fqUU-2LkEHjb_jU3eRL.woff2',
      regular: 'https://fonts.gstatic.com/s/coustard/v16/3XFpErgg3YsZ5fqUU9UKvWXuROTd.woff2',
    },
  },
  {
    family: 'Waiting for the Sunrise',
    files: {
      regular: 'https://fonts.gstatic.com/s/waitingforthesunrise/v20/WBL1rFvOYl9CEv2i1mO6KUW8RKWJ2zoXoz5JsYZV9h_ZYk5J.woff2',
    },
  },
  {
    family: 'Rasa',
    files: {
      '300': 'https://fonts.gstatic.com/s/rasa/v22/xn76YHIn1mWmVKl8ZtAM9NrJfN4YJW4wfcvN2KT4.woff2',
      '500': 'https://fonts.gstatic.com/s/rasa/v22/xn76YHIn1mWmVKl8ZtAM9NrJfN50JW4wfcvN2KT4.woff2',
      '600': 'https://fonts.gstatic.com/s/rasa/v22/xn76YHIn1mWmVKl8ZtAM9NrJfN6YIm4wfcvN2KT4.woff2',
      '700': 'https://fonts.gstatic.com/s/rasa/v22/xn76YHIn1mWmVKl8ZtAM9NrJfN6hIm4wfcvN2KT4.woff2',
      regular: 'https://fonts.gstatic.com/s/rasa/v22/xn76YHIn1mWmVKl8ZtAM9NrJfN5GJW4wfcvN2KT4.woff2',
    },
  },
  {
    family: 'Spectral SC',
    files: {
      '200': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs1qwkTSPYeVXJZB.woff2',
      '300': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs0OwUTSPYeVXJZB.woff2',
      '500': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs1WwETSPYeVXJZB.woff2',
      '600': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs16x0TSPYeVXJZB.woff2',
      '700': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs0exkTSPYeVXJZB.woff2',
      '800': 'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs0CxUTSPYeVXJZB.woff2',
      regular: 'https://fonts.gstatic.com/s/spectralsc/v12/KtkpALCRZonmalTgyPmRfvWn6WDfFpuc.woff2',
    },
  },
  {
    family: 'Fjord One',
    files: {
      regular: 'https://fonts.gstatic.com/s/fjordone/v21/zOL-4pbEnKBY_9S1jNKr7O5As-FeiQ.woff2',
    },
  },
  {
    family: 'Mallanna',
    files: {
      regular: 'https://fonts.gstatic.com/s/mallanna/v13/hv-Vlzx-KEQb84YaDGw2EzRwVvJ-.woff2',
    },
  },
  {
    family: 'Average',
    files: {
      regular: 'https://fonts.gstatic.com/s/average/v18/fC1hPYBHe23MxA7rIedwVWytTyk.woff2',
    },
  },
  {
    family: 'Odibee Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/odibeesans/v18/neIPzCSooYAho6WvjeToRYk3epH9qGsf.woff2',
    },
  },
  {
    family: 'Bungee Inline',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungeeinline/v15/Gg8zN58UcgnlCweMrih332VuDGd1-FEglsc.woff2',
    },
  },
  {
    family: 'Carrois Gothic',
    files: {
      regular: 'https://fonts.gstatic.com/s/carroisgothic/v16/Z9XPDmFATg-N1PLtLOOxvIHl9ZmG3i7ajcJ-.woff2',
    },
  },
  {
    family: 'Homenaje',
    files: {
      regular: 'https://fonts.gstatic.com/s/homenaje/v16/FwZY7-Q-xVAi_l-6Ld6F4sijpFu_.woff2',
    },
  },
  {
    family: 'Grenze Gotisch',
    files: {
      '100': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz5UdYCdYPSd_w.woff2',
      '200': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5rz9UdYCdYPSd_w.woff2',
      '300': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5cT9UdYCdYPSd_w.woff2',
      '500': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5HT9UdYCdYPSd_w.woff2',
      '600': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i58ThUdYCdYPSd_w.woff2',
      '700': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5yDhUdYCdYPSd_w.woff2',
      '800': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5rzhUdYCdYPSd_w.woff2',
      '900': 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5hjhUdYCdYPSd_w.woff2',
      regular: 'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz9UdYCdYPSd_w.woff2',
    },
  },
  {
    family: 'Norican',
    files: {
      regular: 'https://fonts.gstatic.com/s/norican/v15/MwQ2bhXp1eSBqjkPGJdRtGs-lbA.woff2',
    },
  },
  {
    family: 'Cormorant Upright',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1N5phDpU9X6RPzQ.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1MhpxDpU9X6RPzQ.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1MNoBDpU9X6RPzQ.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorantupright/v18/VuJudM3I2Y35poFONtLdafkUCHw1y1NpoRDpU9X6RPzQ.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorantupright/v18/VuJrdM3I2Y35poFONtLdafkUCHw1y2vQjjTkeMnz.woff2',
    },
  },
  {
    family: 'Gabarito',
    files: {
      '500': 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj20cK0EwItq6bFIg.woff2',
      '600': 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj2PcW0EwItq6bFIg.woff2',
      '700': 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj2BMW0EwItq6bFIg.woff2',
      '800': 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj2Y8W0EwItq6bFIg.woff2',
      '900': 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj2SsW0EwItq6bFIg.woff2',
      regular: 'https://fonts.gstatic.com/s/gabarito/v4/QGYwz_0dZAGKJJ4t3FFkc3Q8AkNP9Pj248K0EwItq6bFIg.woff2',
    },
  },
  {
    family: 'Convergence',
    files: {
      regular: 'https://fonts.gstatic.com/s/convergence/v15/rax5HiePvdgXPmmMHcIPYRhfsU7Q8Cad.woff2',
    },
  },
  {
    family: 'Love Ya Like A Sister',
    files: {
      regular: 'https://fonts.gstatic.com/s/loveyalikeasister/v20/R70EjzUBlOqPeouhFDfR80-0FhOqJubN-Be793ZcsGGycA.woff2',
    },
  },
  {
    family: 'Kelly Slab',
    files: {
      regular: 'https://fonts.gstatic.com/s/kellyslab/v17/-W_7XJX0Rz3cxUnJC5t6TkYBf50kbiM.woff2',
    },
  },
  {
    family: 'Bentham',
    files: {
      regular: 'https://fonts.gstatic.com/s/bentham/v18/VdGeAZQPEpYfmHglKWk7CJaK_y4.woff2',
    },
  },
  {
    family: 'IM Fell English SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellenglishsc/v16/a8IENpD3CDX-4zrWfr1VY879qFF05pZLPogOg0shzA.woff2',
    },
  },
  {
    family: 'Big Shoulders Text',
    files: {
      '100': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-r3TcPNl6P2pc.woff2',
      '200': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Q-q3TcPNl6P2pc.woff2',
      '300': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3dGq3TcPNl6P2pc.woff2',
      '500': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3b2q3TcPNl6P2pc.woff2',
      '600': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3VGt3TcPNl6P2pc.woff2',
      '700': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Wit3TcPNl6P2pc.woff2',
      '800': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Q-t3TcPNl6P2pc.woff2',
      '900': 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Sat3TcPNl6P2pc.woff2',
      regular: 'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-q3TcPNl6P2pc.woff2',
    },
  },
  {
    family: 'Hanuman',
    files: {
      '100': 'https://fonts.gstatic.com/s/hanuman/v22/VuJzdNvD15HhpJJBQMLdOaNiaRpFvg.woff2',
      '300': 'https://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQAr_HIxMZRNcp0o.woff2',
      '700': 'https://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQBr4HIxMZRNcp0o.woff2',
      '900': 'https://fonts.gstatic.com/s/hanuman/v22/VuJ0dNvD15HhpJJBQCL6HIxMZRNcp0o.woff2',
      regular: 'https://fonts.gstatic.com/s/hanuman/v22/VuJxdNvD15HhpJJBeKPXOIFneRo.woff2',
    },
  },
  {
    family: 'Montserrat Subrayada',
    files: {
      '700': 'https://fonts.gstatic.com/s/montserratsubrayada/v19/U9MM6c-o9H7PgjlTHThBnNHGVUORwteQQHe3TcMTg3j36Ebz.woff2',
      regular: 'https://fonts.gstatic.com/s/montserratsubrayada/v19/U9MD6c-o9H7PgjlTHThBnNHGVUORwteQQE8OYuceqGT-.woff2',
    },
  },
  {
    family: 'Noto Sans Oriya',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0fq_Z6LhHBRe-.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivh0f6_Z6LhHBRe-.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Iviqf6_Z6LhHBRe-.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvjGf6_Z6LhHBRe-.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgqeK_Z6LhHBRe-.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgTeK_Z6LhHBRe-.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivh0eK_Z6LhHBRe-.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvhdeK_Z6LhHBRe-.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0f6_Z6LhHBRe-.woff2',
    },
  },
  {
    family: 'M PLUS 2',
    files: {
      '100': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa-Vw1qHrzNgAw.woff2',
      '200': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwua6Vw1qHrzNgAw.woff2',
      '300': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwZ66Vw1qHrzNgAw.woff2',
      '500': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwC66Vw1qHrzNgAw.woff2',
      '600': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw56mVw1qHrzNgAw.woff2',
      '700': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw3qmVw1qHrzNgAw.woff2',
      '800': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwuamVw1qHrzNgAw.woff2',
      '900': 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwkKmVw1qHrzNgAw.woff2',
      regular: 'https://fonts.gstatic.com/s/mplus2/v7/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa6Vw1qHrzNgAw.woff2',
    },
  },
  {
    family: 'Fondamento',
    files: {
      regular: 'https://fonts.gstatic.com/s/fondamento/v20/4UaHrEJGsxNmFTPDnkaJx6jj5pN1MwI.woff2',
    },
  },
  {
    family: 'Gravitas One',
    files: {
      regular: 'https://fonts.gstatic.com/s/gravitasone/v19/5h1diZ4hJ3cblKy3LWakKQmaCGRNr3DzbQ.woff2',
    },
  },
  {
    family: 'Chivo Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hrqfQKphL03l4.woff2',
      '200': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5hr6fQKphL03l4.woff2',
      '300': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D6_r6fQKphL03l4.woff2',
      '500': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7Tr6fQKphL03l4.woff2',
      '600': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4_qKfQKphL03l4.woff2',
      '700': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4GqKfQKphL03l4.woff2',
      '800': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5hqKfQKphL03l4.woff2',
      '900': 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5IqKfQKphL03l4.woff2',
      regular: 'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hr6fQKphL03l4.woff2',
    },
  },
  {
    family: 'Monsieur La Doulaise',
    files: {
      regular: 'https://fonts.gstatic.com/s/monsieurladoulaise/v18/_Xmz-GY4rjmCbQfc-aPRaa4pqV340p7EZl5bwkEU4HTy.woff2',
    },
  },
  {
    family: 'Megrim',
    files: {
      regular: 'https://fonts.gstatic.com/s/megrim/v16/46kulbz5WjvLqJZlaGXgd0RY1g.woff2',
    },
  },
  {
    family: 'Qwigley',
    files: {
      regular: 'https://fonts.gstatic.com/s/qwigley/v18/1cXzaU3UGJb5tGoCuVlsi1mBmcE.woff2',
    },
  },
  {
    family: 'Aboreto',
    files: {
      regular: 'https://fonts.gstatic.com/s/aboreto/v2/5DCXAKLhwDDQ4N8blKHeA2yuxSY.woff2',
    },
  },
  {
    family: 'Italiana',
    files: {
      regular: 'https://fonts.gstatic.com/s/italiana/v20/QldNNTtLsx4E__B0XTmUY31Wx7Vv.woff2',
    },
  },
  {
    family: 'IM Fell English',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellenglish/v14/Ktk1ALSLW8zDe0rthJysWrnLsAz3EqmZVY9Y5w.woff2',
    },
  },
  {
    family: 'Thasadith',
    files: {
      '700': 'https://fonts.gstatic.com/s/thasadith/v11/mtG94_1TIqPYrd_f5R1gDGYw3Q6yHk9d8w.woff2',
      regular: 'https://fonts.gstatic.com/s/thasadith/v11/mtG44_1TIqPYrd_f5R1YtUkU0CWuFw.woff2',
    },
  },
  {
    family: 'IM Fell DW Pica',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfelldwpica/v16/2sDGZGRQotv9nbn2qSl0TxXVYNw9YQPUvi88MQ.woff2',
    },
  },
  {
    family: 'Jockey One',
    files: {
      regular: 'https://fonts.gstatic.com/s/jockeyone/v21/HTxpL2g2KjCFj4x8WI6ArIP7HYOk4xc.woff2',
    },
  },
  {
    family: 'Rosario',
    files: {
      '300': 'https://fonts.gstatic.com/s/rosario/v31/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM69GCWc2d-YnOzUD.woff2',
      '500': 'https://fonts.gstatic.com/s/rosario/v31/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM68qCWc2d-YnOzUD.woff2',
      '600': 'https://fonts.gstatic.com/s/rosario/v31/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM6_GDmc2d-YnOzUD.woff2',
      '700': 'https://fonts.gstatic.com/s/rosario/v31/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM6__Dmc2d-YnOzUD.woff2',
      regular: 'https://fonts.gstatic.com/s/rosario/v31/xfuu0WDhWW_fOEoY8l_VPNZfB7jPM68YCWc2d-YnOzUD.woff2',
    },
  },
  {
    family: 'Poller One',
    files: {
      regular: 'https://fonts.gstatic.com/s/pollerone/v23/ahccv82n0TN3gia5E4Bud-xbgUS5u0s.woff2',
    },
  },
  {
    family: 'Turret Road',
    files: {
      '200': 'https://fonts.gstatic.com/s/turretroad/v9/pxidypMgpcBFjE84Zv-fE0ONEdeOYk1Mq3ap.woff2',
      '300': 'https://fonts.gstatic.com/s/turretroad/v9/pxidypMgpcBFjE84Zv-fE0PpEteOYk1Mq3ap.woff2',
      '500': 'https://fonts.gstatic.com/s/turretroad/v9/pxidypMgpcBFjE84Zv-fE0OxE9eOYk1Mq3ap.woff2',
      '700': 'https://fonts.gstatic.com/s/turretroad/v9/pxidypMgpcBFjE84Zv-fE0P5FdeOYk1Mq3ap.woff2',
      '800': 'https://fonts.gstatic.com/s/turretroad/v9/pxidypMgpcBFjE84Zv-fE0PlFteOYk1Mq3ap.woff2',
      regular: 'https://fonts.gstatic.com/s/turretroad/v9/pxiAypMgpcBFjE84Zv-fE3tAOvODSVFF.woff2',
    },
  },
  {
    family: 'Radley',
    files: {
      regular: 'https://fonts.gstatic.com/s/radley/v22/LYjDdGzinEIjCN19pQlEpVs3VQ.woff2',
    },
  },
  {
    family: 'Kdam Thmor Pro',
    files: {
      regular: 'https://fonts.gstatic.com/s/kdamthmorpro/v4/EJRPQgAzVdcI-Qdvt34jzurnGA76j89I8ZWb.woff2',
    },
  },
  {
    family: 'Gloock',
    files: {
      regular: 'https://fonts.gstatic.com/s/gloock/v6/Iurb6YFw84WUY4N5ihylBrdRjQ.woff2',
    },
  },
  {
    family: 'Oxygen Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/oxygenmono/v14/h0GsssGg9FxgDgCjLeAd7ijaze-PPlUu.woff2',
    },
  },
  {
    family: 'Hepta Slab',
    files: {
      '100': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5jfeY5B0NBkz.woff2',
      '200': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvmV5zfeY5B0NBkz.woff2',
      '300': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvlL5zfeY5B0NBkz.woff2',
      '500': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvkn5zfeY5B0NBkz.woff2',
      '600': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvnL4DfeY5B0NBkz.woff2',
      '700': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvny4DfeY5B0NBkz.woff2',
      '800': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvmV4DfeY5B0NBkz.woff2',
      '900': 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvm84DfeY5B0NBkz.woff2',
      regular: 'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5zfeY5B0NBkz.woff2',
    },
  },
  {
    family: 'Kufam',
    files: {
      '500': 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3pKk7rACJHvIwYg.woff2',
      '600': 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3SK47rACJHvIwYg.woff2',
      '700': 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3ca47rACJHvIwYg.woff2',
      '800': 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3Fq47rACJHvIwYg.woff2',
      '900': 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3P647rACJHvIwYg.woff2',
      regular: 'https://fonts.gstatic.com/s/kufam/v21/C8c-4cY7pG7w_oSJDszBXsKCcBH3lqk7rACJHvIwYg.woff2',
    },
  },
  {
    family: 'Mansalva',
    files: {
      regular: 'https://fonts.gstatic.com/s/mansalva/v14/aWB4m0aacbtDfvq5NJlgI47vdyBg.woff2',
    },
  },
  {
    family: 'Schibsted Grotesk',
    files: {
      '500': 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNEMEASsJuXFGVOQ.woff2',
      '600': 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMN_MYASsJuXFGVOQ.woff2',
      '700': 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNxcYASsJuXFGVOQ.woff2',
      '800': 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNosYASsJuXFGVOQ.woff2',
      '900': 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNi8YASsJuXFGVOQ.woff2',
      regular: 'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNIsEASsJuXFGVOQ.woff2',
    },
  },
  {
    family: 'Ma Shan Zheng',
    files: {
      regular: 'https://fonts.gstatic.com/s/mashanzheng/v10/NaPecZTRCLxvwo41b4gvzkXaRMHsDIRSfr0.woff2',
    },
  },
  {
    family: 'Gabriela',
    files: {
      regular: 'https://fonts.gstatic.com/s/gabriela/v20/qkBWXvsO6sreR8E-b_m7zrpHmRzC.woff2',
    },
  },
  {
    family: 'Fauna One',
    files: {
      regular: 'https://fonts.gstatic.com/s/faunaone/v15/wlpzgwTPBVpjpCuwkuEx3ExLYClOCg.woff2',
    },
  },
  {
    family: 'Cormorant SC',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorantsc/v18/0ybmGD4kxqXBmOVLG30OGwsmABIU-B3y8DOWGA.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorantsc/v18/0ybmGD4kxqXBmOVLG30OGwsmWBMU-B3y8DOWGA.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorantsc/v18/0ybmGD4kxqXBmOVLG30OGwsmdBQU-B3y8DOWGA.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorantsc/v18/0ybmGD4kxqXBmOVLG30OGwsmEBUU-B3y8DOWGA.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorantsc/v18/0yb5GD4kxqXBmOVLG30OGwseqTow9Tbu-Q.woff2',
    },
  },
  {
    family: 'Anek Malayalam',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu_HM_5PDO71Qs.woff2',
      '200': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTURu-HM_5PDO71Qs.woff2',
      '300': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUcW-HM_5PDO71Qs.woff2',
      '500': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUam-HM_5PDO71Qs.woff2',
      '600': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUUW5HM_5PDO71Qs.woff2',
      '700': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUXy5HM_5PDO71Qs.woff2',
      '800': 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTURu5HM_5PDO71Qs.woff2',
      regular: 'https://fonts.gstatic.com/s/anekmalayalam/v6/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu-HM_5PDO71Qs.woff2',
    },
  },
  {
    family: 'Inknut Antiqua',
    files: {
      '300': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2vwrj8bBoIYJNf.woff2',
      '500': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU33w7j8bBoIYJNf.woff2',
      '600': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU3bxLj8bBoIYJNf.woff2',
      '700': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2_xbj8bBoIYJNf.woff2',
      '800': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2jxrj8bBoIYJNf.woff2',
      '900': 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2Hx7j8bBoIYJNf.woff2',
      regular: 'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GSYax7VC4ot_qNB4nYpBdaKXUG6pzxRwYB.woff2',
    },
  },
  {
    family: 'Jomhuria',
    files: {
      regular: 'https://fonts.gstatic.com/s/jomhuria/v20/Dxxp8j-TMXf-llKur2bwMOGbC3Dh.woff2',
    },
  },
  {
    family: 'Vesper Libre',
    files: {
      '500': 'https://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdA-2ap14kKXKvPlw.woff2',
      '700': 'https://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdAs2Cp14kKXKvPlw.woff2',
      '900': 'https://fonts.gstatic.com/s/vesperlibre/v19/bx6dNxyWnf-uxPdXDHUD_RdAi2Kp14kKXKvPlw.woff2',
      regular: 'https://fonts.gstatic.com/s/vesperlibre/v19/bx6CNxyWnf-uxPdXDHUD_Rd4Ck-N2qIWVQ.woff2',
    },
  },
  {
    family: 'Style Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/stylescript/v11/vm8xdRX3SV7Z0aPa88xzW5npfVT76NZnMw.woff2',
    },
  },
  {
    family: 'Chelsea Market',
    files: {
      regular: 'https://fonts.gstatic.com/s/chelseamarket/v13/BCawqZsHqfr89WNP_IApC8tzKBhgLA4uKkWk.woff2',
    },
  },
  {
    family: 'Capriola',
    files: {
      regular: 'https://fonts.gstatic.com/s/capriola/v14/wXKoE3YSppcvo1PDln_5L-AinG8y.woff2',
    },
  },
  {
    family: 'Meddon',
    files: {
      regular: 'https://fonts.gstatic.com/s/meddon/v24/kmK8ZqA2EgDNeHTZgRdB3y_Aow.woff2',
    },
  },
  {
    family: 'KoHo',
    files: {
      '200': 'https://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPuE1WJv5JoKhHys.woff2',
      '300': 'https://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPoU2WJv5JoKhHys.woff2',
      '500': 'https://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPt03WJv5JoKhHys.woff2',
      '600': 'https://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPvEwWJv5JoKhHys.woff2',
      '700': 'https://fonts.gstatic.com/s/koho/v16/K2FxfZ5fmddNPpUxWJv5JoKhHys.woff2',
      regular: 'https://fonts.gstatic.com/s/koho/v16/K2F-fZ5fmddNBiwefJbSOos.woff2',
    },
  },
  {
    family: 'Copse',
    files: {
      regular: 'https://fonts.gstatic.com/s/copse/v15/11hPGpDKz1rGb0dmHkihUb-A.woff2',
    },
  },
  {
    family: 'Skranji',
    files: {
      '700': 'https://fonts.gstatic.com/s/skranji/v13/OZpGg_dtriVFNerMW4eBtlnNwED-b4g.woff2',
      regular: 'https://fonts.gstatic.com/s/skranji/v13/OZpDg_dtriVFNerMYz6uklTm3Ek.woff2',
    },
  },
  {
    family: 'Molengo',
    files: {
      regular: 'https://fonts.gstatic.com/s/molengo/v16/I_uuMpWeuBzZNBtQbbFQkiCvs5Y.woff2',
    },
  },
  {
    family: 'Della Respira',
    files: {
      regular: 'https://fonts.gstatic.com/s/dellarespira/v22/RLp5K5v44KaueWI6iEJQBiGPRfwSu6EuTHo.woff2',
    },
  },
  {
    family: 'Tomorrow',
    files: {
      '100': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLgrETNbFtZCeGqgR2xe2DiKMiokE4.woff2',
      '200': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR0dWkXNBsShiVd4.woff2',
      '300': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR15WUXNBsShiVd4.woff2',
      '500': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR0hWEXNBsShiVd4.woff2',
      '600': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR0NX0XNBsShiVd4.woff2',
      '700': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR1pXkXNBsShiVd4.woff2',
      '800': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR11XUXNBsShiVd4.woff2',
      '900': 'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR1RXEXNBsShiVd4.woff2',
      regular: 'https://fonts.gstatic.com/s/tomorrow/v17/WBLmrETNbFtZCeGqgSXQcWHALdio.woff2',
    },
  },
  {
    family: 'Libre Barcode 39 Text',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcode39text/v28/sJoa3KhViNKANw_E3LwoDXvs5Un0HQ1vT-030BRL-9rYaw.woff2',
    },
  },
  {
    family: 'Baloo Paaji 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Al74f3bRUz1r5t.woff2',
      '600': 'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9DJ6If3bRUz1r5t.woff2',
      '700': 'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Dw6If3bRUz1r5t.woff2',
      '800': 'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9CX6If3bRUz1r5t.woff2',
      regular: 'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9AX74f3bRUz1r5t.woff2',
    },
  },
  {
    family: 'Quando',
    files: {
      regular: 'https://fonts.gstatic.com/s/quando/v16/xMQVuFNaVa6YuW0pDqWzKX_QmA.woff2',
    },
  },
  {
    family: 'Antic Didone',
    files: {
      regular: 'https://fonts.gstatic.com/s/anticdidone/v16/RWmPoKKX6u8sp8fIWdnDKqDirIsGBGBzCw.woff2',
    },
  },
  {
    family: 'Baloo Thambi 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloothambi2/v17/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbK_8IzbARG_n4osQ.woff2',
      '600': 'https://fonts.gstatic.com/s/baloothambi2/v17/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKE8UzbARG_n4osQ.woff2',
      '700': 'https://fonts.gstatic.com/s/baloothambi2/v17/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKKsUzbARG_n4osQ.woff2',
      '800': 'https://fonts.gstatic.com/s/baloothambi2/v17/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKTcUzbARG_n4osQ.woff2',
      regular: 'https://fonts.gstatic.com/s/baloothambi2/v17/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKzcIzbARG_n4osQ.woff2',
    },
  },
  {
    family: 'Onest',
    files: {
      '100': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPh9R6ZtxFMQWXgSQ.woff2',
      '200': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhdR-ZtxFMQWXgSQ.woff2',
      '300': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhqx-ZtxFMQWXgSQ.woff2',
      '500': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhxx-ZtxFMQWXgSQ.woff2',
      '600': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhKxiZtxFMQWXgSQ.woff2',
      '700': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhEhiZtxFMQWXgSQ.woff2',
      '800': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhdRiZtxFMQWXgSQ.woff2',
      '900': 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPhXBiZtxFMQWXgSQ.woff2',
      regular: 'https://fonts.gstatic.com/s/onest/v6/gNMZW3F-SZuj7zOT0IfSjTS16cPh9R-ZtxFMQWXgSQ.woff2',
    },
  },
  {
    family: 'Noto Sans Gurmukhi',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1Oe3b0Z_trdp7h.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3Oenb0Z_trdp7h.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG0Qenb0Z_trdp7h.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG18enb0Z_trdp7h.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2QfXb0Z_trdp7h.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2pfXb0Z_trdp7h.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3OfXb0Z_trdp7h.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3nfXb0Z_trdp7h.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1Oenb0Z_trdp7h.woff2',
    },
  },
  {
    family: 'Cambay',
    files: {
      '700': 'https://fonts.gstatic.com/s/cambay/v12/SLXKc1rY6H0_ZDs-0puswvlwYX99kA.woff2',
      regular: 'https://fonts.gstatic.com/s/cambay/v12/SLXJc1rY6H0_ZDsGa7SIz9JsaA.woff2',
    },
  },
  {
    family: 'Oooh Baby',
    files: {
      regular: 'https://fonts.gstatic.com/s/ooohbaby/v4/2sDcZGJWgJTT2Jf76xQDam-4C7wFZQ.woff2',
    },
  },
  {
    family: 'Caladea',
    files: {
      '700': 'https://fonts.gstatic.com/s/caladea/v7/kJE2BugZ7AAjhybUtaNY398YqO52FZ0.woff2',
      regular: 'https://fonts.gstatic.com/s/caladea/v7/kJEzBugZ7AAjhybUjRp3-9IztOc.woff2',
    },
  },
  {
    family: 'Marvel',
    files: {
      '700': 'https://fonts.gstatic.com/s/marvel/v16/nwpWtKeoNgBV0qawLXHgAlWmxwkiYQ.woff2',
      regular: 'https://fonts.gstatic.com/s/marvel/v16/nwpVtKeoNgBV0qaIlF7ED366zg.woff2',
    },
  },
  {
    family: 'Noto Sans Lao Looped',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr2M-Nw5V_T71k.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomHr3M-Nw5V_T71k.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomKT3M-Nw5V_T71k.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomMj3M-Nw5V_T71k.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomCTwM-Nw5V_T71k.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomB3wM-Nw5V_T71k.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomHrwM-Nw5V_T71k.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomFPwM-Nw5V_T71k.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanslaolooped/v7/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr3M-Nw5V_T71k.woff2',
    },
  },
  {
    family: 'Over the Rainbow',
    files: {
      regular: 'https://fonts.gstatic.com/s/overtherainbow/v20/11haGoXG1k_HKhMLUWz7Mc7vvW5upvam9NA2XG0.woff2',
    },
  },
  {
    family: 'Patrick Hand SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/patrickhandsc/v15/0nkwC9f7MfsBiWcLtY65AWDK873VjCi6JQc7Vg.woff2',
    },
  },
  {
    family: 'Baloo Chettan 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CdCTO18eH9xI2gc.woff2',
      '600': 'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CTyUO18eH9xI2gc.woff2',
      '700': 'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CQWUO18eH9xI2gc.woff2',
      '800': 'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CWKUO18eH9xI2gc.woff2',
      regular: 'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CeKTO18eH9xI2gc.woff2',
    },
  },
  {
    family: 'Baloo Tamma 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/balootamma2/v16/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMsuPp-xIF71SGC5.woff2',
      '600': 'https://fonts.gstatic.com/s/balootamma2/v16/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMvCOZ-xIF71SGC5.woff2',
      '700': 'https://fonts.gstatic.com/s/balootamma2/v16/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMv7OZ-xIF71SGC5.woff2',
      '800': 'https://fonts.gstatic.com/s/balootamma2/v16/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMucOZ-xIF71SGC5.woff2',
      regular: 'https://fonts.gstatic.com/s/balootamma2/v16/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMscPp-xIF71SGC5.woff2',
    },
  },
  {
    family: 'Noto Serif Thai',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiFuRUCmsdu0Qx.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qiF-RUCmsdu0Qx.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0p8F-RUCmsdu0Qx.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oQF-RUCmsdu0Qx.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0r8EORUCmsdu0Qx.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0rFEORUCmsdu0Qx.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qiEORUCmsdu0Qx.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qLEORUCmsdu0Qx.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifthai/v24/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiF-RUCmsdu0Qx.woff2',
    },
  },
  {
    family: 'ZCOOL XiaoWei',
    files: {
      regular: 'https://fonts.gstatic.com/s/zcoolxiaowei/v14/i7dMIFFrTRywPpUVX9_RJyM1YFeQHwyVd3U.woff2',
    },
  },
  {
    family: 'Kaisei Decol',
    files: {
      '500': 'https://fonts.gstatic.com/s/kaiseidecol/v8/bMrvmSqP45sidWf3QmfFW6iKr3gr1ki_qb57kA.woff2',
      '700': 'https://fonts.gstatic.com/s/kaiseidecol/v8/bMrvmSqP45sidWf3QmfFW6iK534r1ki_qb57kA.woff2',
      regular: 'https://fonts.gstatic.com/s/kaiseidecol/v8/bMrwmSqP45sidWf3QmfFW6iyXlEP22OjoA.woff2',
    },
  },
  {
    family: 'Sunflower',
    files: {
      '300': 'https://fonts.gstatic.com/s/sunflower/v16/RWmPoKeF8fUjqIj7Vc-06MfirIsGBGBzCw.woff2',
      '500': 'https://fonts.gstatic.com/s/sunflower/v16/RWmPoKeF8fUjqIj7Vc-0sMbirIsGBGBzCw.woff2',
      '700': 'https://fonts.gstatic.com/s/sunflower/v16/RWmPoKeF8fUjqIj7Vc-0-MDirIsGBGBzCw.woff2',
    },
  },
  {
    family: 'Bakbak One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bakbakone/v8/zOL54pXAl6RI-p_ardnuycFuv-hHkOs.woff2',
    },
  },
  {
    family: 'Almendra',
    files: {
      '700': 'https://fonts.gstatic.com/s/almendra/v26/H4cjBXKAlMnTn0Cskx6G7Zu9qKK-aihq.woff2',
      regular: 'https://fonts.gstatic.com/s/almendra/v26/H4ckBXKAlMnTn0CskyY_wr-wg763.woff2',
    },
  },
  {
    family: 'Headland One',
    files: {
      regular: 'https://fonts.gstatic.com/s/headlandone/v16/yYLu0hHR2vKnp89Tk1TCq3Tx1flTeZ3mJA.woff2',
    },
  },
  {
    family: 'Cambo',
    files: {
      regular: 'https://fonts.gstatic.com/s/cambo/v17/IFSqHeNEk8FJk41_ok7xkPm8.woff2',
    },
  },
  {
    family: 'Ms Madi',
    files: {
      regular: 'https://fonts.gstatic.com/s/msmadi/v2/HTxsL2UxNnOji5E1N-XPiI7QAYo.woff2',
    },
  },
  {
    family: 'Gayathri',
    files: {
      '100': 'https://fonts.gstatic.com/s/gayathri/v17/MCoWzAb429DbBilWLLhc-p7SA_gA2W8.woff2',
      '700': 'https://fonts.gstatic.com/s/gayathri/v17/MCoXzAb429DbBilWLLiE37v9LfQJwHbn.woff2',
      regular: 'https://fonts.gstatic.com/s/gayathri/v17/MCoQzAb429DbBilWLIA98J_wBugA.woff2',
    },
  },
  {
    family: 'Kadwa',
    files: {
      '700': 'https://fonts.gstatic.com/s/kadwa/v10/rnCr-x5V0g7ipix7auM7mHnOSOuk.woff2',
      regular: 'https://fonts.gstatic.com/s/kadwa/v10/rnCm-x5V0g7iphTCRcc2s2XH.woff2',
    },
  },
  {
    family: 'Padauk',
    files: {
      '700': 'https://fonts.gstatic.com/s/padauk/v16/RrQSboJg-id7Onb512DE0ZJEZ4YwGg.woff2',
      regular: 'https://fonts.gstatic.com/s/padauk/v16/RrQRboJg-id7OnbBbk_g3LlYbg.woff2',
    },
  },
  {
    family: 'Glory',
    files: {
      '100': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQwIiDo3-dDi9EOQ.woff2',
      '200': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQQImDo3-dDi9EOQ.woff2',
      '300': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQnomDo3-dDi9EOQ.woff2',
      '500': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQ8omDo3-dDi9EOQ.woff2',
      '600': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQHo6Do3-dDi9EOQ.woff2',
      '700': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQJ46Do3-dDi9EOQ.woff2',
      '800': 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQQI6Do3-dDi9EOQ.woff2',
      regular: 'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQwImDo3-dDi9EOQ.woff2',
    },
  },
  {
    family: 'Germania One',
    files: {
      regular: 'https://fonts.gstatic.com/s/germaniaone/v20/Fh4yPjrqIyv2ucM2qzBjeS3eyQJONau6ew.woff2',
    },
  },
  {
    family: 'Geo',
    files: {
      regular: 'https://fonts.gstatic.com/s/geo/v21/CSRz4zRZlufVKnBmQjlCbQ.woff2',
    },
  },
  {
    family: 'Bigshot One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bigshotone/v29/u-470qukhRkkO6BD_7cM_gxrUQJBXv_-.woff2',
    },
  },
  {
    family: 'Angkor',
    files: {
      regular: 'https://fonts.gstatic.com/s/angkor/v32/H4cmBXyAlsPdnlb-9yw-4Lqggw.woff2',
    },
  },
  {
    family: 'DotGothic16',
    files: {
      regular: 'https://fonts.gstatic.com/s/dotgothic16/v17/v6-QGYjBJFKgyw5nSoDAGE7O435YPFrT.woff2',
    },
  },
  {
    family: 'Federo',
    files: {
      regular: 'https://fonts.gstatic.com/s/federo/v19/iJWFBX-cbD_ETsbmiFOe2WTG7Q.woff2',
    },
  },
  {
    family: 'Nova Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/novamono/v20/Cn-0JtiGWQ5Ajb--MRKfZWxYrdM9Sg.woff2',
    },
  },
  {
    family: 'Azeret Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPRh17aa-5s3AA.woff2',
      '200': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfHPVh17aa-5s3AA.woff2',
      '300': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfwvVh17aa-5s3AA.woff2',
      '500': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfrvVh17aa-5s3AA.woff2',
      '600': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfQvJh17aa-5s3AA.woff2',
      '700': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfe_Jh17aa-5s3AA.woff2',
      '800': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfHPJh17aa-5s3AA.woff2',
      '900': 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfNfJh17aa-5s3AA.woff2',
      regular: 'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPVh17aa-5s3AA.woff2',
    },
  },
  {
    family: 'Pompiere',
    files: {
      regular: 'https://fonts.gstatic.com/s/pompiere/v19/VEMyRoxis5Dwuyeov6Wo5jDtreOL.woff2',
    },
  },
  {
    family: 'REM',
    files: {
      '100': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPMLrrT8UbIqIfBU.woff2',
      '200': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPELqrT8UbIqIfBU.woff2',
      '300': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPJzqrT8UbIqIfBU.woff2',
      '500': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPPDqrT8UbIqIfBU.woff2',
      '600': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPBztrT8UbIqIfBU.woff2',
      '700': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPCXtrT8UbIqIfBU.woff2',
      '800': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPELtrT8UbIqIfBU.woff2',
      '900': 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPGvtrT8UbIqIfBU.woff2',
      regular: 'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPMLqrT8UbIqIfBU.woff2',
    },
  },
  {
    family: 'MuseoModerno',
    files: {
      '100': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZFuekajeKlCdo.woff2',
      '200': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMtZEuekajeKlCdo.woff2',
      '300': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMghEuekajeKlCdo.woff2',
      '500': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMmREuekajeKlCdo.woff2',
      '600': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMohDuekajeKlCdo.woff2',
      '700': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMrFDuekajeKlCdo.woff2',
      '800': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMtZDuekajeKlCdo.woff2',
      '900': 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMv9DuekajeKlCdo.woff2',
      regular: 'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZEuekajeKlCdo.woff2',
    },
  },
  {
    family: 'Share',
    files: {
      '700': 'https://fonts.gstatic.com/s/share/v18/i7dJIFliZjKNF63xM567WkJUQUq7.woff2',
      regular: 'https://fonts.gstatic.com/s/share/v18/i7dEIFliZjKNF5VIHLq2cV5d.woff2',
    },
  },
  {
    family: 'Mr De Haviland',
    files: {
      regular: 'https://fonts.gstatic.com/s/mrdehaviland/v14/OpNVnooIhJj96FdB73296ksbOj3H4ULVNTlB.woff2',
    },
  },
  {
    family: 'Zen Kurenaido',
    files: {
      regular: 'https://fonts.gstatic.com/s/zenkurenaido/v16/3XFsEr0515BK2u6UUptu_gWJZfn22PRLd0U.woff2',
    },
  },
  {
    family: 'Imprima',
    files: {
      regular: 'https://fonts.gstatic.com/s/imprima/v18/VEMxRoN7sY3yuy-7-oCHyDzktPo.woff2',
    },
  },
  {
    family: 'Mouse Memoirs',
    files: {
      regular: 'https://fonts.gstatic.com/s/mousememoirs/v17/t5tmIRoSNJ-PH0WNNgDYxdSb7TzFrpOHYh4.woff2',
    },
  },
  {
    family: 'Noto Serif Devanagari',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-og-CMUe1u_dv.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTC-ow-CMUe1u_dv.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTBgow-CMUe1u_dv.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTAMow-CMUe1u_dv.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDgpA-CMUe1u_dv.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDZpA-CMUe1u_dv.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTC-pA-CMUe1u_dv.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTCXpA-CMUe1u_dv.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-ow-CMUe1u_dv.woff2',
    },
  },
  {
    family: 'Brawler',
    files: {
      '700': 'https://fonts.gstatic.com/s/brawler/v19/xn7lYHE3xXewAscGiryUb9j2eNaPfk8.woff2',
      regular: 'https://fonts.gstatic.com/s/brawler/v19/xn7gYHE3xXewAscGsgW7S9XdZN8.woff2',
    },
  },
  {
    family: 'Sansita Swashed',
    files: {
      '300': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW-ppbT8VehmEa4Q.woff2',
      '500': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW4ZpbT8VehmEa4Q.woff2',
      '600': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW2pubT8VehmEa4Q.woff2',
      '700': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW1NubT8VehmEa4Q.woff2',
      '800': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSWzRubT8VehmEa4Q.woff2',
      '900': 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSWx1ubT8VehmEa4Q.woff2',
      regular: 'https://fonts.gstatic.com/s/sansitaswashed/v18/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW7RpbT8VehmEa4Q.woff2',
    },
  },
  {
    family: 'Fresca',
    files: {
      regular: 'https://fonts.gstatic.com/s/fresca/v22/6ae94K--SKgCzbM2H70W13DKPA.woff2',
    },
  },
  {
    family: 'Noto Serif Malayalam',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-1fmFwHpQVySg.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1N-xfmFwHpQVySg.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL16exfmFwHpQVySg.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1hexfmFwHpQVySg.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1aetfmFwHpQVySg.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1UOtfmFwHpQVySg.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1N-tfmFwHpQVySg.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1HutfmFwHpQVySg.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-xfmFwHpQVySg.woff2',
    },
  },
  {
    family: 'Cutive',
    files: {
      regular: 'https://fonts.gstatic.com/s/cutive/v21/NaPZcZ_fHOhV3Ip7SvhDoyqlZQ.woff2',
    },
  },
  {
    family: 'Amethysta',
    files: {
      regular: 'https://fonts.gstatic.com/s/amethysta/v16/rP2Fp2K15kgb_F3ibfWIHTWCBl0O8Q.woff2',
    },
  },
  {
    family: 'Mochiy Pop One',
    files: {
      regular: 'https://fonts.gstatic.com/s/mochiypopone/v9/QdVPSTA9Jh-gg-5XZP2UmU4O9kw1D3s6ZKAi.woff2',
    },
  },
  {
    family: 'Aref Ruqaa',
    files: {
      '700': 'https://fonts.gstatic.com/s/arefruqaa/v25/WwkYxPW1E165rajQKDulKDwNcNcS2N_7Bdk.woff2',
      regular: 'https://fonts.gstatic.com/s/arefruqaa/v25/WwkbxPW1E165rajQKDulEIUiVNo5xNY.woff2',
    },
  },
  {
    family: 'Poly',
    files: {
      regular: 'https://fonts.gstatic.com/s/poly/v16/MQpb-W6wKNitRLWAq2Lpris.woff2',
    },
  },
  {
    family: 'Lexend Exa',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7T6bCHJ8BRq0b.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9p7TqbCHJ8BRq0b.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9qlTqbCHJ8BRq0b.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9rJTqbCHJ8BRq0b.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9olSabCHJ8BRq0b.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9ocSabCHJ8BRq0b.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9p7SabCHJ8BRq0b.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9pSSabCHJ8BRq0b.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7TqbCHJ8BRq0b.woff2',
    },
  },
  {
    family: 'Farro',
    files: {
      '300': 'https://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa3hNJ67WkJUQUq7.woff2',
      '500': 'https://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa25NZ67WkJUQUq7.woff2',
      '700': 'https://fonts.gstatic.com/s/farro/v14/i7dJIFl3byGNHa3xM567WkJUQUq7.woff2',
      regular: 'https://fonts.gstatic.com/s/farro/v14/i7dEIFl3byGNHZVIHLq2cV5d.woff2',
    },
  },
  {
    family: 'Orelega One',
    files: {
      regular: 'https://fonts.gstatic.com/s/orelegaone/v12/3qTpojOggD2XtAdFb-QXZGt_1EcYaQ7F.woff2',
    },
  },
  {
    family: 'Lekton',
    files: {
      '700': 'https://fonts.gstatic.com/s/lekton/v17/SZc73FDmLaWmWpBm4zjMkGjX4DJXgQ.woff2',
      regular: 'https://fonts.gstatic.com/s/lekton/v17/SZc43FDmLaWmWpBeWhfonUPL6Q.woff2',
    },
  },
  {
    family: 'Spline Sans',
    files: {
      '300': 'https://fonts.gstatic.com/s/splinesans/v10/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpZlnYF9vlUfE2kw.woff2',
      '500': 'https://fonts.gstatic.com/s/splinesans/v10/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpClnYF9vlUfE2kw.woff2',
      '600': 'https://fonts.gstatic.com/s/splinesans/v10/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRp5l7YF9vlUfE2kw.woff2',
      '700': 'https://fonts.gstatic.com/s/splinesans/v10/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRp317YF9vlUfE2kw.woff2',
      regular: 'https://fonts.gstatic.com/s/splinesans/v10/_6_sED73Uf-2WfU2LzycEZousNzn1a1lKWRpOFnYF9vlUfE2kw.woff2',
    },
  },
  {
    family: 'Bellota Text',
    files: {
      '300': 'https://fonts.gstatic.com/s/bellotatext/v18/0FlMVP2VnlWS4f3-UE9hHXM5VfsqeAXwQy6yxg.woff2',
      '700': 'https://fonts.gstatic.com/s/bellotatext/v18/0FlMVP2VnlWS4f3-UE9hHXM5RfwqeAXwQy6yxg.woff2',
      regular: 'https://fonts.gstatic.com/s/bellotatext/v18/0FlTVP2VnlWS4f3-UE9hHXMB_NMOdS7sSg.woff2',
    },
  },
  {
    family: 'RocknRoll One',
    files: {
      regular: 'https://fonts.gstatic.com/s/rocknrollone/v10/kmK7ZqspGAfCeUiW6FFlmEC9guBhs7tfUxc.woff2',
    },
  },
  {
    family: 'Anaheim',
    files: {
      regular: 'https://fonts.gstatic.com/s/anaheim/v14/8vII7w042Wp87g4G0UHUEE5eK_w.woff2',
    },
  },
  {
    family: 'Noto Sans Sinhala',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2b5l0LpJwbQRM.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwo2a5l0LpJwbQRM.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwlOa5l0LpJwbQRM.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwj-a5l0LpJwbQRM.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwtOd5l0LpJwbQRM.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwuqd5l0LpJwbQRM.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwo2d5l0LpJwbQRM.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwqSd5l0LpJwbQRM.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2a5l0LpJwbQRM.woff2',
    },
  },
  {
    family: 'Mountains of Christmas',
    files: {
      '700': 'https://fonts.gstatic.com/s/mountainsofchristmas/v22/3y9z6a4zcCnn5X0FDyrKi2ZRUBIy8uxoUo7eBGqJFP5COp6IaEA.woff2',
      regular: 'https://fonts.gstatic.com/s/mountainsofchristmas/v22/3y9w6a4zcCnn5X0FDyrKi2ZRUBIy8uxoUo7ePNOmMPNpJpc.woff2',
    },
  },
  {
    family: 'Gluten',
    files: {
      '100': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7B1Ouni7ciJh.woff2',
      '200': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xb7R1Ouni7ciJh.woff2',
      '300': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8UF7R1Ouni7ciJh.woff2',
      '500': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vp7R1Ouni7ciJh.woff2',
      '600': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8WF6h1Ouni7ciJh.woff2',
      '700': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8W86h1Ouni7ciJh.woff2',
      '800': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xb6h1Ouni7ciJh.woff2',
      '900': 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xy6h1Ouni7ciJh.woff2',
      regular: 'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7R1Ouni7ciJh.woff2',
    },
  },
  {
    family: 'Inder',
    files: {
      regular: 'https://fonts.gstatic.com/s/inder/v14/w8gUH2YoQe8_4vq_pw-P3U4O.woff2',
    },
  },
  {
    family: 'Sue Ellen Francisco',
    files: {
      regular: 'https://fonts.gstatic.com/s/sueellenfrancisco/v20/wXK3E20CsoJ9j1DDkjHcQ5ZL8xRaxru9ro9F2lqk9H4.woff2',
    },
  },
  {
    family: 'IBM Plex Sans JP',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XLDn9KbTDf6_f7dISNqYf_tvPT7E7yifB7twdmHQ.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7OLTrN9Vuw5_BAM.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7IbQrN9Vuw5_BAM.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7N7RrN9Vuw5_BAM.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7PLWrN9Vuw5_BAM.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XKDn9KbTDf6_f7dISNqYf_tvPT7JbXrN9Vuw5_BAM.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsansjp/v5/Z9XNDn9KbTDf6_f7dISNqYf_tvPT1C_4iNJ-pwc.woff2',
    },
  },
  {
    family: 'Alike Angular',
    files: {
      regular: 'https://fonts.gstatic.com/s/alikeangular/v25/3qTrojWunjGQtEBlIcwMbSoI3kY6bB7FKjE.woff2',
    },
  },
  {
    family: 'Sumana',
    files: {
      '700': 'https://fonts.gstatic.com/s/sumana/v10/4UaArE5TqRBjGj--TDfG4ofN6ppsKg.woff2',
      regular: 'https://fonts.gstatic.com/s/sumana/v10/4UaDrE5TqRBjGj-G9Rji76zR4w.woff2',
    },
  },
  {
    family: 'Bayon',
    files: {
      regular: 'https://fonts.gstatic.com/s/bayon/v34/9XUrlJNmn0LPFl-sOhYEd2NJ.woff2',
    },
  },
  {
    family: 'Amarante',
    files: {
      regular: 'https://fonts.gstatic.com/s/amarante/v28/xMQXuF1KTa6EvGx9bq-yC3rAmD-b.woff2',
    },
  },
  {
    family: 'Hurricane',
    files: {
      regular: 'https://fonts.gstatic.com/s/hurricane/v7/pe0sMIuULZxTolZ5YldyB_2-C99ycg.woff2',
    },
  },
  {
    family: 'Asul',
    files: {
      '700': 'https://fonts.gstatic.com/s/asul/v21/VuJxdNjKxYr40U8qeKPXOIFneRo.woff2',
      regular: 'https://fonts.gstatic.com/s/asul/v21/VuJ-dNjKxYr46fYFXK78JIg.woff2',
    },
  },
  {
    family: 'BIZ UDGothic',
    files: {
      '700': 'https://fonts.gstatic.com/s/bizudgothic/v9/daaASTouBF7RUjnbt8p3LuKVCSxZ_hTQZMhbaA.woff2',
      regular: 'https://fonts.gstatic.com/s/bizudgothic/v9/daafSTouBF7RUjnbt8p3LuKtsAN98z_MbQ.woff2',
    },
  },
  {
    family: 'Yusei Magic',
    files: {
      regular: 'https://fonts.gstatic.com/s/yuseimagic/v12/yYLt0hbAyuCmoo5wlhPkpjHU-tdfcIT_.woff2',
    },
  },
  {
    family: 'Rouge Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/rougescript/v18/LYjFdGbiklMoCIQOw1Ep3S4PUfXbUJWq9g.woff2',
    },
  },
  {
    family: 'Oregano',
    files: {
      regular: 'https://fonts.gstatic.com/s/oregano/v15/If2IXTPxciS3H4S2kZLfPznO3yM.woff2',
    },
  },
  {
    family: 'Familjen Grotesk',
    files: {
      '500': 'https://fonts.gstatic.com/s/familjengrotesk/v8/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMG7aSzoc1jcEYq2.woff2',
      '600': 'https://fonts.gstatic.com/s/familjengrotesk/v8/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMFXbizoc1jcEYq2.woff2',
      '700': 'https://fonts.gstatic.com/s/familjengrotesk/v8/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMFubizoc1jcEYq2.woff2',
      regular: 'https://fonts.gstatic.com/s/familjengrotesk/v8/Qw3LZR9ZHiDnImG6-NEMQ41wby8WRnYsfkunR_eGfMGJaSzoc1jcEYq2.woff2',
    },
  },
  {
    family: 'Major Mono Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/majormonodisplay/v16/RWmVoLyb5fEqtsfBX9PDZIGr2tFubRhLD32QIndPww.woff2',
    },
  },
  {
    family: 'Give You Glory',
    files: {
      regular: 'https://fonts.gstatic.com/s/giveyouglory/v15/8QIQdiHOgt3vv4LR7ahjw9-XYc12B4ZD6rwa.woff2',
    },
  },
  {
    family: 'Croissant One',
    files: {
      regular: 'https://fonts.gstatic.com/s/croissantone/v26/3y9n6bU9bTPg4m8NDy3Kq24UM39qn5cdJ-4.woff2',
    },
  },
  {
    family: 'Licorice',
    files: {
      regular: 'https://fonts.gstatic.com/s/licorice/v6/t5tjIR8TMomTCAyjNk2yhqLgzCHu.woff2',
    },
  },
  {
    family: 'Fragment Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/fragmentmono/v4/4iCr6K5wfMRRjxp0DA6-2CLnN4FNh4UI_1U.woff2',
    },
  },
  {
    family: 'Recursive',
    files: {
      '300':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadDck015vwxjDJCL.woff2',
      '500':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCwk015vwxjDJCL.woff2',
      '600':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBclE15vwxjDJCL.woff2',
      '700':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBllE15vwxjDJCL.woff2',
      '800':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadAClE15vwxjDJCL.woff2',
      '900':
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadArlE15vwxjDJCL.woff2',
      regular:
        'https://fonts.gstatic.com/s/recursive/v38/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCCk015vwxjDJCL.woff2',
    },
  },
  {
    family: 'Sedgwick Ave',
    files: {
      regular: 'https://fonts.gstatic.com/s/sedgwickave/v12/uK_04rKEYuguzAcSYRdWTJq8W2g1Vcf5JA.woff2',
    },
  },
  {
    family: 'Finger Paint',
    files: {
      regular: 'https://fonts.gstatic.com/s/fingerpaint/v19/0QInMXVJ-o-oRn_7dron8YWO9pbS8ANesw.woff2',
    },
  },
  {
    family: 'Encode Sans Semi Expanded',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8xOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM-41LgrlKXeOEA.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM0IUCyXLJX6XCWU.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMyYXCyXLJX6XCWU.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM34WCyXLJX6XCWU.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM1IRCyXLJX6XCWU.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMzYQCyXLJX6XCWU.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMyoTCyXLJX6XCWU.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMw4SCyXLJX6XCWU.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke83OhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TC48_LyjgOXc.woff2',
    },
  },
  {
    family: 'Red Rose',
    files: {
      '300': 'https://fonts.gstatic.com/s/redrose/v20/QdVISTYiLBjouPgEUajvsfWwDtc3MH8y8_sDdzSsYUVUjg.woff2',
      '500': 'https://fonts.gstatic.com/s/redrose/v20/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yn_sDdzSsYUVUjg.woff2',
      '600': 'https://fonts.gstatic.com/s/redrose/v20/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yc_wDdzSsYUVUjg.woff2',
      '700': 'https://fonts.gstatic.com/s/redrose/v20/QdVISTYiLBjouPgEUajvsfWwDtc3MH8ySvwDdzSsYUVUjg.woff2',
      regular: 'https://fonts.gstatic.com/s/redrose/v20/QdVISTYiLBjouPgEUajvsfWwDtc3MH8yrfsDdzSsYUVUjg.woff2',
    },
  },
  {
    family: 'Oleo Script Swash Caps',
    files: {
      '700': 'https://fonts.gstatic.com/s/oleoscriptswashcaps/v13/Noag6Vb-w5SFbTTAsZP_7JkCS08K-jCzDn_HCcaBbYAsn9T5dt0.woff2',
      regular: 'https://fonts.gstatic.com/s/oleoscriptswashcaps/v13/Noaj6Vb-w5SFbTTAsZP_7JkCS08K-jCzDn_HMX-uSY0Hg90.woff2',
    },
  },
  {
    family: 'Duru Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/durusans/v20/xn7iYH8xwmSyTvEV_HOxSvfYdN-WZw.woff2',
    },
  },
  {
    family: 'Mukta Vaani',
    files: {
      '200': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXNV8BG-u97MW1a.woff2',
      '300': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGWpVMBG-u97MW1a.woff2',
      '500': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXxVcBG-u97MW1a.woff2',
      '600': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXdUsBG-u97MW1a.woff2',
      '700': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGW5U8BG-u97MW1a.woff2',
      '800': 'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGWlUMBG-u97MW1a.woff2',
      regular: 'https://fonts.gstatic.com/s/muktavaani/v13/3Jn5SD_-ynaxmxnEfVHPIF0AfORL0fNy.woff2',
    },
  },
  {
    family: 'Imbue',
    files: {
      '100': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iWfO4NNK-Q4xY.woff2',
      '200': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP0iXfO4NNK-Q4xY.woff2',
      '300': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP5aXfO4NNK-Q4xY.woff2',
      '500': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP_qXfO4NNK-Q4xY.woff2',
      '600': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPxaQfO4NNK-Q4xY.woff2',
      '700': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPy-QfO4NNK-Q4xY.woff2',
      '800': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP0iQfO4NNK-Q4xY.woff2',
      '900': 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP2GQfO4NNK-Q4xY.woff2',
      regular: 'https://fonts.gstatic.com/s/imbue/v27/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iXfO4NNK-Q4xY.woff2',
    },
  },
  {
    family: 'Coiny',
    files: {
      regular: 'https://fonts.gstatic.com/s/coiny/v16/gyByhwU1K989PXweElSvO5Tc.woff2',
    },
  },
  {
    family: 'Noto Sans Meetei Mayek',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ__TT5PgeFYVa.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1RJ_vTT5PgeFYVa.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1SX_vTT5PgeFYVa.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1T7_vTT5PgeFYVa.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1QX-fTT5PgeFYVa.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1Qu-fTT5PgeFYVa.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1RJ-fTT5PgeFYVa.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1Rg-fTT5PgeFYVa.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansmeeteimayek/v15/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ_vTT5PgeFYVa.woff2',
    },
  },
  {
    family: 'Allan',
    files: {
      '700': 'https://fonts.gstatic.com/s/allan/v24/ea8aadU7WuTxEu5KEPCI2WpNgEKU.woff2',
      regular: 'https://fonts.gstatic.com/s/allan/v24/ea8XadU7WuTxEtbzP9SF8nZE.woff2',
    },
  },
  {
    family: 'Goblin One',
    files: {
      regular: 'https://fonts.gstatic.com/s/goblinone/v26/CSR64z1ZnOqZRjRCBVY_TOIATNt_pOU.woff2',
    },
  },
  {
    family: 'Bricolage Grotesque',
    files: {
      '200':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvZviyMgvs-wJDtw.woff2',
      '300':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvUXiyMgvs-wJDtw.woff2',
      '500':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvSniyMgvs-wJDtw.woff2',
      '600':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvcXlyMgvs-wJDtw.woff2',
      '700':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvfzlyMgvs-wJDtw.woff2',
      '800':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvZvlyMgvs-wJDtw.woff2',
      regular:
        'https://fonts.gstatic.com/s/bricolagegrotesque/v2/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvRviyMgvs-wJDtw.woff2',
    },
  },
  {
    family: 'Fuggles',
    files: {
      regular: 'https://fonts.gstatic.com/s/fuggles/v12/k3kQo8UEJOlD1hpOTdviL0nAMaM.woff2',
    },
  },
  {
    family: 'Lemon',
    files: {
      regular: 'https://fonts.gstatic.com/s/lemon/v17/HI_EiYEVKqRMq0jESZXAQ4-d.woff2',
    },
  },
  {
    family: 'Tilt Neon',
    files: {
      regular: 'https://fonts.gstatic.com/s/tiltneon/v10/E21L_d7gguXdwD9LEFY2WCeElCNtd-eBqpHp1TzrkJSmwpj5ndxquXK4WualJ9DS.woff2',
    },
  },
  {
    family: 'Euphoria Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/euphoriascript/v20/mFTpWb0X2bLb_cx6To2B8GpKoD5alvZT1D8x7Q.woff2',
    },
  },
  {
    family: 'Lexend Zetta',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bH0ztjbs8qbts.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy1bG0ztjbs8qbts.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy4jG0ztjbs8qbts.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy-TG0ztjbs8qbts.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCywjB0ztjbs8qbts.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCyzHB0ztjbs8qbts.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy1bB0ztjbs8qbts.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy3_B0ztjbs8qbts.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bG0ztjbs8qbts.woff2',
    },
  },
  {
    family: 'Anek Latin',
    files: {
      '100': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7EZLNClWL3kgw.woff2',
      '200': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3Pux7AZLNClWL3kgw.woff2',
      '300': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuGbAZLNClWL3kgw.woff2',
      '500': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PudbAZLNClWL3kgw.woff2',
      '600': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PumbcZLNClWL3kgw.woff2',
      '700': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuoLcZLNClWL3kgw.woff2',
      '800': 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3Pux7cZLNClWL3kgw.woff2',
      regular: 'https://fonts.gstatic.com/s/aneklatin/v5/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7AZLNClWL3kgw.woff2',
    },
  },
  {
    family: 'Inria Serif',
    files: {
      '300': 'https://fonts.gstatic.com/s/inriaserif/v16/fC14PYxPY3rXxEndZJAzN3wAVQjAhFyta3xN.woff2',
      '700': 'https://fonts.gstatic.com/s/inriaserif/v16/fC14PYxPY3rXxEndZJAzN3wQUgjAhFyta3xN.woff2',
      regular: 'https://fonts.gstatic.com/s/inriaserif/v16/fC1lPYxPY3rXxEndZJAzN0SpfSzNr0Ck.woff2',
    },
  },
  {
    family: 'Bungee Spice',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungeespice/v11/nwpTtK2nIhxE0q-IwgSpZBqCyiI-aMPF7Q.woff2',
    },
  },
  {
    family: 'Aguafina Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/aguafinascript/v22/If2QXTv_ZzSxGIO30LemWEOmt1bHr84pgicOrg.woff2',
    },
  },
  {
    family: 'Expletus Sans',
    files: {
      '500': 'https://fonts.gstatic.com/s/expletussans/v29/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaSq2s1tFQTcXfMm.woff2',
      '600': 'https://fonts.gstatic.com/s/expletussans/v29/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaRG3c1tFQTcXfMm.woff2',
      '700': 'https://fonts.gstatic.com/s/expletussans/v29/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaR_3c1tFQTcXfMm.woff2',
      regular: 'https://fonts.gstatic.com/s/expletussans/v29/RLpqK5v5_bqufTYdnhFzDj2dX_IwS3my73zcDaSY2s1tFQTcXfMm.woff2',
    },
  },
  {
    family: 'Flamenco',
    files: {
      '300': 'https://fonts.gstatic.com/s/flamenco/v18/neIPzCehqYguo67ssZ0qNIk3epH9qGsf.woff2',
      regular: 'https://fonts.gstatic.com/s/flamenco/v18/neIIzCehqYguo67ssaWDHK06UY30.woff2',
    },
  },
  {
    family: 'Zen Antique Soft',
    files: {
      regular: 'https://fonts.gstatic.com/s/zenantiquesoft/v12/DtV4JwqzSL1q_KwnEWMc_3xfgW6ihwVmkui5HNg.woff2',
    },
  },
  {
    family: 'Kodchasan',
    files: {
      '200': 'https://fonts.gstatic.com/s/kodchasan/v17/1cX0aUPOAJv9sG4I-DJeR1CghOqo3eMeoA.woff2',
      '300': 'https://fonts.gstatic.com/s/kodchasan/v17/1cX0aUPOAJv9sG4I-DJeI1OghOqo3eMeoA.woff2',
      '500': 'https://fonts.gstatic.com/s/kodchasan/v17/1cX0aUPOAJv9sG4I-DJee1KghOqo3eMeoA.woff2',
      '600': 'https://fonts.gstatic.com/s/kodchasan/v17/1cX0aUPOAJv9sG4I-DJeV1WghOqo3eMeoA.woff2',
      '700': 'https://fonts.gstatic.com/s/kodchasan/v17/1cX0aUPOAJv9sG4I-DJeM1SghOqo3eMeoA.woff2',
      regular: 'https://fonts.gstatic.com/s/kodchasan/v17/1cXxaUPOAJv9sG4I-DJminuEicG01A.woff2',
    },
  },
  {
    family: 'Gantari',
    files: {
      '100': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOz31a5GD2qnm.woff2',
      '200': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2gOj31a5GD2qnm.woff2',
      '300': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g1-Oj31a5GD2qnm.woff2',
      '500': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0SOj31a5GD2qnm.woff2',
      '600': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3-PT31a5GD2qnm.woff2',
      '700': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3HPT31a5GD2qnm.woff2',
      '800': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2gPT31a5GD2qnm.woff2',
      '900': 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2JPT31a5GD2qnm.woff2',
      regular: 'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOj31a5GD2qnm.woff2',
    },
  },
  {
    family: 'Walter Turncoat',
    files: {
      regular: 'https://fonts.gstatic.com/s/walterturncoat/v23/snfys0Gs98ln43n0d-14ULoToe67ZR2dQ5ZPqQ.woff2',
    },
  },
  {
    family: 'Inria Sans',
    files: {
      '300': 'https://fonts.gstatic.com/s/inriasans/v14/ptRPTiqXYfZMCOiVj9kQ3ELaDQ5FqeY3fX4.woff2',
      '700': 'https://fonts.gstatic.com/s/inriasans/v14/ptRPTiqXYfZMCOiVj9kQ3FLdDQ5FqeY3fX4.woff2',
      regular: 'https://fonts.gstatic.com/s/inriasans/v14/ptRMTiqXYfZMCOiVj9kQ5OvyKQNute8.woff2',
    },
  },
  {
    family: 'Elsie',
    files: {
      '900': 'https://fonts.gstatic.com/s/elsie/v24/BCaqqZABrez54x6q2-1NU6QeXSBk.woff2',
      regular: 'https://fonts.gstatic.com/s/elsie/v24/BCanqZABrez54yYr9slAeLgX.woff2',
    },
  },
  {
    family: 'Sail',
    files: {
      regular: 'https://fonts.gstatic.com/s/sail/v16/DPEjYwiBxwYJFBHDADYAbvw.woff2',
    },
  },
  {
    family: 'Happy Monkey',
    files: {
      regular: 'https://fonts.gstatic.com/s/happymonkey/v14/K2F2fZZcl-9SXwl5F_C4R_OAAgD2bWqVjw.woff2',
    },
  },
  {
    family: 'Young Serif',
    files: {
      regular: 'https://fonts.gstatic.com/s/youngserif/v2/3qTpojO2nS2VtkB3KtkQZ2t_1EcYaQ7F.woff2',
    },
  },
  {
    family: 'Montez',
    files: {
      regular: 'https://fonts.gstatic.com/s/montez/v22/845ZNMk5GoGIX8lm0bDeSd-R_g.woff2',
    },
  },
  {
    family: 'Vina Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/vinasans/v6/m8JQjfZKf6-d2273MP7zdZ5BZmqa3A.woff2',
    },
  },
  {
    family: 'Mako',
    files: {
      regular: 'https://fonts.gstatic.com/s/mako/v19/H4coBX6Mmc_Z0SH09g478Lo.woff2',
    },
  },
  {
    family: 'Numans',
    files: {
      regular: 'https://fonts.gstatic.com/s/numans/v15/SlGRmQmGupYAfH8IZBggiHVqaQ.woff2',
    },
  },
  {
    family: 'Clicker Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/clickerscript/v13/raxkHiKPvt8CMH6ZWP8PdlEq72rd2zqUKafv.woff2',
    },
  },
  {
    family: 'Averia Sans Libre',
    files: {
      '300': 'https://fonts.gstatic.com/s/averiasanslibre/v19/ga6SaxZG_G5OvCf_rt7FH3B6BHLMEd3lMKcVJZP1LmD9.woff2',
      '700': 'https://fonts.gstatic.com/s/averiasanslibre/v19/ga6SaxZG_G5OvCf_rt7FH3B6BHLMEd31N6cVJZP1LmD9.woff2',
      regular: 'https://fonts.gstatic.com/s/averiasanslibre/v19/ga6XaxZG_G5OvCf_rt7FH3B6BHLMEeVMGIMYDo_8.woff2',
    },
  },
  {
    family: 'Suranna',
    files: {
      regular: 'https://fonts.gstatic.com/s/suranna/v13/gokuH6ztGkFjWe58tBFZT2KmgP0.woff2',
    },
  },
  {
    family: 'Scheherazade New',
    files: {
      '500': 'https://fonts.gstatic.com/s/scheherazadenew/v15/4UaerFhTvxVnHDvUkUiHg8jprP4DM_dFHlMC-IKnoSE.woff2',
      '600': 'https://fonts.gstatic.com/s/scheherazadenew/v15/4UaerFhTvxVnHDvUkUiHg8jprP4DM9tCHlMC-IKnoSE.woff2',
      '700': 'https://fonts.gstatic.com/s/scheherazadenew/v15/4UaerFhTvxVnHDvUkUiHg8jprP4DM79DHlMC-IKnoSE.woff2',
      regular: 'https://fonts.gstatic.com/s/scheherazadenew/v15/4UaZrFhTvxVnHDvUkUiHg8jprP4DCwZsOl4p5Is.woff2',
    },
  },
  {
    family: 'Mukta Mahee',
    files: {
      '200': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9MFcBoCJndqZCsW.woff2',
      '300': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9NhcxoCJndqZCsW.woff2',
      '500': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9M5choCJndqZCsW.woff2',
      '600': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9MVdRoCJndqZCsW.woff2',
      '700': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9NxdBoCJndqZCsW.woff2',
      '800': 'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9NtdxoCJndqZCsW.woff2',
      regular: 'https://fonts.gstatic.com/s/muktamahee/v16/XRXQ3IOIi0hcP8iVU67hA-vIWz4PDWtj.woff2',
    },
  },
  {
    family: 'Prosto One',
    files: {
      regular: 'https://fonts.gstatic.com/s/prostoone/v19/OpNJno4VhNfK-RgpwWWxpi9fWhXD00c.woff2',
    },
  },
  {
    family: 'Carme',
    files: {
      regular: 'https://fonts.gstatic.com/s/carme/v16/ptRHTiWdbvZIDOjDxLNrxfbZ.woff2',
    },
  },
  {
    family: 'Hi Melody',
    files: {
      regular: 'https://fonts.gstatic.com/s/himelody/v15/46ktlbP8Vnz0pJcqCTbEem9E31BBGA.woff2',
    },
  },
  {
    family: 'Libre Caslon Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/librecaslondisplay/v16/TuGOUUFxWphYQ6YI6q9Xp61FQzxDRKmzr2lUdRhtCC4d.woff2',
    },
  },
  {
    family: 'Slabo 13px',
    files: {
      regular: 'https://fonts.gstatic.com/s/slabo13px/v15/11hEGp_azEvXZUdSBzzRcKKr2wkYnvI.woff2',
    },
  },
  {
    family: 'Vibur',
    files: {
      regular: 'https://fonts.gstatic.com/s/vibur/v23/DPEiYwmEzw0QRjTsLjoJd-Xa.woff2',
    },
  },
  {
    family: 'Gotu',
    files: {
      regular: 'https://fonts.gstatic.com/s/gotu/v16/o-0FIpksx3QOlHgLioh6-hU.woff2',
    },
  },
  {
    family: 'Codystar',
    files: {
      '300': 'https://fonts.gstatic.com/s/codystar/v17/FwZf7-Q1xVk-40qxOuYsyuyuj0e29bfC.woff2',
      regular: 'https://fonts.gstatic.com/s/codystar/v17/FwZY7-Q1xVk-40qxOt6F4sijpFu_.woff2',
    },
  },
  {
    family: 'Noto Sans Georgian',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzVj7f5WK0OQV.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptnzFj7f5WK0OQV.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpu5zFj7f5WK0OQV.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvVzFj7f5WK0OQV.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdps5y1j7f5WK0OQV.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpsAy1j7f5WK0OQV.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptny1j7f5WK0OQV.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptOy1j7f5WK0OQV.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansgeorgian/v44/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzFj7f5WK0OQV.woff2',
    },
  },
  {
    family: 'Solway',
    files: {
      '300': 'https://fonts.gstatic.com/s/solway/v18/AMOTz46Cs2uTAOCuLlgZn80QW3mqyg.woff2',
      '500': 'https://fonts.gstatic.com/s/solway/v18/AMOTz46Cs2uTAOCudlkZn80QW3mqyg.woff2',
      '700': 'https://fonts.gstatic.com/s/solway/v18/AMOTz46Cs2uTAOCuPl8Zn80QW3mqyg.woff2',
      '800': 'https://fonts.gstatic.com/s/solway/v18/AMOTz46Cs2uTAOCuIlwZn80QW3mqyg.woff2',
      regular: 'https://fonts.gstatic.com/s/solway/v18/AMOQz46Cs2uTAOCWh3A9kuYMUg.woff2',
    },
  },
  {
    family: 'Barriecito',
    files: {
      regular: 'https://fonts.gstatic.com/s/barriecito/v17/WWXXlj-CbBOSLY2QTuY_KdAiYwTO0MU.woff2',
    },
  },
  {
    family: 'Tenali Ramakrishna',
    files: {
      regular: 'https://fonts.gstatic.com/s/tenaliramakrishna/v12/raxgHj6Yt9gAN3LLKs0BZVMo8jmwn1-8LZXqUFFvtA.woff2',
    },
  },
  {
    family: 'Noto Sans Myanmar',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZs_y1ZtY3ymOryg38hOCSdOnFq0HGS1uQapkAC3AY.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HE-98E1iEwLxR-r.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFa9ME1iEwLxR-r.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HEC9cE1iEwLxR-r.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HEu8sE1iEwLxR-r.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFK88E1iEwLxR-r.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFW8ME1iEwLxR-r.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZv_y1ZtY3ymOryg38hOCSdOnFq0HFy8cE1iEwLxR-r.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansmyanmar/v20/AlZq_y1ZtY3ymOryg38hOCSdOnFq0Enz3OU4o1AC.woff2',
    },
  },
  {
    family: 'Supermercado One',
    files: {
      regular: 'https://fonts.gstatic.com/s/supermercadoone/v26/OpNXnpQWg8jc_xps_Gi14kVVEXOn60P3MClBRTs.woff2',
    },
  },
  {
    family: 'Just Me Again Down Here',
    files: {
      regular: 'https://fonts.gstatic.com/s/justmeagaindownhere/v24/MwQmbgXtz-Wc6RUEGNMc0QpRrfUh2hSdBBMoAuwCvqDwc_fg.woff2',
    },
  },
  {
    family: 'Mogra',
    files: {
      regular: 'https://fonts.gstatic.com/s/mogra/v19/f0X40eSs8c95TBo9DvLmxtnG.woff2',
    },
  },
  {
    family: 'Syne Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/synemono/v15/K2FzfZNHj_FHBmRbFvHzJ6CkDyvqZA.woff2',
    },
  },
  {
    family: 'Wix Madefor Display',
    files: {
      '500': 'https://fonts.gstatic.com/s/wixmadefordisplay/v10/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYFTYlthv_3HQKgh.woff2',
      '600': 'https://fonts.gstatic.com/s/wixmadefordisplay/v10/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYG_ZVthv_3HQKgh.woff2',
      '700': 'https://fonts.gstatic.com/s/wixmadefordisplay/v10/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYGGZVthv_3HQKgh.woff2',
      '800': 'https://fonts.gstatic.com/s/wixmadefordisplay/v10/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYHhZVthv_3HQKgh.woff2',
      regular: 'https://fonts.gstatic.com/s/wixmadefordisplay/v10/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYFhYlthv_3HQKgh.woff2',
    },
  },
  {
    family: 'ZCOOL QingKe HuangYou',
    files: {
      regular: 'https://fonts.gstatic.com/s/zcoolqingkehuangyou/v15/2Eb5L_R5IXJEWhD3AOhSvFC554MOOahI4mRIjv28c8bHWA.woff2',
    },
  },
  {
    family: 'Original Surfer',
    files: {
      regular: 'https://fonts.gstatic.com/s/originalsurfer/v22/RWmQoKGZ9vIirYntXJ3_MbekzNMiCUtvAlaMKw.woff2',
    },
  },
  {
    family: 'Crafty Girls',
    files: {
      regular: 'https://fonts.gstatic.com/s/craftygirls/v16/va9B4kXI39VaDdlPJo8N_NvuRB37fF3Wlg.woff2',
    },
  },
  {
    family: 'League Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/leaguescript/v28/CSR54zpSlumSWj9CGVsoBZdeaNZUuOwkC2s.woff2',
    },
  },
  {
    family: 'Noto Sans NKo Unjoined',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansnkounjoined/v2/MCo_zBjx1d3VUhJFK9MYlNCXJ6VvqwGPz3szPOBB5nuzMdWs0rv32gEKxf5wbh3T.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansnkounjoined/v2/MCo_zBjx1d3VUhJFK9MYlNCXJ6VvqwGPz3szPOBB5nuzMdWs0rsb3QEKxf5wbh3T.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansnkounjoined/v2/MCo_zBjx1d3VUhJFK9MYlNCXJ6VvqwGPz3szPOBB5nuzMdWs0rsi3QEKxf5wbh3T.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansnkounjoined/v2/MCo_zBjx1d3VUhJFK9MYlNCXJ6VvqwGPz3szPOBB5nuzMdWs0rvF2gEKxf5wbh3T.woff2',
    },
  },
  {
    family: 'Vast Shadow',
    files: {
      regular: 'https://fonts.gstatic.com/s/vastshadow/v19/pe0qMImKOZ1V62ZwbVY9dfe_Kdpickwp.woff2',
    },
  },
  {
    family: 'Reem Kufi Fun',
    files: {
      '500': 'https://fonts.gstatic.com/s/reemkufifun/v7/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChoYR3nClrvqZzZXq.woff2',
      '600': 'https://fonts.gstatic.com/s/reemkufifun/v7/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChob92XClrvqZzZXq.woff2',
      '700': 'https://fonts.gstatic.com/s/reemkufifun/v7/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChobE2XClrvqZzZXq.woff2',
      regular: 'https://fonts.gstatic.com/s/reemkufifun/v7/uK_m4rOFYukkmyUEbF43fIryZEk5qRZ8nrKChoYj3nClrvqZzZXq.woff2',
    },
  },
  {
    family: 'Saira Stencil One',
    files: {
      regular: 'https://fonts.gstatic.com/s/sairastencilone/v16/SLXSc03I6HkvZGJ1GvvipLoYSTEL9AsJawif2YQ2.woff2',
    },
  },
  {
    family: 'Esteban',
    files: {
      regular: 'https://fonts.gstatic.com/s/esteban/v15/r05bGLZE-bdGdN-GdO6D5jokU8E.woff2',
    },
  },
  {
    family: 'Dokdo',
    files: {
      regular: 'https://fonts.gstatic.com/s/dokdo/v17/esDf315XNuCBLxLt4NaMlKcH.woff2',
    },
  },
  {
    family: 'Freehand',
    files: {
      regular: 'https://fonts.gstatic.com/s/freehand/v31/cIf-Ma5eqk01VjKTgAmETmUOmZJk.woff2',
    },
  },
  {
    family: 'BIZ UDPMincho',
    files: {
      '700': 'https://fonts.gstatic.com/s/bizudpmincho/v9/ypvCbXOBrmYppy7oWWTg1_58pqR3kUvfnZAy57k.woff2',
      regular: 'https://fonts.gstatic.com/s/bizudpmincho/v9/ypvfbXOBrmYppy7oWWTg1_58nh1YtUb0gZk.woff2',
    },
  },
  {
    family: 'Baloo Bhai 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNhohMXKCo-jsZzo.woff2',
      '600': 'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNvYmMXKCo-jsZzo.woff2',
      '700': 'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNs8mMXKCo-jsZzo.woff2',
      '800': 'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNqgmMXKCo-jsZzo.woff2',
      regular: 'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNighMXKCo-jsZzo.woff2',
    },
  },
  {
    family: 'Ruslan Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/ruslandisplay/v26/Gw6jwczl81XcIZuckK_e3UpfdzxuldyFvm1n.woff2',
    },
  },
  {
    family: 'Dongle',
    files: {
      '300': 'https://fonts.gstatic.com/s/dongle/v12/sJoG3Ltdjt6VPkqeEcxrZzWNzXvVPA.woff2',
      '700': 'https://fonts.gstatic.com/s/dongle/v12/sJoG3Ltdjt6VPkqeActrZzWNzXvVPA.woff2',
      regular: 'https://fonts.gstatic.com/s/dongle/v12/sJoF3Ltdjt6VPkqmuORPah6RxA.woff2',
    },
  },
  {
    family: 'Noto Sans Symbols',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ4gb_VFRkzrbQ.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g_Q8gb_VFRkzrbQ.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gIw8gb_VFRkzrbQ.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gTw8gb_VFRkzrbQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gowggb_VFRkzrbQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gmgggb_VFRkzrbQ.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g_Qggb_VFRkzrbQ.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g1Aggb_VFRkzrbQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanssymbols/v42/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ8gb_VFRkzrbQ.woff2',
    },
  },
  {
    family: 'Sarpanch',
    files: {
      '500': 'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziV0ba7a1HEuRHkM.woff2',
      '600': 'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziVYaq7a1HEuRHkM.woff2',
      '700': 'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziU8a67a1HEuRHkM.woff2',
      '800': 'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziUgaK7a1HEuRHkM.woff2',
      '900': 'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziUEaa7a1HEuRHkM.woff2',
      regular: 'https://fonts.gstatic.com/s/sarpanch/v13/hESy6Xt4NCpRuk6Pzh2FRIrX_20n.woff2',
    },
  },
  {
    family: 'Artifika',
    files: {
      regular: 'https://fonts.gstatic.com/s/artifika/v21/VEMyRoxzronptCuxu6Wo5jDtreOL.woff2',
    },
  },
  {
    family: 'Notable',
    files: {
      regular: 'https://fonts.gstatic.com/s/notable/v18/gNMEW3N_SIqx-WX9-HYoFIez5MI.woff2',
    },
  },
  {
    family: 'Gugi',
    files: {
      regular: 'https://fonts.gstatic.com/s/gugi/v15/A2BVn5dXywshVAuA9DEfgqM.woff2',
    },
  },
  {
    family: 'Loved by the King',
    files: {
      regular: 'https://fonts.gstatic.com/s/lovedbytheking/v21/Gw6gwdP76VDVJNXerebZxUMeRXUF2PiIlXFu2R64.woff2',
    },
  },
  {
    family: 'Battambang',
    files: {
      '100': 'https://fonts.gstatic.com/s/battambang/v24/uk-kEGe7raEw-HjkzZabNhGp4g50_o9T7Q.woff2',
      '300': 'https://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNtmLxyFa8oZK9I0.woff2',
      '700': 'https://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNsmMxyFa8oZK9I0.woff2',
      '900': 'https://fonts.gstatic.com/s/battambang/v24/uk-lEGe7raEw-HjkzZabNvGOxyFa8oZK9I0.woff2',
      regular: 'https://fonts.gstatic.com/s/battambang/v24/uk-mEGe7raEw-HjkzZabDnCj4yxx7o8.woff2',
    },
  },
  {
    family: 'Potta One',
    files: {
      regular: 'https://fonts.gstatic.com/s/pottaone/v16/FeVSS05Bp6cy7xI-YfxQ2J5nm29Gww.woff2',
    },
  },
  {
    family: 'Nerko One',
    files: {
      regular: 'https://fonts.gstatic.com/s/nerkoone/v16/m8JQjfZSc7OXlB3ZMOjzdZ5BZmqa3A.woff2',
    },
  },
  {
    family: 'Montaga',
    files: {
      regular: 'https://fonts.gstatic.com/s/montaga/v13/H4cnBX2Ml8rCkEO_0gMQ7LO5mqc.woff2',
    },
  },
  {
    family: 'Eater',
    files: {
      regular: 'https://fonts.gstatic.com/s/eater/v25/mtG04_FCK7bOvpuzu3FwsXsR.woff2',
    },
  },
  {
    family: 'Metamorphous',
    files: {
      regular: 'https://fonts.gstatic.com/s/metamorphous/v20/Wnz8HA03aAXcC39ZEX5y1330OSCthTsmaQ.woff2',
    },
  },
  {
    family: 'Buenard',
    files: {
      '700': 'https://fonts.gstatic.com/s/buenard/v17/OD5GuM6Cyma8FnnsB4vSjGWWALepwss.woff2',
      regular: 'https://fonts.gstatic.com/s/buenard/v17/OD5DuM6Cyma8FnnsPzL9qGi9HL4.woff2',
    },
  },
  {
    family: 'Xanh Mono',
    files: {
      regular: 'https://fonts.gstatic.com/s/xanhmono/v18/R70YjykVmvKCep-vWhSYnQCQXzLhTg.woff2',
    },
  },
  {
    family: 'BhuTuka Expanded One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bhutukaexpandedone/v7/SLXXc0jZ4WUJcClHTtv0t7IaDRsBsWRiJCyS8pg_RVH1.woff2',
    },
  },
  {
    family: 'Libre Barcode 128',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcode128/v28/cIfnMbdUsUoiW3O_hVviCwVjuLtXeJ_F_gMk0izH.woff2',
    },
  },
  {
    family: 'Goldman',
    files: {
      '700': 'https://fonts.gstatic.com/s/goldman/v19/pe0rMIWbN4JFplR2FI5XItKQB9Zra1U.woff2',
      regular: 'https://fonts.gstatic.com/s/goldman/v19/pe0uMIWbN4JFplR2LDd4Bt-7G98.woff2',
    },
  },
  {
    family: 'Mirza',
    files: {
      '500': 'https://fonts.gstatic.com/s/mirza/v17/co3FmWlikiN5EtIpAeO9mafBomDi.woff2',
      '600': 'https://fonts.gstatic.com/s/mirza/v17/co3FmWlikiN5EtIFBuO9mafBomDi.woff2',
      '700': 'https://fonts.gstatic.com/s/mirza/v17/co3FmWlikiN5EtJhB-O9mafBomDi.woff2',
      regular: 'https://fonts.gstatic.com/s/mirza/v17/co3ImWlikiN5EurYKMewsrvI.woff2',
    },
  },
  {
    family: 'Gaegu',
    files: {
      '300': 'https://fonts.gstatic.com/s/gaegu/v17/TuGSUVB6Up9NU57nifw-4sdtBk0x.woff2',
      '700': 'https://fonts.gstatic.com/s/gaegu/v17/TuGSUVB6Up9NU573jvw-4sdtBk0x.woff2',
      regular: 'https://fonts.gstatic.com/s/gaegu/v17/TuGfUVB6Up9NU6ZOodgzydtk.woff2',
    },
  },
  {
    family: 'Delius Unicase',
    files: {
      '700': 'https://fonts.gstatic.com/s/deliusunicase/v28/845CNMEwEIOVT8BmgfSzIr_6mlp7WMr6BmmlS5aw.woff2',
      regular: 'https://fonts.gstatic.com/s/deliusunicase/v28/845BNMEwEIOVT8BmgfSzIr_6mmLCd-73LXWs.woff2',
    },
  },
  {
    family: 'Puritan',
    files: {
      '700': 'https://fonts.gstatic.com/s/puritan/v24/845dNMgkAJ2VTtIozCbfYduj-0rGRes.woff2',
      regular: 'https://fonts.gstatic.com/s/puritan/v24/845YNMgkAJ2VTtIo9J_wRdaI50M.woff2',
    },
  },
  {
    family: 'The Girl Next Door',
    files: {
      regular: 'https://fonts.gstatic.com/s/thegirlnextdoor/v22/pe0zMJCIMIsBjFxqYBIcZ6_OI5oFHCYIUrt7w6bE2A.woff2',
    },
  },
  {
    family: 'Shojumaru',
    files: {
      regular: 'https://fonts.gstatic.com/s/shojumaru/v15/rax_HiWfutkLLnaKCtlMARJek0vA8A.woff2',
    },
  },
  {
    family: 'Wendy One',
    files: {
      regular: 'https://fonts.gstatic.com/s/wendyone/v18/2sDcZGJOipXfgfXV5wgDam-4C7wFZQ.woff2',
    },
  },
  {
    family: 'Monomaniac One',
    files: {
      regular: 'https://fonts.gstatic.com/s/monomaniacone/v11/4iC06K17YctZjx50EU-QlwPmcqRiqYkB5kwI.woff2',
    },
  },
  {
    family: 'Spicy Rice',
    files: {
      regular: 'https://fonts.gstatic.com/s/spicyrice/v25/uK_24rSEd-Uqwk4jY1RyGvq2WkowRcc.woff2',
    },
  },
  {
    family: 'Slackey',
    files: {
      regular: 'https://fonts.gstatic.com/s/slackey/v28/N0bV2SdQO-5yM0-dKlFaJdbWgdY.woff2',
    },
  },
  {
    family: 'Manuale',
    files: {
      '300': 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeG6e7wG1TB_JHHY.woff2',
      '500': 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHWe7wG1TB_JHHY.woff2',
      '600': 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeE6fLwG1TB_JHHY.woff2',
      '700': 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeEDfLwG1TB_JHHY.woff2',
      '800': 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeFkfLwG1TB_JHHY.woff2',
      regular: 'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHke7wG1TB_JHHY.woff2',
    },
  },
  {
    family: 'Charmonman',
    files: {
      '700': 'https://fonts.gstatic.com/s/charmonman/v18/MjQAmiR3vP_nuxDv47jiYC2HmLpK9OhmGnY.woff2',
      regular: 'https://fonts.gstatic.com/s/charmonman/v18/MjQDmiR3vP_nuxDv47jiWJSovLdh6OE.woff2',
    },
  },
  {
    family: 'Noto Sans Armenian',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxbq0nYy6zF3Eg.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopxb60nYy6zF3Eg.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLoqvb60nYy6zF3Eg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorDb60nYy6zF3Eg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLoovaK0nYy6zF3Eg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLooWaK0nYy6zF3Eg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopxaK0nYy6zF3Eg.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopYaK0nYy6zF3Eg.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansarmenian/v43/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxb60nYy6zF3Eg.woff2',
    },
  },
  {
    family: 'Mochiy Pop P One',
    files: {
      regular: 'https://fonts.gstatic.com/s/mochiypoppone/v9/Ktk2AKuPeY_td1-h9LayHYWCjAqyN4a3WYZB_sU.woff2',
    },
  },
  {
    family: 'Nokora',
    files: {
      '100': 'https://fonts.gstatic.com/s/nokora/v31/hYkKPuwgTubzaWxoXzAOgPNw8QZN.woff2',
      '300': 'https://fonts.gstatic.com/s/nokora/v31/hYkLPuwgTubzaWxolxIrr918-B9Uuw.woff2',
      '700': 'https://fonts.gstatic.com/s/nokora/v31/hYkLPuwgTubzaWxohxUrr918-B9Uuw.woff2',
      '900': 'https://fonts.gstatic.com/s/nokora/v31/hYkLPuwgTubzaWxovxcrr918-B9Uuw.woff2',
      regular: 'https://fonts.gstatic.com/s/nokora/v31/hYkIPuwgTubzaWxQPjoPovZg8Q.woff2',
    },
  },
  {
    family: 'Atma',
    files: {
      '300': 'https://fonts.gstatic.com/s/atma/v16/uK_z4rqWc-Eoo8JzKjI9PvedRkM.woff2',
      '500': 'https://fonts.gstatic.com/s/atma/v16/uK_z4rqWc-Eoo5pyKjI9PvedRkM.woff2',
      '600': 'https://fonts.gstatic.com/s/atma/v16/uK_z4rqWc-Eoo7Z1KjI9PvedRkM.woff2',
      '700': 'https://fonts.gstatic.com/s/atma/v16/uK_z4rqWc-Eoo9J0KjI9PvedRkM.woff2',
      regular: 'https://fonts.gstatic.com/s/atma/v16/uK_84rqWc-Eom2tbDj8WIv4.woff2',
    },
  },
  {
    family: 'Shalimar',
    files: {
      regular: 'https://fonts.gstatic.com/s/shalimar/v7/uU9MCBoE6I6iNWFUvTP08PCOg0uX.woff2',
    },
  },
  {
    family: 'Ceviche One',
    files: {
      regular: 'https://fonts.gstatic.com/s/cevicheone/v16/gyB4hws1IcA6JzR-GB_JX6zYZ4vZVbgZ.woff2',
    },
  },
  {
    family: 'Overlock SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/overlocksc/v23/1cX3aUHKGZrstGAY8nwVzHGFq8Sk1PoH.woff2',
    },
  },
  {
    family: 'Kranky',
    files: {
      regular: 'https://fonts.gstatic.com/s/kranky/v28/hESw6XVgJzlPsFnMoxeEZo_H_w.woff2',
    },
  },
  {
    family: 'Kaisei Tokumin',
    files: {
      '500': 'https://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnqr_3kkpMIzeI6v.woff2',
      '700': 'https://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnrj-XkkpMIzeI6v.woff2',
      '800': 'https://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8vN5wdZg7xCwuMsylww2ZiQnr_-nkkpMIzeI6v.woff2',
      regular: 'https://fonts.gstatic.com/s/kaiseitokumin/v8/Gg8sN5wdZg7xCwuMsylww2ZiQkJa1l0pj946.woff2',
    },
  },
  {
    family: 'Libre Barcode 39 Extended Text',
    files: {
      regular:
        'https://fonts.gstatic.com/s/librebarcode39extendedtext/v27/eLG1P_rwIgOiDA7yrs9LoKaYRVLQ1YldrrOnnL7xPO4jNP68ebIiPopNNA.woff2',
    },
  },
  {
    family: 'Corinthia',
    files: {
      '700': 'https://fonts.gstatic.com/s/corinthia/v11/wEO6EBrAnchaJyPMHE097d8v0WAbgbLXQA.woff2',
      regular: 'https://fonts.gstatic.com/s/corinthia/v11/wEO_EBrAnchaJyPMHE0FVPAL3EsHiA.woff2',
    },
  },
  {
    family: 'Birthstone',
    files: {
      regular: 'https://fonts.gstatic.com/s/birthstone/v14/8AtsGs2xO4yLRhy87sv_HLz5jRfZHzM.woff2',
    },
  },
  {
    family: 'Chau Philomene One',
    files: {
      regular: 'https://fonts.gstatic.com/s/chauphilomeneone/v15/55xxezRsPtfie1vPY49qzdgSlJiHRQFsmYx7QMISdQ.woff2',
    },
  },
  {
    family: 'Bilbo Swash Caps',
    files: {
      regular: 'https://fonts.gstatic.com/s/bilboswashcaps/v22/zrf-0GXbz-H3Wb4XBsGrTgq2PVmdqAbopiRfKp8.woff2',
    },
  },
  {
    family: 'Ramaraja',
    files: {
      regular: 'https://fonts.gstatic.com/s/ramaraja/v15/SlGTmQearpYAYG1CABIhqnB6aSQU.woff2',
    },
  },
  {
    family: 'Harmattan',
    files: {
      '500': 'https://fonts.gstatic.com/s/harmattan/v19/gokpH6L2DkFvVvRp9Xprv2mHndZEq6TTFw.woff2',
      '600': 'https://fonts.gstatic.com/s/harmattan/v19/gokpH6L2DkFvVvRp9Xprk26HndZEq6TTFw.woff2',
      '700': 'https://fonts.gstatic.com/s/harmattan/v19/gokpH6L2DkFvVvRp9Xpr92-HndZEq6TTFw.woff2',
      regular: 'https://fonts.gstatic.com/s/harmattan/v19/goksH6L2DkFvVvRp9XpTTkCjkP1Yog.woff2',
    },
  },
  {
    family: 'Dynalight',
    files: {
      regular: 'https://fonts.gstatic.com/s/dynalight/v22/1Ptsg8LOU_aOmQvTsF4IT4trDfGGxA.woff2',
    },
  },
  {
    family: 'Bellota',
    files: {
      '300': 'https://fonts.gstatic.com/s/bellota/v16/MwQzbhXl3_qEpiwAID55kGYViblPtXs.woff2',
      '700': 'https://fonts.gstatic.com/s/bellota/v16/MwQzbhXl3_qEpiwAIC5-kGYViblPtXs.woff2',
      regular: 'https://fonts.gstatic.com/s/bellota/v16/MwQ2bhXl3_qEpiwAGJdRtGs-lbA.woff2',
    },
  },
  {
    family: 'Nova Round',
    files: {
      regular: 'https://fonts.gstatic.com/s/novaround/v21/flU9Rqquw5UhEnlwTJYTYYLeeetYEBc.woff2',
    },
  },
  {
    family: 'Sulphur Point',
    files: {
      '300': 'https://fonts.gstatic.com/s/sulphurpoint/v15/RLpkK5vv8KaycDcazWFPBj2afVU6n6wFUHPIFaU.woff2',
      '700': 'https://fonts.gstatic.com/s/sulphurpoint/v15/RLpkK5vv8KaycDcazWFPBj2afUU9n6wFUHPIFaU.woff2',
      regular: 'https://fonts.gstatic.com/s/sulphurpoint/v15/RLp5K5vv8KaycDcazWFPBj2aRfwSu6EuTHo.woff2',
    },
  },
  {
    family: 'Trykker',
    files: {
      regular: 'https://fonts.gstatic.com/s/trykker/v21/KtktALyWZJXudUPzhNzoOd2j22U.woff2',
    },
  },
  {
    family: 'Tiro Kannada',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirokannada/v6/CSR44ztKmvqaDxEDJFY7CIYKTfl6tOU9Eg.woff2',
    },
  },
  {
    family: 'Edu SA Beginner',
    files: {
      '500': 'https://fonts.gstatic.com/s/edusabeginner/v3/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9-09fohyBydUEDs.woff2',
      '600': 'https://fonts.gstatic.com/s/edusabeginner/v3/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9wE6fohyBydUEDs.woff2',
      '700': 'https://fonts.gstatic.com/s/edusabeginner/v3/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9zg6fohyBydUEDs.woff2',
      regular: 'https://fonts.gstatic.com/s/edusabeginner/v3/rnC_-xRb1x-1lHXnLaZZ2xOoLIGfU3L82irpr_3C9989fohyBydUEDs.woff2',
    },
  },
  {
    family: 'Wire One',
    files: {
      regular: 'https://fonts.gstatic.com/s/wireone/v28/qFdH35Wah5htUhV75WGnWdrCwwcJ.woff2',
    },
  },
  {
    family: 'Unkempt',
    files: {
      '700': 'https://fonts.gstatic.com/s/unkempt/v21/2EbiL-Z2DFZue0DScTow1zCzq_5uT84.woff2',
      regular: 'https://fonts.gstatic.com/s/unkempt/v21/2EbnL-Z2DFZue0DSSYMf8z2Yt_c.woff2',
    },
  },
  {
    family: 'Kaisei Opti',
    files: {
      '500': 'https://fonts.gstatic.com/s/kaiseiopti/v8/QldXNThJphYb8_g6c2nlIGGqxY1r7f34DYwn.woff2',
      '700': 'https://fonts.gstatic.com/s/kaiseiopti/v8/QldXNThJphYb8_g6c2nlIGHiw41r7f34DYwn.woff2',
      regular: 'https://fonts.gstatic.com/s/kaiseiopti/v8/QldKNThJphYb8_g6c2nlIFlb7KlmxuHx.woff2',
    },
  },
  {
    family: 'Rampart One',
    files: {
      regular: 'https://fonts.gstatic.com/s/rampartone/v9/K2F1fZFGl_JSR1tAWNG9R6qlLS76ZHOM.woff2',
    },
  },
  {
    family: 'Cherry Cream Soda',
    files: {
      regular: 'https://fonts.gstatic.com/s/cherrycreamsoda/v21/UMBIrOxBrW6w2FFyi9paG0fdVdRciTd_Cd47DJ7G.woff2',
    },
  },
  {
    family: 'Martian Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qus6TD75kdpF2.woff2',
      '200': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY3qu86TD75kdpF2.woff2',
      '300': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY00u86TD75kdpF2.woff2',
      '500': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1Yu86TD75kdpF2.woff2',
      '600': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY20vM6TD75kdpF2.woff2',
      '700': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY2NvM6TD75kdpF2.woff2',
      '800': 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY3qvM6TD75kdpF2.woff2',
      regular: 'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qu86TD75kdpF2.woff2',
    },
  },
  {
    family: 'Lily Script One',
    files: {
      regular: 'https://fonts.gstatic.com/s/lilyscriptone/v15/LhW9MV7ZMfIPdMxeBjBvFN8SXLS4h8SjQNsRMg.woff2',
    },
  },
  {
    family: 'Share Tech',
    files: {
      regular: 'https://fonts.gstatic.com/s/sharetech/v21/7cHtv4Uyi5K0OeZ7bohUwH8DmTcibrA.woff2',
    },
  },
  {
    family: 'Modak',
    files: {
      regular: 'https://fonts.gstatic.com/s/modak/v18/EJRYQgs1XtIEsnMC8BVZ76KU.woff2',
    },
  },
  {
    family: 'Scope One',
    files: {
      regular: 'https://fonts.gstatic.com/s/scopeone/v14/WBLnrEXKYFlGHrOKmGD1Xk_MJMGxiQ.woff2',
    },
  },
  {
    family: 'Tienne',
    files: {
      '700': 'https://fonts.gstatic.com/s/tienne/v20/AYCJpX7pe9YCRP0zLGzjRXhuzvef5Q.woff2',
      '900': 'https://fonts.gstatic.com/s/tienne/v20/AYCJpX7pe9YCRP0zFG7jRXhuzvef5Q.woff2',
      regular: 'https://fonts.gstatic.com/s/tienne/v20/AYCKpX7pe9YCRP0LlUPHSFNyxw.woff2',
    },
  },
  {
    family: 'Abyssinica SIL',
    files: {
      regular: 'https://fonts.gstatic.com/s/abyssinicasil/v5/oY1H8ezOqK7iI3rK_45WKoc8J6UcBFOVAXuI.woff2',
    },
  },
  {
    family: 'Balthazar',
    files: {
      regular: 'https://fonts.gstatic.com/s/balthazar/v17/d6lKkaajS8Gm4CVQjFEvzBTo39l8hw.woff2',
    },
  },
  {
    family: 'Trade Winds',
    files: {
      regular: 'https://fonts.gstatic.com/s/tradewinds/v17/AYCPpXPpYNIIT7h8-QenM3Jv7PKP5Z_G.woff2',
    },
  },
  {
    family: 'Tauri',
    files: {
      regular: 'https://fonts.gstatic.com/s/tauri/v18/TwMA-IISS0AM3IpQWHU_TBqO.woff2',
    },
  },
  {
    family: 'Faster One',
    files: {
      regular: 'https://fonts.gstatic.com/s/fasterone/v19/H4ciBXCHmdfClFb-vWhfyL6Shq63czE.woff2',
    },
  },
  {
    family: 'Red Hat Mono',
    files: {
      '300': 'https://fonts.gstatic.com/s/redhatmono/v11/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQQPI-7TNuW4QuKI.woff2',
      '500': 'https://fonts.gstatic.com/s/redhatmono/v11/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQW_I-7TNuW4QuKI.woff2',
      '600': 'https://fonts.gstatic.com/s/redhatmono/v11/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQYPP-7TNuW4QuKI.woff2',
      '700': 'https://fonts.gstatic.com/s/redhatmono/v11/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQbrP-7TNuW4QuKI.woff2',
      regular: 'https://fonts.gstatic.com/s/redhatmono/v11/jVyY7nDnA2uf2zVvFAhhzEs-VMSjJpBTfgjwQV3I-7TNuW4QuKI.woff2',
    },
  },
  {
    family: 'Freckle Face',
    files: {
      regular: 'https://fonts.gstatic.com/s/freckleface/v15/AMOWz4SXrmKHCvXTohxY-YI0VlK2w9lb4g.woff2',
    },
  },
  {
    family: 'IM Fell Double Pica',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfelldoublepica/v14/3XF2EqMq_94s9PeKF7Fg4gOKINyMtZ8rT0G1UL5Ayp0.woff2',
    },
  },
  {
    family: 'Fontdiner Swanky',
    files: {
      regular: 'https://fonts.gstatic.com/s/fontdinerswanky/v23/ijwOs4XgRNsiaI5-hcVb4hQgMvCD4uQfKiGvxts.woff2',
    },
  },
  {
    family: 'Sofia Sans Semi Condensed',
    files: {
      '100':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEO9WGahllIhN.woff2',
      '200':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqbEe9WGahllIhN.woff2',
      '300':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvopFEe9WGahllIhN.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoopEe9WGahllIhN.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvorFFu9WGahllIhN.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvor8Fu9WGahllIhN.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqbFu9WGahllIhN.woff2',
      '900':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqyFu9WGahllIhN.woff2',
      regular:
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEe9WGahllIhN.woff2',
    },
  },
  {
    family: 'Noto Serif HK',
    files: {
      '200': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMf-K2RjV9Su1M6i.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMcgK2RjV9Su1M6i.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMdMK2RjV9Su1M6i.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMegLGRjV9Su1M6i.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMeZLGRjV9Su1M6i.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMf-LGRjV9Su1M6i.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMfXLGRjV9Su1M6i.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMd-K2RjV9Su1M6i.woff2',
    },
  },
  {
    family: 'Timmana',
    files: {
      regular: 'https://fonts.gstatic.com/s/timmana/v12/6xKvdShfL9yK-rvpCm7bKHwJUOM.woff2',
    },
  },
  {
    family: 'Life Savers',
    files: {
      '700': 'https://fonts.gstatic.com/s/lifesavers/v20/ZXu_e1UftKKabUQMgxAal8HXOS5Wk8fIpPRW.woff2',
      '800': 'https://fonts.gstatic.com/s/lifesavers/v20/ZXu_e1UftKKabUQMgxAal8HLOi5Wk8fIpPRW.woff2',
      regular: 'https://fonts.gstatic.com/s/lifesavers/v20/ZXuie1UftKKabUQMgxAal_luFgpbuNvB.woff2',
    },
  },
  {
    family: 'Noto Serif Hebrew',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwTAGo_vlQxz24.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVIwSAGo_vlQxz24.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVFISAGo_vlQxz24.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVD4SAGo_vlQxz24.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVNIVAGo_vlQxz24.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVOsVAGo_vlQxz24.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVIwVAGo_vlQxz24.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVKUVAGo_vlQxz24.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwSAGo_vlQxz24.woff2',
    },
  },
  {
    family: 'Hina Mincho',
    files: {
      regular: 'https://fonts.gstatic.com/s/hinamincho/v12/2sDaZGBRhpXa2Jjz5w5LAGW5KbkVZTHR.woff2',
    },
  },
  {
    family: 'Doppio One',
    files: {
      regular: 'https://fonts.gstatic.com/s/doppioone/v13/Gg8wN5gSaBfyBw2MqCh-lg4hKGpe5Fg.woff2',
    },
  },
  {
    family: 'Stick',
    files: {
      regular: 'https://fonts.gstatic.com/s/stick/v17/Qw3TZQpMCyTtJSvavPVDMPoF.woff2',
    },
  },
  {
    family: 'Baumans',
    files: {
      regular: 'https://fonts.gstatic.com/s/baumans/v17/-W_-XJj9QyTd3QfpR_8yaksqY5Q.woff2',
    },
  },
  {
    family: 'MedievalSharp',
    files: {
      regular: 'https://fonts.gstatic.com/s/medievalsharp/v26/EvOJzAlL3oU5AQl2mP5KdgptAqp6MwvXLDk.woff2',
    },
  },
  {
    family: 'Ledger',
    files: {
      regular: 'https://fonts.gstatic.com/s/ledger/v16/j8_q6-HK1L3if_sxnsDwHTBhHw.woff2',
    },
  },
  {
    family: 'Protest Revolution',
    files: {
      regular: 'https://fonts.gstatic.com/s/protestrevolution/v2/11hcGofZ0kXBbxQXFB7MJsjtqnVw6Z2s9fIzTG1nQw.woff2',
    },
  },
  {
    family: 'Road Rage',
    files: {
      regular: 'https://fonts.gstatic.com/s/roadrage/v7/6NUU8F2fKAOBKjjr4ekvscYAwdRZfw.woff2',
    },
  },
  {
    family: 'Medula One',
    files: {
      regular: 'https://fonts.gstatic.com/s/medulaone/v19/YA9Wr0qb5kjJM6l2V0yukiQqs7GtlvY.woff2',
    },
  },
  {
    family: 'Peralta',
    files: {
      regular: 'https://fonts.gstatic.com/s/peralta/v19/hYkJPu0-RP_9d3kRGxUhrv956B8.woff2',
    },
  },
  {
    family: 'Shanti',
    files: {
      regular: 'https://fonts.gstatic.com/s/shanti/v25/t5thIREMM4uSDgzgVkezpKfwzA.woff2',
    },
  },
  {
    family: 'Shantell Sans',
    files: {
      '300':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYQiS2izyPwxjyRN.woff2',
      '500':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYROS2izyPwxjyRN.woff2',
      '600':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYSiTGizyPwxjyRN.woff2',
      '700':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYSbTGizyPwxjyRN.woff2',
      '800':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYT8TGizyPwxjyRN.woff2',
      regular:
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYR8S2izyPwxjyRN.woff2',
    },
  },
  {
    family: 'Ruthie',
    files: {
      regular: 'https://fonts.gstatic.com/s/ruthie/v26/gokvH63sGkdqXuU9kT53Q2u_mQ.woff2',
    },
  },
  {
    family: 'Emilys Candy',
    files: {
      regular: 'https://fonts.gstatic.com/s/emilyscandy/v19/2EbgL-1mD1Rnb0OGKudbk0y5qtxrX84JjA.woff2',
    },
  },
  {
    family: 'Tiro Bangla',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirobangla/v6/IFSgHe1Tm95E3O8b5i2V8MG4-UPeuz4i.woff2',
    },
  },
  {
    family: 'Viaoda Libre',
    files: {
      regular: 'https://fonts.gstatic.com/s/viaodalibre/v18/vEFW2_lWCgoR6OKuRz9kcRVJamIY2tOHXg.woff2',
    },
  },
  {
    family: 'Kalnia',
    files: {
      '100': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW9il2xUGNcykIZc.woff2',
      '200': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW_ilmxUGNcykIZc.woff2',
      '300': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW88lmxUGNcykIZc.woff2',
      '500': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW9QlmxUGNcykIZc.woff2',
      '600': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW-8kWxUGNcykIZc.woff2',
      '700': 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW-FkWxUGNcykIZc.woff2',
      regular: 'https://fonts.gstatic.com/s/kalnia/v2/11hqGpPCwUbbYwZZP0RBuDY62BQZhjvOytM_sLzi-TFWAW9ilmxUGNcykIZc.woff2',
    },
  },
  {
    family: 'Orienta',
    files: {
      regular: 'https://fonts.gstatic.com/s/orienta/v15/PlI9FlK4Jrl5Y9zNeyKo9HRFhcU.woff2',
    },
  },
  {
    family: 'Caprasimo',
    files: {
      regular: 'https://fonts.gstatic.com/s/caprasimo/v5/esDT31JQOPuXIUGBp72kkJUCGpG-GQ.woff2',
    },
  },
  {
    family: 'Reddit Mono',
    files: {
      '200': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUQCYad3nYz7yQYA.woff2',
      '300': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUniYad3nYz7yQYA.woff2',
      '500': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vU8iYad3nYz7yQYA.woff2',
      '600': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUHiEad3nYz7yQYA.woff2',
      '700': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUJyEad3nYz7yQYA.woff2',
      '800': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUQCEad3nYz7yQYA.woff2',
      '900': 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUaSEad3nYz7yQYA.woff2',
      regular: 'https://fonts.gstatic.com/s/redditmono/v1/oPWc_kRmmu4oQ88oo13o48DHbsqn28eR20vUwCYad3nYz7yQYA.woff2',
    },
  },
  {
    family: 'Reggae One',
    files: {
      regular: 'https://fonts.gstatic.com/s/reggaeone/v16/7r3DqX5msMIkeuwJwOJt_atL5uH-mts.woff2',
    },
  },
  {
    family: 'Noto Serif Georgian',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvsfcjTw-FgZxQ.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSzvofcjTw-FgZxQ.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSEPofcjTw-FgZxQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSfPofcjTw-FgZxQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSkP0fcjTw-FgZxQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSqf0fcjTw-FgZxQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSzv0fcjTw-FgZxQ.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aS5_0fcjTw-FgZxQ.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifgeorgian/v26/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvofcjTw-FgZxQ.woff2',
    },
  },
  {
    family: 'Redressed',
    files: {
      regular: 'https://fonts.gstatic.com/s/redressed/v29/x3dickHUbrmJ7wMy9MsBefACvy_1BA.woff2',
    },
  },
  {
    family: 'Instrument Serif',
    files: {
      regular: 'https://fonts.gstatic.com/s/instrumentserif/v4/jizBRFtNs2ka5fXjeivQ4LroWlx-2zcZj1bIkNo.woff2',
    },
  },
  {
    family: 'Voces',
    files: {
      regular: 'https://fonts.gstatic.com/s/voces/v22/-F6_fjJyLyU8d4PEBG7YpzlJ.woff2',
    },
  },
  {
    family: 'Montagu Slab',
    files: {
      '100': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDbE3P4Fs7bOSO7.woff2',
      '200': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkBbEnP4Fs7bOSO7.woff2',
      '300': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkCFEnP4Fs7bOSO7.woff2',
      '500': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDpEnP4Fs7bOSO7.woff2',
      '600': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkAFFXP4Fs7bOSO7.woff2',
      '700': 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkA8FXP4Fs7bOSO7.woff2',
      regular: 'https://fonts.gstatic.com/s/montaguslab/v12/6qLhKZIQtB_zv0xUaXRDWkY_HXsphdLRZF40vm_jzR2jhk_n3T6ACkDbEnP4Fs7bOSO7.woff2',
    },
  },
  {
    family: 'Noto Emoji',
    files: {
      '300': 'https://fonts.gstatic.com/s/notoemoji/v47/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob_10jwqS-FGJCMY.woff2',
      '500': 'https://fonts.gstatic.com/s/notoemoji/v47/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob-Z0jwqS-FGJCMY.woff2',
      '600': 'https://fonts.gstatic.com/s/notoemoji/v47/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob911TwqS-FGJCMY.woff2',
      '700': 'https://fonts.gstatic.com/s/notoemoji/v47/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob9M1TwqS-FGJCMY.woff2',
      regular: 'https://fonts.gstatic.com/s/notoemoji/v47/bMrnmSyK7YY-MEu6aWjPDs-ar6uWaGWuob-r0jwqS-FGJCMY.woff2',
    },
  },
  {
    family: 'Cormorant Unicase',
    files: {
      '300': 'https://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9N_tucq7Gy0DRzS.woff2',
      '500': 'https://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9Mnt-cq7Gy0DRzS.woff2',
      '600': 'https://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9MLsOcq7Gy0DRzS.woff2',
      '700': 'https://fonts.gstatic.com/s/cormorantunicase/v24/HI_ViZUaILtOqhqgDeXoF_n1_fTGX9Nvsecq7Gy0DRzS.woff2',
      regular: 'https://fonts.gstatic.com/s/cormorantunicase/v24/HI_QiZUaILtOqhqgDeXoF_n1_fTGX-vWnsMnx3C9.woff2',
    },
  },
  {
    family: 'Belgrano',
    files: {
      regular: 'https://fonts.gstatic.com/s/belgrano/v18/55xvey5tM9rwKWrJZcMAirl08KDJ.woff2',
    },
  },
  {
    family: 'ADLaM Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/adlamdisplay/v1/KFOhCnGXkPOLlhx6jD8_b1ZECsTYkYBPY3o.woff2',
    },
  },
  {
    family: 'Qwitcher Grypen',
    files: {
      '700': 'https://fonts.gstatic.com/s/qwitchergrypen/v6/pxiZypclp9tDilN9RrC5BSI1dZmT9Exkr0SsrvNXiA.woff2',
      regular: 'https://fonts.gstatic.com/s/qwitchergrypen/v6/pxicypclp9tDilN9RrC5BSI1dZmrTWNAom-wpw.woff2',
    },
  },
  {
    family: 'Mina',
    files: {
      '700': 'https://fonts.gstatic.com/s/mina/v11/-nF8OGc18vARl4NMyiDZ95OkJwA.woff2',
      regular: 'https://fonts.gstatic.com/s/mina/v11/-nFzOGc18vARrzpj7i3y65o.woff2',
    },
  },
  {
    family: 'Monofett',
    files: {
      regular: 'https://fonts.gstatic.com/s/monofett/v23/mFTyWbofw6zc9NtnW43XuRwr0VJ7.woff2',
    },
  },
  {
    family: 'Ranchers',
    files: {
      regular: 'https://fonts.gstatic.com/s/ranchers/v17/zrfm0H3Lx-P2Xvs2AoDdDC79XTHv.woff2',
    },
  },
  {
    family: 'Bubbler One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bubblerone/v20/f0Xy0eqj68ppQV9KBLmAouHC26MPePkt.woff2',
    },
  },
  {
    family: 'Grape Nuts',
    files: {
      regular: 'https://fonts.gstatic.com/s/grapenuts/v5/syk2-yF4iLM2RfKj4F7k3tfvol2RN1E.woff2',
    },
  },
  {
    family: 'Gowun Dodum',
    files: {
      regular: 'https://fonts.gstatic.com/s/gowundodum/v7/3Jn5SD_00GqwlBnWc1TUJF0AfORL0fNy.woff2',
    },
  },
  {
    family: 'Sura',
    files: {
      '700': 'https://fonts.gstatic.com/s/sura/v19/SZc53FL5PbyzLUJ7fzjGkUrS8DI.woff2',
      regular: 'https://fonts.gstatic.com/s/sura/v19/SZc23FL5PbyzFftUWzXtjUM.woff2',
    },
  },
  {
    family: 'Poltawski Nowy',
    files: {
      '500': 'https://fonts.gstatic.com/s/poltawskinowy/v2/flUsRq6ww480U1xsUpFXD-iDBNlSAOLkKCLnWq8KmiWnCC6V5CzCoQ.woff2',
      '600': 'https://fonts.gstatic.com/s/poltawskinowy/v2/flUsRq6ww480U1xsUpFXD-iDBNlSAOLkKCLnWq8KdiKnCC6V5CzCoQ.woff2',
      '700': 'https://fonts.gstatic.com/s/poltawskinowy/v2/flUsRq6ww480U1xsUpFXD-iDBNlSAOLkKCLnWq8KTyKnCC6V5CzCoQ.woff2',
      regular: 'https://fonts.gstatic.com/s/poltawskinowy/v2/flUsRq6ww480U1xsUpFXD-iDBNlSAOLkKCLnWq8KqCWnCC6V5CzCoQ.woff2',
    },
  },
  {
    family: 'Stint Ultra Condensed',
    files: {
      regular: 'https://fonts.gstatic.com/s/stintultracondensed/v23/-W_gXIrsVjjeyEnPC45qD2NoFPtBE0xCh2A-rxUO2cNvdg.woff2',
    },
  },
  {
    family: 'Gemunu Libre',
    files: {
      '200': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp05iJPvGLeMXPIWA.woff2',
      '300': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp00aJPvGLeMXPIWA.woff2',
      '500': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0yqJPvGLeMXPIWA.woff2',
      '600': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp08aOPvGLeMXPIWA.woff2',
      '700': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0_-OPvGLeMXPIWA.woff2',
      '800': 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp05iOPvGLeMXPIWA.woff2',
      regular: 'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0xiJPvGLeMXPIWA.woff2',
    },
  },
  {
    family: 'Chango',
    files: {
      regular: 'https://fonts.gstatic.com/s/chango/v27/2V0cKI0OB5U7WaJyyn24TFUaAw.woff2',
    },
  },
  {
    family: 'Rhodium Libre',
    files: {
      regular: 'https://fonts.gstatic.com/s/rhodiumlibre/v19/1q2AY5adA0tn_ukeHcQHqpx6pEHLeo2gm2U.woff2',
    },
  },
  {
    family: 'Baloo Bhaina 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEgMPvQPRLYWmZSA.woff2',
      '600': 'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEbMTvQPRLYWmZSA.woff2',
      '700': 'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEVcTvQPRLYWmZSA.woff2',
      '800': 'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEMsTvQPRLYWmZSA.woff2',
      regular: 'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEssPvQPRLYWmZSA.woff2',
    },
  },
  {
    family: 'Rubik Doodle Shadow',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikdoodleshadow/v1/rP2bp3im_k8G_wTVdvvMdHqmXTR3lEaLyK6Z3KOY7Gw.woff2',
    },
  },
  {
    family: 'Zen Dots',
    files: {
      regular: 'https://fonts.gstatic.com/s/zendots/v12/XRXX3ICfm00IGoesQeaBTM_FcCIG.woff2',
    },
  },
  {
    family: 'ZCOOL KuaiLe',
    files: {
      regular: 'https://fonts.gstatic.com/s/zcoolkuaile/v19/tssqApdaRQokwFjFJjvM6h2Wo4zzoXhC2g.woff2',
    },
  },
  {
    family: 'Katibeh',
    files: {
      regular: 'https://fonts.gstatic.com/s/katibeh/v19/ZGjXol5MQJog4bxDaChRVDNdGDs.woff2',
    },
  },
  {
    family: 'Gamja Flower',
    files: {
      regular: 'https://fonts.gstatic.com/s/gamjaflower/v22/6NUR8FiKJg-Pa0rM6uN40Z4kzP9Fdty2ew.woff2',
    },
  },
  {
    family: 'Rubik Dirt',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikdirt/v2/DtVmJxC7WLEj1uIXEWAdulkm6gDXvwE.woff2',
    },
  },
  {
    family: 'Lexend Peta',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SFyXlYuRTsnfw.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRaSByXlYuRTsnfw.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRtyByXlYuRTsnfw.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR2yByXlYuRTsnfw.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRNydyXlYuRTsnfw.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRDidyXlYuRTsnfw.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRaSdyXlYuRTsnfw.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRQCdyXlYuRTsnfw.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SByXlYuRTsnfw.woff2',
    },
  },
  {
    family: 'Jomolhari',
    files: {
      regular: 'https://fonts.gstatic.com/s/jomolhari/v18/EvONzA1M1Iw_CBd2hsQCElIZKq5INg.woff2',
    },
  },
  {
    family: 'Londrina Outline',
    files: {
      regular: 'https://fonts.gstatic.com/s/londrinaoutline/v27/C8c44dM8vmb14dfsZxhetg3pDH-Sfu8xrSKMDvI.woff2',
    },
  },
  {
    family: 'Song Myung',
    files: {
      regular: 'https://fonts.gstatic.com/s/songmyung/v20/1cX2aUDWAJH5-EIC7DIhr1SqhcitzeM.woff2',
    },
  },
  {
    family: 'Varta',
    files: {
      '300': 'https://fonts.gstatic.com/s/varta/v21/Qw3AZQpJHj_6LzHUngWbrFkDH1x96j4Ej7E-9PGLfQ.woff2',
      '500': 'https://fonts.gstatic.com/s/varta/v21/Qw3AZQpJHj_6LzHUngWbrFkDH1x9hj4Ej7E-9PGLfQ.woff2',
      '600': 'https://fonts.gstatic.com/s/varta/v21/Qw3AZQpJHj_6LzHUngWbrFkDH1x9ajkEj7E-9PGLfQ.woff2',
      '700': 'https://fonts.gstatic.com/s/varta/v21/Qw3AZQpJHj_6LzHUngWbrFkDH1x9UzkEj7E-9PGLfQ.woff2',
      regular: 'https://fonts.gstatic.com/s/varta/v21/Qw3AZQpJHj_6LzHUngWbrFkDH1x9tD4Ej7E-9PGLfQ.woff2',
    },
  },
  {
    family: 'Pixelify Sans',
    files: {
      '500': 'https://fonts.gstatic.com/s/pixelifysans/v1/CHy2V-3HFUT7aC4iv1TxGDR9DHEserHN25py2TTb0H1db5JagkmX.woff2',
      '600': 'https://fonts.gstatic.com/s/pixelifysans/v1/CHy2V-3HFUT7aC4iv1TxGDR9DHEserHN25py2TQ3131db5JagkmX.woff2',
      '700': 'https://fonts.gstatic.com/s/pixelifysans/v1/CHy2V-3HFUT7aC4iv1TxGDR9DHEserHN25py2TQO131db5JagkmX.woff2',
      regular: 'https://fonts.gstatic.com/s/pixelifysans/v1/CHy2V-3HFUT7aC4iv1TxGDR9DHEserHN25py2TTp0H1db5JagkmX.woff2',
    },
  },
  {
    family: 'Murecho',
    files: {
      '100': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5HWcLCpUOaM6.woff2',
      '200': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrr5XWcLCpUOaM6.woff2',
      '300': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMo15XWcLCpUOaM6.woff2',
      '500': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpZ5XWcLCpUOaM6.woff2',
      '600': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMq14nWcLCpUOaM6.woff2',
      '700': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMqM4nWcLCpUOaM6.woff2',
      '800': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrr4nWcLCpUOaM6.woff2',
      '900': 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrC4nWcLCpUOaM6.woff2',
      regular: 'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5XWcLCpUOaM6.woff2',
    },
  },
  {
    family: 'Tilt Warp',
    files: {
      regular: 'https://fonts.gstatic.com/s/tiltwarp/v12/AlZc_zVDs5XpmO7yn3w7flUoytXJp3z29uEwmEMLEJljLXvT8UJSZTB0AVfMGOPb.woff2',
    },
  },
  {
    family: 'Comforter Brush',
    files: {
      regular: 'https://fonts.gstatic.com/s/comforterbrush/v7/Y4GTYa1xVSggrfzZI5WMjxRaOz0jxbL9Th8YYA.woff2',
    },
  },
  {
    family: 'Pavanam',
    files: {
      regular: 'https://fonts.gstatic.com/s/pavanam/v11/BXRrvF_aiezLh0xPDO5Q9Wf0QcE.woff2',
    },
  },
  {
    family: 'Delius Swash Caps',
    files: {
      regular: 'https://fonts.gstatic.com/s/deliusswashcaps/v23/oY1E8fPLr7v4JWCExZpWebxVKORpXXeYKmeBvEYs.woff2',
    },
  },
  {
    family: 'IM Fell French Canon',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellfrenchcanon/v21/-F6ufiNtDWYfYc-tDiyiw08rrghJszkK6coQPt1ozoPz.woff2',
    },
  },
  {
    family: 'Metal Mania',
    files: {
      regular: 'https://fonts.gstatic.com/s/metalmania/v22/RWmMoKWb4e8kqMfBUdPFJeXHg6UKDXlq.woff2',
    },
  },
  {
    family: 'Crushed',
    files: {
      regular: 'https://fonts.gstatic.com/s/crushed/v29/U9Mc6dym6WXImTlFT1wfuIqyLzA.woff2',
    },
  },
  {
    family: 'Frijole',
    files: {
      regular: 'https://fonts.gstatic.com/s/frijole/v14/uU9PCBUR8oakM2BQ7xbb3vyHmlI.woff2',
    },
  },
  {
    family: 'Square Peg',
    files: {
      regular: 'https://fonts.gstatic.com/s/squarepeg/v5/y83eW48Nzw6ZlUHc-phrBDTrHHfrFPE.woff2',
    },
  },
  {
    family: 'Victor Mono',
    files: {
      '100': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCyO8_NgdyOV0Y9bQ.woff2',
      '200': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCyu87NgdyOV0Y9bQ.woff2',
      '300': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCyZc7NgdyOV0Y9bQ.woff2',
      '500': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCyCc7NgdyOV0Y9bQ.woff2',
      '600': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCy5cnNgdyOV0Y9bQ.woff2',
      '700': 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCy3MnNgdyOV0Y9bQ.woff2',
      regular: 'https://fonts.gstatic.com/s/victormono/v3/Yq6H-LGQWyfv-LGy7lEO09xRn-T81AVB_tCyO87NgdyOV0Y9bQ.woff2',
    },
  },
  {
    family: 'East Sea Dokdo',
    files: {
      regular: 'https://fonts.gstatic.com/s/eastseadokdo/v22/xfuo0Wn2V2_KanASqXSZp22m05_fGavYS18y.woff2',
    },
  },
  {
    family: 'Modern Antiqua',
    files: {
      regular: 'https://fonts.gstatic.com/s/modernantiqua/v24/NGStv5TIAUg6Iq_RLNo_2dp1sI1Ba2u0c3Gi.woff2',
    },
  },
  {
    family: 'Rosarivo',
    files: {
      regular: 'https://fonts.gstatic.com/s/rosarivo/v22/PlI-Fl2lO6N9f8HaNAeH2nhMnNy5.woff2',
    },
  },
  {
    family: 'Prociono',
    files: {
      regular: 'https://fonts.gstatic.com/s/prociono/v26/r05YGLlR-KxAf9GGO8usyDYtStiJ.woff2',
    },
  },
  {
    family: 'Asar',
    files: {
      regular: 'https://fonts.gstatic.com/s/asar/v22/sZlLdRyI6TBIXkMQDLlTW6E.woff2',
    },
  },
  {
    family: 'Lovers Quarrel',
    files: {
      regular: 'https://fonts.gstatic.com/s/loversquarrel/v23/Yq6N-LSKXTL-5bCy8ksBzpQ_-zApY7pO6siz.woff2',
    },
  },
  {
    family: 'Alkatra',
    files: {
      '500': 'https://fonts.gstatic.com/s/alkatra/v3/r05EGLZA5qhCYsyJbuChFuK48MedzngUu7cKrNDVemxE.woff2',
      '600': 'https://fonts.gstatic.com/s/alkatra/v3/r05EGLZA5qhCYsyJbuChFuK48Medznj4vLcKrNDVemxE.woff2',
      '700': 'https://fonts.gstatic.com/s/alkatra/v3/r05EGLZA5qhCYsyJbuChFuK48MedznjBvLcKrNDVemxE.woff2',
      regular: 'https://fonts.gstatic.com/s/alkatra/v3/r05EGLZA5qhCYsyJbuChFuK48Medzngmu7cKrNDVemxE.woff2',
    },
  },
  {
    family: 'Zilla Slab Highlight',
    files: {
      '700': 'https://fonts.gstatic.com/s/zillaslabhighlight/v19/gNMUW2BrTpK8-inLtBJgMMfbm6uNVDvRxiP0TET9YmVF0Mb6.woff2',
      regular: 'https://fonts.gstatic.com/s/zillaslabhighlight/v19/gNMbW2BrTpK8-inLtBJgMMfbm6uNVDvRxhtNY2DwSXlM.woff2',
    },
  },
  {
    family: 'Akronim',
    files: {
      regular: 'https://fonts.gstatic.com/s/akronim/v23/fdN-9sqWtWZZlHRp-gVxkFYN-a8.woff2',
    },
  },
  {
    family: 'Alkalami',
    files: {
      regular: 'https://fonts.gstatic.com/s/alkalami/v7/zOL_4pfDmqRL95WXi5eOw8BMuvhH.woff2',
    },
  },
  {
    family: 'Tillana',
    files: {
      '500': 'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQFL-HIxMZRNcp0o.woff2',
      '600': 'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQH75HIxMZRNcp0o.woff2',
      '700': 'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQBr4HIxMZRNcp0o.woff2',
      '800': 'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQAb7HIxMZRNcp0o.woff2',
      regular: 'https://fonts.gstatic.com/s/tillana/v13/VuJxdNvf35P4qJ1OeKPXOIFneRo.woff2',
    },
  },
  {
    family: 'Iceland',
    files: {
      regular: 'https://fonts.gstatic.com/s/iceland/v20/rax9HiuFsdMNOnWPWKlGADBbg0s.woff2',
    },
  },
  {
    family: 'Miniver',
    files: {
      regular: 'https://fonts.gstatic.com/s/miniver/v25/eLGcP-PxIg-5H0vC77gCy8r8fWA.woff2',
    },
  },
  {
    family: 'Hachi Maru Pop',
    files: {
      regular: 'https://fonts.gstatic.com/s/hachimarupop/v19/HI_TiYoRLqpLrEiMAuO9Ysfz7rWwEM_btd8u.woff2',
    },
  },
  {
    family: 'Raleway Dots',
    files: {
      regular: 'https://fonts.gstatic.com/s/ralewaydots/v16/6NUR8FifJg6AfQvzpshgwJ8kzP9Fdty2ew.woff2',
    },
  },
  {
    family: 'Swanky and Moo Moo',
    files: {
      regular: 'https://fonts.gstatic.com/s/swankyandmoomoo/v22/flUlRrKz24IuWVI_WJYTYcqbEsMUZ3kUsLPkR64SYQ.woff2',
    },
  },
  {
    family: 'Libre Barcode 128 Text',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcode128text/v28/fdNv9tubt3ZEnz1Gu3I4-zppwZ9CWZ16Z0w5cVjY6M90w4k.woff2',
    },
  },
  {
    family: 'Single Day',
    files: {
      regular: 'https://fonts.gstatic.com/s/singleday/v17/LYjHdGDjlEgoAcF95EI5jV8FUNfeQJU.woff2',
    },
  },
  {
    family: 'Lexend Mega',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fivuOyiq9EqQw.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLcfmvuOyiq9EqQw.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLr_mvuOyiq9EqQw.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLw_mvuOyiq9EqQw.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLL_6vuOyiq9EqQw.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLFv6vuOyiq9EqQw.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLcf6vuOyiq9EqQw.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLWP6vuOyiq9EqQw.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendmega/v25/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fmvuOyiq9EqQw.woff2',
    },
  },
  {
    family: 'Gowun Batang',
    files: {
      '700': 'https://fonts.gstatic.com/s/gowunbatang/v7/ijwNs5nhRMIjYsdSgcMa3wRZ4J7ax8sxJii23w.woff2',
      regular: 'https://fonts.gstatic.com/s/gowunbatang/v7/ijwSs5nhRMIjYsdSgcMa3wRhWbH-yuAtLw.woff2',
    },
  },
  {
    family: 'Bona Nova',
    files: {
      '700': 'https://fonts.gstatic.com/s/bonanova/v10/B50IF7ZCpX7fcHfvIUBxN4dOEYSeJY8GgQ.woff2',
      regular: 'https://fonts.gstatic.com/s/bonanova/v10/B50NF7ZCpX7fcHfvIUBJjqhqHK-CLA.woff2',
    },
  },
  {
    family: 'Sonsie One',
    files: {
      regular: 'https://fonts.gstatic.com/s/sonsieone/v21/PbymFmP_EAnPqbKaoc18YV680lbp8JM.woff2',
    },
  },
  {
    family: 'Butterfly Kids',
    files: {
      regular: 'https://fonts.gstatic.com/s/butterflykids/v25/ll8lK2CWTjuqAsXDqlnIbMNs5S4frxFrAX1D.woff2',
    },
  },
  {
    family: 'Yarndings 12',
    files: {
      regular: 'https://fonts.gstatic.com/s/yarndings12/v2/55xreyp2N8T5P2LJbZAlkY9c9JLMI2VUnQ.woff2',
    },
  },
  {
    family: 'Port Lligat Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/portlligatsans/v22/kmKmZrYrGBbdN1aV7Vokow6Lw4s4l7Z0Tx4xEcQ.woff2',
    },
  },
  {
    family: 'Yarndings 20 Charted',
    files: {
      regular: 'https://fonts.gstatic.com/s/yarndings20charted/v2/QldRNSdbpg0G8vh0W2qxe0l-hcUPtY2VaLQj4UTqz5V9.woff2',
    },
  },
  {
    family: 'Rubik Scribble',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikscribble/v1/snfzs0Cp48d67SuHQOpjXLsQpbqeSjORSo9W.woff2',
    },
  },
  {
    family: 'Gafata',
    files: {
      regular: 'https://fonts.gstatic.com/s/gafata/v20/XRXV3I6Cn0VJKon4N-yAbsrVcA.woff2',
    },
  },
  {
    family: 'Yarndings 12 Charted',
    files: {
      regular: 'https://fonts.gstatic.com/s/yarndings12charted/v2/eLGDP_DlKhO-DUfeqM4I_vDdJgmIh7hAvvbM0t-dHaJH.woff2',
    },
  },
  {
    family: 'Yarndings 20',
    files: {
      regular: 'https://fonts.gstatic.com/s/yarndings20/v2/TuGWUVlkUohEQu8l7K8b-vNFAn80PMTK1w.woff2',
    },
  },
  {
    family: 'Strait',
    files: {
      regular: 'https://fonts.gstatic.com/s/strait/v17/DtViJxy6WaEr1LZzfThtkl0U7w.woff2',
    },
  },
  {
    family: 'WindSong',
    files: {
      '500': 'https://fonts.gstatic.com/s/windsong/v11/KR1RBsyu-P-GFEW57oeNNPW3lS3-jVXm.woff2',
      regular: 'https://fonts.gstatic.com/s/windsong/v11/KR1WBsyu-P-GFEW57r98HdG6vjH3.woff2',
    },
  },
  {
    family: 'Rum Raisin',
    files: {
      regular: 'https://fonts.gstatic.com/s/rumraisin/v22/nwpRtKu3Ih8D5avB4h2uJ3qIywA7eMM.woff2',
    },
  },
  {
    family: 'Agbalumo',
    files: {
      regular: 'https://fonts.gstatic.com/s/agbalumo/v5/55xvey5uMdT2N37KZcMAirl08KDJ.woff2',
    },
  },
  {
    family: 'Noto Sans Khmer',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAZz9kAbrddiA.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYsNAJz9kAbrddiA.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYvTAJz9kAbrddiA.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYu_AJz9kAbrddiA.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtTB5z9kAbrddiA.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtqB5z9kAbrddiA.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYsNB5z9kAbrddiA.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYskB5z9kAbrddiA.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanskhmer/v24/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAJz9kAbrddiA.woff2',
    },
  },
  {
    family: 'Iceberg',
    files: {
      regular: 'https://fonts.gstatic.com/s/iceberg/v24/8QIJdijAiM7o-qnZuI0Oq7jkAOw.woff2',
    },
  },
  {
    family: 'Denk One',
    files: {
      regular: 'https://fonts.gstatic.com/s/denkone/v19/dg4m_pzhrqcFb2IzROtCpbglShon.woff2',
    },
  },
  {
    family: 'Anybody',
    files: {
      '100': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12HPq8XD_nBPpQ.woff2',
      '200': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JV2DPq8XD_nBPpQ.woff2',
      '300': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JiWDPq8XD_nBPpQ.woff2',
      '500': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J5WDPq8XD_nBPpQ.woff2',
      '600': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JCWfPq8XD_nBPpQ.woff2',
      '700': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JMGfPq8XD_nBPpQ.woff2',
      '800': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JV2fPq8XD_nBPpQ.woff2',
      '900': 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JfmfPq8XD_nBPpQ.woff2',
      regular: 'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12DPq8XD_nBPpQ.woff2',
    },
  },
  {
    family: 'Moul',
    files: {
      regular: 'https://fonts.gstatic.com/s/moul/v27/nuF2D__FSo_3E-FYiJCy-00.woff2',
    },
  },
  {
    family: 'Ribeye',
    files: {
      regular: 'https://fonts.gstatic.com/s/ribeye/v25/L0x8DFMxk1MP9R3RufCmRSlUig.woff2',
    },
  },
  {
    family: 'Akaya Telivigala',
    files: {
      regular: 'https://fonts.gstatic.com/s/akayatelivigala/v22/lJwc-oo_iG9wXqU3rCTD395tp0uifdfdsIH0YH8.woff2',
    },
  },
  {
    family: 'Yuji Syuku',
    files: {
      regular: 'https://fonts.gstatic.com/s/yujisyuku/v5/BngNUXdTV3vO6Lw5ApOPqPLgwqiA-Rk.woff2',
    },
  },
  {
    family: 'Noto Serif Telugu',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TGwvI2fjgrZYA.woff2',
      '200': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DdTCwvI2fjgrZYA.woff2',
      '300': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DqzCwvI2fjgrZYA.woff2',
      '500': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DxzCwvI2fjgrZYA.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DKzewvI2fjgrZYA.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DEjewvI2fjgrZYA.woff2',
      '800': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DdTewvI2fjgrZYA.woff2',
      '900': 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DXDewvI2fjgrZYA.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriftelugu/v26/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TCwvI2fjgrZYA.woff2',
    },
  },
  {
    family: 'Kantumruy Pro',
    files: {
      '100': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1urUsxM34dR6dW.woff2',
      '200': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg3urEsxM34dR6dW.woff2',
      '300': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg0wrEsxM34dR6dW.woff2',
      '500': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1crEsxM34dR6dW.woff2',
      '600': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg2wq0sxM34dR6dW.woff2',
      '700': 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg2Jq0sxM34dR6dW.woff2',
      regular: 'https://fonts.gstatic.com/s/kantumruypro/v8/1q2TY5aECkp34vEBSPFOmJxwvk_pilU8OGNfyg1urEsxM34dR6dW.woff2',
    },
  },
  {
    family: 'MonteCarlo',
    files: {
      regular: 'https://fonts.gstatic.com/s/montecarlo/v11/buEzpo6-f9X01GadLA0G0C8V_NxLeiw.woff2',
    },
  },
  {
    family: 'Gorditas',
    files: {
      '700': 'https://fonts.gstatic.com/s/gorditas/v22/ll84K2aTVD26DsPEtThUIooNvAoShA1i.woff2',
      regular: 'https://fonts.gstatic.com/s/gorditas/v22/ll8_K2aTVD26DsPEtQDtDa4AlxYb.woff2',
    },
  },
  {
    family: 'Sunshiney',
    files: {
      regular: 'https://fonts.gstatic.com/s/sunshiney/v24/LDIwapGTLBwsS-wT4vcgFsmoUePWkg.woff2',
    },
  },
  {
    family: 'Carlito',
    files: {
      '700': 'https://fonts.gstatic.com/s/carlito/v3/3Jn4SDPw3m-pk039BIykaXgvUuhCyOo.woff2',
      regular: 'https://fonts.gstatic.com/s/carlito/v3/3Jn9SDPw3m-pk039PDWLTXUETuE.woff2',
    },
  },
  {
    family: 'Arima',
    files: {
      '100': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1YTE-oAGOyYw2fw.woff2',
      '200': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX14TA-oAGOyYw2fw.woff2',
      '300': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1PzA-oAGOyYw2fw.woff2',
      '500': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1UzA-oAGOyYw2fw.woff2',
      '600': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1vzc-oAGOyYw2fw.woff2',
      '700': 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1hjc-oAGOyYw2fw.woff2',
      regular: 'https://fonts.gstatic.com/s/arima/v5/neIWzCqmt4Aup_qE1nFWqxI1RZX1YTA-oAGOyYw2fw.woff2',
    },
  },
  {
    family: 'Suwannaphum',
    files: {
      '100': 'https://fonts.gstatic.com/s/suwannaphum/v31/jAnAgHV7GtDvc8jbe8hXXL3B9cGWXx2VZmk.woff2',
      '300': 'https://fonts.gstatic.com/s/suwannaphum/v31/jAnfgHV7GtDvc8jbe8hXXL0J1-S5cRGcf3Ai.woff2',
      '700': 'https://fonts.gstatic.com/s/suwannaphum/v31/jAnfgHV7GtDvc8jbe8hXXL0Z0OS5cRGcf3Ai.woff2',
      '900': 'https://fonts.gstatic.com/s/suwannaphum/v31/jAnfgHV7GtDvc8jbe8hXXL0h0uS5cRGcf3Ai.woff2',
      regular: 'https://fonts.gstatic.com/s/suwannaphum/v31/jAnCgHV7GtDvc8jbe8hXXIWg_8C0Wg2V.woff2',
    },
  },
  {
    family: 'Stalemate',
    files: {
      regular: 'https://fonts.gstatic.com/s/stalemate/v22/taiIGmZ_EJq97-UfkZRpv6Ss8ZQpaQ.woff2',
    },
  },
  {
    family: 'Meow Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/meowscript/v5/0FlQVPqanlaJrtr8AnJ0ESck0_0CfDf1.woff2',
    },
  },
  {
    family: 'Karantina',
    files: {
      '300': 'https://fonts.gstatic.com/s/karantina/v11/buExpo24ccnh31GVMABxXCgf_f5Oaiw4cw.woff2',
      '700': 'https://fonts.gstatic.com/s/karantina/v11/buExpo24ccnh31GVMABxTC8f_f5Oaiw4cw.woff2',
      regular: 'https://fonts.gstatic.com/s/karantina/v11/buE0po24ccnh31GVMABJ9QA78NVSYw.woff2',
    },
  },
  {
    family: 'Fenix',
    files: {
      regular: 'https://fonts.gstatic.com/s/fenix/v20/XoHo2YL_S7-g5osoKzAFvs8o.woff2',
    },
  },
  {
    family: 'Galdeano',
    files: {
      regular: 'https://fonts.gstatic.com/s/galdeano/v22/uU9MCBoQ4YOqOW1boDP08PCOg0uX.woff2',
    },
  },
  {
    family: 'Carrois Gothic SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/carroisgothicsc/v15/ZgNJjOVHM6jfUZCmyUqT2A2HVKjc-28iNHabY4dN.woff2',
    },
  },
  {
    family: 'Noto Sans Adlam',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansadlam/v22/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufkn0TGzBZLwhuvk.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansadlam/v22/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufqXzTGzBZLwhuvk.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansadlam/v22/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufpzzTGzBZLwhuvk.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansadlam/v22/neIczCCpqp0s5pPusPamd81eMfjPonvqdbYxxpgufnv0TGzBZLwhuvk.woff2',
    },
  },
  {
    family: 'Workbench',
    files: {
      regular: 'https://fonts.gstatic.com/s/workbench/v1/FeV8S05Gp6Et7FcfbPFK1rynGd_MxtkvNFmoUDFhgF2VKTGQk6vapdOO0GKqgZyb.woff2',
    },
  },
  {
    family: 'Macondo Swash Caps',
    files: {
      regular: 'https://fonts.gstatic.com/s/macondoswashcaps/v24/6NUL8EaAJgGKZA7lpt941Z9s6ZYgDq6Of0oa_mm5bA.woff2',
    },
  },
  {
    family: 'Nova Flat',
    files: {
      regular: 'https://fonts.gstatic.com/s/novaflat/v24/QdVUSTc-JgqpytEbVebEvCtkm20oJA.woff2',
    },
  },
  {
    family: 'Stylish',
    files: {
      regular: 'https://fonts.gstatic.com/s/stylish/v22/m8JSjfhPYriQkk7-foj5dLxEdmo.woff2',
    },
  },
  {
    family: 'Marhey',
    files: {
      '300': 'https://fonts.gstatic.com/s/marhey/v6/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBZVwO2IXiGevOMw.woff2',
      '500': 'https://fonts.gstatic.com/s/marhey/v6/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBflwO2IXiGevOMw.woff2',
      '600': 'https://fonts.gstatic.com/s/marhey/v6/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBRV3O2IXiGevOMw.woff2',
      '700': 'https://fonts.gstatic.com/s/marhey/v6/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBSx3O2IXiGevOMw.woff2',
      regular: 'https://fonts.gstatic.com/s/marhey/v6/x3d8ck7Laq-T7wl7mqfVrEe9sDvtBctwO2IXiGevOMw.woff2',
    },
  },
  {
    family: 'Barrio',
    files: {
      regular: 'https://fonts.gstatic.com/s/barrio/v19/wEO8EBXBk8hBIDiEcAYhWdsX1Q.woff2',
    },
  },
  {
    family: 'Maiden Orange',
    files: {
      regular: 'https://fonts.gstatic.com/s/maidenorange/v29/kJE1BuIX7AUmhi2V4m08kb1XjONdCZS8FY8.woff2',
    },
  },
  {
    family: 'IM Fell Great Primer',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellgreatprimer/v21/bx6aNwSJtayYxOkbYFsT6hMsLzX7u85rJorSvDo3SQY1.woff2',
    },
  },
  {
    family: 'Anek Bangla',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9YIoIg56yyvt0.woff2',
      '200': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofu9ZIoIg56yyvt0.woff2',
      '300': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfjFZIoIg56yyvt0.woff2',
      '500': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofl1ZIoIg56yyvt0.woff2',
      '600': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfrFeIoIg56yyvt0.woff2',
      '700': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfoheIoIg56yyvt0.woff2',
      '800': 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofu9eIoIg56yyvt0.woff2',
      regular: 'https://fonts.gstatic.com/s/anekbangla/v5/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9ZIoIg56yyvt0.woff2',
    },
  },
  {
    family: 'Nosifer',
    files: {
      regular: 'https://fonts.gstatic.com/s/nosifer/v22/ZGjXol5JTp0g5bxZaChRVDNdGDs.woff2',
    },
  },
  {
    family: 'Fuzzy Bubbles',
    files: {
      '700': 'https://fonts.gstatic.com/s/fuzzybubbles/v7/6qLbKZMbrgv9pwtjPEVNV0F2Ds_WQxYAZkM1pn4.woff2',
      regular: 'https://fonts.gstatic.com/s/fuzzybubbles/v7/6qLGKZMbrgv9pwtjPEVNV0F2Nnb5Zxsreko.woff2',
    },
  },
  {
    family: 'Engagement',
    files: {
      regular: 'https://fonts.gstatic.com/s/engagement/v26/x3dlckLDZbqa7RUs9MFVXN8ssybsHQI.woff2',
    },
  },
  {
    family: 'IM Fell DW Pica SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfelldwpicasc/v21/0ybjGCAu5PfqkvtGVU15aBhXz3EUrnTW_RiKEUiBGA.woff2',
    },
  },
  {
    family: 'Cute Font',
    files: {
      regular: 'https://fonts.gstatic.com/s/cutefont/v22/Noaw6Uny2oWPbSHMrY6vnZNVNC9hkw.woff2',
    },
  },
  {
    family: 'M PLUS 1 Code',
    files: {
      '100': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7iN0XHsapwmdZhY.woff2',
      '200': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7gN0HHsapwmdZhY.woff2',
      '300': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7jT0HHsapwmdZhY.woff2',
      '500': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7i_0HHsapwmdZhY.woff2',
      '600': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7hT13HsapwmdZhY.woff2',
      '700': 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7hq13HsapwmdZhY.woff2',
      regular: 'https://fonts.gstatic.com/s/mplus1code/v12/ypvMbXOOx2xFpzmYJS3N2_J2hBN6RZ5oIp8m_7iN0HHsapwmdZhY.woff2',
    },
  },
  {
    family: 'Habibi',
    files: {
      regular: 'https://fonts.gstatic.com/s/habibi/v21/CSR-4zFWkuqcTTNCTxJeZOYySQ.woff2',
    },
  },
  {
    family: 'Bahianita',
    files: {
      regular: 'https://fonts.gstatic.com/s/bahianita/v21/yYLr0hTb3vuqqsBUgxWtwDvV2NJPcA.woff2',
    },
  },
  {
    family: 'UnifrakturCook',
    files: {
      '700': 'https://fonts.gstatic.com/s/unifrakturcook/v23/IurA6Yli8YOdcoky-0PTTdkm56n05Uww3ILXs-h6.woff2',
    },
  },
  {
    family: 'Yomogi',
    files: {
      regular: 'https://fonts.gstatic.com/s/yomogi/v11/VuJwdNrS2ZL7rpoPXYz5NIh-YA.woff2',
    },
  },
  {
    family: 'Uncial Antiqua',
    files: {
      regular: 'https://fonts.gstatic.com/s/uncialantiqua/v20/N0bM2S5WOex4OUbESzoESK-i-PfUS5VBBSSF.woff2',
    },
  },
  {
    family: 'Rationale',
    files: {
      regular: 'https://fonts.gstatic.com/s/rationale/v28/9XUnlJ92n0_JFxHIfHcsc1FMzLC2Zw.woff2',
    },
  },
  {
    family: 'Shippori Antique',
    files: {
      regular: 'https://fonts.gstatic.com/s/shipporiantique/v8/-F6qfid3KC8pdMyzR0qRyFUht11v8lJPg-IUDNg.woff2',
    },
  },
  {
    family: 'Kulim Park',
    files: {
      '200': 'https://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjJYNwataZbUvGjU.woff2',
      '300': 'https://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjPIOwataZbUvGjU.woff2',
      '600': 'https://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjIYIwataZbUvGjU.woff2',
      '700': 'https://fonts.gstatic.com/s/kulimpark/v14/fdN49secq3hflz1Uu3IwjOIJwataZbUvGjU.woff2',
      regular: 'https://fonts.gstatic.com/s/kulimpark/v14/fdN79secq3hflz1Uu3IwtFsm5aZxebw.woff2',
    },
  },
  {
    family: 'Afacad',
    files: {
      '500': 'https://fonts.gstatic.com/s/afacad/v1/6NUK8FKMIQOGaw6wjYT7ZHG_zsBBfiftWmU08mCgdfM.woff2',
      '600': 'https://fonts.gstatic.com/s/afacad/v1/6NUK8FKMIQOGaw6wjYT7ZHG_zsBBfsvqWmU08mCgdfM.woff2',
      '700': 'https://fonts.gstatic.com/s/afacad/v1/6NUK8FKMIQOGaw6wjYT7ZHG_zsBBfvLqWmU08mCgdfM.woff2',
      regular: 'https://fonts.gstatic.com/s/afacad/v1/6NUK8FKMIQOGaw6wjYT7ZHG_zsBBfhXtWmU08mCgdfM.woff2',
    },
  },
  {
    family: 'Cantora One',
    files: {
      regular: 'https://fonts.gstatic.com/s/cantoraone/v19/gyB4hws1JdgnKy56GB_JX6zYZ4vZVbgZ.woff2',
    },
  },
  {
    family: 'Anek Devanagari',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtk-9iFk0LjZ7E.woff2',
      '200': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLBtku9iFk0LjZ7E.woff2',
      '300': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLCzku9iFk0LjZ7E.woff2',
      '500': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDfku9iFk0LjZ7E.woff2',
      '600': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAzle9iFk0LjZ7E.woff2',
      '700': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAKle9iFk0LjZ7E.woff2',
      '800': 'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLBtle9iFk0LjZ7E.woff2',
      regular:
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtku9iFk0LjZ7E.woff2',
    },
  },
  {
    family: 'Flow Circular',
    files: {
      regular: 'https://fonts.gstatic.com/s/flowcircular/v11/lJwB-pc4j2F-H8YKuyvfxdZ45iLpWdr2rIg.woff2',
    },
  },
  {
    family: 'Tiro Devanagari Hindi',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirodevanagarihindi/v5/55xyezN7P8T4e0_CfIJrwdodg9HoYw0i-M9fTekOfG0Y3A.woff2',
    },
  },
  {
    family: 'Madimi One',
    files: {
      regular: 'https://fonts.gstatic.com/s/madimione/v1/2V0YKIEADpA8U6RygDnZZFEoBoHMd2U.woff2',
    },
  },
  {
    family: 'Meera Inimai',
    files: {
      regular: 'https://fonts.gstatic.com/s/meerainimai/v12/845fNMM5EIqOW5MPuvO3ILep-mjDVevnLQ.woff2',
    },
  },
  {
    family: 'Kite One',
    files: {
      regular: 'https://fonts.gstatic.com/s/kiteone/v22/70lQu7shLnA_E02vyq1e6HnGO4uA.woff2',
    },
  },
  {
    family: 'Farsan',
    files: {
      regular: 'https://fonts.gstatic.com/s/farsan/v22/VEMwRoJ0vY_zsyz636-pxDX9rQ.woff2',
    },
  },
  {
    family: 'Sree Krushnadevaraya',
    files: {
      regular: 'https://fonts.gstatic.com/s/sreekrushnadevaraya/v21/R70FjzQeifmPepmyQQjQ9kvwMkWYPfTA_EWe2FhQuXir.woff2',
    },
  },
  {
    family: 'Lexend Giga',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2LmE7soo6eepYQ.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCWLiE7soo6eepYQ.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRChriE7soo6eepYQ.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC6riE7soo6eepYQ.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCBr-E7soo6eepYQ.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCP7-E7soo6eepYQ.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCWL-E7soo6eepYQ.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCcb-E7soo6eepYQ.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendgiga/v25/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2LiE7soo6eepYQ.woff2',
    },
  },
  {
    family: 'Asset',
    files: {
      regular: 'https://fonts.gstatic.com/s/asset/v29/SLXGc1na-mM4cWIjRJqExst1.woff2',
    },
  },
  {
    family: 'Dekko',
    files: {
      regular: 'https://fonts.gstatic.com/s/dekko/v21/46khlb_wWjfSrttAR0vsfl1B.woff2',
    },
  },
  {
    family: 'Meie Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/meiescript/v21/_LOImzDK7erRjhunIspaMjxi5IXg0WDz.woff2',
    },
  },
  {
    family: 'Noto Sans Lao',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccfdepMK3riB2w.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt48cbdepMK3riB2w.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4L8bdepMK3riB2w.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4Q8bdepMK3riB2w.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4r8HdepMK3riB2w.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4lsHdepMK3riB2w.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt48cHdepMK3riB2w.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt42MHdepMK3riB2w.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanslao/v30/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccbdepMK3riB2w.woff2',
    },
  },
  {
    family: 'Paprika',
    files: {
      regular: 'https://fonts.gstatic.com/s/paprika/v21/8QIJdijZitv49rDfuI0Oq7jkAOw.woff2',
    },
  },
  {
    family: 'Smooch Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUFoc6IeNlzayg.woff2',
      '200': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiQUBoc6IeNlzayg.woff2',
      '300': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oin0Boc6IeNlzayg.woff2',
      '500': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oi80Boc6IeNlzayg.woff2',
      '600': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiH0doc6IeNlzayg.woff2',
      '700': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiJkdoc6IeNlzayg.woff2',
      '800': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiQUdoc6IeNlzayg.woff2',
      '900': 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiaEdoc6IeNlzayg.woff2',
      regular: 'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUBoc6IeNlzayg.woff2',
    },
  },
  {
    family: 'Vujahday Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/vujahdayscript/v8/RWmQoKGA8fEkrIPtSZ3_J7er2dUiCUtvAlaMKw.woff2',
    },
  },
  {
    family: 'Sancreek',
    files: {
      regular: 'https://fonts.gstatic.com/s/sancreek/v25/pxiHypAnsdxUm159X7D7XV9NEe-K.woff2',
    },
  },
  {
    family: 'Tac One',
    files: {
      regular: 'https://fonts.gstatic.com/s/tacone/v2/ahcZv8Cj3zw7qDr8fOshU-FwnU0.woff2',
    },
  },
  {
    family: 'Whisper',
    files: {
      regular: 'https://fonts.gstatic.com/s/whisper/v5/q5uHsoqtKftx74K9mixCBxxdmYU.woff2',
    },
  },
  {
    family: 'Noto Sans Anatolian Hieroglyphs',
    files: {
      regular:
        'https://fonts.gstatic.com/s/notosansanatolianhieroglyphs/v16/ijw9s4roRME5LLRxjsRb8A0gKPSWq4BbDmHHu6j2pEtUJzZWXyPIymc5QYo.woff2',
    },
  },
  {
    family: 'Milonga',
    files: {
      regular: 'https://fonts.gstatic.com/s/milonga/v22/SZc53FHnIaK9W5kffzjGkUrS8DI.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Hebrew',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa4qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEXB-lgVqDaM7C4.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEVt2306hjqF9Tc2.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEUJ2H06hjqF9Tc2.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEVR2X06hjqF9Tc2.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEV93n06hjqF9Tc2.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa5qYENg9Kw1mpLpO0bGM5lfHAAZHhDXEUZ3306hjqF9Tc2.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsanshebrew/v11/BCa2qYENg9Kw1mpLpO0bGM5lfHAAZHhDXH2g8Fk3rSaM.woff2',
    },
  },
  {
    family: 'Baloo Tammudu 2',
    files: {
      '500': 'https://fonts.gstatic.com/s/balootammudu2/v23/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jc0e4cuPZSlGmAA.woff2',
      '600': 'https://fonts.gstatic.com/s/balootammudu2/v23/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JSEZ4cuPZSlGmAA.woff2',
      '700': 'https://fonts.gstatic.com/s/balootammudu2/v23/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JRgZ4cuPZSlGmAA.woff2',
      '800': 'https://fonts.gstatic.com/s/balootammudu2/v23/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JX8Z4cuPZSlGmAA.woff2',
      regular: 'https://fonts.gstatic.com/s/balootammudu2/v23/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jf8e4cuPZSlGmAA.woff2',
    },
  },
  {
    family: 'Mystery Quest',
    files: {
      regular: 'https://fonts.gstatic.com/s/mysteryquest/v20/-nF6OG414u0E6k0wynSGlujRHwQlD_9Qz9E.woff2',
    },
  },
  {
    family: 'Genos',
    files: {
      '100': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVqknoqEK6K7ZsAg.woff2',
      '200': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVKkjoqEK6K7ZsAg.woff2',
      '300': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwV9EjoqEK6K7ZsAg.woff2',
      '500': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVmEjoqEK6K7ZsAg.woff2',
      '600': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVdE_oqEK6K7ZsAg.woff2',
      '700': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVTU_oqEK6K7ZsAg.woff2',
      '800': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVKk_oqEK6K7ZsAg.woff2',
      '900': 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVA0_oqEK6K7ZsAg.woff2',
      regular: 'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVqkjoqEK6K7ZsAg.woff2',
    },
  },
  {
    family: 'Bruno Ace SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/brunoacesc/v5/ptROTiycffFLBuiHjdJDl634KCFrpe8uZA.woff2',
    },
  },
  {
    family: 'Port Lligat Slab',
    files: {
      regular: 'https://fonts.gstatic.com/s/portlligatslab/v25/LDIpaoiQNgArA8kR7ulhZ8P_NYOss78b9yGLmfI.woff2',
    },
  },
  {
    family: 'Jolly Lodger',
    files: {
      regular: 'https://fonts.gstatic.com/s/jollylodger/v20/BXRsvFTAh_bGkA1uQ48dlB3VXOrT3ZyuqA.woff2',
    },
  },
  {
    family: 'Tektur',
    files: {
      '500': 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrwcVYtLY8P7TWd0.woff2',
      '600': 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrzwUotLY8P7TWd0.woff2',
      '700': 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrzJUotLY8P7TWd0.woff2',
      '800': 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TryuUotLY8P7TWd0.woff2',
      '900': 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TryHUotLY8P7TWd0.woff2',
      regular: 'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrwuVYtLY8P7TWd0.woff2',
    },
  },
  {
    family: 'Smythe',
    files: {
      regular: 'https://fonts.gstatic.com/s/smythe/v23/MwQ3bhT01--coT1BPbh_uGInjA.woff2',
    },
  },
  {
    family: 'Finlandica',
    files: {
      '500': 'https://fonts.gstatic.com/s/finlandica/v8/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19AJrEj09i5ss3a3.woff2',
      '600': 'https://fonts.gstatic.com/s/finlandica/v8/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19Dlq0j09i5ss3a3.woff2',
      '700': 'https://fonts.gstatic.com/s/finlandica/v8/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19Dcq0j09i5ss3a3.woff2',
      regular: 'https://fonts.gstatic.com/s/finlandica/v8/-nFsOGk-8vAc7lEtg0aSyZCty9GSsPBE19A7rEj09i5ss3a3.woff2',
    },
  },
  {
    family: 'Anta',
    files: {
      regular: 'https://fonts.gstatic.com/s/anta/v1/gyBzhwQ3KsIyZFkxPFimIo0.woff2',
    },
  },
  {
    family: 'Kaisei HarunoUmi',
    files: {
      '500': 'https://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_WiZQSLqBQoAHhK_C6N_nzy_jcIj_QlMIFwmC9FAU.woff2',
      '700': 'https://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_WiZQSLqBQoAHhK_C6N_nzy_jcInfWlMIFwmC9FAU.woff2',
      regular: 'https://fonts.gstatic.com/s/kaiseiharunoumi/v8/HI_RiZQSLqBQoAHhK_C6N_nzy_jcGs75sM8u3mk.woff2',
    },
  },
  {
    family: 'IM Fell French Canon SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellfrenchcanonsc/v22/FBVmdCru5-ifcor2bgq9V89khWcmQghEURY7H3cxUBCVIVqH.woff2',
    },
  },
  {
    family: 'Fasthand',
    files: {
      regular: 'https://fonts.gstatic.com/s/fasthand/v30/0yb9GDohyKTYn_ZEESkrYkw2rQg1.woff2',
    },
  },
  {
    family: 'Sedgwick Ave Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/sedgwickavedisplay/v21/xfuu0XPgU3jZPUoUo3ScvmPi-NapQ8OxM2c2d-YnOzUD.woff2',
    },
  },
  {
    family: 'Waterfall',
    files: {
      regular: 'https://fonts.gstatic.com/s/waterfall/v6/MCoRzAfo293fACdFKcwY37H8D_EZwA.woff2',
    },
  },
  {
    family: 'Delicious Handrawn',
    files: {
      regular: 'https://fonts.gstatic.com/s/delicioushandrawn/v8/wlpsgx_NAUNkpmKQifcxkQchDFo3fJ112ZpDd6u3AQ.woff2',
    },
  },
  {
    family: 'Srisakdi',
    files: {
      '700': 'https://fonts.gstatic.com/s/srisakdi/v16/yMJWMIlvdpDbkB0A-gIAUgh0oNFxW0Hz.woff2',
      regular: 'https://fonts.gstatic.com/s/srisakdi/v16/yMJRMIlvdpDbkB0A-jq5fSx5i814.woff2',
    },
  },
  {
    family: 'Offside',
    files: {
      regular: 'https://fonts.gstatic.com/s/offside/v24/HI_KiYMWKa9QrAykQ5TiRp-dhpQ.woff2',
    },
  },
  {
    family: 'Kotta One',
    files: {
      regular: 'https://fonts.gstatic.com/s/kottaone/v20/S6u_w41LXzPc_jlfNWqPGQ3s5dwt7w.woff2',
    },
  },
  {
    family: 'Akaya Kanadaka',
    files: {
      regular: 'https://fonts.gstatic.com/s/akayakanadaka/v16/N0bM2S5CPO5oOQqvazoRRb-8-PfUS5VBBSSF.woff2',
    },
  },
  {
    family: 'Nova Slim',
    files: {
      regular: 'https://fonts.gstatic.com/s/novaslim/v24/Z9XUDmZNQAuem8jyZcn-zcOInrib9Q.woff2',
    },
  },
  {
    family: 'Kenia',
    files: {
      regular: 'https://fonts.gstatic.com/s/kenia/v28/jizURE5PuHQH9qCLNUGswfGM.woff2',
    },
  },
  {
    family: 'Margarine',
    files: {
      regular: 'https://fonts.gstatic.com/s/margarine/v25/qkBXXvoE6trLT9Y7YLye4ZRLkAXbMQ.woff2',
    },
  },
  {
    family: 'Redacted',
    files: {
      regular: 'https://fonts.gstatic.com/s/redacted/v8/Z9XVDmdRShme2O_7aITb4u2El6GC.woff2',
    },
  },
  {
    family: 'Moon Dance',
    files: {
      regular: 'https://fonts.gstatic.com/s/moondance/v6/WBLgrEbUbFlYW9ekmGawe2DiKMiokE4.woff2',
    },
  },
  {
    family: 'Caesar Dressing',
    files: {
      regular: 'https://fonts.gstatic.com/s/caesardressing/v21/yYLx0hLa3vawqtwdswbotmK4vrR3dLb6LZttyg.woff2',
    },
  },
  {
    family: 'Beth Ellen',
    files: {
      regular: 'https://fonts.gstatic.com/s/bethellen/v17/WwkbxPW2BE-3rb_JNT-qEIUiVNo5xNY.woff2',
    },
  },
  {
    family: 'Donegal One',
    files: {
      regular: 'https://fonts.gstatic.com/s/donegalone/v21/m8JWjfRYea-ZnFz6fsK9FZRARG-K3Mud.woff2',
    },
  },
  {
    family: 'IM Fell Great Primer SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfellgreatprimersc/v21/ga6daxBOxyt6sCqz3fjZCTFCTUDMHagsQKdDTLf4BXz0s8FG.woff2',
    },
  },
  {
    family: 'Underdog',
    files: {
      regular: 'https://fonts.gstatic.com/s/underdog/v23/CHygV-jCElj7diMroVSnU14GN2Il.woff2',
    },
  },
  {
    family: 'Stoke',
    files: {
      '300': 'https://fonts.gstatic.com/s/stoke/v24/z7NXdRb7aTMfKNvFVgxH_pjcTeWU.woff2',
      regular: 'https://fonts.gstatic.com/s/stoke/v24/z7NadRb7aTMfKONsfihK1YTV.woff2',
    },
  },
  {
    family: 'Bungee Hairline',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungeehairline/v22/snfys0G548t04270a_ljTLUVrv-7ZR2dQ5ZPqQ.woff2',
    },
  },
  {
    family: 'Passions Conflict',
    files: {
      regular: 'https://fonts.gstatic.com/s/passionsconflict/v7/kmKnZrcrFhfafnWX9x0GuEC-zowow5NbYRI4CN2V.woff2',
    },
  },
  {
    family: 'Spline Sans Mono',
    files: {
      '300': 'https://fonts.gstatic.com/s/splinesansmono/v10/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGA8MrtQy4d4dGb1.woff2',
      '500': 'https://fonts.gstatic.com/s/splinesansmono/v10/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGBQMrtQy4d4dGb1.woff2',
      '600': 'https://fonts.gstatic.com/s/splinesansmono/v10/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGC8NbtQy4d4dGb1.woff2',
      '700': 'https://fonts.gstatic.com/s/splinesansmono/v10/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGCFNbtQy4d4dGb1.woff2',
      regular: 'https://fonts.gstatic.com/s/splinesansmono/v10/R70MjzAei_CDNLfgZxrW6wrZOF2WdZ6xabUGSVtNuGBiMrtQy4d4dGb1.woff2',
    },
  },
  {
    family: 'Astloch',
    files: {
      '700': 'https://fonts.gstatic.com/s/astloch/v26/TuGUUVJ8QI5GSeUjk2A-6MZPA10xLMQ.woff2',
      regular: 'https://fonts.gstatic.com/s/astloch/v26/TuGRUVJ8QI5GSeUjq9kRzMtkH1Q.woff2',
    },
  },
  {
    family: 'Stick No Bills',
    files: {
      '200': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVP8Q7L7iwKhcTKA.woff2',
      '300': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcV4cQ7L7iwKhcTKA.woff2',
      '500': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVjcQ7L7iwKhcTKA.woff2',
      '600': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVYcM7L7iwKhcTKA.woff2',
      '700': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVWMM7L7iwKhcTKA.woff2',
      '800': 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVP8M7L7iwKhcTKA.woff2',
      regular: 'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVv8Q7L7iwKhcTKA.woff2',
    },
  },
  {
    family: 'Arbutus',
    files: {
      regular: 'https://fonts.gstatic.com/s/arbutus/v28/NaPYcZ7dG_5J3poob9dtryO8fMU.woff2',
    },
  },
  {
    family: 'Mohave',
    files: {
      '300': 'https://fonts.gstatic.com/s/mohave/v9/7cH0v4ksjJunKqMVAOPIMOeSmiojdif_HvWQopLSvBk.woff2',
      '500': 'https://fonts.gstatic.com/s/mohave/v9/7cH0v4ksjJunKqMVAOPIMOeSmiojdkv_HvWQopLSvBk.woff2',
      '600': 'https://fonts.gstatic.com/s/mohave/v9/7cH0v4ksjJunKqMVAOPIMOeSmiojdqf4HvWQopLSvBk.woff2',
      '700': 'https://fonts.gstatic.com/s/mohave/v9/7cH0v4ksjJunKqMVAOPIMOeSmiojdp74HvWQopLSvBk.woff2',
      regular: 'https://fonts.gstatic.com/s/mohave/v9/7cH0v4ksjJunKqMVAOPIMOeSmiojdnn_HvWQopLSvBk.woff2',
    },
  },
  {
    family: 'Ysabeau Office',
    files: {
      '100': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbh6IfZCfpQj7IGQ.woff2',
      '200': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbB6MfZCfpQj7IGQ.woff2',
      '300': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPb2aMfZCfpQj7IGQ.woff2',
      '500': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbtaMfZCfpQj7IGQ.woff2',
      '600': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbWaQfZCfpQj7IGQ.woff2',
      '700': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbYKQfZCfpQj7IGQ.woff2',
      '800': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbB6QfZCfpQj7IGQ.woff2',
      '900': 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbLqQfZCfpQj7IGQ.woff2',
      regular: 'https://fonts.gstatic.com/s/ysabeauoffice/v2/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbh6MfZCfpQj7IGQ.woff2',
    },
  },
  {
    family: 'IM Fell Double Pica SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/imfelldoublepicasc/v21/neIazDmuiMkFo6zj_sHpQ8teNbWlwBB_hXjJ4YgEeru2dGg.woff2',
    },
  },
  {
    family: 'Eagle Lake',
    files: {
      regular: 'https://fonts.gstatic.com/s/eaglelake/v24/ptRMTiqbbuNJDOiKj9wG5OvyKQNute8.woff2',
    },
  },
  {
    family: 'Charis SIL',
    files: {
      '700': 'https://fonts.gstatic.com/s/charissil/v2/oPWJ_kV3l-s-Q8govXvKlEbJRjtdQnSX1ko.woff2',
      regular: 'https://fonts.gstatic.com/s/charissil/v2/oPWK_kV3l-s-Q8govXvKrP_mYjZ2Xn0.woff2',
    },
  },
  {
    family: 'Text Me One',
    files: {
      regular: 'https://fonts.gstatic.com/s/textmeone/v24/i7dOIFdlayuLUvgoFvHQFWZZalayGhyV.woff2',
    },
  },
  {
    family: 'Piazzolla',
    files: {
      '100': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYx3L31AHfAAy5.woff2',
      '200': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JYxnL31AHfAAy5.woff2',
      '300': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7KGxnL31AHfAAy5.woff2',
      '500': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LqxnL31AHfAAy5.woff2',
      '600': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7IGwXL31AHfAAy5.woff2',
      '700': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7I_wXL31AHfAAy5.woff2',
      '800': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JYwXL31AHfAAy5.woff2',
      '900': 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JxwXL31AHfAAy5.woff2',
      regular: 'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYxnL31AHfAAy5.woff2',
    },
  },
  {
    family: 'Shippori Antique B1',
    files: {
      regular: 'https://fonts.gstatic.com/s/shipporiantiqueb1/v8/2Eb7L_JwClR7Zl_UAKZ0mUHw3oMKd40grRRCj9-5Y8Y.woff2',
    },
  },
  {
    family: 'Black And White Picture',
    files: {
      regular: 'https://fonts.gstatic.com/s/blackandwhitepicture/v24/TwMe-JAERlQd3ooUHBUXGmrmioKjjnRSFO-NqI5CbcMi-yWY.woff2',
    },
  },
  {
    family: 'Carattere',
    files: {
      regular: 'https://fonts.gstatic.com/s/carattere/v7/4iCv6Kp1b9dXlgt_CkvTsmaMH4V_gg.woff2',
    },
  },
  {
    family: 'Poor Story',
    files: {
      regular: 'https://fonts.gstatic.com/s/poorstory/v20/jizfREFUsnUct9P6cDfd4OynLD0Z4zM.woff2',
    },
  },
  {
    family: 'Girassol',
    files: {
      regular: 'https://fonts.gstatic.com/s/girassol/v22/JTUUjIo_-DK48laaNC9Iz2pJzxbi.woff2',
    },
  },
  {
    family: 'Khmer',
    files: {
      regular: 'https://fonts.gstatic.com/s/khmer/v29/MjQImit_vPPwpF-EpN2EeYmD.woff2',
    },
  },
  {
    family: 'Miltonian Tattoo',
    files: {
      regular: 'https://fonts.gstatic.com/s/miltoniantattoo/v32/EvOUzBRL0o0kCxF-lcMCQxlpVsA_Fwb8MDBku-s.woff2',
    },
  },
  {
    family: 'The Nautigal',
    files: {
      '700': 'https://fonts.gstatic.com/s/thenautigal/v6/VdGGAZ8ZH51Lvng9fQV2bfKTWypA3v-C7LoS7g.woff2',
      regular: 'https://fonts.gstatic.com/s/thenautigal/v6/VdGZAZ8ZH51Lvng9fQV2bfKr4gVk09Se5Q.woff2',
    },
  },
  {
    family: 'Molle',
    files: {},
  },
  {
    family: 'Nova Cut',
    files: {
      regular: 'https://fonts.gstatic.com/s/novacut/v24/KFOkCnSYu8mL-39LkWxKKTM1K9nz.woff2',
    },
  },
  {
    family: 'Anek Tamil',
    files: {
      '100': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQiZ6rov4oegjOQ.woff2',
      '200': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNwid6rov4oegjOQ.woff2',
      '300': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNHCd6rov4oegjOQ.woff2',
      '500': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNcCd6rov4oegjOQ.woff2',
      '600': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNnCB6rov4oegjOQ.woff2',
      '700': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNpSB6rov4oegjOQ.woff2',
      '800': 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNwiB6rov4oegjOQ.woff2',
      regular: 'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQid6rov4oegjOQ.woff2',
    },
  },
  {
    family: 'Junge',
    files: {
      regular: 'https://fonts.gstatic.com/s/junge/v24/gokgH670Gl1lUqAYvhB7SnKm.woff2',
    },
  },
  {
    family: 'Keania One',
    files: {
      regular: 'https://fonts.gstatic.com/s/keaniaone/v24/zOL54pXJk65E8pXardnuycFuv-hHkOs.woff2',
    },
  },
  {
    family: 'Sarina',
    files: {
      regular: 'https://fonts.gstatic.com/s/sarina/v23/-F6wfjF3ITQwasLhK0DUriBQxw.woff2',
    },
  },
  {
    family: 'Nova Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/novascript/v25/7Au7p_IpkSWSTWaFWkumvmQIEl0O0kEx.woff2',
    },
  },
  {
    family: 'Cagliostro',
    files: {
      regular: 'https://fonts.gstatic.com/s/cagliostro/v21/ZgNWjP5HM73BV5amnX-TjGDEM4COoE4.woff2',
    },
  },
  {
    family: 'Birthstone Bounce',
    files: {
      '500': 'https://fonts.gstatic.com/s/birthstonebounce/v11/ga6SaxZF43lIvTWrktHOTBJZGH7dEd29MacVJZP1LmD9.woff2',
      regular: 'https://fonts.gstatic.com/s/birthstonebounce/v11/ga6XaxZF43lIvTWrktHOTBJZGH7dEeVMGIMYDo_8.woff2',
    },
  },
  {
    family: 'Nova Oval',
    files: {
      regular: 'https://fonts.gstatic.com/s/novaoval/v24/jAnEgHdmANHvPenMaswCNI-h3cWkWg.woff2',
    },
  },
  {
    family: 'Tilt Prism',
    files: {
      regular: 'https://fonts.gstatic.com/s/tiltprism/v11/5h11iZgyPHoZ3YikNzWGfWey2dCAZXT-bH9V4VGn-FJ7tLI25oc_rIbwpDSrn86NKw.woff2',
    },
  },
  {
    family: 'Dorsa',
    files: {
      regular: 'https://fonts.gstatic.com/s/dorsa/v27/yYLn0hjd0OGwqo443XCFxAnQ.woff2',
    },
  },
  {
    family: 'AR One Sans',
    files: {
      '500': 'https://fonts.gstatic.com/s/aronesans/v4/TUZezwhrmbFp0Srr_tH6fv6RcUejHO_u7GF5aXfv-U2QzBLF6gslWk39DWg3no5mBF4.woff2',
      '600': 'https://fonts.gstatic.com/s/aronesans/v4/TUZezwhrmbFp0Srr_tH6fv6RcUejHO_u7GF5aXfv-U2QzBLF6gslWqH6DWg3no5mBF4.woff2',
      '700': 'https://fonts.gstatic.com/s/aronesans/v4/TUZezwhrmbFp0Srr_tH6fv6RcUejHO_u7GF5aXfv-U2QzBLF6gslWpj6DWg3no5mBF4.woff2',
      regular: 'https://fonts.gstatic.com/s/aronesans/v4/TUZezwhrmbFp0Srr_tH6fv6RcUejHO_u7GF5aXfv-U2QzBLF6gslWn_9DWg3no5mBF4.woff2',
    },
  },
  {
    family: 'Miltonian',
    files: {
      regular: 'https://fonts.gstatic.com/s/miltonian/v30/zOL-4pbPn6Ne9JqTg9mr7O5As-FeiQ.woff2',
    },
  },
  {
    family: 'Zhi Mang Xing',
    files: {
      regular: 'https://fonts.gstatic.com/s/zhimangxing/v17/f0Xw0ey79sErYFtWQ9a2rq-g0aItfektIJ0.woff2',
    },
  },
  {
    family: 'Stint Ultra Expanded',
    files: {
      regular: 'https://fonts.gstatic.com/s/stintultraexpanded/v22/CSRg4yNNh-GbW3o3JkwoDcdvMKMf0oBAd0qtATQkWwam.woff2',
    },
  },
  {
    family: 'Inika',
    files: {
      '700': 'https://fonts.gstatic.com/s/inika/v21/rnCr-x5X3QP-pix7auM7mHnOSOuk.woff2',
      regular: 'https://fonts.gstatic.com/s/inika/v21/rnCm-x5X3QP-phTCRcc2s2XH.woff2',
    },
  },
  {
    family: 'Chilanka',
    files: {
      regular: 'https://fonts.gstatic.com/s/chilanka/v20/WWXRlj2DZQiMJYaYRrJVI9EAZhTO.woff2',
    },
  },
  {
    family: 'Bilbo',
    files: {
      regular: 'https://fonts.gstatic.com/s/bilbo/v20/o-0EIpgpwWwZ210kpIRz4wxE.woff2',
    },
  },
  {
    family: 'Kumar One',
    files: {
      regular: 'https://fonts.gstatic.com/s/kumarone/v21/bMr1mS-P958wYi6YaGeGMe6WU3oT0g.woff2',
    },
  },
  {
    family: 'Felipa',
    files: {
      regular: 'https://fonts.gstatic.com/s/felipa/v25/FwZa7-owz1Eu4F_wTdSEwM2zpA.woff2',
    },
  },
  {
    family: 'Marko One',
    files: {
      regular: 'https://fonts.gstatic.com/s/markoone/v22/9Btq3DFG0cnVM5lw1haaL5UfrHPzUw.woff2',
    },
  },
  {
    family: 'Kavoon',
    files: {
      regular: 'https://fonts.gstatic.com/s/kavoon/v23/pxiFyp4_scRYhlU4Mbr6f1pdEQ.woff2',
    },
  },
  {
    family: 'Mrs Sheppards',
    files: {
      regular: 'https://fonts.gstatic.com/s/mrssheppards/v23/PN_2Rfm9snC0XUGoEZhb91ig3v3xynMix4Y.woff2',
    },
  },
  {
    family: 'Sahitya',
    files: {
      '700': 'https://fonts.gstatic.com/s/sahitya/v17/6qLFKZkOuhnuqlJAUZsqGyEvEnvSexI.woff2',
      regular: 'https://fonts.gstatic.com/s/sahitya/v17/6qLAKZkOuhnuqlJAaSIFPywEDnI.woff2',
    },
  },
  {
    family: 'Trispace',
    files: {
      '100': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9qoQx0zHugpt0.woff2',
      '200': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbP9roQx0zHugpt0.woff2',
      '300': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbCFroQx0zHugpt0.woff2',
      '500': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbE1roQx0zHugpt0.woff2',
      '600': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbKFsoQx0zHugpt0.woff2',
      '700': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbJhsoQx0zHugpt0.woff2',
      '800': 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbP9soQx0zHugpt0.woff2',
      regular: 'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9roQx0zHugpt0.woff2',
    },
  },
  {
    family: 'Chicle',
    files: {
      regular: 'https://fonts.gstatic.com/s/chicle/v25/lJwG-pw9i2dqU-BDzGKuobYSxw.woff2',
    },
  },
  {
    family: 'New Rocker',
    files: {
      regular: 'https://fonts.gstatic.com/s/newrocker/v16/MwQzbhjp3-HImzcCU_cJkGYViblPtXs.woff2',
    },
  },
  {
    family: 'Condiment',
    files: {
      regular: 'https://fonts.gstatic.com/s/condiment/v24/pONk1hggFNmwvXALyH6Sron4o1vyCQ.woff2',
    },
  },
  {
    family: 'Noto Sans Thai Looped',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50fF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3YX6AdeCT_Wfd1.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Y84E4VwrzUO5sKA.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yl4I4VwrzUO5sKA.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yz4M4VwrzUO5sKA.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Y44Q4VwrzUO5sKA.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yh4U4VwrzUO5sKA.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Ym4Y4VwrzUO5sKA.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yv4c4VwrzUO5sKA.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansthailooped/v14/B50RF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3gPqocWiHvWQ.woff2',
    },
  },
  {
    family: 'Long Cang',
    files: {
      regular: 'https://fonts.gstatic.com/s/longcang/v17/LYjAdGP8kkgoTec8zkRgqHArXN7HWQ.woff2',
    },
  },
  {
    family: 'Wellfleet',
    files: {
      regular: 'https://fonts.gstatic.com/s/wellfleet/v22/nuF7D_LfQJb3VYgX6eyT5maLDhO2HA.woff2',
    },
  },
  {
    family: 'Noto Sans Math',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmath/v15/7Aump_cpkSecTWaHRlH2hyV5UHkD-V048PW0.woff2',
    },
  },
  {
    family: 'Smooch',
    files: {
      regular: 'https://fonts.gstatic.com/s/smooch/v7/o-0LIps4xW8U1xUBi6p_6hVdYg.woff2',
    },
  },
  {
    family: 'Aoboshi One',
    files: {
      regular: 'https://fonts.gstatic.com/s/aoboshione/v10/Gg8xN5kXaAXtHQrFxwl10ysOBmZX_UEg.woff2',
    },
  },
  {
    family: 'Akatab',
    files: {
      '500': 'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3rKXdOaNiaRpFvg.woff2',
      '600': 'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3gKLdOaNiaRpFvg.woff2',
      '700': 'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE35KPdOaNiaRpFvg.woff2',
      '800': 'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3-KDdOaNiaRpFvg.woff2',
      '900': 'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE33KHdOaNiaRpFvg.woff2',
      regular: 'https://fonts.gstatic.com/s/akatab/v7/VuJwdNrK3Z7gqJEPXYz5NIh-YA.woff2',
    },
  },
  {
    family: 'Beau Rivage',
    files: {
      regular: 'https://fonts.gstatic.com/s/beaurivage/v2/UcCi3FIgIG2bH4mMNWJUlmgyNZp8K2sL.woff2',
    },
  },
  {
    family: 'Averia Gruesa Libre',
    files: {
      regular: 'https://fonts.gstatic.com/s/averiagruesalibre/v22/NGSov4nEGEktOaDRKsY-1dhh8eEtIx3ZUmyJw0SLRA8.woff2',
    },
  },
  {
    family: 'Comforter',
    files: {
      regular: 'https://fonts.gstatic.com/s/comforter/v7/H4clBXOCl8nQnlaql3Qa7ZG8iqeuag.woff2',
    },
  },
  {
    family: 'Unlock',
    files: {
      regular: 'https://fonts.gstatic.com/s/unlock/v26/7Au-p_8ykD-cDl7GLQjSwkUVOQ.woff2',
    },
  },
  {
    family: 'Train One',
    files: {
      regular: 'https://fonts.gstatic.com/s/trainone/v13/gyB-hwkiNtc6KnxUVjWHP6bZRY7JVQ.woff2',
    },
  },
  {
    family: 'Kavivanar',
    files: {
      regular: 'https://fonts.gstatic.com/s/kavivanar/v20/o-0IIpQgyXYSwhxP7_Jb5z5Ba_2c7A.woff2',
    },
  },
  {
    family: 'Simonetta',
    files: {
      '900': 'https://fonts.gstatic.com/s/simonetta/v27/x3dnckHVYrCU5BU15c45-N0msgTpDQIrGg.woff2',
      regular: 'https://fonts.gstatic.com/s/simonetta/v27/x3dickHVYrCU5BU15c4BefACvy_1BA.woff2',
    },
  },
  {
    family: 'Linden Hill',
    files: {
      regular: 'https://fonts.gstatic.com/s/lindenhill/v24/-F61fjxoKSg9Yc3hZgO8ygFN7CwC009k.woff2',
    },
  },
  {
    family: 'Buda',
    files: {
      '300': 'https://fonts.gstatic.com/s/buda/v29/GFDqWAN8mnyIJSSrG7ABr7pZKA0.woff2',
    },
  },
  {
    family: 'Liu Jian Mao Cao',
    files: {
      regular: 'https://fonts.gstatic.com/s/liujianmaocao/v20/845DNN84HJrccNonurqXILGpvCOofe_VKGWsUo8.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Thai Looped',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss5AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_HaKoXOtFCQ76Q.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_NqrhFyDGC0i8Cc.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_L6ohFyDGC0i8Cc.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_OaphFyDGC0i8Cc.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_MquhFyDGC0i8Cc.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss6AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30L_K6vhFyDGC0i8Cc.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsansthailooped/v11/tss_AoJJRAhL3BTrK3r2xxbFhvKfyBB6l7hHT30LxBeAoFGoBCQ.woff2',
    },
  },
  {
    family: 'Spirax',
    files: {
      regular: 'https://fonts.gstatic.com/s/spirax/v21/buE3poKgYNLy0F3cW0tt-Csn-Q.woff2',
    },
  },
  {
    family: 'Fascinate',
    files: {
      regular: 'https://fonts.gstatic.com/s/fascinate/v21/z7NWdRrufC8XJK0IIEli0bbQRPyNrw.woff2',
    },
  },
  {
    family: 'Ruluko',
    files: {
      regular: 'https://fonts.gstatic.com/s/ruluko/v21/xMQVuFNZVaODtm0pDqWzKX_QmA.woff2',
    },
  },
  {
    family: 'Vampiro One',
    files: {
      regular: 'https://fonts.gstatic.com/s/vampiroone/v18/gokqH6DoDl5yXvJytFsdLkqisvhIor3K.woff2',
    },
  },
  {
    family: 'Gentium Plus',
    files: {
      '700': 'https://fonts.gstatic.com/s/gentiumplus/v2/IurC6Ytw-oSPaZ00r2bNe8VRMLRo5UYx_ofHsw.woff2',
      regular: 'https://fonts.gstatic.com/s/gentiumplus/v2/Iurd6Ytw-oSPaZ00r2bNe8VpiZtM6G0t9w.woff2',
    },
  },
  {
    family: 'Seymour One',
    files: {
      regular: 'https://fonts.gstatic.com/s/seymourone/v23/4iCp6Khla9xbjQpoWGGd0myNPYBvgpUI.woff2',
    },
  },
  {
    family: 'BIZ UDMincho',
    files: {
      '700': 'https://fonts.gstatic.com/s/bizudmincho/v9/EJROQgI6eOxFjBdKs38yhtWNyyvfoOFE-IyCrw.woff2',
      regular: 'https://fonts.gstatic.com/s/bizudmincho/v9/EJRRQgI6eOxFjBdKs38yhtW1cgT7rcpY8Q.woff2',
    },
  },
  {
    family: 'New Tegomin',
    files: {
      regular: 'https://fonts.gstatic.com/s/newtegomin/v10/SLXMc1fV7Gd9USdBAfPlqfNxQ3ptkDMN.woff2',
    },
  },
  {
    family: 'Tulpen One',
    files: {
      regular: 'https://fonts.gstatic.com/s/tulpenone/v25/dFa6ZfeC474skLgesc0CWjgw_HyIRlE.woff2',
    },
  },
  {
    family: 'Jacques Francois',
    files: {
      regular: 'https://fonts.gstatic.com/s/jacquesfrancois/v24/ZXu9e04ZvKeOOHIe1TMahbcIU2cgmcbqoeRWfbs.woff2',
    },
  },
  {
    family: 'Englebert',
    files: {
      regular: 'https://fonts.gstatic.com/s/englebert/v21/xn7iYH8w2XGrC8AR4HSxSvfYdN-WZw.woff2',
    },
  },
  {
    family: 'Noto Sans Gothic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansgothic/v16/TuGKUUVzXI5FBtUq5a8bj6wRbzxTFMD40kFQRx0.woff2',
    },
  },
  {
    family: 'Kirang Haerang',
    files: {
      regular: 'https://fonts.gstatic.com/s/kiranghaerang/v20/E21-_dn_gvvIjhYON1lpIU4-bcqqWPaJq4no.woff2',
    },
  },
  {
    family: 'Qahiri',
    files: {
      regular: 'https://fonts.gstatic.com/s/qahiri/v9/tsssAp1RZy0C_hGuVnChrnmupw.woff2',
    },
  },
  {
    family: 'Edu NSW ACT Foundation',
    files: {
      '500': 'https://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki9fovGOeC-sfguJ.woff2',
      '600': 'https://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki-zpfGOeC-sfguJ.woff2',
      '700': 'https://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki-KpfGOeC-sfguJ.woff2',
      regular: 'https://fonts.gstatic.com/s/edunswactfoundation/v2/raxRHjqJtsNBFUi8WO0vUBgc9D-2lV_oQdCAYlt_QTQ0vUxJki9tovGOeC-sfguJ.woff2',
    },
  },
  {
    family: 'Texturina',
    files: {
      '100': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYG_Ul25riW1OD.woff2',
      '200': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cYGvUl25riW1OD.woff2',
      '300': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2fGGvUl25riW1OD.woff2',
      '500': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eqGvUl25riW1OD.woff2',
      '600': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2dGHfUl25riW1OD.woff2',
      '700': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2d_HfUl25riW1OD.woff2',
      '800': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cYHfUl25riW1OD.woff2',
      '900': 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cxHfUl25riW1OD.woff2',
      regular: 'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYGvUl25riW1OD.woff2',
    },
  },
  {
    family: 'Belanosima',
    files: {
      '600': 'https://fonts.gstatic.com/s/belanosima/v3/3y9n6bI8ejDo_3MfCDSL_Nh1M39qn5cdJ-4.woff2',
      '700': 'https://fonts.gstatic.com/s/belanosima/v3/3y9n6bI8ejDo_3MfCDSL_Lx0M39qn5cdJ-4.woff2',
      regular: 'https://fonts.gstatic.com/s/belanosima/v3/3y9k6bI8ejDo_3MfCDSLxAVbF3JBg54.woff2',
    },
  },
  {
    family: 'Rethink Sans',
    files: {
      '500': 'https://fonts.gstatic.com/s/rethinksans/v4/AMODz4SDuXOMCPfdoglY9JQuWHBGG0X45DmqklNRCEvmma-aua4.woff2',
      '600': 'https://fonts.gstatic.com/s/rethinksans/v4/AMODz4SDuXOMCPfdoglY9JQuWHBGG0X45Dmqkr9WCEvmma-aua4.woff2',
      '700': 'https://fonts.gstatic.com/s/rethinksans/v4/AMODz4SDuXOMCPfdoglY9JQuWHBGG0X45DmqkoZWCEvmma-aua4.woff2',
      '800': 'https://fonts.gstatic.com/s/rethinksans/v4/AMODz4SDuXOMCPfdoglY9JQuWHBGG0X45DmqkuFWCEvmma-aua4.woff2',
      regular: 'https://fonts.gstatic.com/s/rethinksans/v4/AMODz4SDuXOMCPfdoglY9JQuWHBGG0X45DmqkmFRCEvmma-aua4.woff2',
    },
  },
  {
    family: 'Playpen Sans',
    files: {
      '100': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IvRgunE9Ffmme0w.woff2',
      '200': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4InRhunE9Ffmme0w.woff2',
      '300': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IqphunE9Ffmme0w.woff2',
      '500': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IsZhunE9Ffmme0w.woff2',
      '600': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IipmunE9Ffmme0w.woff2',
      '700': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IhNmunE9Ffmme0w.woff2',
      '800': 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4InRmunE9Ffmme0w.woff2',
      regular: 'https://fonts.gstatic.com/s/playpensans/v6/dg43_pj1p6gXP0gzAZgm4c8XQArSU7ACQSn4IvRhunE9Ffmme0w.woff2',
    },
  },
  {
    family: 'Chathura',
    files: {
      '100': 'https://fonts.gstatic.com/s/chathura/v20/_gP91R7-rzUuVjim42dEq0GbTvZyuDo.woff2',
      '300': 'https://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42eMiWS0YPp7oSNy.woff2',
      '700': 'https://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42ecjmS0YPp7oSNy.woff2',
      '800': 'https://fonts.gstatic.com/s/chathura/v20/_gP81R7-rzUuVjim42eAjWS0YPp7oSNy.woff2',
      regular: 'https://fonts.gstatic.com/s/chathura/v20/_gP71R7-rzUuVjim418loUC5S-Zy.woff2',
    },
  },
  {
    family: 'Noto Sans Buhid',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansbuhid/v22/Dxxy8jiXMW75w3OmoDXVWJD7YwzAfqtgnaFoGA.woff2',
    },
  },
  {
    family: 'Ravi Prakash',
    files: {
      regular: 'https://fonts.gstatic.com/s/raviprakash/v19/gokpH6fsDkVrF9Bv9X8SOAKHndZEq6TTFw.woff2',
    },
  },
  {
    family: 'Autour One',
    files: {
      regular: 'https://fonts.gstatic.com/s/autourone/v24/UqyVK80cP25l3fJgbdfbk5xWVscxdKE.woff2',
    },
  },
  {
    family: 'Libre Barcode 39 Extended',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcode39extended/v27/8At7Gt6_O5yNS0-K4Nf5U922qSzhJ3dUdfJpwNUgfNFCOZ1GOBw.woff2',
    },
  },
  {
    family: 'Benne',
    files: {
      regular: 'https://fonts.gstatic.com/s/benne/v22/L0xzDFAhn18E6Vj0lt6qTDBN.woff2',
    },
  },
  {
    family: 'Galindo',
    files: {
      regular: 'https://fonts.gstatic.com/s/galindo/v24/HI_KiYMeLqVKqwyuQ5TiRp-dhpQ.woff2',
    },
  },
  {
    family: 'Yeon Sung',
    files: {
      regular: 'https://fonts.gstatic.com/s/yeonsung/v20/QldMNTpbohAGtsJvUn6xTFNazqx2xg.woff2',
    },
  },
  {
    family: 'Odor Mean Chey',
    files: {
      regular: 'https://fonts.gstatic.com/s/odormeanchey/v27/raxkHiKDttkTe1aOGcJMR1A_4mrd2zqUKafv.woff2',
    },
  },
  {
    family: 'Gentium Book Plus',
    files: {
      '700': 'https://fonts.gstatic.com/s/gentiumbookplus/v1/vEFO2-RHBgUK5fbjKxRpbBtJPyRpocojWpbDhs_cfKe1.woff2',
      regular: 'https://fonts.gstatic.com/s/gentiumbookplus/v1/vEFL2-RHBgUK5fbjKxRpbBtJPyRpofKadbLOrdPV.woff2',
    },
  },
  {
    family: 'Imperial Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/imperialscript/v6/5DCPAKrpzy_H98IV2ISnZBbGrVNvOOnlvttWNg.woff2',
    },
  },
  {
    family: 'Kumar One Outline',
    files: {
      regular: 'https://fonts.gstatic.com/s/kumaroneoutline/v17/Noao6VH62pyLP0fsrZ-v18wlUEcX9zD1RQu8EGKF.woff2',
    },
  },
  {
    family: 'Anek Telugu',
    files: {
      '100': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y-_oEiG2ep10_8.woff2',
      '200': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i136--oEiG2ep10_8.woff2',
      '300': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i133G-oEiG2ep10_8.woff2',
      '500': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13x2-oEiG2ep10_8.woff2',
      '600': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13_G5oEiG2ep10_8.woff2',
      '700': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i138i5oEiG2ep10_8.woff2',
      '800': 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i136-5oEiG2ep10_8.woff2',
      regular: 'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y--oEiG2ep10_8.woff2',
    },
  },
  {
    family: 'Noto Sans Symbols 2',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssymbols2/v23/I_uyMoGduATTei9eI8daxVHDyfisHr71ypbqfX71-AI.woff2',
    },
  },
  {
    family: 'Elsie Swash Caps',
    files: {
      '900': 'https://fonts.gstatic.com/s/elsieswashcaps/v23/845ENN8xGZyVX5MVo_upKf7KnjK0RW74DGiHToawrdU.woff2',
      regular: 'https://fonts.gstatic.com/s/elsieswashcaps/v23/845DNN8xGZyVX5MVo_upKf7KnjK0fe_VKGWsUo8.woff2',
    },
  },
  {
    family: 'Koh Santepheap',
    files: {
      '100': 'https://fonts.gstatic.com/s/kohsantepheap/v11/gNMfW3p6SJbwyGj2rBZyeOrTjNuFHVmTtjNJUWU.woff2',
      '300': 'https://fonts.gstatic.com/s/kohsantepheap/v11/gNMeW3p6SJbwyGj2rBZyeOrTjNtNP3y8mD9ASHz5.woff2',
      '700': 'https://fonts.gstatic.com/s/kohsantepheap/v11/gNMeW3p6SJbwyGj2rBZyeOrTjNtdOHy8mD9ASHz5.woff2',
      '900': 'https://fonts.gstatic.com/s/kohsantepheap/v11/gNMeW3p6SJbwyGj2rBZyeOrTjNtlOny8mD9ASHz5.woff2',
      regular: 'https://fonts.gstatic.com/s/kohsantepheap/v11/gNMdW3p6SJbwyGj2rBZyeOrTjOPkF1ixsyNJ.woff2',
    },
  },
  {
    family: 'Joti One',
    files: {
      regular: 'https://fonts.gstatic.com/s/jotione/v26/Z9XVDmdJQAmWm9TwaYTb4u2El6GC.woff2',
    },
  },
  {
    family: 'Content',
    files: {
      '700': 'https://fonts.gstatic.com/s/content/v24/zrfg0HLayePhU_AwaRzdBi_fWCHvkAI.woff2',
      regular: 'https://fonts.gstatic.com/s/content/v24/zrfl0HLayePhU_AwUaXyIiL0RCg.woff2',
    },
  },
  {
    family: 'Climate Crisis',
    files: {
      regular: 'https://fonts.gstatic.com/s/climatecrisis/v8/wEOpEB3AntNeKCPBVW9XOKlmp3AUgWFN1DvIvcM0gFp6iKUrGb7PsQ.woff2',
    },
  },
  {
    family: 'Oldenburg',
    files: {
      regular: 'https://fonts.gstatic.com/s/oldenburg/v22/fC1jPY5JYWzbywv7c4V6VE6oXyndrw.woff2',
    },
  },
  {
    family: 'Sirin Stencil',
    files: {
      regular: 'https://fonts.gstatic.com/s/sirinstencil/v25/mem4YaWwznmLx-lzGfN7MdRydc1GBq6al6o.woff2',
    },
  },
  {
    family: 'Gulzar',
    files: {
      regular: 'https://fonts.gstatic.com/s/gulzar/v12/Wnz6HAc9eB3HB2ILZDwZqg_MPQ.woff2',
    },
  },
  {
    family: 'Yaldevi',
    files: {
      '200': 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpfxJzvtbxLCBJkS.woff2',
      '300': 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpcvJzvtbxLCBJkS.woff2',
      '500': 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpdDJzvtbxLCBJkS.woff2',
      '600': 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpevIDvtbxLCBJkS.woff2',
      '700': 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpeWIDvtbxLCBJkS.woff2',
      regular: 'https://fonts.gstatic.com/s/yaldevi/v12/cY9afj6VW0NMrDWtDNzCOwlPMq9SLpdxJzvtbxLCBJkS.woff2',
    },
  },
  {
    family: 'Risque',
    files: {
      regular: 'https://fonts.gstatic.com/s/risque/v22/VdGfAZUfHosahXxoDEYVBJ-T5g.woff2',
    },
  },
  {
    family: 'Protest Riot',
    files: {
      regular: 'https://fonts.gstatic.com/s/protestriot/v2/d6lPkaOxWMKm7TdezXFmpkrM0vJgjmRpOA.woff2',
    },
  },
  {
    family: 'Preahvihear',
    files: {
      regular: 'https://fonts.gstatic.com/s/preahvihear/v29/6NUS8F-dNQeEYhzj7uluxswB49FJf8Wv.woff2',
    },
  },
  {
    family: 'Plaster',
    files: {
      regular: 'https://fonts.gstatic.com/s/plaster/v24/DdTm79QatW80eRh4EitJOtLOeLI.woff2',
    },
  },
  {
    family: 'Romanesco',
    files: {
      regular: 'https://fonts.gstatic.com/s/romanesco/v21/w8gYH2ozQOY7_r_J7mSn2XwLqOqSBg.woff2',
    },
  },
  {
    family: 'Amiri Quran',
    files: {
      regular: 'https://fonts.gstatic.com/s/amiriquran/v14/_Xmo-Hk0rD6DbUL4_vH8Zq5o7Cycsu-2.woff2',
    },
  },
  {
    family: 'Atomic Age',
    files: {
      regular: 'https://fonts.gstatic.com/s/atomicage/v27/f0Xz0eug6sdmRFkYZZGL58Tt9a8GYeA.woff2',
    },
  },
  {
    family: 'Glass Antiqua',
    files: {
      regular: 'https://fonts.gstatic.com/s/glassantiqua/v24/xfu30Wr0Wn3NOQM2piC0uXOjnLrwN6fRUkY.woff2',
    },
  },
  {
    family: 'Sono',
    files: {
      '200': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVNkWdF3R4qYeB4Q.woff2',
      '300': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxV6EWdF3R4qYeB4Q.woff2',
      '500': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVhEWdF3R4qYeB4Q.woff2',
      '600': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVaEKdF3R4qYeB4Q.woff2',
      '700': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVUUKdF3R4qYeB4Q.woff2',
      '800': 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVNkKdF3R4qYeB4Q.woff2',
      regular: 'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVtkWdF3R4qYeB4Q.woff2',
    },
  },
  {
    family: 'Hanalei Fill',
    files: {
      regular: 'https://fonts.gstatic.com/s/hanaleifill/v22/fC1mPYtObGbfyQznIaQzPQiMUgLBplm9aw.woff2',
    },
  },
  {
    family: 'Grenze',
    files: {
      '100': 'https://fonts.gstatic.com/s/grenze/v15/O4ZRFGb7hR12BxqPm2ImuAkalnmd.woff2',
      '200': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPN0MDlycWn2CEyw.woff2',
      '300': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPU0ADlycWn2CEyw.woff2',
      '500': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPC0EDlycWn2CEyw.woff2',
      '600': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPJ0YDlycWn2CEyw.woff2',
      '700': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPQ0cDlycWn2CEyw.woff2',
      '800': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPX0QDlycWn2CEyw.woff2',
      '900': 'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPe0UDlycWn2CEyw.woff2',
      regular: 'https://fonts.gstatic.com/s/grenze/v15/O4ZTFGb7hR12Bxq3-mgnmgwKlg.woff2',
    },
  },
  {
    family: 'Ranga',
    files: {
      '700': 'https://fonts.gstatic.com/s/ranga/v21/C8cg4cYisGb28qY-AxgU6X2NZAn2.woff2',
      regular: 'https://fonts.gstatic.com/s/ranga/v21/C8ct4cYisGb28p6HLDwZwmGE.woff2',
    },
  },
  {
    family: 'Luxurious Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/luxuriousscript/v7/ahcCv9e7yydulT32KZ0rBIoD7DzMg0_Oby1JtYk.woff2',
    },
  },
  {
    family: 'Water Brush',
    files: {
      regular: 'https://fonts.gstatic.com/s/waterbrush/v4/AYCPpXPqc8cJWLhp4hywKHJv7PKP5Z_G.woff2',
    },
  },
  {
    family: 'Londrina Shadow',
    files: {
      regular: 'https://fonts.gstatic.com/s/londrinashadow/v26/oPWX_kB4kOQoWNJmjxLV5JuoCUlXQ1aSxkrMCQ.woff2',
    },
  },
  {
    family: 'Gupter',
    files: {
      '500': 'https://fonts.gstatic.com/s/gupter/v14/2-cl9JNmxJqPO1Qslb-bV8T5rZhaZg.woff2',
      '700': 'https://fonts.gstatic.com/s/gupter/v14/2-cl9JNmxJqPO1Qs3bmbV8T5rZhaZg.woff2',
      regular: 'https://fonts.gstatic.com/s/gupter/v14/2-cm9JNmxJqPO1QUZJa_Wu_lpA.woff2',
    },
  },
  {
    family: 'Bahiana',
    files: {
      regular: 'https://fonts.gstatic.com/s/bahiana/v23/uU9PCBUV4YenPWJU7xbb3vyHmlI.woff2',
    },
  },
  {
    family: 'DynaPuff',
    files: {
      '500': 'https://fonts.gstatic.com/s/dynapuff/v4/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RSyQu6Y3rSRs4wn8.woff2',
      '600': 'https://fonts.gstatic.com/s/dynapuff/v4/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RS8gp6Y3rSRs4wn8.woff2',
      '700': 'https://fonts.gstatic.com/s/dynapuff/v4/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RS_Ep6Y3rSRs4wn8.woff2',
      regular: 'https://fonts.gstatic.com/s/dynapuff/v4/z7N5dRvsZDIVHbYPMhZJ3HQ83UaSu4uhr7-ZFeoYkgAr1x8RSxYu6Y3rSRs4wn8.woff2',
    },
  },
  {
    family: 'Alumni Sans Inline One',
    files: {
      regular: 'https://fonts.gstatic.com/s/alumnisansinlineone/v5/RrQBbpJx9zZ3IXTBOASKp5gJAetBdaihcjbpD3UZcr7xbYw.woff2',
    },
  },
  {
    family: 'Ewert',
    files: {
      regular: 'https://fonts.gstatic.com/s/ewert/v25/va9I4kzO2tFODYBqS-J3kbDP.woff2',
    },
  },
  {
    family: 'Braah One',
    files: {
      regular: 'https://fonts.gstatic.com/s/braahone/v6/KFOlCnWUpt6LsxxxiylvBh05IsDqlA.woff2',
    },
  },
  {
    family: 'Smokum',
    files: {
      regular: 'https://fonts.gstatic.com/s/smokum/v28/TK3iWkUbAhopmrdGGzUHte5fKg.woff2',
    },
  },
  {
    family: 'Princess Sofia',
    files: {
      regular: 'https://fonts.gstatic.com/s/princesssofia/v25/qWczB6yguIb8DZ_GXZst16n7GRz-mDUoupoI.woff2',
    },
  },
  {
    family: 'Almendra SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/almendrasc/v29/Iure6Yx284eebowr7hbyTZZMprVA4XQ0.woff2',
    },
  },
  {
    family: 'Anek Gujarati',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5G7xkKgB7Lm7g.woff2',
      '200': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0l5C7xkKgB7Lm7g.woff2',
      '300': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0SZC7xkKgB7Lm7g.woff2',
      '500': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0JZC7xkKgB7Lm7g.woff2',
      '600': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0yZe7xkKgB7Lm7g.woff2',
      '700': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-08Je7xkKgB7Lm7g.woff2',
      '800': 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0l5e7xkKgB7Lm7g.woff2',
      regular: 'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5C7xkKgB7Lm7g.woff2',
    },
  },
  {
    family: 'Piedra',
    files: {
      regular: 'https://fonts.gstatic.com/s/piedra/v25/ke8kOg8aN0Bn7hTumUyHN_M3gA.woff2',
    },
  },
  {
    family: 'Big Shoulders Stencil Text',
    files: {
      '100':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04XIHC_Py_AWbQ.woff2',
      '200':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRU4TIHC_Py_AWbQ.woff2',
      '300':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRjYTIHC_Py_AWbQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR4YTIHC_Py_AWbQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRDYPIHC_Py_AWbQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRNIPIHC_Py_AWbQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRU4PIHC_Py_AWbQ.woff2',
      '900':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGReoPIHC_Py_AWbQ.woff2',
      regular:
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04TIHC_Py_AWbQ.woff2',
    },
  },
  {
    family: 'Ribeye Marrow',
    files: {
      regular: 'https://fonts.gstatic.com/s/ribeyemarrow/v24/GFDsWApshnqMRO2JdtRZ2d0vEAkTVWgKdtw.woff2',
    },
  },
  {
    family: 'Ysabeau',
    files: {
      '100': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OWCTY1I8Gcw6Oi.woff2',
      '200': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7MWCDY1I8Gcw6Oi.woff2',
      '300': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7PICDY1I8Gcw6Oi.woff2',
      '500': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OkCDY1I8Gcw6Oi.woff2',
      '600': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7NIDzY1I8Gcw6Oi.woff2',
      '700': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7NxDzY1I8Gcw6Oi.woff2',
      '800': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7MWDzY1I8Gcw6Oi.woff2',
      '900': 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7M_DzY1I8Gcw6Oi.woff2',
      regular: 'https://fonts.gstatic.com/s/ysabeau/v2/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OWCDY1I8Gcw6Oi.woff2',
    },
  },
  {
    family: 'Dangrek',
    files: {
      regular: 'https://fonts.gstatic.com/s/dangrek/v30/LYjCdG30nEgoH8E2gCZqqVIuTN4.woff2',
    },
  },
  {
    family: 'Lakki Reddy',
    files: {
      regular: 'https://fonts.gstatic.com/s/lakkireddy/v21/S6u5w49MUSzD9jlCPmvLZQftx9k97-xZ.woff2',
    },
  },
  {
    family: 'Dr Sugiyama',
    files: {
      regular: 'https://fonts.gstatic.com/s/drsugiyama/v28/HTxoL2k4N3O9n5I1boGI7abUM4-t-g7y.woff2',
    },
  },
  {
    family: 'Truculenta',
    files: {
      '100':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAjswIFHnJMMhg.woff2',
      '200':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMtAiswIFHnJMMhg.woff2',
      '300':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMg4iswIFHnJMMhg.woff2',
      '500':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMmIiswIFHnJMMhg.woff2',
      '600':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMo4lswIFHnJMMhg.woff2',
      '700':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMrclswIFHnJMMhg.woff2',
      '800':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMtAlswIFHnJMMhg.woff2',
      '900':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMvklswIFHnJMMhg.woff2',
      regular:
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAiswIFHnJMMhg.woff2',
    },
  },
  {
    family: 'Zen Tokyo Zoo',
    files: {
      regular: 'https://fonts.gstatic.com/s/zentokyozoo/v7/NGSyv5ffC0J_BK6aFNtr6sRv8ahuRWe9amg.woff2',
    },
  },
  {
    family: 'Gwendolyn',
    files: {
      '700': 'https://fonts.gstatic.com/s/gwendolyn/v7/qkBSXvoO_M3CSss-d7emWLtvnS7HONiSFQ.woff2',
      regular: 'https://fonts.gstatic.com/s/gwendolyn/v7/qkBXXvoO_M3CSss-d7ee4ZRLkAXbMQ.woff2',
    },
  },
  {
    family: 'Lancelot',
    files: {
      regular: 'https://fonts.gstatic.com/s/lancelot/v26/J7acnppxBGtQEulG4JY9xJ9CGyAa.woff2',
    },
  },
  {
    family: 'Phudu',
    files: {
      '300': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkK62zUTgWuz38Tgg.woff2',
      '500': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKh2zUTgWuz38Tgg.woff2',
      '600': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKa2vUTgWuz38Tgg.woff2',
      '700': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKUmvUTgWuz38Tgg.woff2',
      '800': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKNWvUTgWuz38Tgg.woff2',
      '900': 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKHGvUTgWuz38Tgg.woff2',
      regular: 'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKtWzUTgWuz38Tgg.woff2',
    },
  },
  {
    family: 'Bonheur Royale',
    files: {
      regular: 'https://fonts.gstatic.com/s/bonheurroyale/v13/c4m51nt_GMTrtX-b9GcG4-YRmYK6c0f1N5Ij.woff2',
    },
  },
  {
    family: 'Bungee Outline',
    files: {
      regular: 'https://fonts.gstatic.com/s/bungeeoutline/v20/_6_mEDvmVP24UvU2MyiGDslL3QgyYhJqPXxo.woff2',
    },
  },
  {
    family: 'Tiro Devanagari Marathi',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirodevanagarimarathi/v5/fC1xPZBSZHrRhS3rd4M0MAPNJUHl4znXCxAkotDuDJYM2lAZ.woff2',
    },
  },
  {
    family: 'Griffy',
    files: {
      regular: 'https://fonts.gstatic.com/s/griffy/v22/FwZa7-ox2FQh9kfwTdSEwM2zpA.woff2',
    },
  },
  {
    family: 'Jacques Francois Shadow',
    files: {
      regular: 'https://fonts.gstatic.com/s/jacquesfrancoisshadow/v25/KR1FBtOz8PKTMk-kqdkLVrvR0ECFrB6Pin-2_q8QsHuV5ULS.woff2',
    },
  },
  {
    family: 'Festive',
    files: {
      regular: 'https://fonts.gstatic.com/s/festive/v9/cY9Ffj6KX1xcoDWhFtLgy9HTkak.woff2',
    },
  },
  {
    family: 'Noto Serif Khojki',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoserifkhojki/v11/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMY4AhvzJ0Qtc5HAQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifkhojki/v11/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMYDA9vzJ0Qtc5HAQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifkhojki/v11/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMYNQ9vzJ0Qtc5HAQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifkhojki/v11/I_uHMoOduATTei9aP90ctmPGxP2rBKTM4mcQ5M3z9QMY0ghvzJ0Qtc5HAQ.woff2',
    },
  },
  {
    family: 'Labrada',
    files: {
      '100': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VTSgM9QPdUej17.woff2',
      '200': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9XTSwM9QPdUej17.woff2',
      '300': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9UNSwM9QPdUej17.woff2',
      '500': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VhSwM9QPdUej17.woff2',
      '600': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9WNTAM9QPdUej17.woff2',
      '700': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9W0TAM9QPdUej17.woff2',
      '800': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9XTTAM9QPdUej17.woff2',
      '900': 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9X6TAM9QPdUej17.woff2',
      regular: 'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VTSwM9QPdUej17.woff2',
    },
  },
  {
    family: 'Anek Gurmukhi',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5ppWa41H6DjbA.woff2',
      '200': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkb95tpWa41H6DjbA.woff2',
      '300': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbKZtpWa41H6DjbA.woff2',
      '500': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbRZtpWa41H6DjbA.woff2',
      '600': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbqZxpWa41H6DjbA.woff2',
      '700': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbkJxpWa41H6DjbA.woff2',
      '800': 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkb95xpWa41H6DjbA.woff2',
      regular: 'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5tpWa41H6DjbA.woff2',
    },
  },
  {
    family: 'Hubballi',
    files: {
      regular: 'https://fonts.gstatic.com/s/hubballi/v7/o-0JIpUj3WIZ1RFN56B-yBBNYuSF.woff2',
    },
  },
  {
    family: 'Diplomata SC',
    files: {
      regular: 'https://fonts.gstatic.com/s/diplomatasc/v28/buExpoi3ecvs3kidKgBJo2kf_f5Oaiw4cw.woff2',
    },
  },
  {
    family: 'Noto Sans Ethiopic',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OKqDmwmfeaY9u.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37OK6DmwmfeaY9u.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T34QK6DmwmfeaY9u.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T358K6DmwmfeaY9u.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36QLKDmwmfeaY9u.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36pLKDmwmfeaY9u.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37OLKDmwmfeaY9u.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37nLKDmwmfeaY9u.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansethiopic/v47/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OK6DmwmfeaY9u.woff2',
    },
  },
  {
    family: 'Praise',
    files: {
      regular: 'https://fonts.gstatic.com/s/praise/v7/qkBUXvUZ-cnFXcFyC_O67L9XmQ.woff2',
    },
  },
  {
    family: 'Borel',
    files: {
      regular: 'https://fonts.gstatic.com/s/borel/v3/6qLOKZsftAPisgskYyMnOjwE.woff2',
    },
  },
  {
    family: 'Noto Sans Samaritan',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssamaritan/v16/buEqppe9f8_vkXadMBJJo0tSmaYjFkxOUotjNlOVMzQ.woff2',
    },
  },
  {
    family: 'Encode Sans SC',
    files: {
      '100': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhn8cpNOEEClIc.woff2',
      '200': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HPhm8cpNOEEClIc.woff2',
      '300': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HCZm8cpNOEEClIc.woff2',
      '500': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HEpm8cpNOEEClIc.woff2',
      '600': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HKZh8cpNOEEClIc.woff2',
      '700': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HJ9h8cpNOEEClIc.woff2',
      '800': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HPhh8cpNOEEClIc.woff2',
      '900': 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HNFh8cpNOEEClIc.woff2',
      regular: 'https://fonts.gstatic.com/s/encodesanssc/v9/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhm8cpNOEEClIc.woff2',
    },
  },
  {
    family: 'BioRhyme Expanded',
    files: {
      '200': 'https://fonts.gstatic.com/s/biorhymeexpanded/v21/i7dVIE1zZzytGswgU577CDY9LjbffxxcblSCSdTXrb_z.woff2',
      '300': 'https://fonts.gstatic.com/s/biorhymeexpanded/v21/i7dVIE1zZzytGswgU577CDY9Ljbffxw4bVSCSdTXrb_z.woff2',
      '700': 'https://fonts.gstatic.com/s/biorhymeexpanded/v21/i7dVIE1zZzytGswgU577CDY9LjbffxwoalSCSdTXrb_z.woff2',
      '800': 'https://fonts.gstatic.com/s/biorhymeexpanded/v21/i7dVIE1zZzytGswgU577CDY9Ljbffxw0aVSCSdTXrb_z.woff2',
      regular: 'https://fonts.gstatic.com/s/biorhymeexpanded/v21/i7dQIE1zZzytGswgU577CDY9LjbffySRRXCPYsje.woff2',
    },
  },
  {
    family: 'Anek Kannada',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDEAuhVReA1oef.woff2',
      '200': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dHDEQuhVReA1oef.woff2',
      '300': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dEdEQuhVReA1oef.woff2',
      '500': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFxEQuhVReA1oef.woff2',
      '600': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGdFguhVReA1oef.woff2',
      '700': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGkFguhVReA1oef.woff2',
      '800': 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dHDFguhVReA1oef.woff2',
      regular: 'https://fonts.gstatic.com/s/anekkannada/v5/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDEQuhVReA1oef.woff2',
    },
  },
  {
    family: 'Snippet',
    files: {
      regular: 'https://fonts.gstatic.com/s/snippet/v21/bWt47f7XfQH9Gupu2vrAfcp9QWc.woff2',
    },
  },
  {
    family: 'Emblema One',
    files: {
      regular: 'https://fonts.gstatic.com/s/emblemaone/v21/nKKT-GQ0F5dSY8vzG0rOEIREHl57G_f_.woff2',
    },
  },
  {
    family: 'Solitreo',
    files: {
      regular: 'https://fonts.gstatic.com/s/solitreo/v2/r05YGLlS5a9KYsyNO8usyDYtStiJ.woff2',
    },
  },
  {
    family: 'Darumadrop One',
    files: {
      regular: 'https://fonts.gstatic.com/s/darumadropone/v10/cY9cfjeIW11dpCKgRLi675a87IhCBJOxZQPp.woff2',
    },
  },
  {
    family: 'Lacquer',
    files: {
      regular: 'https://fonts.gstatic.com/s/lacquer/v15/EYqzma1QwqpG4_BBB7qAXhttQ5I.woff2',
    },
  },
  {
    family: 'Fascinate Inline',
    files: {
      regular: 'https://fonts.gstatic.com/s/fascinateinline/v22/jVyR7mzzB3zc-jp6QCAu60poNqIy1gjCfRXxWZQ.woff2',
    },
  },
  {
    family: 'Kode Mono',
    files: {
      '500': 'https://fonts.gstatic.com/s/kodemono/v1/A2BLn5pb0QgtVEPFnlYkkaoBgw4qv9odq6uy9D-TaOW2A3k.woff2',
      '600': 'https://fonts.gstatic.com/s/kodemono/v1/A2BLn5pb0QgtVEPFnlYkkaoBgw4qv9odq0e19D-TaOW2A3k.woff2',
      '700': 'https://fonts.gstatic.com/s/kodemono/v1/A2BLn5pb0QgtVEPFnlYkkaoBgw4qv9odq3619D-TaOW2A3k.woff2',
      regular: 'https://fonts.gstatic.com/s/kodemono/v1/A2BLn5pb0QgtVEPFnlYkkaoBgw4qv9odq5my9D-TaOW2A3k.woff2',
    },
  },
  {
    family: 'Revalia',
    files: {
      regular: 'https://fonts.gstatic.com/s/revalia/v22/WwkexPimBE2-4ZPEeV_uNIgJSNM.woff2',
    },
  },
  {
    family: 'Flavors',
    files: {
      regular: 'https://fonts.gstatic.com/s/flavors/v26/FBV2dDrhxqmveJTpbknlNqkG9UY.woff2',
    },
  },
  {
    family: 'Lexend Tera',
    files: {
      '100': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zITc5z0fYxcrQ.woff2',
      '200': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMZzMTc5z0fYxcrQ.woff2',
      '300': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMuTMTc5z0fYxcrQ.woff2',
      '500': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM1TMTc5z0fYxcrQ.woff2',
      '600': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMOTQTc5z0fYxcrQ.woff2',
      '700': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMADQTc5z0fYxcrQ.woff2',
      '800': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMZzQTc5z0fYxcrQ.woff2',
      '900': 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMTjQTc5z0fYxcrQ.woff2',
      regular: 'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zMTc5z0fYxcrQ.woff2',
    },
  },
  {
    family: 'Chela One',
    files: {
      regular: 'https://fonts.gstatic.com/s/chelaone/v21/6ae-4KC7Uqgdz_JZdPIy2lvWNTMwoQ.woff2',
    },
  },
  {
    family: 'Noto Serif Kannada',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYCceFJ71svgcI.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgUYDceFJ71svgcI.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgZgDceFJ71svgcI.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgfQDceFJ71svgcI.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgRgEceFJ71svgcI.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgSEEceFJ71svgcI.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgUYEceFJ71svgcI.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgW8EceFJ71svgcI.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifkannada/v27/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYDceFJ71svgcI.woff2',
    },
  },
  {
    family: 'Erica One',
    files: {
      regular: 'https://fonts.gstatic.com/s/ericaone/v27/WBLnrEXccV9VGrOKmGD1Xk_MJMGxiQ.woff2',
    },
  },
  {
    family: 'Sometype Mono',
    files: {
      '500': 'https://fonts.gstatic.com/s/sometypemono/v1/70lGu745KGk_R3uxyq0WrROhAJiJsJ_eTWllpTA-GE9fgQBbs7uG.woff2',
      '600': 'https://fonts.gstatic.com/s/sometypemono/v1/70lGu745KGk_R3uxyq0WrROhAJiJsJ_eTWllpTDSH09fgQBbs7uG.woff2',
      '700': 'https://fonts.gstatic.com/s/sometypemono/v1/70lGu745KGk_R3uxyq0WrROhAJiJsJ_eTWllpTDrH09fgQBbs7uG.woff2',
      regular: 'https://fonts.gstatic.com/s/sometypemono/v1/70lGu745KGk_R3uxyq0WrROhAJiJsJ_eTWllpTAMGE9fgQBbs7uG.woff2',
    },
  },
  {
    family: 'Almendra Display',
    files: {
      regular: 'https://fonts.gstatic.com/s/almendradisplay/v31/0FlPVOGWl1Sb4O3tETtADHRRlZhzXSreTyer338.woff2',
    },
  },
  {
    family: 'Bagel Fat One',
    files: {
      regular: 'https://fonts.gstatic.com/s/bagelfatone/v1/hYkPPucsQOr5dy02WmQr5Zkd0Btmvv0dSbM.woff2',
    },
  },
  {
    family: 'Bokor',
    files: {
      regular: 'https://fonts.gstatic.com/s/bokor/v30/m8JcjfpeeaqTiR2TdInbcaxE.woff2',
    },
  },
  {
    family: 'Bigelow Rules',
    files: {
      regular: 'https://fonts.gstatic.com/s/bigelowrules/v29/RrQWboly8iR_I3KWSzeRuN0zT4ICH8WAJVk.woff2',
    },
  },
  {
    family: 'Agdasima',
    files: {
      '700': 'https://fonts.gstatic.com/s/agdasima/v4/PN_0Rfyxp2f1fUCgAPCGgBzW1PzTz2Mi.woff2',
      regular: 'https://fonts.gstatic.com/s/agdasima/v4/PN_zRfyxp2f1fUCgAMg_rzjb_-Da.woff2',
    },
  },
  {
    family: 'Mea Culpa',
    files: {
      regular: 'https://fonts.gstatic.com/s/meaculpa/v6/AMOTz4GcuWbEIuza8jsZn80QW3mqyg.woff2',
    },
  },
  {
    family: 'Protest Strike',
    files: {
      regular: 'https://fonts.gstatic.com/s/proteststrike/v2/0QI5MXdf4Y67Rn6vBog67ZjFlpzT0gZOs7BX.woff2',
    },
  },
  {
    family: 'Konkhmer Sleokchher',
    files: {
      regular: 'https://fonts.gstatic.com/s/konkhmersleokchher/v2/_Xmw-GE-rjmabA_M-aPOZOsCrUv825LFI3t07E0d-W0.woff2',
    },
  },
  {
    family: 'IBM Plex Sans Devanagari',
    files: {
      '100': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXB3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HMUj1UcjwCEQq.woff2',
      '200': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HnWnQfub8AV0z0w.woff2',
      '300': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_H-WrQfub8AV0z0w.woff2',
      '500': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HoWvQfub8AV0z0w.woff2',
      '600': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_HjWzQfub8AV0z0w.woff2',
      '700': 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXA3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O_H6W3Qfub8AV0z0w.woff2',
      regular: 'https://fonts.gstatic.com/s/ibmplexsansdevanagari/v11/XRXH3JCMvG4IDoS9SubXB6W-UX5iehIMBFR2-O__UEL0c83gCA.woff2',
    },
  },
  {
    family: 'GFS Neohellenic',
    files: {
      '700': 'https://fonts.gstatic.com/s/gfsneohellenic/v25/8QIUdiDOrfiq0b7R8O1Iw9WLcY5rkYdr7o4fWsRO9w.woff2',
      regular: 'https://fonts.gstatic.com/s/gfsneohellenic/v25/8QIRdiDOrfiq0b7R8O1Iw9WLcY5TKKhP46UDUw.woff2',
    },
  },
  {
    family: 'Big Shoulders Stencil Display',
    files: {
      '100':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0nPLXznJucP9w.woff2',
      '200':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_u0jPLXznJucP9w.woff2',
      '300':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_ZUjPLXznJucP9w.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_CUjPLXznJucP9w.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_5U_PLXznJucP9w.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_3E_PLXznJucP9w.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_u0_PLXznJucP9w.woff2',
      '900':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_kk_PLXznJucP9w.woff2',
      regular:
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0jPLXznJucP9w.woff2',
    },
  },
  {
    family: 'Devonshire',
    files: {
      regular: 'https://fonts.gstatic.com/s/devonshire/v27/46kqlbDwWirWr4gtBD2BX0Bq01lYAZM.woff2',
    },
  },
  {
    family: 'Tiro Devanagari Sanskrit',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirodevanagarisanskrit/v5/MCoAzBbr09vVUgVBM8FWu_yZdZkhkg-I0nUlb59pF4EqgtOh0w.woff2',
    },
  },
  {
    family: 'Big Shoulders Inline Text',
    files: {
      '100':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0yqGI7Y6Jsc8c.woff2',
      '200':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgY0y6GI7Y6Jsc8c.woff2',
      '300':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgbqy6GI7Y6Jsc8c.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgaGy6GI7Y6Jsc8c.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZqzKGI7Y6Jsc8c.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZTzKGI7Y6Jsc8c.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgY0zKGI7Y6Jsc8c.woff2',
      '900':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgYdzKGI7Y6Jsc8c.woff2',
      regular:
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0y6GI7Y6Jsc8c.woff2',
    },
  },
  {
    family: 'Peddana',
    files: {
      regular: 'https://fonts.gstatic.com/s/peddana/v20/aFTU7PBhaX89UcKWhhiaBYyMcKw.woff2',
    },
  },
  {
    family: 'Joan',
    files: {
      regular: 'https://fonts.gstatic.com/s/joan/v9/ZXupe1oZsqWRbRJH8X1p_Ng.woff2',
    },
  },
  {
    family: 'Cairo Play',
    files: {
      '200': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1EnYq8iXa8GvzaA.woff2',
      '300': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1zHYq8iXa8GvzaA.woff2',
      '500': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1oHYq8iXa8GvzaA.woff2',
      '600': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1THEq8iXa8GvzaA.woff2',
      '700': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1dXEq8iXa8GvzaA.woff2',
      '800': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1EnEq8iXa8GvzaA.woff2',
      '900': 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1O3Eq8iXa8GvzaA.woff2',
      regular: 'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1knYq8iXa8GvzaA.woff2',
    },
  },
  {
    family: 'Mr Bedfort',
    files: {
      regular: 'https://fonts.gstatic.com/s/mrbedfort/v22/MQpR-WCtNZSWAdTMwBicli-0XZe_Iy8.woff2',
    },
  },
  {
    family: 'Federant',
    files: {
      regular: 'https://fonts.gstatic.com/s/federant/v29/2sDdZGNfip_eirT0_U0mRUG0AqUc.woff2',
    },
  },
  {
    family: 'Foldit',
    files: {
      '100': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XpANma9UYLHkN80.woff2',
      '200': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XhAMma9UYLHkN80.woff2',
      '300': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8Xs4Mma9UYLHkN80.woff2',
      '500': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XqIMma9UYLHkN80.woff2',
      '600': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8Xk4Lma9UYLHkN80.woff2',
      '700': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XncLma9UYLHkN80.woff2',
      '800': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XhALma9UYLHkN80.woff2',
      '900': 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XjkLma9UYLHkN80.woff2',
      regular: 'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XpAMma9UYLHkN80.woff2',
    },
  },
  {
    family: 'Lavishly Yours',
    files: {
      regular: 'https://fonts.gstatic.com/s/lavishlyyours/v5/jizDREVIvGwH5OjiZmX9r5z_WxUd0TY7ikbI.woff2',
    },
  },
  {
    family: 'Siemreap',
    files: {
      regular: 'https://fonts.gstatic.com/s/siemreap/v28/Gg82N5oFbgLvHAfNl2YenA8DLXpe.woff2',
    },
  },
  {
    family: 'Babylonica',
    files: {
      regular: 'https://fonts.gstatic.com/s/babylonica/v5/5aUw9_i2qxWVCAE2aHjTqDd0-VVMoEw.woff2',
    },
  },
  {
    family: 'Rubik Distressed',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikdistressed/v1/GFDxWBdsmnqAVqjtUsZf2dcrQ2ldcWUhatVBaGM.woff2',
    },
  },
  {
    family: 'Gasoek One',
    files: {
      regular: 'https://fonts.gstatic.com/s/gasoekone/v3/EJRTQgQ_UMUKvDgnlX80zr-_cyb-vco.woff2',
    },
  },
  {
    family: 'Jim Nightshade',
    files: {
      regular: 'https://fonts.gstatic.com/s/jimnightshade/v20/PlIkFlu9Pb08Q8HLM1PxmB0g-OS9V3qKaMxD.woff2',
    },
  },
  {
    family: 'Trochut',
    files: {
      '700': 'https://fonts.gstatic.com/s/trochut/v22/CHymV-fDDlP9bDIw3sinWV8kMnIllmA.woff2',
      regular: 'https://fonts.gstatic.com/s/trochut/v22/CHyjV-fDDlP9bDIw5nGIfVIPLns.woff2',
    },
  },
  {
    family: 'Caramel',
    files: {
      regular: 'https://fonts.gstatic.com/s/caramel/v7/P5sCzZKBbMTf_ShyxCFuiZ-uydg.woff2',
    },
  },
  {
    family: 'Blaka',
    files: {
      regular: 'https://fonts.gstatic.com/s/blaka/v7/8vIG7w8722p_6kdu20D2FV5e.woff2',
    },
  },
  {
    family: 'Ysabeau Infant',
    files: {
      '100': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYFo4HLpChLwKH6A.woff2',
      '200': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYlo8HLpChLwKH6A.woff2',
      '300': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYSI8HLpChLwKH6A.woff2',
      '500': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYJI8HLpChLwKH6A.woff2',
      '600': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYyIgHLpChLwKH6A.woff2',
      '700': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQY8YgHLpChLwKH6A.woff2',
      '800': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYlogHLpChLwKH6A.woff2',
      '900': 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYv4gHLpChLwKH6A.woff2',
      regular: 'https://fonts.gstatic.com/s/ysabeauinfant/v2/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYFo8HLpChLwKH6A.woff2',
    },
  },
  {
    family: 'Stalinist One',
    files: {
      regular: 'https://fonts.gstatic.com/s/stalinistone/v56/MQpS-WezM9W4Dd7D3B7I-UT7eZqUPyacPbo.woff2',
    },
  },
  {
    family: 'Butcherman',
    files: {
      regular: 'https://fonts.gstatic.com/s/butcherman/v24/2EbiL-thF0loflXUBOdb1zCzq_5uT84.woff2',
    },
  },
  {
    family: 'Neonderthaw',
    files: {
      regular: 'https://fonts.gstatic.com/s/neonderthaw/v6/Iure6Yx5-oWVZI0r-17AeZZMprVA4XQ0.woff2',
    },
  },
  {
    family: 'Rubik Glitch',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikglitch/v2/qkBSXv8b_srFRYQVYrDKh9ZvnS7HONiSFQ.woff2',
    },
  },
  {
    family: 'Noto Sans Sharada',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssharada/v16/gok0H7rwAEdtF9N8-mdTGALG6p0kwoXOPOwr4H8a.woff2',
    },
  },
  {
    family: 'Edu TAS Beginner',
    files: {
      '500': 'https://fonts.gstatic.com/s/edutasbeginner/v3/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_HCemkuBWRhvk02.woff2',
      '600': 'https://fonts.gstatic.com/s/edutasbeginner/v3/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_EufWkuBWRhvk02.woff2',
      '700': 'https://fonts.gstatic.com/s/edutasbeginner/v3/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_EXfWkuBWRhvk02.woff2',
      regular: 'https://fonts.gstatic.com/s/edutasbeginner/v3/ZXuwe04WubHfGVY-1TcNg7AFUmshg8jIUTzK3r34f_HwemkuBWRhvk02.woff2',
    },
  },
  {
    family: 'Metal',
    files: {
      regular: 'https://fonts.gstatic.com/s/metal/v30/lW-wwjUJIXTo7i3inoQAUdN2.woff2',
    },
  },
  {
    family: 'Dhurjati',
    files: {
      regular: 'https://fonts.gstatic.com/s/dhurjati/v24/_6_8ED3gSeatXfFiFX33SKQtuTA2.woff2',
    },
  },
  {
    family: 'Passero One',
    files: {
      regular: 'https://fonts.gstatic.com/s/passeroone/v26/JTUTjIko8DOq5FeaeEAjgE5E5Arr-s50.woff2',
    },
  },
  {
    family: 'Diplomata',
    files: {
      regular: 'https://fonts.gstatic.com/s/diplomata/v31/Cn-0JtiMXwhNwp-wKxyfZWxYrdM9Sg.woff2',
    },
  },
  {
    family: 'Gidugu',
    files: {
      regular: 'https://fonts.gstatic.com/s/gidugu/v25/L0x8DFMkk1Uf6w3RufCmRSlUig.woff2',
    },
  },
  {
    family: 'Miss Fajardose',
    files: {
      regular: 'https://fonts.gstatic.com/s/missfajardose/v22/E21-_dn5gvrawDdPFVl-N0Ajb8qqWPaJq4no.woff2',
    },
  },
  {
    family: 'Noto Serif Sinhala',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxRlMpxaLRn3W-.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pExR1MpxaLRn3W-.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pHvR1MpxaLRn3W-.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGDR1MpxaLRn3W-.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFvQFMpxaLRn3W-.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFWQFMpxaLRn3W-.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pExQFMpxaLRn3W-.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pEYQFMpxaLRn3W-.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxR1MpxaLRn3W-.woff2',
    },
  },
  {
    family: 'Londrina Sketch',
    files: {
      regular: 'https://fonts.gstatic.com/s/londrinasketch/v25/c4m41npxGMTnomOHtRU68eIJn8qfXGn5Pos6CA.woff2',
    },
  },
  {
    family: 'Lumanosimo',
    files: {
      regular: 'https://fonts.gstatic.com/s/lumanosimo/v4/K2F0fZBYg_JDSEZHEfO8Ao-KAyLzfWo.woff2',
    },
  },
  {
    family: 'Sevillana',
    files: {
      regular: 'https://fonts.gstatic.com/s/sevillana/v23/KFOlCnWFscmDt1Bfiy1vBh05IsDqlA.woff2',
    },
  },
  {
    family: 'Rubik Iso',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikiso/v2/x3dickHUfr-S4VAI4sABefACvy_1BA.woff2',
    },
  },
  {
    family: 'Libre Barcode EAN13 Text',
    files: {
      regular: 'https://fonts.gstatic.com/s/librebarcodeean13text/v21/wlpigxXFDU1_oCu9nfZytgIqSG0XRcJm_OQiB96PBWEki52WfA.woff2',
    },
  },
  {
    family: 'Noto Sans Tai Viet',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstaiviet/v19/8QIUdj3HhN_lv4jf9vsE-9GMOLsaSPZr7o4fWsRO9w.woff2',
    },
  },
  {
    family: 'Inclusive Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/inclusivesans/v1/0nkxC9biPuwflXcJ46P4PGWE097wowa2LB4i.woff2',
    },
  },
  {
    family: 'Ballet',
    files: {
      regular: 'https://fonts.gstatic.com/s/ballet/v27/QGYyz_MYZA-HM4NjuGOVnUEXme1I4Xi3C4S-EiAou6Y.woff2',
    },
  },
  {
    family: 'Noto Sans Old South Arabian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldsoutharabian/v16/3qT5oiOhnSyU8TNFIdhZTice3hB_HWKsEnF--0XCHiKx0etDT9HwTA.woff2',
    },
  },
  {
    family: 'Chenla',
    files: {
      regular: 'https://fonts.gstatic.com/s/chenla/v25/SZc43FDpIKu8WZ9eWhfonUPL6Q.woff2',
    },
  },
  {
    family: 'Aubrey',
    files: {
      regular: 'https://fonts.gstatic.com/s/aubrey/v28/q5uGsou7NPBw-p7vvwNsCxVEgA.woff2',
    },
  },
  {
    family: 'Anek Odia',
    files: {
      '100': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZf63jXZAtm_es.woff2',
      '200': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnkZfq3jXZAtm_es.woff2',
      '300': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnnHfq3jXZAtm_es.woff2',
      '500': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmrfq3jXZAtm_es.woff2',
      '600': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnlHea3jXZAtm_es.woff2',
      '700': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnl-ea3jXZAtm_es.woff2',
      '800': 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnkZea3jXZAtm_es.woff2',
      regular: 'https://fonts.gstatic.com/s/anekodia/v6/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZfq3jXZAtm_es.woff2',
    },
  },
  {
    family: 'Love Light',
    files: {
      regular: 'https://fonts.gstatic.com/s/lovelight/v6/t5tlIR0TNJyZWimpNAXDjKPCyTHuspo.woff2',
    },
  },
  {
    family: 'Noto Serif Armenian',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8Obw_XagGdkbg.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZC8Kbw_XagGdkbg.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZ1cKbw_XagGdkbg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZucKbw_XagGdkbg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZVcWbw_XagGdkbg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZbMWbw_XagGdkbg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZC8Wbw_XagGdkbg.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZIsWbw_XagGdkbg.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifarmenian/v27/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8Kbw_XagGdkbg.woff2',
    },
  },
  {
    family: 'Gideon Roman',
    files: {
      regular: 'https://fonts.gstatic.com/s/gideonroman/v11/e3tmeuGrVOys8sxzZgWlmXogfkPWovdU4w.woff2',
    },
  },
  {
    family: 'Geostar',
    files: {
      regular: 'https://fonts.gstatic.com/s/geostar/v26/sykz-yx4n701VLOftS-9-trEvlQ.woff2',
    },
  },
  {
    family: 'Vibes',
    files: {
      regular: 'https://fonts.gstatic.com/s/vibes/v14/QdVYSTsmIB6tmbdyHpbsuBlh.woff2',
    },
  },
  {
    family: 'Combo',
    files: {
      regular: 'https://fonts.gstatic.com/s/combo/v21/BXRlvF3Jh_fIhg0nBu9y8Hf0.woff2',
    },
  },
  {
    family: 'Uchen',
    files: {
      regular: 'https://fonts.gstatic.com/s/uchen/v9/nKKZ-GokGZ1baIaXEQGodLxA.woff2',
    },
  },
  {
    family: 'Inspiration',
    files: {
      regular: 'https://fonts.gstatic.com/s/inspiration/v6/x3dkckPPZa6L4wIg5cZOEvoDnSrlBBsy.woff2',
    },
  },
  {
    family: 'My Soul',
    files: {
      regular: 'https://fonts.gstatic.com/s/mysoul/v5/3XFqErcuy945_u6KF_Alk2nnXf0.woff2',
    },
  },
  {
    family: 'Reem Kufi Ink',
    files: {
      regular: 'https://fonts.gstatic.com/s/reemkufiink/v9/oPWJ_kJmmu8hCvB9iFumxZSnRjtdQnSX1ko.woff2',
    },
  },
  {
    family: 'Alumni Sans Collegiate One',
    files: {
      regular: 'https://fonts.gstatic.com/s/alumnisanscollegiateone/v5/MQpB-XChK8G5CtmK_AuGxQrdNvPSXkn0RM-XqjWWhjdfyDiPw2ta.woff2',
    },
  },
  {
    family: 'Noto Serif Vithkuqi',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoserifvithkuqi/v1/YA94r1OY7FjTf5szakutkndpw9HH-4a4z9pklvg1IQSNcRW-dW2Hqy9A4teH.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifvithkuqi/v1/YA94r1OY7FjTf5szakutkndpw9HH-4a4z9pklvg1IQSNcRVScm2Hqy9A4teH.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifvithkuqi/v1/YA94r1OY7FjTf5szakutkndpw9HH-4a4z9pklvg1IQSNcRVrcm2Hqy9A4teH.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifvithkuqi/v1/YA94r1OY7FjTf5szakutkndpw9HH-4a4z9pklvg1IQSNcRWMdW2Hqy9A4teH.woff2',
    },
  },
  {
    family: 'Noto Serif Khmer',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B4wWUZK9Xo4xg.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNaB8wWUZK9Xo4xg.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNth8wWUZK9Xo4xg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN2h8wWUZK9Xo4xg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNNhgwWUZK9Xo4xg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNDxgwWUZK9Xo4xg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNaBgwWUZK9Xo4xg.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNQRgwWUZK9Xo4xg.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifkhmer/v25/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B8wWUZK9Xo4xg.woff2',
    },
  },
  {
    family: 'Taprom',
    files: {
      regular: 'https://fonts.gstatic.com/s/taprom/v27/UcCn3F82JHycULbFRik3-0kvHg.woff2',
    },
  },
  {
    family: 'Rubik Wet Paint',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikwetpaint/v2/HTx0L20uMDGHgdULcpTF3Oe4d_-F_jz313DuvQ.woff2',
    },
  },
  {
    family: 'Bacasime Antique',
    files: {
      regular: 'https://fonts.gstatic.com/s/bacasimeantique/v1/tDbX2pGXkFYEykldjZSrmI6T_XWZOwGtSUrV_BE.woff2',
    },
  },
  {
    family: 'Updock',
    files: {
      regular: 'https://fonts.gstatic.com/s/updock/v5/nuF4D_3dVZ70UI9SibK3602XBw.woff2',
    },
  },
  {
    family: 'Luxurious Roman',
    files: {
      regular: 'https://fonts.gstatic.com/s/luxuriousroman/v8/buEupou_ZcP1w0yTKxJJokVSmbpqZwckeo9RMw.woff2',
    },
  },
  {
    family: 'Castoro Titling',
    files: {
      regular: 'https://fonts.gstatic.com/s/castorotitling/v8/buEupouwccj03leTfjUAhEZWlrNqZwckeo9RMw.woff2',
    },
  },
  {
    family: 'Tiro Telugu',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirotelugu/v7/aFTQ7PxlZWk2EPiSymjXdKSIQqn0X0BO.woff2',
    },
  },
  {
    family: 'Aref Ruqaa Ink',
    files: {
      '700': 'https://fonts.gstatic.com/s/arefruqaaink/v10/1q2cY5WOGUFlt84GTOkP6Kdx71xde6WkqWBCyxWn.woff2',
      regular: 'https://fonts.gstatic.com/s/arefruqaaink/v10/1q2fY5WOGUFlt84GTOkP6Kdx72TkVIGpgnxL.woff2',
    },
  },
  {
    family: 'Mynerve',
    files: {
      regular: 'https://fonts.gstatic.com/s/mynerve/v6/P5sCzZKPdNjb4jt7xCFuiZ-uydg.woff2',
    },
  },
  {
    family: 'Sofadi One',
    files: {
      regular: 'https://fonts.gstatic.com/s/sofadione/v21/JIA2UVBxdnVBuElZaMFGcDaIETkmYDU.woff2',
    },
  },
  {
    family: 'Fruktur',
    files: {
      regular: 'https://fonts.gstatic.com/s/fruktur/v27/SZc53FHsOru5QYsMfzjGkUrS8DI.woff2',
    },
  },
  {
    family: 'Redacted Script',
    files: {
      '300': 'https://fonts.gstatic.com/s/redactedscript/v10/ypvEbXGRglhokR7dcC3d1-R6zmxqHUzVnLI397ldkg.woff2',
      '700': 'https://fonts.gstatic.com/s/redactedscript/v10/ypvEbXGRglhokR7dcC3d1-R6zmxqDUvVnLI397ldkg.woff2',
      regular: 'https://fonts.gstatic.com/s/redactedscript/v10/ypvBbXGRglhokR7dcC3d1-R6zmxStGTxkZkr_g.woff2',
    },
  },
  {
    family: 'Ruge Boogie',
    files: {
      regular: 'https://fonts.gstatic.com/s/rugeboogie/v28/JIA3UVFwbHRF_GIWSMhKNROnPzUveSxy.woff2',
    },
  },
  {
    family: 'Suravaram',
    files: {
      regular: 'https://fonts.gstatic.com/s/suravaram/v21/_gP61R_usiY7SCym4xIAjm61Qv9roQ.woff2',
    },
  },
  {
    family: 'Mooli',
    files: {
      regular: 'https://fonts.gstatic.com/s/mooli/v1/-F6_fjJpLyk1bYPEBG7YpzlJ.woff2',
    },
  },
  {
    family: 'Honk',
    files: {
      regular: 'https://fonts.gstatic.com/s/honk/v1/m8J7jftUea-XwTaemClumrBQbmvynOmXBji9zFhHRr8WFgVLprtNepQKvg.woff2',
    },
  },
  {
    family: 'Yuji Mai',
    files: {
      regular: 'https://fonts.gstatic.com/s/yujimai/v5/ZgNQjPxdJ7DEHrS0gC35hmHmNpCO.woff2',
    },
  },
  {
    family: 'Explora',
    files: {
      regular: 'https://fonts.gstatic.com/s/explora/v9/tsstApxFfjUH4wrvc1-PonC3vqc.woff2',
    },
  },
  {
    family: 'Ojuju',
    files: {
      '200': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_ypk54mFRLYeruQ.woff2',
      '300': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_FJk54mFRLYeruQ.woff2',
      '500': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_eJk54mFRLYeruQ.woff2',
      '600': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_lJ454mFRLYeruQ.woff2',
      '700': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_rZ454mFRLYeruQ.woff2',
      '800': 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_yp454mFRLYeruQ.woff2',
      regular: 'https://fonts.gstatic.com/s/ojuju/v1/7r3bqXF7v9ApbrMih3jYQBVm9-n_Spk54mFRLYeruQ.woff2',
    },
  },
  {
    family: 'Flow Block',
    files: {
      regular: 'https://fonts.gstatic.com/s/flowblock/v11/wlp0gwfPCEB65UmTk-d6-WNlbCBXE_I.woff2',
    },
  },
  {
    family: 'Cherry Bomb One',
    files: {
      regular: 'https://fonts.gstatic.com/s/cherrybombone/v8/y83DW4od1h6KlV3c6JJhRhGOdhrKCdpF41fr-w.woff2',
    },
  },
  {
    family: 'Yuji Boku',
    files: {
      regular: 'https://fonts.gstatic.com/s/yujiboku/v5/P5sAzZybeNzXsA9xj1FkiL2r2dgvJA.woff2',
    },
  },
  {
    family: 'Noto Serif Gujarati',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycYzrM1Kf-OJu.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuaycIzrM1Kf-OJu.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuZscIzrM1Kf-OJu.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYAcIzrM1Kf-OJu.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Hubsd4zrM1Kf-OJu.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HubVd4zrM1Kf-OJu.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Huayd4zrM1Kf-OJu.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Huabd4zrM1Kf-OJu.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifgujarati/v27/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycIzrM1Kf-OJu.woff2',
    },
  },
  {
    family: 'Tiro Tamil',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirotamil/v10/m8JXjfVIf7OT22n3M-S_ULFvamODxdI.woff2',
    },
  },
  {
    family: 'Rubik Beastly',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikbeastly/v10/0QImMXRd5oOmSC2ZQ7o9653X07n8_ApHqqk.woff2',
    },
  },
  {
    family: 'Langar',
    files: {
      regular: 'https://fonts.gstatic.com/s/langar/v27/kJEyBukW7AIlgjGVqDVZ99sqrQ.woff2',
    },
  },
  {
    family: 'Handjet',
    files: {
      '100':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHTmbUkAsEHFAH2A.woff2',
      '200':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHbmaUkAsEHFAH2A.woff2',
      '300':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHWeaUkAsEHFAH2A.woff2',
      '500':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHQuaUkAsEHFAH2A.woff2',
      '600':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHeedUkAsEHFAH2A.woff2',
      '700':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHd6dUkAsEHFAH2A.woff2',
      '800':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHbmdUkAsEHFAH2A.woff2',
      '900':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHZCdUkAsEHFAH2A.woff2',
      regular:
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHTmaUkAsEHFAH2A.woff2',
    },
  },
  {
    family: 'Fleur De Leah',
    files: {
      regular: 'https://fonts.gstatic.com/s/fleurdeleah/v9/AYCNpXX7ftYZWLhv9UmPJTMC5vOt4I_Gdq0.woff2',
    },
  },
  {
    family: 'Hedvig Letters Serif',
    files: {
      regular: 'https://fonts.gstatic.com/s/hedviglettersserif/v2/OD5puN2I2mekHmyoU1Kj2AXOd5_7v7gIDlX8quj7viQ_N1HixEAZerfcvSGpZg.woff2',
    },
  },
  {
    family: 'Moulpali',
    files: {
      regular: 'https://fonts.gstatic.com/s/moulpali/v30/H4ckBXKMl9HagUWymyY_wr-wg763.woff2',
    },
  },
  {
    family: 'Nabla',
    files: {
      regular: 'https://fonts.gstatic.com/s/nabla/v10/j8_D6-LI0Lvpe7Makz5UhJt9C3uqg_X_75gyGS4jAxsNIjrRNRVUFFR_198.woff2',
    },
  },
  {
    family: 'Ysabeau SC',
    files: {
      '100': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw98U1qBZ4EOmsT5.woff2',
      '200': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw_8UlqBZ4EOmsT5.woff2',
      '300': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw8iUlqBZ4EOmsT5.woff2',
      '500': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw9OUlqBZ4EOmsT5.woff2',
      '600': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw-iVVqBZ4EOmsT5.woff2',
      '700': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw-bVVqBZ4EOmsT5.woff2',
      '800': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw_8VVqBZ4EOmsT5.woff2',
      '900': 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw_VVVqBZ4EOmsT5.woff2',
      regular: 'https://fonts.gstatic.com/s/ysabeausc/v2/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw98UlqBZ4EOmsT5.woff2',
    },
  },
  {
    family: 'Tourney',
    files: {
      '100': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQByYDp1I1LcGA.woff2',
      '200': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GuQFyYDp1I1LcGA.woff2',
      '300': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GZwFyYDp1I1LcGA.woff2',
      '500': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GCwFyYDp1I1LcGA.woff2',
      '600': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G5wZyYDp1I1LcGA.woff2',
      '700': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G3gZyYDp1I1LcGA.woff2',
      '800': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GuQZyYDp1I1LcGA.woff2',
      '900': 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GkAZyYDp1I1LcGA.woff2',
      regular: 'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQFyYDp1I1LcGA.woff2',
    },
  },
  {
    family: 'Purple Purse',
    files: {
      regular: 'https://fonts.gstatic.com/s/purplepurse/v23/qWctB66gv53iAp-Vfs4My6qyfRb_ujA4ug.woff2',
    },
  },
  {
    family: 'Noto Sans Osmanya',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansosmanya/v18/8vIS7xs32H97qzQKnzfeWzUyUpOJmz6hR47NCV5Z.woff2',
    },
  },
  {
    family: 'Hedvig Letters Sans',
    files: {
      regular: 'https://fonts.gstatic.com/s/hedvigletterssans/v2/CHy_V_PfGVjobSBkihHWDT98RVp37w8jQJhN3Twgi1w.woff2',
    },
  },
  {
    family: 'Island Moments',
    files: {
      regular: 'https://fonts.gstatic.com/s/islandmoments/v6/NaPBcZfVGvBdxIt7Ar0qzkXJF-TDIohbZ6SY.woff2',
    },
  },
  {
    family: 'Snowburst One',
    files: {
      regular: 'https://fonts.gstatic.com/s/snowburstone/v20/MQpS-WezKdujBsXY3B7I-UT7eZqUPyacPbo.woff2',
    },
  },
  {
    family: 'Tsukimi Rounded',
    files: {
      '300': 'https://fonts.gstatic.com/s/tsukimirounded/v10/sJoZ3LJNksWZO0LvnZwkF3HtoB7VkVsqMrMT3T9X8g.woff2',
      '500': 'https://fonts.gstatic.com/s/tsukimirounded/v10/sJoZ3LJNksWZO0LvnZwkF3HtoB7VyVoqMrMT3T9X8g.woff2',
      '600': 'https://fonts.gstatic.com/s/tsukimirounded/v10/sJoZ3LJNksWZO0LvnZwkF3HtoB7V5V0qMrMT3T9X8g.woff2',
      '700': 'https://fonts.gstatic.com/s/tsukimirounded/v10/sJoZ3LJNksWZO0LvnZwkF3HtoB7VgVwqMrMT3T9X8g.woff2',
      regular: 'https://fonts.gstatic.com/s/tsukimirounded/v10/sJoc3LJNksWZO0LvnZwkF3HtoB7tOHMOP5gP1A.woff2',
    },
  },
  {
    family: 'Nuosu SIL',
    files: {
      regular: 'https://fonts.gstatic.com/s/nuosusil/v10/8vIK7wM3wmRn_kc4uAjeEWxbO_zo-w.woff2',
    },
  },
  {
    family: 'Splash',
    files: {
      regular: 'https://fonts.gstatic.com/s/splash/v6/KtksAL2RZoDkbU6hofPGNdS6wg.woff2',
    },
  },
  {
    family: 'Tai Heritage Pro',
    files: {
      '700': 'https://fonts.gstatic.com/s/taiheritagepro/v6/sZlYdQid-zgaNiNIYcUzJMU3IYyNmMB9NNFFMuhjCXY.woff2',
      regular: 'https://fonts.gstatic.com/s/taiheritagepro/v6/sZlfdQid-zgaNiNIYcUzJMU3IYyNoHlSENxuLuE.woff2',
    },
  },
  {
    family: 'Oi',
    files: {
      regular: 'https://fonts.gstatic.com/s/oi/v19/w8gXH2EuRqtfut6yjBOG.woff2',
    },
  },
  {
    family: 'Send Flowers',
    files: {
      regular: 'https://fonts.gstatic.com/s/sendflowers/v5/If2PXTjtZS-0Xqy13uCQSULvwgjjouU1iw.woff2',
    },
  },
  {
    family: 'Bonbon',
    files: {
      regular: 'https://fonts.gstatic.com/s/bonbon/v30/0FlVVPeVlFec4ee_dTEAbQY5-A.woff2',
    },
  },
  {
    family: 'Bruno Ace',
    files: {
      regular: 'https://fonts.gstatic.com/s/brunoace/v5/WwkcxPa2E06x4trkOj_kNaoMWNMg3Q.woff2',
    },
  },
  {
    family: 'Comme',
    files: {
      '100': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z5cBr7o4fWsRO9w.woff2',
      '200': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zZcFr7o4fWsRO9w.woff2',
      '300': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zu8Fr7o4fWsRO9w.woff2',
      '500': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z18Fr7o4fWsRO9w.woff2',
      '600': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zO8Zr7o4fWsRO9w.woff2',
      '700': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zAsZr7o4fWsRO9w.woff2',
      '800': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zZcZr7o4fWsRO9w.woff2',
      '900': 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zTMZr7o4fWsRO9w.woff2',
      regular: 'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z5cFr7o4fWsRO9w.woff2',
    },
  },
  {
    family: 'Alumni Sans Pinstripe',
    files: {
      regular: 'https://fonts.gstatic.com/s/alumnisanspinstripe/v6/ZgNNjOFFPq_AUJD1umyS30W-Xub8zD1ObhezZ7VIpcDA5w.woff2',
    },
  },
  {
    family: 'Noto Sans Javanese',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansjavanese/v23/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxKvkFFxiZYWj4O8.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansjavanese/v23/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxEfjFFxiZYWj4O8.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansjavanese/v23/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxH7jFFxiZYWj4O8.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansjavanese/v23/2V01KJkDAIA6Hp4zoSScDjV0Y-eoHAHT-Z3MngEefiidxJnkFFxiZYWj4O8.woff2',
    },
  },
  {
    family: 'Diphylleia',
    files: {
      regular: 'https://fonts.gstatic.com/s/diphylleia/v1/DtVmJxCtRKMixK4_HXsIulkm6gDXvwE.woff2',
    },
  },
  {
    family: 'Edu VIC WA NT Beginner',
    files: {
      '500': 'https://fonts.gstatic.com/s/eduvicwantbeginner/v4/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-OllPmAXwnpkeGR.woff2',
      '600': 'https://fonts.gstatic.com/s/eduvicwantbeginner/v4/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-NJk_mAXwnpkeGR.woff2',
      '700': 'https://fonts.gstatic.com/s/eduvicwantbeginner/v4/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-Nwk_mAXwnpkeGR.woff2',
      regular: 'https://fonts.gstatic.com/s/eduvicwantbeginner/v4/jiz2RF1BuW9OwcnNPxLl4KfZCHd9nFtd5Tu7stCpElYpvPfZZ-OXlPmAXwnpkeGR.woff2',
    },
  },
  {
    family: 'Noto Serif Ethiopic',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSQjlKO9UVLyiw.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCTSUjlKO9UVLyiw.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCkyUjlKO9UVLyiw.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxC_yUjlKO9UVLyiw.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCEyIjlKO9UVLyiw.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCKiIjlKO9UVLyiw.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCTSIjlKO9UVLyiw.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCZCIjlKO9UVLyiw.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoserifethiopic/v30/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSUjlKO9UVLyiw.woff2',
    },
  },
  {
    family: 'Kolker Brush',
    files: {
      regular: 'https://fonts.gstatic.com/s/kolkerbrush/v6/iJWDBXWRZjfKWdvmzwvvog3-6aJ6x8qNUQ.woff2',
    },
  },
  {
    family: 'Sassy Frass',
    files: {
      regular: 'https://fonts.gstatic.com/s/sassyfrass/v7/LhWhMVrGOe0FLb97BjhsE99YGNWQg_am.woff2',
    },
  },
  {
    family: 'Noto Rashi Hebrew',
    files: {
      '100': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-DkQiq6Nf2pfA.woff2',
      '200': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZh-HkQiq6Nf2pfA.woff2',
      '300': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZWeHkQiq6Nf2pfA.woff2',
      '500': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZNeHkQiq6Nf2pfA.woff2',
      '600': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ2ebkQiq6Nf2pfA.woff2',
      '700': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ4ObkQiq6Nf2pfA.woff2',
      '800': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZh-bkQiq6Nf2pfA.woff2',
      '900': 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZrubkQiq6Nf2pfA.woff2',
      regular: 'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-HkQiq6Nf2pfA.woff2',
    },
  },
  {
    family: 'Geostar Fill',
    files: {
      regular: 'https://fonts.gstatic.com/s/geostarfill/v26/AMOWz4SWuWiXFfjEohxQ9os0VlK2w9lb4g.woff2',
    },
  },
  {
    family: 'Rubik Vinyl',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikvinyl/v1/iJWABXKIfDnIV4mQ5BfjvUXbxox2ztOU.woff2',
    },
  },
  {
    family: 'Sixtyfour',
    files: {
      regular: 'https://fonts.gstatic.com/s/sixtyfour/v1/OD5vuMCT1numDm3nakXtp2h4jg463t9haG_3mBkVsV20uFT3BAE5f73dnyS5ZuOV.woff2',
    },
  },
  {
    family: 'Noto Sans Syloti Nagri',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssylotinagri/v20/uU9eCAQZ75uhfF9UoWDRiY3q7Sf_VFV3m4dGFVLxN87gsj0.woff2',
    },
  },
  {
    family: 'Big Shoulders Inline Display',
    files: {
      '100':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBEnR8yPc2Huux.woff2',
      '200':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0lBE3R8yPc2Huux.woff2',
      '300':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0mfE3R8yPc2Huux.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nzE3R8yPc2Huux.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kfFHR8yPc2Huux.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kmFHR8yPc2Huux.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0lBFHR8yPc2Huux.woff2',
      '900':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0loFHR8yPc2Huux.woff2',
      regular:
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBE3R8yPc2Huux.woff2',
    },
  },
  {
    family: 'Noto Serif Balinese',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifbalinese/v18/QdVKSS0-JginysQSRvuCmUMB_wVeQAxXRb0JdhapcUU.woff2',
    },
  },
  {
    family: 'Moirai One',
    files: {
      regular: 'https://fonts.gstatic.com/s/moiraione/v1/2sDbZGFUgJLJmby6xgNGT0CWB7UcfCg.woff2',
    },
  },
  {
    family: 'Grechen Fuemen',
    files: {
      regular: 'https://fonts.gstatic.com/s/grechenfuemen/v9/vEFI2_tHEQ4d5ObgKxBzZh0MAWgZ-NaXXq7H.woff2',
    },
  },
  {
    family: 'Zen Loop',
    files: {
      regular: 'https://fonts.gstatic.com/s/zenloop/v9/h0GrssK16UsnJwHsEK92qwzX5vOG.woff2',
    },
  },
  {
    family: 'Noto Serif Tibetan',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYdPSvrdSy_32c.woff2',
      '200': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIjYcPSvrdSy_32c.woff2',
      '300': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIugcPSvrdSy_32c.woff2',
      '500': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIoQcPSvrdSy_32c.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmImgbPSvrdSy_32c.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIlEbPSvrdSy_32c.woff2',
      '800': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIjYbPSvrdSy_32c.woff2',
      '900': 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIh8bPSvrdSy_32c.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYcPSvrdSy_32c.woff2',
    },
  },
  {
    family: 'Dai Banna SIL',
    files: {
      '300': 'https://fonts.gstatic.com/s/daibannasil/v2/lW-lwj0AJWmpwGyJ2uEoA4I7tYKoDs_KOgMX95A.woff2',
      '500': 'https://fonts.gstatic.com/s/daibannasil/v2/lW-lwj0AJWmpwGyJ2uEoA4I7tdqpDs_KOgMX95A.woff2',
      '600': 'https://fonts.gstatic.com/s/daibannasil/v2/lW-lwj0AJWmpwGyJ2uEoA4I7tfauDs_KOgMX95A.woff2',
      '700': 'https://fonts.gstatic.com/s/daibannasil/v2/lW-lwj0AJWmpwGyJ2uEoA4I7tZKvDs_KOgMX95A.woff2',
      regular: 'https://fonts.gstatic.com/s/daibannasil/v2/lW-4wj0AJWmpwGyJ2uEoA4I7jSuAKsLhJgo.woff2',
    },
  },
  {
    family: 'Noto Sans Sora Sompeng',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanssorasompeng/v24/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHRO18DsZXJQd4Mu.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanssorasompeng/v24/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHSi0MDsZXJQd4Mu.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanssorasompeng/v24/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHSb0MDsZXJQd4Mu.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanssorasompeng/v24/PlIRFkO5O6RzLfvNNVSioxM2_OTrEhPyDLolKvCsHzCxWuGkYHR818DsZXJQd4Mu.woff2',
    },
  },
  {
    family: 'Noto Sans Lepcha',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslepcha/v19/0QI7MWlB_JWgA166SKhu05TekNS32AdstqBXgd4.woff2',
    },
  },
  {
    family: 'Noto Sans Tagalog',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstagalog/v22/J7aFnoNzCnFcV9ZI-sUYuvote1R0wwEFA8jHexnL.woff2',
    },
  },
  {
    family: 'Gajraj One',
    files: {
      regular: 'https://fonts.gstatic.com/s/gajrajone/v5/1cX2aUDCDpXsuWVb1jIjr1SqhcitzeM.woff2',
    },
  },
  {
    family: 'Petemoss',
    files: {
      regular: 'https://fonts.gstatic.com/s/petemoss/v7/A2BZn5tA2xgtGWHZgxkbsKb9UouQ.woff2',
    },
  },
  {
    family: 'Protest Guerrilla',
    files: {
      regular: 'https://fonts.gstatic.com/s/protestguerrilla/v2/Qw3HZR5PDSL6K3irtrY-VJB2YzARHV0hoJ8y_eiS.woff2',
    },
  },
  {
    family: 'Palette Mosaic',
    files: {
      regular: 'https://fonts.gstatic.com/s/palettemosaic/v10/AMOIz4aBvWuBFe3TohdW6YZ9MFi34dxL4jSr.woff2',
    },
  },
  {
    family: 'Rubik Doodle Triangles',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikdoodletriangles/v1/esDA301BLOmMKxKspb3g-domRuLPeaSn2bTzdL2_slZxgWE.woff2',
    },
  },
  {
    family: 'Sigmar',
    files: {
      regular: 'https://fonts.gstatic.com/s/sigmar/v7/hv-XlzJgIE8a85pUaGY3MTFgVg.woff2',
    },
  },
  {
    family: 'Kablammo',
    files: {
      regular: 'https://fonts.gstatic.com/s/kablammo/v1/bWtm7fHPcgrhC-J3lcXhcQTY5Ixs6Au9YgCjih0Rf4YDKw.woff2',
    },
  },
  {
    family: 'Noto Music',
    files: {
      regular: 'https://fonts.gstatic.com/s/notomusic/v20/pe0rMIiSN5pO63htf1sxItKQB9Zra1U.woff2',
    },
  },
  {
    family: 'Micro 5',
    files: {
      regular: 'https://fonts.gstatic.com/s/micro5/v1/H4cnBX2MkcfEngTr0gMQ7LO5mqc.woff2',
    },
  },
  {
    family: 'Noto Sans Mongolian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmongolian/v19/VdGCAYADGIwE0EopZx8xQfHlgEAMsrToxL4g6-av1x0.woff2',
    },
  },
  {
    family: 'Slackside One',
    files: {
      regular: 'https://fonts.gstatic.com/s/slacksideone/v10/EJRQQgMrXdcGsiBuvnRxodTwVyvVocNB6Iw.woff2',
    },
  },
  {
    family: 'Rubik 80s Fade',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubik80sfade/v2/U9MF6dW37nLSmnwZXyoV-uPXUhH1kbL8IHcK.woff2',
    },
  },
  {
    family: 'Noto Serif Tangut',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoseriftangut/v16/xn76YGc72GKoTvER4Gn3b4m9Ern7Em4wfcvN2KT4.woff2',
    },
  },
  {
    family: 'Annapurna SIL',
    files: {
      '700': 'https://fonts.gstatic.com/s/annapurnasil/v2/yYLy0hDY0f2iu9tPmRWtllidyG9SUZnUIZJ008A.woff2',
      regular: 'https://fonts.gstatic.com/s/annapurnasil/v2/yYLv0hDY0f2iu9tPmRWtllid8NZ9dZT_PZs.woff2',
    },
  },
  {
    family: 'Noto Sans Coptic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscoptic/v21/iJWfBWmUZi_OHPqn4wq6kgqumOEd786_VG0xR4Y.woff2',
    },
  },
  {
    family: 'Cherish',
    files: {
      regular: 'https://fonts.gstatic.com/s/cherish/v8/ll88K2mXUyqsDsTN5iXCI6IJjg8.woff2',
    },
  },
  {
    family: 'Noto Serif NP Hmong',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbj9hFLs3u0rVO-d.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbgRg1Ls3u0rVO-d.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbgog1Ls3u0rVO-d.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifnphmong/v1/pONN1gItFMO79E4L1GPUi-2sixKHZyFj9Jy6_KhXPwzdvbjPhFLs3u0rVO-d.woff2',
    },
  },
  {
    family: 'Estonia',
    files: {
      regular: 'https://fonts.gstatic.com/s/estonia/v11/7Au_p_4ijSecA1yHCCf8zkwMIFg.woff2',
    },
  },
  {
    family: 'Are You Serious',
    files: {
      regular: 'https://fonts.gstatic.com/s/areyouserious/v12/ll8kK2GVSSr-PtjQ5nONVcNn4306gD9nCGRayg.woff2',
    },
  },
  {
    family: 'Grey Qo',
    files: {
      regular: 'https://fonts.gstatic.com/s/greyqo/v9/BXRrvF_Nmv_TyXxNDO5Q9Wf0QcE.woff2',
    },
  },
  {
    family: 'Jacquarda Bastarda 9',
    files: {
      regular: 'https://fonts.gstatic.com/s/jacquardabastarda9/v4/f0Xp0fWr_8t6WFtKQJfOhaC0hcZ1HYAMAbwG1TB_JHHY.woff2',
    },
  },
  {
    family: 'Noto Sans Canadian Aboriginal',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLj_zQsg0q0uhQ.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig2Ln_zQsg0q0uhQ.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigBrn_zQsg0q0uhQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigarn_zQsg0q0uhQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzighr7_zQsg0q0uhQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigv77_zQsg0q0uhQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig2L7_zQsg0q0uhQ.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig8b7_zQsg0q0uhQ.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v22/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLn_zQsg0q0uhQ.woff2',
    },
  },
  {
    family: 'Edu QLD Beginner',
    files: {
      '500': 'https://fonts.gstatic.com/s/eduqldbeginner/v3/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE423oeei6vyVWCN.woff2',
      '600': 'https://fonts.gstatic.com/s/eduqldbeginner/v3/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE7a2Yeei6vyVWCN.woff2',
      '700': 'https://fonts.gstatic.com/s/eduqldbeginner/v3/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE7j2Yeei6vyVWCN.woff2',
      regular: 'https://fonts.gstatic.com/s/eduqldbeginner/v3/AMOHz5iUuHLEMNXyohhc_Y56PR3A8dNLF_w3Ka4HKE4E3oeei6vyVWCN.woff2',
    },
  },
  {
    family: 'Tiro Gurmukhi',
    files: {
      regular: 'https://fonts.gstatic.com/s/tirogurmukhi/v6/x3dmckXSYq-Uqjc048JUF7JvlyvHAQsyA2Y.woff2',
    },
  },
  {
    family: 'Noto Serif Lao',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMLrvajlmyhHHQ.woff2',
      '200': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VWMKrvajlmyhHHQ.woff2',
      '300': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8Vb0KrvajlmyhHHQ.woff2',
      '500': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VdEKrvajlmyhHHQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VT0NrvajlmyhHHQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VQQNrvajlmyhHHQ.woff2',
      '800': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VWMNrvajlmyhHHQ.woff2',
      '900': 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VUoNrvajlmyhHHQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriflao/v24/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMKrvajlmyhHHQ.woff2',
    },
  },
  {
    family: 'Noto Sans Tangsa',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanstangsa/v6/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp1qkyoUYdplyJDA.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanstangsa/v6/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp2GlCoUYdplyJDA.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanstangsa/v6/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp2_lCoUYdplyJDA.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanstangsa/v6/z7NCdQPmcigbbZAIOl9igP26K470lICpky0-peX5Qp1YkyoUYdplyJDA.woff2',
    },
  },
  {
    family: 'Ruwudu',
    files: {
      '500': 'https://fonts.gstatic.com/s/ruwudu/v4/sykx-y1tj6UzRKf1YSm3-_jBrlSILg.woff2',
      '600': 'https://fonts.gstatic.com/s/ruwudu/v4/sykx-y1tj6UzRKf1TS63-_jBrlSILg.woff2',
      '700': 'https://fonts.gstatic.com/s/ruwudu/v4/sykx-y1tj6UzRKf1KS-3-_jBrlSILg.woff2',
      regular: 'https://fonts.gstatic.com/s/ruwudu/v4/syky-y1tj6UzRKfNkACT9tPdpw.woff2',
    },
  },
  {
    family: 'Noto Serif Toto',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoseriftoto/v4/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhCx_Il-Oj55vdNug.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriftoto/v4/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhC_PPl-Oj55vdNug.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriftoto/v4/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhC8rPl-Oj55vdNug.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriftoto/v4/Ktk6ALSMeZjqPnXk1rCkHYHNtwvtHItpjRP74dHhCy3Il-Oj55vdNug.woff2',
    },
  },
  {
    family: 'Noto Serif Tamil',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN6R9fz3v8Etew.woff2',
      '200':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatNN-R9fz3v8Etew.woff2',
      '300':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecat6t-R9fz3v8Etew.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatht-R9fz3v8Etew.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatatiR9fz3v8Etew.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatU9iR9fz3v8Etew.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatNNiR9fz3v8Etew.woff2',
      '900':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatHdiR9fz3v8Etew.woff2',
      regular:
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN-R9fz3v8Etew.woff2',
    },
  },
  {
    family: 'Orbit',
    files: {
      regular: 'https://fonts.gstatic.com/s/orbit/v1/_LOCmz7I-uHd2mjBeqciRwRm.woff2',
    },
  },
  {
    family: 'Syne Tactile',
    files: {
      regular: 'https://fonts.gstatic.com/s/synetactile/v15/11hGGpna2UTQKjMCVzjAPMKh2isdjvKU8Q.woff2',
    },
  },
  {
    family: 'Moo Lah Lah',
    files: {
      regular: 'https://fonts.gstatic.com/s/moolahlah/v6/dg4h_p_opKZOA0w1AYcm55woYQYugjW4.woff2',
    },
  },
  {
    family: 'Namdhinggo',
    files: {
      '500': 'https://fonts.gstatic.com/s/namdhinggo/v2/uk-lEGe3rbgg8Xzoy5-TNoGKxyFa8oZK9I0.woff2',
      '600': 'https://fonts.gstatic.com/s/namdhinggo/v2/uk-lEGe3rbgg8Xzoy5-TNq2NxyFa8oZK9I0.woff2',
      '700': 'https://fonts.gstatic.com/s/namdhinggo/v2/uk-lEGe3rbgg8Xzoy5-TNsmMxyFa8oZK9I0.woff2',
      '800': 'https://fonts.gstatic.com/s/namdhinggo/v2/uk-lEGe3rbgg8Xzoy5-TNtWPxyFa8oZK9I0.woff2',
      regular: 'https://fonts.gstatic.com/s/namdhinggo/v2/uk-mEGe3rbgg8Xzoy5-TDnCj4yxx7o8.woff2',
    },
  },
  {
    family: 'Noto Sans Old Hungarian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldhungarian/v18/E213_cD6hP3GwCJPEUssHEM0KqLaHJXg2PiIgRfmbg5nCYXt.woff2',
    },
  },
  {
    family: 'Lugrasimo',
    files: {
      regular: 'https://fonts.gstatic.com/s/lugrasimo/v4/qkBXXvoF_s_eT9c7Y7ae4ZRLkAXbMQ.woff2',
    },
  },
  {
    family: 'Noto Sans Glagolitic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansglagolitic/v18/1q2ZY4-BBFBst88SU_tOj4J-4yuNF_HI4ERP4Amu7nM1.woff2',
    },
  },
  {
    family: 'Flow Rounded',
    files: {
      regular: 'https://fonts.gstatic.com/s/flowrounded/v11/-zki91mtwsU9qlLiGwD4oQX3pJX-Xup87g.woff2',
    },
  },
  {
    family: 'Warnes',
    files: {
      regular: 'https://fonts.gstatic.com/s/warnes/v27/pONn1hc0GsW6sW5OoyC2o6Lkqg.woff2',
    },
  },
  {
    family: 'Noto Sans Batak',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansbatak/v20/gok2H6TwAEdtF9N8-mdTCQvT-Zdgpo_PHuk74A.woff2',
    },
  },
  {
    family: 'Grandiflora One',
    files: {
      regular: 'https://fonts.gstatic.com/s/grandifloraone/v3/0ybmGD0g27bCk_5MGWZcKWhxwnUU-B3y8DOWGA.woff2',
    },
  },
  {
    family: 'M PLUS Code Latin',
    files: {
      '100':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1EbB6itMqF9TRwg.woff2',
      '200':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1MbA6itMqF9TRwg.woff2',
      '300':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1BjA6itMqF9TRwg.woff2',
      '500':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1HTA6itMqF9TRwg.woff2',
      '600':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1JjH6itMqF9TRwg.woff2',
      '700':
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1KHH6itMqF9TRwg.woff2',
      regular:
        'https://fonts.gstatic.com/s/mpluscodelatin/v13/hv-ylyV-aXg7x7tULiNXXBA0Np4WMS8fDIymHY8fy8wn4_ifLAtrObKDO0Xf1EbA6itMqF9TRwg.woff2',
    },
  },
  {
    family: 'Noto Serif Ottoman Siyaq',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifottomansiyaq/v2/fC1yPZ9IYnzRhTrrc4s8cSvYI0eozzaFOQ01qoHLI7gA00kAdA.woff2',
    },
  },
  {
    family: 'Rubik Glitch Pop',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikglitchpop/v1/tDbX2pGHhFcM0gB3hN2elZLa3G-MOwGtSUrV_BE.woff2',
    },
  },
  {
    family: 'Twinkle Star',
    files: {
      regular: 'https://fonts.gstatic.com/s/twinklestar/v6/pe0pMI6IL4dPoFl9LGEmY6WaBvRue1UwVg.woff2',
    },
  },
  {
    family: 'Rubik Spray Paint',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikspraypaint/v1/WnzhHBAoeBPUDTB4EWR82y6EXWPH-Ro7QoaBZQxP.woff2',
    },
  },
  {
    family: 'Tapestry',
    files: {
      regular: 'https://fonts.gstatic.com/s/tapestry/v4/SlGTmQecrosEYXhaGBIhqnB6aSQU.woff2',
    },
  },
  {
    family: 'Hanalei',
    files: {
      regular: 'https://fonts.gstatic.com/s/hanalei/v23/E21n_dD8iufIjBRHXz0mVydREus.woff2',
    },
  },
  {
    family: 'Noto Traditional Nushu',
    files: {
      '300': 'https://fonts.gstatic.com/s/nototraditionalnushu/v17/SZcV3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67PUZX6ADm6oa8IXvy1tnKa7QoqirI.woff2',
      '500': 'https://fonts.gstatic.com/s/nototraditionalnushu/v17/SZcV3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67PUZX6ADm6oa8IXue1tnKa7QoqirI.woff2',
      '600': 'https://fonts.gstatic.com/s/nototraditionalnushu/v17/SZcV3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67PUZX6ADm6oa8IXty0dnKa7QoqirI.woff2',
      '700': 'https://fonts.gstatic.com/s/nototraditionalnushu/v17/SZcV3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67PUZX6ADm6oa8IXtL0dnKa7QoqirI.woff2',
      regular:
        'https://fonts.gstatic.com/s/nototraditionalnushu/v17/SZcV3EDkJ7q9FaoMPlmF4Su8hlIjoGh5aj67PUZX6ADm6oa8IXus1tnKa7QoqirI.woff2',
    },
  },
  {
    family: 'Noto Sans Carian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscarian/v16/LDIpaoiONgYwA9Yc6f0gUILeMIOgs78b9yGLmfI.woff2',
    },
  },
  {
    family: 'Noto Sans Miao',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmiao/v17/Dxxz8jmXMW75w3OmoDXVV4zyZUjlUYVslLhx.woff2',
    },
  },
  {
    family: 'Noto Sans Linear A',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslineara/v18/oPWS_l16kP4jCuhpgEGmwJOiA18FZj22y2HQAGQicw.woff2',
    },
  },
  {
    family: 'Rubik Puddles',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikpuddles/v2/1Ptog8bYX_qGnkLkrU5MJsQcJfW0wVMT-aE.woff2',
    },
  },
  {
    family: 'Noto Sans Imperial Aramaic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansimperialaramaic/v16/a8IMNpjwKmHXpgXbMIsbTc_kvks91LlLetBr5itQrtdjl3YfPNno.woff2',
    },
  },
  {
    family: 'Noto Sans Thaana',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbxLknu4-tbNu.woff2',
      '200': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VrbhLknu4-tbNu.woff2',
      '300': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4W1bhLknu4-tbNu.woff2',
      '500': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XZbhLknu4-tbNu.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4U1aRLknu4-tbNu.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4UMaRLknu4-tbNu.woff2',
      '800': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VraRLknu4-tbNu.woff2',
      '900': 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VCaRLknu4-tbNu.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansthaana/v24/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbhLknu4-tbNu.woff2',
    },
  },
  {
    family: 'Ingrid Darling',
    files: {
      regular: 'https://fonts.gstatic.com/s/ingriddarling/v5/LDIrapaJNxUtSuFdw-9yf4rCPsLLub458jGL.woff2',
    },
  },
  {
    family: 'Rubik Pixels',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikpixels/v2/SlGXmQOaupkIeSx4CEpB7AdSbRYRagrQrA.woff2',
    },
  },
  {
    family: 'Ole',
    files: {
      regular: 'https://fonts.gstatic.com/s/ole/v3/dFazZf6Z-rd88Pw69qJ_ew.woff2',
    },
  },
  {
    family: 'Noto Sans Old Italic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansolditalic/v16/TuGOUUFzXI5FBtUq5a8bh68BJxxEVam7tWlUdRhtCC4d.woff2',
    },
  },
  {
    family: 'Rubik Gemstones',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikgemstones/v1/zrf90HrL0-_8Xb4DFM2rUkWbOVrOjSnGqi1GMw.woff2',
    },
  },
  {
    family: 'Rubik Microbe',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmicrobe/v2/UqyWK8oPP3hjw6ANS9rM3PsZcsoaaKgiauE.woff2',
    },
  },
  {
    family: 'Lunasima',
    files: {
      '700': 'https://fonts.gstatic.com/s/lunasima/v1/wEO5EBvPh9RSOj7JFDSZVPoK_k4XiKvO.woff2',
      regular: 'https://fonts.gstatic.com/s/lunasima/v1/wEO-EBvPh9RSOj7JFAwge94H1VIe.woff2',
    },
  },
  {
    family: 'Noto Serif Yezidi',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoserifyezidi/v21/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspD6SEkq1GJgmVCqg.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifyezidi/v21/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspDBSYkq1GJgmVCqg.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifyezidi/v21/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspDPCYkq1GJgmVCqg.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifyezidi/v21/XLYPIYr5bJNDGYxLBibeHZAn3B5KJENnQjbfhMSVZspD2yEkq1GJgmVCqg.woff2',
    },
  },
  {
    family: 'Rubik Burned',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikburned/v1/Jqzk5TmOVOqQHihKqPpscqniGAuaCY5ZSg.woff2',
    },
  },
  {
    family: 'Rubik Maze',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmaze/v2/xMQRuF9ZVa2ftiJEavXSAXvinS-bxV4.woff2',
    },
  },
  {
    family: 'Rock 3D',
    files: {
      regular: 'https://fonts.gstatic.com/s/rock3d/v10/yYLp0hrL0PCo651513GnwRnQyNI.woff2',
    },
  },
  {
    family: 'Noto Sans Egyptian Hieroglyphs',
    files: {
      regular:
        'https://fonts.gstatic.com/s/notosansegyptianhieroglyphs/v28/vEF42-tODB8RrNDvZSUmRhcQHzx1s7y_F9-j3qSzEcbEYindTFK8xRg7iw.woff2',
    },
  },
  {
    family: 'Shizuru',
    files: {
      regular: 'https://fonts.gstatic.com/s/shizuru/v10/O4ZSFGfvnxFiCA3i30cJlgUTj2A.woff2',
    },
  },
  {
    family: 'Blaka Hollow',
    files: {
      regular: 'https://fonts.gstatic.com/s/blakahollow/v7/MCoUzAL91sjRE2FsKsxUtezYAtoFyW_-oA.woff2',
    },
  },
  {
    family: 'Noto Serif Myanmar',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJudM7F2Yv76aBKKs-bHMQfAHUw3jnNwBDpU9X6RPzQ.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNbDHMfPv2TeXJng.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNCDLMfPv2TeXJng.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNUDPMfPv2TeXJng.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNfDTMfPv2TeXJng.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNGDXMfPv2TeXJng.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNBDbMfPv2TeXJng.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJvdM7F2Yv76aBKKs-bHMQfAHUw3jnNIDfMfPv2TeXJng.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifmyanmar/v13/VuJsdM7F2Yv76aBKKs-bHMQfAHUw3jn1oRrocdDqRA.woff2',
    },
  },
  {
    family: 'Noto Sans Cypro Minoan',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscyprominoan/v1/2Eb2L_dtDUlkNmPHB_UVtEzp3ZlPGqZ_4nAGq9KSf8_eQSE.woff2',
    },
  },
  {
    family: 'Blaka Ink',
    files: {
      regular: 'https://fonts.gstatic.com/s/blakaink/v8/AlZy_zVVtpj22Znag2chcHf4XB0Tow.woff2',
    },
  },
  {
    family: 'Rubik Maps',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmaps/v1/Gw6_wcjl80TZK9XxtbbejSMUChRqp9k.woff2',
    },
  },
  {
    family: 'Yuji Hentaigana Akari',
    files: {
      regular: 'https://fonts.gstatic.com/s/yujihentaiganaakari/v11/cY9bfiyVT0VB6QuhWKOrpr6z58lnb_zYFnLIQDzODYALaA.woff2',
    },
  },
  {
    family: 'Lisu Bosa',
    files: {
      '200': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXX2DGQNbY1P1Sbg.woff2',
      '300': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXO2PGQNbY1P1Sbg.woff2',
      '500': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXY2LGQNbY1P1Sbg.woff2',
      '600': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXT2XGQNbY1P1Sbg.woff2',
      '700': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXK2TGQNbY1P1Sbg.woff2',
      '800': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXN2fGQNbY1P1Sbg.woff2',
      '900': 'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXE2bGQNbY1P1Sbg.woff2',
      regular: 'https://fonts.gstatic.com/s/lisubosa/v2/3XFoErkv240fsdmJRJQvkkviTf3E3Q.woff2',
    },
  },
  {
    family: 'Noto Serif Ahom',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifahom/v20/FeVIS0hfp6cprmEUffAW_fUL_AN-x-YrPFiwaw.woff2',
    },
  },
  {
    family: 'Kings',
    files: {
      regular: 'https://fonts.gstatic.com/s/kings/v7/8AtnGsK4O5CYXU_Nq6GSPaHS.woff2',
    },
  },
  {
    family: 'Rubik Marker Hatch',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikmarkerhatch/v1/QldTNSFQsh0B_bFXXWv6LAt-jswapJHQCb4iw0H6zw.woff2',
    },
  },
  {
    family: 'Rubik Storm',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikstorm/v1/eLGYP-_uPgO5Ag7ju9JaouL4T2Xh9NQk.woff2',
    },
  },
  {
    family: 'Noto Sans Balinese',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansbalinese/v24/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov4XdhEtVd222PPY.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansbalinese/v24/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov2nahEtVd222PPY.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansbalinese/v24/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov1DahEtVd222PPY.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansbalinese/v24/NaPwcYvSBuhTirw6IaFn6UrRDaqje-lpbbRtYf-Fwu2Ov7fdhEtVd222PPY.woff2',
    },
  },
  {
    family: 'Puppies Play',
    files: {
      regular: 'https://fonts.gstatic.com/s/puppiesplay/v9/wlp2gwHZEV99rG6M3NR9uB9vbQJSA_JN3Q.woff2',
    },
  },
  {
    family: 'Noto Sans Cherokee',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5ODky5rAffjl0.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWq5PDky5rAffjl0.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWnBPDky5rAffjl0.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWhxPDky5rAffjl0.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWvBIDky5rAffjl0.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWslIDky5rAffjl0.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWq5IDky5rAffjl0.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWodIDky5rAffjl0.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanscherokee/v20/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5PDky5rAffjl0.woff2',
    },
  },
  {
    family: 'Noto Sans Nag Mundari',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansnagmundari/v1/3qTAoi2hnSyU8TNFIdhZTyod3g5lBnKlQFk2kS9fr9Eq09RHRyqrbUSA0whP19M.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansnagmundari/v1/3qTAoi2hnSyU8TNFIdhZTyod3g5lBnKlQFk2kS9fr9Eq09RHR8asbUSA0whP19M.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansnagmundari/v1/3qTAoi2hnSyU8TNFIdhZTyod3g5lBnKlQFk2kS9fr9Eq09RHR_-sbUSA0whP19M.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansnagmundari/v1/3qTAoi2hnSyU8TNFIdhZTyod3g5lBnKlQFk2kS9fr9Eq09RHRxirbUSA0whP19M.woff2',
    },
  },
  {
    family: 'Rubik Broken Fax',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubikbrokenfax/v1/NGSvv4rXG042O-GzH9sg1cUgl8w8YWqWdmGi300.woff2',
    },
  },
  {
    family: 'Noto Sans Avestan',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansavestan/v21/bWti7ejKfBziStx7lIzKOLQZKhIJkyu4SASLji8U.woff2',
    },
  },
  {
    family: 'Linefont',
    files: {
      '100': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY4UNbuvtmdXux3U.woff2',
      '200': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnYwUMbuvtmdXux3U.woff2',
      '300': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY9sMbuvtmdXux3U.woff2',
      '500': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY7cMbuvtmdXux3U.woff2',
      '600': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY1sLbuvtmdXux3U.woff2',
      '700': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY2ILbuvtmdXux3U.woff2',
      '800': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnYwULbuvtmdXux3U.woff2',
      '900': 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnYywLbuvtmdXux3U.woff2',
      regular: 'https://fonts.gstatic.com/s/linefont/v5/dg4I_pzpoqcLKUIzVfFMh1TF2rkhli25jn7CKTTWSumsFuSnY4UMbuvtmdXux3U.woff2',
    },
  },
  {
    family: 'Noto Sans Bamum',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansbamum/v27/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEeVO-_0LykxEkxA.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansbamum/v27/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEQlJ-_0LykxEkxA.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansbamum/v27/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPETBJ-_0LykxEkxA.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansbamum/v27/uk-0EGK3o6EruUbnwovcbBTkkklK_Ya_PBHfNGTPEddO-_0LykxEkxA.woff2',
    },
  },
  {
    family: 'Noto Sans Adlam Unjoined',
    files: {
      '500':
        'https://fonts.gstatic.com/s/notosansadlamunjoined/v25/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_Yd_5PMQe-E3slUg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansadlamunjoined/v25/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_YTP-PMQe-E3slUg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansadlamunjoined/v25/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_YQr-PMQe-E3slUg.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansadlamunjoined/v25/P5sszY2MYsLRsB5_ildkzPPDsLQXcOEmaFOqOGcaYrzFTIjsPam_Ye35PMQe-E3slUg.woff2',
    },
  },
  {
    family: 'Noto Sans Khojki',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanskhojki/v19/-nFnOHM29Oofr2wohFbTuPPKVWpmK_J709jy92k.woff2',
    },
  },
  {
    family: 'Noto Sans Kawi',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanskawi/v3/92zBtBJLNqsg7tCciW0EPHNNh1ZgbtGWiTYDjvnK0ghmD5RyMjXVsQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanskawi/v3/92zBtBJLNqsg7tCciW0EPHNNh1ZgbtGWiTYDjvnKPg9mD5RyMjXVsQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanskawi/v3/92zBtBJLNqsg7tCciW0EPHNNh1ZgbtGWiTYDjvnKBw9mD5RyMjXVsQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanskawi/v3/92zBtBJLNqsg7tCciW0EPHNNh1ZgbtGWiTYDjvnK4AhmD5RyMjXVsQ.woff2',
    },
  },
  {
    family: 'Noto Sans Deseret',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansdeseret/v17/MwQsbgPp1eKH6QsAVuFb9AZM6MMr2Vq4ZnJSZtQG.woff2',
    },
  },
  {
    family: 'Noto Sans Ol Chiki',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansolchiki/v29/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALVs267c6gVrz5gQ.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansolchiki/v29/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALbcx67c6gVrz5gQ.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansolchiki/v29/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALY4x67c6gVrz5gQ.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansolchiki/v29/N0b92TJNOPt-eHmFZCdQbrL32r-4CvhzDzRwlxOQYuVALWk267c6gVrz5gQ.woff2',
    },
  },
  {
    family: 'Noto Sans Hanunoo',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanshanunoo/v21/f0Xs0fCv8dxkDWlZSoXOj6CphMloFsEpEpgL_ix2.woff2',
    },
  },
  {
    family: 'Noto Sans Nandinagari',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansnandinagari/v4/or38Q7733eiDljA1IufXSNFT-1KI5y10H4jVbpRXzC1KOw.woff2',
    },
  },
  {
    family: 'Noto Serif Oriya',
    files: {
      '500': 'https://fonts.gstatic.com/s/notoseriforiya/v4/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxru_Hy7v039MF1j.woff2',
      '600': 'https://fonts.gstatic.com/s/notoseriforiya/v4/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxoC-3y7v039MF1j.woff2',
      '700': 'https://fonts.gstatic.com/s/notoseriforiya/v4/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxo7-3y7v039MF1j.woff2',
      regular: 'https://fonts.gstatic.com/s/notoseriforiya/v4/MjQQmj56u-r69izk_LDqWN7w0cYByutv9qeWYrvLaxrc_Hy7v039MF1j.woff2',
    },
  },
  {
    family: 'Noto Sans Bassa Vah',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4MoAc6s34gH-GD7.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4PEBs6s34gH-GD7.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4P9Bs6s34gH-GD7.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansbassavah/v17/PN_bRee-r3f7LnqsD5sax12gjZn7mBpL5YwUpA2MBdcFn4MaAc6s34gH-GD7.woff2',
    },
  },
  {
    family: 'Noto Sans Medefaidrin',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansmedefaidrin/v23/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmHjWlTj18e5A3rw.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansmedefaidrin/v23/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmJTRlTj18e5A3rw.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansmedefaidrin/v23/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmK3RlTj18e5A3rw.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansmedefaidrin/v23/WwkzxOq6Dk-wranENynkfeVsNbRZtbOIdLb1exeM4ZeuabBfmErWlTj18e5A3rw.woff2',
    },
  },
  {
    family: 'Noto Sans Chakma',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanschakma/v17/Y4GQYbJ8VTEp4t3MKJSMjg5OIzhi4J3TQhYBeYo.woff2',
    },
  },
  {
    family: 'Noto Sans Lydian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslydian/v18/c4m71mVzGN7s8FmIukZJ1v4ZlcPReUbXMoIjEQI.woff2',
    },
  },
  {
    family: 'Noto Sans Tifinagh',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstifinagh/v20/I_uzMoCduATTei9eI8dawkHIwvmhCvbn77nEcXfs4Q.woff2',
    },
  },
  {
    family: 'Noto Sans Marchen',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmarchen/v19/aFTO7OZ_Y282EP-WyG6QTOX_C8WZMHhKk652ZaHk.woff2',
    },
  },
  {
    family: 'Kay Pho Du',
    files: {
      '500': 'https://fonts.gstatic.com/s/kayphodu/v2/jizcREFPvGNOx-jhPwHR2B2OCDAy_zoyk18.woff2',
      '600': 'https://fonts.gstatic.com/s/kayphodu/v2/jizcREFPvGNOx-jhPwHR2DGJCDAy_zoyk18.woff2',
      '700': 'https://fonts.gstatic.com/s/kayphodu/v2/jizcREFPvGNOx-jhPwHR2FWICDAy_zoyk18.woff2',
      regular: 'https://fonts.gstatic.com/s/kayphodu/v2/jizfREFPvGNOx-jhPwHR4OynLD0Z4zM.woff2',
    },
  },
  {
    family: 'Noto Sans Old Persian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldpersian/v16/wEOjEAbNnc5caQTFG18FHrZr9Bp6-8CmIJ_trelQfx9CjA.woff2',
    },
  },
  {
    family: 'Noto Sans Cham',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcER0curGykboaLg.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfckRwcurGykboaLg.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcTxwcurGykboaLg.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcIxwcurGykboaLg.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfczxscurGykboaLg.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfc9hscurGykboaLg.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfckRscurGykboaLg.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcuBscurGykboaLg.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanscham/v30/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcERwcurGykboaLg.woff2',
    },
  },
  {
    family: 'Noto Sans Kaithi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanskaithi/v21/buEtppS9f8_vkXadMBJJu0tWjLwjQigKdoZIKlo.woff2',
    },
  },
  {
    family: 'Padyakke Expanded One',
    files: {
      regular: 'https://fonts.gstatic.com/s/padyakkeexpandedone/v6/K2FvfY9El_tbR0JfHb6WWvrBaU6XAUvC4IAYPaRkpDjeoQ.woff2',
    },
  },
  {
    family: 'Noto Serif Grantha',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifgrantha/v19/qkBIXuEH5NzDDvc3fLDYxPk9-Wq3WLiqEUNLR7fHGw.woff2',
    },
  },
  {
    family: 'Noto Sans Indic Siyaq Numbers',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansindicsiyaqnumbers/v16/6xK5dTJFKcWIu4bpRBjRZRpsIYHabOeZ8UZLubTzpXNHKx2TPOpVd5Iu.woff2',
    },
  },
  {
    family: 'Noto Serif Makasar',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifmakasar/v1/memjYbqtyH-NiZpFH_9zcvB_PqkfY9S7ioHTVSmevw.woff2',
    },
  },
  {
    family: 'Noto Sans Takri',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstakri/v24/TuGJUVpzXI5FBtUq5a8bnKIOdTwQMe_W3khJXg.woff2',
    },
  },
  {
    family: 'Rubik Lines',
    files: {
      regular: 'https://fonts.gstatic.com/s/rubiklines/v1/_gP81R3vsjYzVW2Y6xFF-GS0YPp7oSNy.woff2',
    },
  },
  {
    family: 'Noto Sans Tamil Supplement',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstamilsupplement/v21/DdTz78kEtnooLS5rXF1DaruiCd_bFp_Ph4sGcn7ax_vpAeMkeq1x.woff2',
    },
  },
  {
    family: 'Noto Sans Chorasmian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanschorasmian/v3/MQpL-X6uKMC7ROPLwRnI9ULxK_7NVkf8S5v3oH7w4g9b.woff2',
    },
  },
  {
    family: 'Noto Sans Yi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansyi/v19/sJoD3LFXjsSdcnzn071rO3apwFDJNVgSNg.woff2',
    },
  },
  {
    family: 'Noto Sans Brahmi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansbrahmi/v19/vEFK2-VODB8RrNDvZSUmQQIIByV18te1W77HtMo.woff2',
    },
  },
  {
    family: 'Mingzat',
    files: {
      regular: 'https://fonts.gstatic.com/s/mingzat/v8/0QIgMX5C-o-oWWyvBt5km_mv670.woff2',
    },
  },
  {
    family: 'Noto Sans Zanabazar Square',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanszanabazarsquare/v19/Cn-jJsuGWQxOjaGwMQ6fOicyxLBEMRfDtkzl4uagQtJ0OCEgN0Gc.woff2',
    },
  },
  {
    family: 'Noto Sans Inscriptional Pahlavi',
    files: {
      regular:
        'https://fonts.gstatic.com/s/notosansinscriptionalpahlavi/v16/ll8UK3GaVDuxR-TEqFPIbsR79Xxz9WEKbwsjpz7VklYlC7FCVt-VOAYK0QA.woff2',
    },
  },
  {
    family: 'Noto Sans Vithkuqi',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansvithkuqi/v1/jVyi7m77CXvQswd6WjYu9E1wN6cih2TSchUEkQgw3KTnvZxSgKY7vmn0BLE.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansvithkuqi/v1/jVyi7m77CXvQswd6WjYu9E1wN6cih2TSchUEkQgw3KTnvXBVgKY7vmn0BLE.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansvithkuqi/v1/jVyi7m77CXvQswd6WjYu9E1wN6cih2TSchUEkQgw3KTnvUlVgKY7vmn0BLE.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansvithkuqi/v1/jVyi7m77CXvQswd6WjYu9E1wN6cih2TSchUEkQgw3KTnva5SgKY7vmn0BLE.woff2',
    },
  },
  {
    family: 'Noto Sans Kayah Li',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanskayahli/v21/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WBU3CZT4EXLuKVM.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanskayahli/v21/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WPkwCZT4EXLuKVM.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanskayahli/v21/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WMAwCZT4EXLuKVM.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanskayahli/v21/B50nF61OpWTRcGrhOVJJwOMXdca6Yecki3E06x2jVTX3WCc3CZT4EXLuKVM.woff2',
    },
  },
  {
    family: 'Noto Sans Vai',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansvai/v17/NaPecZTSBuhTirw6IaFn_UrURMHsDIRSfr0.woff2',
    },
  },
  {
    family: 'Noto Sans Sundanese',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanssundanese/v25/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctxbNNHHizv7fQES.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanssundanese/v25/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6cty3M9HHizv7fQES.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanssundanese/v25/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctyOM9HHizv7fQES.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanssundanese/v25/FwZw7_84xUkosG2xJo2gm7nFwSLQkdymq2mkz3Gz1_b6ctxpNNHHizv7fQES.woff2',
    },
  },
  {
    family: 'Noto Sans Lycian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslycian/v15/QldVNSNMqAsHtsJ7UmqxBQA9r8wA5_zaCJwn00E.woff2',
    },
  },
  {
    family: 'Noto Sans Lisu',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanslisu/v25/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHP61wt3tIlxkVdig.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanslisu/v25/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHPB1st3tIlxkVdig.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanslisu/v25/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHPPlst3tIlxkVdig.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanslisu/v25/uk-3EGO3o6EruUbnwovcYhz6kh57_nqbcTdjJnHP2Vwt3tIlxkVdig.woff2',
    },
  },
  {
    family: 'Noto Serif Dogra',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifdogra/v23/MQpP-XquKMC7ROPP3QOOlm7xPu3fGyu3IbPzkns.woff2',
    },
  },
  {
    family: 'Noto Sans Old Turkic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldturkic/v17/yMJNMJVya43H0SUF_WmcGEQVqoEMKDKbsE2UjEw-Vyws.woff2',
    },
  },
  {
    family: 'Noto Sans Tagbanwa',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstagbanwa/v18/Y4GWYbB8VTEp4t3MKJSMmQdIKjRtt_nZQzQEaYpGoQ.woff2',
    },
  },
  {
    family: 'Noto Sans Multani',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmultani/v20/9Bty3ClF38_RfOpe1gCaZ8p30BOFO1AxpfCs5Kos.woff2',
    },
  },
  {
    family: 'Wavefont',
    files: {
      '100':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI3V0rDCXKtOXOg4.woff2',
      '200':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI1V07DCXKtOXOg4.woff2',
      '300':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI2L07DCXKtOXOg4.woff2',
      '500':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI3n07DCXKtOXOg4.woff2',
      '600':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI0L1LDCXKtOXOg4.woff2',
      '700':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI0y1LDCXKtOXOg4.woff2',
      '800':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI1V1LDCXKtOXOg4.woff2',
      '900':
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI181LDCXKtOXOg4.woff2',
      regular:
        'https://fonts.gstatic.com/s/wavefont/v10/L0xFDF00m0cP6hefyOCpRezQNuizSrqDyx8FHbFu21B3L4m0SEzuQYwq-f_JJ8I1WI3V07DCXKtOXOg4.woff2',
    },
  },
  {
    family: 'Noto Serif Old Uyghur',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifolduyghur/v3/v6-KGZbLJFKIhClqUYqXDiGnrVoFRCW6JdwnL-meF2yVgA.woff2',
    },
  },
  {
    family: 'Noto Serif Gurmukhi',
    files: {
      '100': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eBTImqVU7y6l.woff2',
      '200': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4-eRTImqVU7y6l.woff2',
      '300': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr7geRTImqVU7y6l.woff2',
      '500': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6MeRTImqVU7y6l.woff2',
      '600': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5gfhTImqVU7y6l.woff2',
      '700': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5ZfhTImqVU7y6l.woff2',
      '800': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4-fhTImqVU7y6l.woff2',
      '900': 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4XfhTImqVU7y6l.woff2',
      regular: 'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eRTImqVU7y6l.woff2',
    },
  },
  {
    family: 'Yuji Hentaigana Akebono',
    files: {
      regular: 'https://fonts.gstatic.com/s/yujihentaiganaakebono/v12/EJRGQhkhRNwM-RtitGUwh930GU_f5KAlkuL0wQy4NKXRzrrF.woff2',
    },
  },
  {
    family: 'Noto Sans Tai Tham',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosanstaitham/v20/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBBcbPg-uyaRGKMw.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanstaitham/v20/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBPscPg-uyaRGKMw.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanstaitham/v20/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBMIcPg-uyaRGKMw.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanstaitham/v20/kJEbBv0U4hgtwxDUw2x9q7tbjLIfbPGHBoaVSAZ3MdLJBCUbPg-uyaRGKMw.woff2',
    },
  },
  {
    family: 'Noto Sans Wancho',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanswancho/v17/zrf-0GXXyfn6Fs0lH9P4cUubP0GBqAbopiRfKp8.woff2',
    },
  },
  {
    family: 'Narnoor',
    files: {
      '500': 'https://fonts.gstatic.com/s/narnoor/v7/cIf4MaFWuVo-UTyP_N2CRGQsnIJkWL4.woff2',
      '600': 'https://fonts.gstatic.com/s/narnoor/v7/cIf4MaFWuVo-UTyP_PGFRGQsnIJkWL4.woff2',
      '700': 'https://fonts.gstatic.com/s/narnoor/v7/cIf4MaFWuVo-UTyP_JWERGQsnIJkWL4.woff2',
      '800': 'https://fonts.gstatic.com/s/narnoor/v7/cIf4MaFWuVo-UTyP_ImHRGQsnIJkWL4.woff2',
      regular: 'https://fonts.gstatic.com/s/narnoor/v7/cIf9MaFWuVo-UTyPxCyrYGkHgIs.woff2',
    },
  },
  {
    family: 'Noto Sans Cypriot',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscypriot/v19/8AtzGta9PYqQDjyp79a6f8Cj-3a3cxIpK5MPpahF.woff2',
    },
  },
  {
    family: 'Noto Sans Siddham',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssiddham/v20/OZpZg-FwqiNLe9PELUikxTWDoCCeGqnYk3Ic92ZH.woff2',
    },
  },
  {
    family: 'Noto Serif Khitan Small Script',
    files: {
      regular: 'https://fonts.gstatic.com/s/notoserifkhitansmallscript/v4/jizzRFVKsm4Bt9PrbSzC4KLlQUF5lRJg5j-l5PvyhfTdd4TsYslb39iddA.woff2',
    },
  },
  {
    family: 'Noto Sans Shavian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansshavian/v17/CHy5V_HZE0jxJBQlqAeCKjJvQBNF4EFVSplv2Cwg.woff2',
    },
  },
  {
    family: 'Noto Sans Limbu',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslimbu/v22/3JnlSDv90Gmq2mrzckOBBRRoNJVj1cF3OHRDnA.woff2',
    },
  },
  {
    family: 'Noto Sans Phags Pa',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansphagspa/v15/pxiZyoo6v8ZYyWh5WuPeJzMkd4SrGChkr0SsrvNXiA.woff2',
    },
  },
  {
    family: 'Noto Sans Pahawh Hmong',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanspahawhhmong/v18/bWtp7e_KfBziStx7lIzKKaMUOBEA3UPQDW7krzI_c48aMpM.woff2',
    },
  },
  {
    family: 'Noto Sans Inscriptional Parthian',
    files: {
      regular:
        'https://fonts.gstatic.com/s/notosansinscriptionalparthian/v16/k3k7o-IMPvpLmixcA63oYi-yStDkgXuXncL7dzfW3P4TAJ2yklBM2jNkLlLr.woff2',
    },
  },
  {
    family: 'Noto Sans Syriac',
    files: {
      '100': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-VD9caMyZfUL_FC.woff2',
      '200': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-XD9MaMyZfUL_FC.woff2',
      '300': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Ud9MaMyZfUL_FC.woff2',
      '500': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Vx9MaMyZfUL_FC.woff2',
      '600': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Wd88aMyZfUL_FC.woff2',
      '700': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Wk88aMyZfUL_FC.woff2',
      '800': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-XD88aMyZfUL_FC.woff2',
      '900': 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Xq88aMyZfUL_FC.woff2',
      regular: 'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-VD9MaMyZfUL_FC.woff2',
    },
  },
  {
    family: 'Noto Sans Tai Le',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstaile/v17/vEFK2-VODB8RrNDvZSUmVxEATwR58te1W77HtMo.woff2',
    },
  },
  {
    family: 'Noto Sans Psalter Pahlavi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanspsalterpahlavi/v16/rP2Vp3K65FkAtHfwd-eISGznYihzggmsicPfud3w1GjKsUQBct4.woff2',
    },
  },
  {
    family: 'Noto Sans Palmyrene',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanspalmyrene/v16/ZgNPjOdKPa7CHqq0h37c_ASCWvH93SFCPne5ZpdNtcA.woff2',
    },
  },
  {
    family: 'Noto Sans Duployan',
    files: {
      '700': 'https://fonts.gstatic.com/s/notosansduployan/v17/gokwH7nwAEdtF9N8-mdTDx_X9JM5wsvTqu0D5E0ftZS-Iw.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansduployan/v17/gokzH7nwAEdtF9N8-mdTDx_X9JM5wsvrE8In6WYDvA.woff2',
    },
  },
  {
    family: 'Noto Sans Syriac Eastern',
    files: {
      '100':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPi-eszWL5ep1QPQ.woff2',
      '200':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPq-fszWL5ep1QPQ.woff2',
      '300':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPnGfszWL5ep1QPQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPh2fszWL5ep1QPQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPvGYszWL5ep1QPQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPsiYszWL5ep1QPQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPq-YszWL5ep1QPQ.woff2',
      '900':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPoaYszWL5ep1QPQ.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPi-fszWL5ep1QPQ.woff2',
    },
  },
  {
    family: 'Noto Sans Old North Arabian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldnortharabian/v16/esDF30BdNv-KYGGJpKGk2tNiMt7Jar6olZDyNdr81zBQnEo_xw4ABw.woff2',
    },
  },
  {
    family: 'Noto Sans Khudawadi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanskhudawadi/v21/fdNi9t6ZsWBZ2k5ltHN73zZ5hc8HANlHIjFnVVXz9MY.woff2',
    },
  },
  {
    family: 'Noto Sans Cuneiform',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscuneiform/v17/bMrrmTWK7YY-MF22aHGGd7H8PhJtvBDWgbpJlRQueeQ.woff2',
    },
  },
  {
    family: 'Noto Sans Old Permic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldpermic/v17/snf1s1q1-dF8pli1TesqcbUY4Mr-ElrwKLdSgv_dKYB5.woff2',
    },
  },
  {
    family: 'Noto Sans Tirhuta',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanstirhuta/v16/t5t6IQYRNJ6TWjahPR6X-M-apUyby7uDUBsTrn5P.woff2',
    },
  },
  {
    family: 'Noto Sans Grantha',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansgrantha/v17/3y976akwcCjmsU8NDyrKo3IQfQ4o-r8ZFeulHc6N.woff2',
    },
  },
  {
    family: 'Noto Sans Saurashtra',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssaurashtra/v23/ea8GacQ0Wfz_XKWXe6OtoA8w8zvmYwTef9nYjhPTSIx9.woff2',
    },
  },
  {
    family: 'Noto Sans Osage',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansosage/v18/oPWX_kB6kP4jCuhpgEGmw4mtAVtXQ1aSxkrMCQ.woff2',
    },
  },
  {
    family: 'Noto Sans Runic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansrunic/v17/H4c_BXWPl9DZ0Xe_nHUaus7W68WWbhpvHtgIYg.woff2',
    },
  },
  {
    family: 'Noto Sans Newa',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansnewa/v16/7r3fqXp6utEsO9pI4f8ok8sWg8n6qN4R5lNU.woff2',
    },
  },
  {
    family: 'Noto Sans Buginese',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansbuginese/v18/esDM30ldNv-KYGGJpKGk18phe_7Da6_gsPuEXLmNtw.woff2',
    },
  },
  {
    family: 'Noto Sans Mayan Numerals',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmayannumerals/v16/PlIuFk25O6RzLfvNNVSivR09_KqYMwvvDKYjfIiE7soo6eepYQ.woff2',
    },
  },
  {
    family: 'Noto Sans Mandaic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmandaic/v16/cIfnMbdWt1w_HgCcilqhKQBo_OsMI5_F_gMk0izH.woff2',
    },
  },
  {
    family: 'Chokokutai',
    files: {
      regular: 'https://fonts.gstatic.com/s/chokokutai/v9/kmK4Zqw4HwvCeHGM8Fws9yvypu1Kr7I.woff2',
    },
  },
  {
    family: 'Noto Sans Hanifi Rohingya',
    files: {
      '500':
        'https://fonts.gstatic.com/s/notosanshanifirohingya/v28/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIYq4j6qvcudK8rN.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanshanifirohingya/v28/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIbG5T6qvcudK8rN.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanshanifirohingya/v28/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIb_5T6qvcudK8rN.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosanshanifirohingya/v28/5h17iYsoOmIC3Yu3MDXLDw3UZCgghyOEBBY7hhLNyo3tiaiuSIAqrIYY4j6qvcudK8rN.woff2',
    },
  },
  {
    family: 'Noto Sans Nabataean',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansnabataean/v16/IFS4HfVJndhE3P4b5jnZ34DfsjO330dNoBd9hK8kMK4.woff2',
    },
  },
  {
    family: 'Noto Sans Phoenician',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansphoenician/v17/jizFRF9Ksm4Bt9PvcTaEkIHiTVtxmFtS5X7Mot-p5561.woff2',
    },
  },
  {
    family: 'Noto Sans Rejang',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansrejang/v21/Ktk2AKuMeZjqPnXgyqrib7DIogqwN4a3WYZB_sU.woff2',
    },
  },
  {
    family: 'Noto Sans Hatran',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanshatran/v16/A2BBn4Ne0RgnVF3Lnko-0sOBIfL_mMo3r1nwzDs.woff2',
    },
  },
  {
    family: 'Noto Sans Gunjala Gondi',
    files: {
      '500':
        'https://fonts.gstatic.com/s/notosansgunjalagondi/v19/bWtX7e7KfBziStx7lIzKPrcSMwcEnCv6DW7n5g0ef3PLtymzNxYL04DE5Z4vCTxEJQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgunjalagondi/v19/bWtX7e7KfBziStx7lIzKPrcSMwcEnCv6DW7n5g0ef3PLtymzNxYLP4fE5Z4vCTxEJQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgunjalagondi/v19/bWtX7e7KfBziStx7lIzKPrcSMwcEnCv6DW7n5g0ef3PLtymzNxYLBofE5Z4vCTxEJQ.woff2',
      regular:
        'https://fonts.gstatic.com/s/notosansgunjalagondi/v19/bWtX7e7KfBziStx7lIzKPrcSMwcEnCv6DW7n5g0ef3PLtymzNxYL4YDE5Z4vCTxEJQ.woff2',
    },
  },
  {
    family: 'Noto Sans Bhaiksuki',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansbhaiksuki/v17/UcC63EosKniBH4iELXATsSBWdvUHXxhj8rfUdU4wh9U.woff2',
    },
  },
  {
    family: 'Noto Sans Linear B',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanslinearb/v17/HhyJU4wt9vSgfHoORYOiXOckKNB737IV2RkFTq4EPw.woff2',
    },
  },
  {
    family: 'Noto Sans Sogdian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssogdian/v16/taiQGn5iC4--qtsfi4Jp6eHPnfxQBo-7Pm6KHidM.woff2',
    },
  },
  {
    family: 'Noto Sans Caucasian Albanian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanscaucasianalbanian/v18/nKKA-HM_FYFRJvXzVXaANsU0VzsAc46QGOkWytlTs-TXrYXmoVmRSZo.woff2',
    },
  },
  {
    family: 'Noto Sans Mro',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmro/v18/qWcsB6--pZv9TqnUQMhe9b39WDnRtjkho4M.woff2',
    },
  },
  {
    family: 'Noto Sans New Tai Lue',
    files: {
      '500': 'https://fonts.gstatic.com/s/notosansnewtailue/v22/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pddfAYUPghFPKzeY.woff2',
      '600': 'https://fonts.gstatic.com/s/notosansnewtailue/v22/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdTvHYUPghFPKzeY.woff2',
      '700': 'https://fonts.gstatic.com/s/notosansnewtailue/v22/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdQLHYUPghFPKzeY.woff2',
      regular: 'https://fonts.gstatic.com/s/notosansnewtailue/v22/H4cKBW-Pl9DZ0Xe_nHUapt7PovLXAhAnY7wqaLy-OJgU3p_pdeXAYUPghFPKzeY.woff2',
    },
  },
  {
    family: 'Noto Sans Modi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmodi/v23/pe03MIySN5pO62Z5YkFyT7jeav5vWVAgVol-.woff2',
    },
  },
  {
    family: 'Noto Sans Old Sogdian',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansoldsogdian/v16/3JnjSCH90Gmq2mrzckOBBhFhdrMst48aURt7mOIqM-9uyg.woff2',
    },
  },
  {
    family: 'Noto Sans Ogham',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansogham/v17/kmKlZqk1GBDGN0mY6k5lmEmww4hrsplaQxcoCA.woff2',
    },
  },
  {
    family: 'Noto Sans Ugaritic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansugaritic/v16/3qTwoiqhnSyU8TNFIdhZVCwbjCpkAXXkNxoIkiazfg.woff2',
    },
  },
  {
    family: 'Noto Sans Kharoshthi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanskharoshthi/v16/Fh4qPiLjKS30-P4-pGMMXCCfvkc5Vd7KE5z9rFyx5mR1.woff2',
    },
  },
  {
    family: 'Noto Sans Elymaic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanselymaic/v17/UqyKK9YTJW5liNMhTMqe9vUFP65ZD4AmWOT0zi2V.woff2',
    },
  },
  {
    family: 'Noto Sans Warang Citi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanswarangciti/v17/EYqtmb9SzL1YtsZSScyKDXIeOv3w-zgsNvKRoOVCCXzdgA.woff2',
    },
  },
  {
    family: 'Noto Sans Masaram Gondi',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmasaramgondi/v17/6xK_dThFKcWIu4bpRBjRYRV7KZCbUq6n_1kPnuGb7RI9WSWX.woff2',
    },
  },
  {
    family: 'Noto Sans Meroitic',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmeroitic/v18/IFS5HfRJndhE3P4b5jnZ3ITPvC6i00UDhThTiKY9KQ.woff2',
    },
  },
  {
    family: 'Noto Sans Mende Kikakui',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmendekikakui/v28/11hRGoLHz17aKjQCWj-JHcLvu2Q5zZrnkbNCLUx6aDJLAHer.woff2',
    },
  },
  {
    family: 'Noto Sans Nushu',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansnushu/v19/rnCw-xRQ3B7652emAbAe_Ai1IYaFXVAMArZKqQ.woff2',
    },
  },
  {
    family: 'Noto Sans Soyombo',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssoyombo/v17/RWmSoL-Y6-8q5LTtXs6MF6q7xsxgY0FuIFOcK25W.woff2',
    },
  },
  {
    family: 'Noto Sans Elbasan',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanselbasan/v16/-F6rfiZqLzI2JPCgQBnw400qp1trvHdgre4dFcFh.woff2',
    },
  },
  {
    family: 'Noto Sans Manichaean',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmanichaean/v18/taiVGntiC4--qtsfi4Jp9-_GkPZZCcrfekqHNTtFCtdX.woff2',
    },
  },
  {
    family: 'Noto Sans Mahajani',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansmahajani/v19/-F6sfiVqLzI2JPCgQBnw60Agp0JrvD5FgsARHNh4zg.woff2',
    },
  },
  {
    family: 'Noto Sans Pau Cin Hau',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanspaucinhau/v20/x3d-cl3IZKmUqiMg_9wBLLtzl22EayN7ehIdiUWqKMxsKw.woff2',
    },
  },
  {
    family: 'Noto Sans SignWriting',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosanssignwriting/v4/Noas6VX_wIWFbTTCrYmvy9A2UnkL-2SZAWiUFFCARYQemg.woff2',
    },
  },
  {
    family: 'Noto Sans NKo',
    files: {
      regular: 'https://fonts.gstatic.com/s/notosansnko/v6/esDX31ZdNv-KYGGJpKGk2_RpMpWMHMLBrdA.woff2',
    },
  },
];

export const getGoogleFontOptions = (): Array<Option> => {
  return GOOGLE_FONTS.flatMap((item) =>
    Object.entries(item.files)
      .filter(([variant]) => !variant.includes('italic'))
      .map(([variant, url]) => ({ label: `${item.family} - ${variant}`, value: url })),
  );
};
